import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CamelizedJson: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** Access entity */
export type Access = {
  __typename?: 'Access';
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Related items IDs */
  itemIds: Array<Scalars['ID']['output']>;
  /** Level of access */
  level: Maybe<AccessLevelEnum>;
  /** Policy type */
  policy: Maybe<AccessPolicyEnum>;
  /** Scope level */
  scopeLevel: Maybe<AccessScopeLevelEnum>;
};

/** Available components */
export enum AccessComponentEnum {
  /** Assets counter reading (index adding) */
  AssetsCounterReading = 'ASSETS_COUNTER_READING',
  /** Assets management */
  AssetsManagement = 'ASSETS_MANAGEMENT',
  /** Assets management in asset categories only */
  AssetsManagementCategoriesScope = 'ASSETS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Asset categories management */
  AssetCategoriesManagement = 'ASSET_CATEGORIES_MANAGEMENT',
  /** Form categories management */
  FormCategoriesManagement = 'FORM_CATEGORIES_MANAGEMENT',
  /** Home page management */
  HomePageManagement = 'HOME_PAGE_MANAGEMENT',
  /** Interventions management */
  InterventionsManagement = 'INTERVENTIONS_MANAGEMENT',
  /** Interventions management in intervention categories only */
  InterventionsManagementCategoriesScope = 'INTERVENTIONS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Intervention categories management */
  InterventionCategoriesManagement = 'INTERVENTION_CATEGORIES_MANAGEMENT',
  /** Sites management */
  SitesManagement = 'SITES_MANAGEMENT',
  /** Tasks management */
  TasksManagement = 'TASKS_MANAGEMENT',
  /** Tasks performing */
  TasksPerforming = 'TASKS_PERFORMING',
  /** Users and teams management */
  UsersManagement = 'USERS_MANAGEMENT'
}

/** Access attributes */
export type AccessCuInputObject = {
  /** Destroy access */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Scope items attributes array */
  items?: InputMaybe<Array<LinkingInputObject>>;
  /** Level of access (for non-scope access) */
  level?: InputMaybe<AccessLevelEnum>;
  /** Scope level of access (for scope access) */
  scopeLevel?: InputMaybe<AccessScopeLevelEnum>;
};

/** Available levels of access */
export enum AccessLevelEnum {
  LimitedRead = 'LIMITED_READ',
  Read = 'READ',
  Write = 'WRITE'
}

/** Available policies of accesses based on every possible setup */
export enum AccessPolicyEnum {
  CompanyPlan = 'COMPANY_PLAN',
  Default = 'DEFAULT',
  Team = 'TEAM',
  User = 'USER'
}

/** Available scope levels of access */
export enum AccessScopeLevelEnum {
  All = 'ALL',
  Selected = 'SELECTED'
}

/** API Token */
export type ApiToken = TimestampInterface & {
  __typename?: 'ApiToken';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ApiToken ID */
  id: Scalars['ID']['output'];
  /** Label */
  label: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status */
  status: Maybe<ApiTokenStatusEnum>;
  /** Token (can be accessed once only after creation) */
  token: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** ApiTokenCollection type */
export type ApiTokenCollection = {
  __typename?: 'ApiTokenCollection';
  /** A collection of paginated ApiTokenCollection */
  collection: Array<ApiToken>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenCreateInput = {
  /** Create attributes */
  attributes: ApiTokenCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** ApiToken attributes */
export type ApiTokenCreateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** Available statuses */
export enum ApiTokenStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type ApiTokenUpdateInput = {
  /** Update attributes */
  attributes: ApiTokenUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** ApiToken attributes */
export type ApiTokenUpdateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status?: InputMaybe<ApiTokenStatusEnum>;
};

/** Asset entity */
export type Asset = TimestampInterface & {
  __typename?: 'Asset';
  canDestroy: AuthorizationResult;
  /**
   * Asset Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<AssetCategory>;
  /** Asset Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Counter count */
  countersCount: Maybe<Scalars['Int']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Asset icon */
  iconAttached: Maybe<Attachment>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Manufacturer */
  manufacturer: Maybe<Scalars['String']['output']>;
  /** Model */
  model: Maybe<Scalars['String']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /** QR code prefix */
  qrPrefix: Maybe<Scalars['String']['output']>;
  /** Serial number */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** Service date */
  serviceDate: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates number of nomenclatures where is used */
  usesAsNomenclatureCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** Asset Category entity */
export type AssetCategory = TimestampInterface & {
  __typename?: 'AssetCategory';
  /** Assets collection */
  assets: AssetCollection;
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Asset Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Prefix */
  prefix: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Assets */
  visibleAssetsCount: Scalars['Int']['output'];
};


/** Asset Category entity */
export type AssetCategoryAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** AssetCategoryCollection type */
export type AssetCategoryCollection = {
  __typename?: 'AssetCategoryCollection';
  /** A collection of paginated AssetCategoryCollection */
  collection: Array<AssetCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryCreateInput = {
  /** Create attributes */
  attributes: AssetCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
};

/** Asset Category filters */
export type AssetCategoryFilterInputObject = {
  /** Asset Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Asset Category sorts */
export type AssetCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Assets in this category */
  visibleAssetsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryUpdateInput = {
  /** Update attributes */
  attributes: AssetCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
  /** Refresh QR prefix for related assets */
  refreshQrPrefixForAssets?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** AssetCollection type */
export type AssetCollection = {
  __typename?: 'AssetCollection';
  /** A collection of paginated AssetCollection */
  collection: Array<Asset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCreateInput = {
  /** Create attributes */
  attributes: AssetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset attributes */
export type AssetCreateInputObject = {
  /** Asset Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
};

/** Asset filters */
export type AssetFilterInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Asset code */
  code?: InputMaybe<FilterInputObject>;
  /** Counter count */
  countersCount?: InputMaybe<FilterIntInputObject>;
  /** Asset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<FilterInputObject>;
  /** Asset name */
  name?: InputMaybe<FilterInputObject>;
  /** QR prefix */
  qrPrefix?: InputMaybe<FilterInputObject>;
  /** Asset serial number */
  serialNumber?: InputMaybe<FilterInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Site Sector ID */
  siteSectorId?: InputMaybe<FilterIdInputObject>;
};

/** Asset attributes */
export type AssetFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Asset sorts */
export type AssetSortInputObject = {
  /** Asset Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Asset serial number */
  serialNumber?: InputMaybe<SortDirectionEnum>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetUpdateInput = {
  /** Update attributes */
  attributes: AssetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset ID */
  id: Scalars['ID']['input'];
};

/** Asset attributes */
export type AssetUpdateInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Update QR prefix (if true, QR prefix will be used from asset category prefix) */
  updateQrPrefix?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attachment */
export type Attachment = {
  __typename?: 'Attachment';
  /** Raw file data JSON (to copy attached files from one object to another without reprocessing) */
  fileData: Maybe<Scalars['JSON']['output']>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag: Maybe<Scalars['String']['output']>;
  /** Filename */
  filename: Maybe<Scalars['String']['output']>;
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** {description: "Metadata", fields: {intended_use: "Intended use"}} */
  metadata: Maybe<AttachmentMetadata>;
  /** MIME type */
  mimeType: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if attachment is processed */
  processed: Scalars['Boolean']['output'];
  /** URLs */
  urls: Maybe<AttachmentUrl>;
};

/** Attachment attributes */
export type AttachmentCuInputObject = {
  /** Destroy attachment */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** File */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag?: InputMaybe<Scalars['String']['input']>;
  /** Filename */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Attachment ID (to update existing attachment pass ID. To create new attachment do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata */
  metadata?: InputMaybe<AttachmentMetadataInputObject>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** File attributes */
export type AttachmentFileDerivativesInputObject = {
  /** Large */
  large: AttachmentFileInfoInputObject;
  /** Medium */
  medium: AttachmentFileInfoInputObject;
  /** Small */
  small: AttachmentFileInfoInputObject;
};

/** File attributes */
export type AttachmentFileInfoInputObject = {
  /** File ID */
  id: Scalars['String']['input'];
  /** Metadata */
  metadata: AttachmentFileMetadataInputObject;
  /** Storage */
  storage: AttachmentStorageEnum;
};

/** File attributes */
export type AttachmentFileInputObject = {
  /** Derivatives */
  derivatives?: InputMaybe<AttachmentFileDerivativesInputObject>;
  /** File ID */
  id: Scalars['String']['input'];
  /** Metadata */
  metadata: AttachmentFileMetadataInputObject;
  /** Storage */
  storage: AttachmentStorageEnum;
};

/** File attributes */
export type AttachmentFileMetadataInputObject = {
  /** Filename */
  filename: Scalars['String']['input'];
  /** Height */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Mime type */
  mimeType: Scalars['String']['input'];
  /** Size of file */
  size: Scalars['Int']['input'];
  /** Width */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Metadata */
export type AttachmentMetadata = {
  __typename?: 'AttachmentMetadata';
  /** Intended use */
  intendedUse: Maybe<Scalars['String']['output']>;
};

/** Metadata attributes */
export type AttachmentMetadataInputObject = {
  /** Intended use */
  intendedUse?: InputMaybe<Scalars['String']['input']>;
};

/** Available storages */
export enum AttachmentStorageEnum {
  Cache = 'cache',
  Store = 'store'
}

/** Attachment URLs */
export type AttachmentUrl = {
  __typename?: 'AttachmentUrl';
  /** Image preview URL */
  imagePreview: Maybe<Scalars['String']['output']>;
  /** Large URL */
  large: Maybe<Scalars['String']['output']>;
  /** Medium URL */
  medium: Maybe<Scalars['String']['output']>;
  /** Original URL */
  original: Maybe<Scalars['String']['output']>;
  /** Original direct download URL (without preview in browser even for known formats) */
  originalDirectDownload: Maybe<Scalars['String']['output']>;
  /** Small URL */
  small: Maybe<Scalars['String']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Show entrypoint */
export type AuthenticationEntrypointUnion = ApiToken | Session;

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordSetupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsForgotInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email: Scalars['String']['input'];
  /** Url to change password */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** Current password. Required only if user already has a password set (check hasPassword field). */
  passwordChallenge?: InputMaybe<Scalars['String']['input']>;
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailForAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to include in the email for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** ID of the locked admin to send the email to */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the locked account */
  email: Scalars['String']['input'];
  /** URL for account restore link in email */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Account type (USER or SYSTEM_ADMIN) */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationRestoreAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Account restore token from email */
  token: Scalars['String']['input'];
};

/** Available resource scopes */
export enum AuthenticationScopeEnum {
  SystemAdmin = 'SYSTEM_ADMIN',
  User = 'USER'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Email or username */
  uid: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to exclude current session (default true) */
  excludeCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndSpecificInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID */
  sessionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Token from email */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Session ID to report */
  sessionId: Scalars['ID']['input'];
};

/** Two-factor authentication code types */
export enum AuthenticationTwoFactorCodeTypeEnum {
  /** Backup code */
  Backup = 'BACKUP',
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from email */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling email OTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling TOTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorGenerateBackupCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Two-factor authentication methods */
export enum AuthenticationTwoFactorOtpMethodEnum {
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password (authenticator app) */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResendEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current admin's 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Target SystemAdmin ID */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app or email */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Show current user */
export type AuthenticationWhoamiUnion = SystemAdmin | User;

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** Company entity */
export type Company = TimestampInterface & {
  __typename?: 'Company';
  /** Active users count in the company */
  activeUsersCount: Scalars['Int']['output'];
  /** Country */
  country: CountryEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if company is deactivated */
  deactivated: Scalars['Boolean']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Company ID */
  id: Scalars['ID']['output'];
  /** Industry */
  industry: Maybe<Industry>;
  /** Name */
  name: Scalars['String']['output'];
  /** Company full admin owner entity */
  owner: Maybe<User>;
  /** Plan entity */
  plan: CompanyPlan;
  /** Timezone name */
  timezone: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Website */
  website: Maybe<Scalars['String']['output']>;
};

/** CompanyCollection type */
export type CompanyCollection = {
  __typename?: 'CompanyCollection';
  /** A collection of paginated CompanyCollection */
  collection: Array<Company>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyCreateInput = {
  /** Create attributes */
  attributes: CompanyCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** Company attributes */
export type CompanyCreateInputObject = {
  /** Admin attributes */
  admin: UserCreateOwnerInputObject;
  /** Country */
  country: CountryEnum;
  /** Description */
  description: Scalars['String']['input'];
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Plan attributes */
  plan: CompanyPlanCuInputObject;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company Domain entity */
export type CompanyDomain = TimestampInterface & {
  __typename?: 'CompanyDomain';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full DNS TXT record for domain verification */
  dnsTxtRecord: Scalars['String']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Company Domain ID */
  id: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** DNS verification token */
  verificationToken: Scalars['String']['output'];
  /** Indicates if domain is verified */
  verified: Scalars['Boolean']['output'];
  /** Verification timestamp */
  verifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** CompanyDomainCollection type */
export type CompanyDomainCollection = {
  __typename?: 'CompanyDomainCollection';
  /** A collection of paginated CompanyDomainCollection */
  collection: Array<CompanyDomain>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainCreateInput = {
  /** Create attributes */
  attributes: CompanyDomainCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Company Domain attributes */
export type CompanyDomainCreateInputObject = {
  /** Domain name (e.g., example.com) */
  domain: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company Domain filters */
export type CompanyDomainFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Domain name */
  domain?: InputMaybe<FilterInputObject>;
  /** Company Domain ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<FilterDateInputObject>;
};

/** Company Domain sorts */
export type CompanyDomainSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Domain name */
  domain?: InputMaybe<SortDirectionEnum>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company filters */
export type CompanyFilterInputObject = {
  /** Country name */
  country?: InputMaybe<FilterInputObject>;
  /** Industry ID */
  industryId?: InputMaybe<FilterIdInputObject>;
  /** Industry name */
  industryName?: InputMaybe<FilterInputObject>;
  /** Company name */
  name?: InputMaybe<FilterInputObject>;
  /** Owner full name */
  ownerFullName?: InputMaybe<FilterInputObject>;
  /** Plan kind */
  planKind?: InputMaybe<FilterIntInputObject>;
};

/** Company plan entity */
export type CompanyPlan = TimestampInterface & {
  __typename?: 'CompanyPlan';
  /** Accesses */
  accesses: Array<Access>;
  /** Shows a list of available access components to create or edit for company users */
  allowedUsersAccessComponents: Array<AccessComponentEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Currency
   * ATTENTION: Access allowed for system admins.
   */
  currency: Maybe<CompanyPlanCurrencyEnum>;
  /** Company plan ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: CompanyPlanKindEnum;
  /**
   * Payment period
   * ATTENTION: Access allowed for system admins.
   */
  paymentPeriod: Maybe<CompanyPlanPaymentPeriodEnum>;
  /**
   * Price
   * ATTENTION: Access allowed for system admins.
   */
  price: Maybe<Scalars['Float']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Maximum active users */
  usersLimit: Maybe<Scalars['Int']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyPlanChangeRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: CompanyPlanChangeRequestInputObject;
};

/** Company Plan change params */
export type CompanyPlanChangeRequestInputObject = {
  /**  Link to open the company profile page for system admins. Supported variables: `companyId`. Example: `https://system.datizy.com/dashboard/accounts/:companyId/view`  */
  companyProfileLink: Scalars['String']['input'];
  /** Email to contact */
  contactEmail: Scalars['String']['input'];
  /** Message */
  message: Scalars['String']['input'];
};

/** Company Plan attributes */
export type CompanyPlanCuInputObject = {
  /** Accesses */
  accesses: Array<AccessCuInputObject>;
  /** Currency */
  currency: CompanyPlanCurrencyEnum;
  /** Kind */
  kind: CompanyPlanKindEnum;
  /** Payment period */
  paymentPeriod: CompanyPlanPaymentPeriodEnum;
  /** Price */
  price: Scalars['Float']['input'];
  /** Limit of users */
  usersLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Available currencies */
export enum CompanyPlanCurrencyEnum {
  Eur = 'EUR'
}

/** Available plans */
export enum CompanyPlanKindEnum {
  Custom = 'CUSTOM',
  Gold = 'GOLD',
  Silver = 'SILVER',
  Starter = 'STARTER'
}

/** Available payment periods */
export enum CompanyPlanPaymentPeriodEnum {
  Month = 'MONTH'
}

/** Company sorts */
export type CompanySortInputObject = {
  /** Active users count */
  activeUsersCount?: InputMaybe<SortDirectionEnum>;
  /** Country name */
  country?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Industry name */
  industryName?: InputMaybe<SortDirectionEnum>;
  /** Company name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Owner full name */
  ownerFullName?: InputMaybe<SortDirectionEnum>;
  /** Plan kind */
  planKind?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyUpdateInput = {
  /** Update attributes */
  attributes: CompanyUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company attributes */
export type CompanyUpdateInputObject = {
  /** Admin ID */
  adminId?: InputMaybe<Scalars['ID']['input']>;
  /** Country */
  country?: InputMaybe<CountryEnum>;
  /** Deactivate company */
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Plan attributes */
  plan?: InputMaybe<CompanyPlanCuInputObject>;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Counter entity */
export type Counter = TimestampInterface & {
  __typename?: 'Counter';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Asset;
  /** Asset ID */
  assetId: Scalars['ID']['output'];
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Last check at */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Latest index value */
  latestIndex: Maybe<Scalars['Float']['output']>;
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['output'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkDestroyInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkQrCodeCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** CounterCollection type */
export type CounterCollection = {
  __typename?: 'CounterCollection';
  /** A collection of paginated CounterCollection */
  collection: Array<Counter>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterCreateInput = {
  /** Create attributes */
  attributes: CounterCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter attributes */
export type CounterCreateInputObject = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Code */
  code: Scalars['String']['input'];
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['input'];
};

/** Counter filters */
export type CounterFilterInputObject = {
  /** Code */
  code?: InputMaybe<FilterInputObject>;
};

/** Counter attributes */
export type CounterFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Counter Measure entity */
export type CounterMeasure = TimestampInterface & {
  __typename?: 'CounterMeasure';
  /**
   * Counter entity
   * NOTE: if you only need an Object ID, please use the counterId field to reduce the load on the database.
   */
  counter: Counter;
  /** Counter ID */
  counterId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Manually entered the reading value */
  index: Scalars['Float']['output'];
  /** Indicates if the measure was reset to zero */
  resetToZero: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** CounterMeasureCollection type */
export type CounterMeasureCollection = {
  __typename?: 'CounterMeasureCollection';
  /** A collection of paginated CounterMeasureCollection */
  collection: Array<CounterMeasure>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterMeasureCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Create attributes */
  attributes: CounterMeasureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter Measure attributes */
export type CounterMeasureCreateInputObject = {
  /** Counter ID */
  counterId: Scalars['ID']['input'];
  /** Manually entered the reading value */
  index: Scalars['Float']['input'];
};

/** Counter Measure filters */
export type CounterMeasureFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
};

/** Counter Measure graph data */
export type CounterMeasureGraphData = {
  __typename?: 'CounterMeasureGraphData';
  /** Created at */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
};

/** Counter Measure sorts */
export type CounterMeasureSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** All available measure types */
export enum CounterMeasureTypeEnum {
  Distance = 'DISTANCE',
  Energy = 'ENERGY',
  Mass = 'MASS',
  Quantity = 'QUANTITY',
  Time = 'TIME'
}

/** All available measure units */
export enum CounterMeasureUnitEnum {
  Centimeter = 'CENTIMETER',
  Foot = 'FOOT',
  Gram = 'GRAM',
  Hour = 'HOUR',
  Kilogram = 'KILOGRAM',
  Kilometer = 'KILOMETER',
  KilowattHour = 'KILOWATT_HOUR',
  Meter = 'METER',
  Mile = 'MILE',
  Minute = 'MINUTE',
  Piece = 'PIECE',
  Second = 'SECOND',
  Ton = 'TON',
  Yard = 'YARD'
}

/** Description from base input object. Please set your description for child object. */
export type CounterResetToZeroInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter sorts */
export type CounterSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Latest index value */
  latestIndex?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterUpdateInput = {
  /** Counter ID */
  assetId: Scalars['ID']['input'];
  /** Update attributes */
  attributes: CounterUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter attributes */
export type CounterUpdateInputObject = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available countries */
export enum CountryEnum {
  /** Andorra */
  Ad = 'AD',
  /** Albania */
  Al = 'AL',
  /** Austria */
  At = 'AT',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Belgium */
  Be = 'BE',
  /** Bulgaria */
  Bg = 'BG',
  /** Canada */
  Ca = 'CA',
  /** Switzerland */
  Ch = 'CH',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Denmark */
  Dk = 'DK',
  /** Estonia */
  Ee = 'EE',
  /** Spain */
  Es = 'ES',
  /** Finland */
  Fi = 'FI',
  /** France */
  Fr = 'FR',
  /** United Kingdom */
  Gb = 'GB',
  /** Greenland */
  Gl = 'GL',
  /** Greece */
  Gr = 'GR',
  /** Croatia */
  Hr = 'HR',
  /** Hungary */
  Hu = 'HU',
  /** Ireland */
  Ie = 'IE',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** North Macedonia */
  Mk = 'MK',
  /** Malta */
  Mt = 'MT',
  /** Mexico */
  Mx = 'MX',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Portugal */
  Pt = 'PT',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Sweden */
  Se = 'SE',
  /** Slovenia */
  Si = 'SI',
  /** Slovakia */
  Sk = 'SK',
  /** San Marino */
  Sm = 'SM',
  /** Ukraine */
  Ua = 'UA',
  /** United States of America */
  Us = 'US',
  /** Vatican City */
  Va = 'VA'
}

/** Data Import entity */
export type DataImport = TimestampInterface & {
  __typename?: 'DataImport';
  /** Attachment to import */
  attachmentAttached: Maybe<Attachment>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Failure error details */
  failureDetails: Maybe<Scalars['CamelizedJson']['output']>;
  /** File exception (use when failureDetails is empty and there is a file exception) */
  fileException: Maybe<Array<Scalars['String']['output']>>;
  /** Data Import ID */
  id: Scalars['ID']['output'];
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors: Scalars['Boolean']['output'];
  /** Imported rows */
  importedRows: Maybe<Scalars['Int']['output']>;
  /** Job ID */
  jid: Maybe<Scalars['String']['output']>;
  /** Job entity */
  job: Maybe<Job>;
  /** Kind of import */
  kind: DataImportKindEnum;
  /** Current status */
  status: DataImportStatusEnum;
  /** Total rows to import */
  totalRows: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Created by User
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: User;
  /** Created by User ID */
  userId: Scalars['ID']['output'];
};

/** DataImportCollection type */
export type DataImportCollection = {
  __typename?: 'DataImportCollection';
  /** A collection of paginated DataImportCollection */
  collection: Array<DataImport>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportCreateInput = {
  /** Create attributes */
  attributes: DataImportCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Data Import attributes */
export type DataImportCreateInputObject = {
  /** Attachment to import */
  attachmentAttached: AttachmentCuInputObject;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Kind of import */
  kind: DataImportKindEnum;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import filters */
export type DataImportFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterInputObject>;
  /** Data Import ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind of import */
  kind?: InputMaybe<FilterInputObject>;
};

/** Available data import kinds */
export enum DataImportKindEnum {
  Asset = 'ASSET',
  Site = 'SITE',
  SiteArea = 'SITE_AREA'
}

/** Data Import sorts */
export type DataImportSortInputObject = {
  /** Attachment filename */
  attachmentFilename?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Kind of import */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  userFullName?: InputMaybe<SortDirectionEnum>;
};

/** Available data import statuses */
export enum DataImportStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Retrying again (after failure) */
  Retrying = 'RETRYING',
  /** Stopped */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Description from base input object. Please set your description for child object. */
export type DataImportUpdateInput = {
  /** Update attributes */
  attributes: DataImportUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import attributes */
export type DataImportUpdateInputObject = {
  /** Attachment to import */
  attachmentAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Date range attributes */
export type DateRangeInputObject = {
  /** End date */
  endDate: Scalars['ISO8601Date']['input'];
  /** Start date */
  startDate: Scalars['ISO8601Date']['input'];
};

/** Documentation entity */
export type Documentation = TimestampInterface & {
  __typename?: 'Documentation';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Asset;
  /** Asset ID */
  assetId: Scalars['ID']['output'];
  /** File */
  attachmentAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: User;
  /** User ID */
  createdById: Scalars['ID']['output'];
  /** Documentation ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Tags collection */
  tags: Array<Tag>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Create attributes */
  attributes: Array<DocumentationCreateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkDestroyInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** DocumentationCollection type */
export type DocumentationCollection = {
  __typename?: 'DocumentationCollection';
  /** A collection of paginated DocumentationCollection */
  collection: Array<Documentation>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Documentation attributes */
export type DocumentationCreateInputObject = {
  /** File */
  attachmentAttached: AttachmentCuInputObject;
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Documentation filters */
export type DocumentationFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Tag name */
  tagsName?: InputMaybe<FilterInputObject>;
};

/** Documentation sorts */
export type DocumentationSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationUpdateInput = {
  /** Documentation ID */
  assetId: Scalars['ID']['input'];
  /** Update attributes */
  attributes: DocumentationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  id: Scalars['ID']['input'];
};

/** Documentation attributes */
export type DocumentationUpdateInputObject = {
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

/** Fake DNS record entity (non-production only) */
export type FakeDnsRecord = TimestampInterface & {
  __typename?: 'FakeDnsRecord';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Fake DNS record ID */
  id: Scalars['ID']['output'];
  /** DNS record type */
  recordType: FakeDnsRecordTypeEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Record value */
  value: Maybe<Scalars['String']['output']>;
};

/** FakeDnsRecordCollection type */
export type FakeDnsRecordCollection = {
  __typename?: 'FakeDnsRecordCollection';
  /** A collection of paginated FakeDnsRecordCollection */
  collection: Array<FakeDnsRecord>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordCreateInput = {
  /** Create attributes */
  attributes: FakeDnsRecordCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordCreateInputObject = {
  /** Domain name */
  domain: Scalars['String']['input'];
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Available fake DNS record types (non-production only) */
export enum FakeDnsRecordTypeEnum {
  /** A record */
  A = 'A',
  /** CNAME record */
  Cname = 'CNAME',
  /** MX record */
  Mx = 'MX',
  /** TXT record */
  Txt = 'TXT'
}

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordUpdateInput = {
  /** Update attributes */
  attributes: FakeDnsRecordUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordUpdateInputObject = {
  /** Domain name */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset entity */
export type FeFilterPreset = TimestampInterface & {
  __typename?: 'FeFilterPreset';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Untyped data in any format that frontend will understand. */
  data: Scalars['JSON']['output'];
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities: FeFilterPresetEntities;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FeFilterPresetCollection type */
export type FeFilterPresetCollection = {
  __typename?: 'FeFilterPresetCollection';
  /** A collection of paginated FeFilterPresetCollection */
  collection: Array<FeFilterPreset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetCreateInput = {
  /** Create attributes */
  attributes: FeFilterPresetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetCreateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Kind */
  kind: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset Entities entity */
export type FeFilterPresetEntities = {
  __typename?: 'FeFilterPresetEntities';
  /** Form Categories collection */
  formCategories: Maybe<Array<FeFilterPresetEntity>>;
  /** Form Templates collection */
  formTemplates: Maybe<Array<FeFilterPresetEntity>>;
  /** Sectors collection */
  sectors: Maybe<Array<FeFilterPresetEntity>>;
  /** Sites collection */
  sites: Maybe<Array<FeFilterPresetEntity>>;
};

/** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
export type FeFilterPresetEntitiesInputObject = {
  /** Form Categories attributes array */
  formCategories?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Form Templates attributes array */
  formTemplates?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sectors attributes array */
  sectors?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sites attributes array */
  sites?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
};

/** Frontend Filter Preset Entity entity */
export type FeFilterPresetEntity = {
  __typename?: 'FeFilterPresetEntity';
  /** Entity ID */
  id: Scalars['ID']['output'];
};

/** Entity attributes */
export type FeFilterPresetEntityInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset filters */
export type FeFilterPresetFilterInputObject = {
  /** Frontend Filter Preset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind */
  kind?: InputMaybe<FilterInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Frontend Filter Preset sorts */
export type FeFilterPresetSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetUpdateInput = {
  /** Update attributes */
  attributes: FeFilterPresetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetUpdateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterDateInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterDatePredicateInputObject;
};

/** Filters */
export type FilterDatePredicateInputObject = {
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Determines if result must be matched with all filters ('and') or any of them ('or') */
export enum FilterGroupingEnum {
  /** All */
  And = 'and',
  /** Any */
  Or = 'or'
}

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIdInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIdPredicateInputObject;
};

/** Filters */
export type FilterIdPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterPredicateInputObject;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIntInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIntPredicateInputObject;
};

/** Filters */
export type FilterIntPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters */
export type FilterPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains (ILIKE %value%) */
  cont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all (ILIKE %all values%) */
  contAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any (ILIKE %any value%) */
  contAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match (NOT ILIKE value) */
  doesNotMatch?: InputMaybe<Scalars['String']['input']>;
  /** Does not match all (NOT ILIKE all values) */
  doesNotMatchAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match any (NOT ILIKE any value) */
  doesNotMatchAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with (ILIKE %value) */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Ends with all (ILIKE %all values) */
  endAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with any (ILIKE %any value) */
  endAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** false */
  false?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains value with case insensitive */
  iCont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all values with case insensitive */
  iContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any value with case insensitive */
  iContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches (ILIKE value) */
  matches?: InputMaybe<Scalars['String']['input']>;
  /** Matches all (ILIKE all values) */
  matchesAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any (ILIKE any value) */
  matchesAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain (NOT ILIKE %value%) */
  notCont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all (NOT ILIKE %all values%) */
  notContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any (NOT ILIKE %any value%) */
  notContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with (NOT ILIKE %value) */
  notEnd?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with all (NOT ILIKE %all values) */
  notEndAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with any (NOT ILIKE %any value) */
  notEndAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain value with case insensitive */
  notICont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all values with case insensitive */
  notIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any value with case insensitive */
  notIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does not start with (NOT ILIKE value%) */
  notStart?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with all (NOT ILIKE all values%) */
  notStartAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not start with any (NOT ILIKE any value%) */
  notStartAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
  /** Starts with (ILIKE value%) */
  start?: InputMaybe<Scalars['String']['input']>;
  /** Starts with all (ILIKE all values%) */
  startAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Starts with any (ILIKE any value%) */
  startAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** true */
  true?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Answer entity */
export type FormAnswer = TimestampInterface & {
  __typename?: 'FormAnswer';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Template Question Field */
  field: FormTemplateQuestionField;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Form Answer ID */
  id: Scalars['ID']['output'];
  /** Form Template Question Field kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template Question description */
  questionDescription: Maybe<Scalars['String']['output']>;
  /** Form Template Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template Question name */
  questionName: Maybe<Scalars['String']['output']>;
  /** Response object to a Form Answer */
  resp: Array<FormAnswerResp>;
  /** Task Completion ID */
  taskCompletionId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if response is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Form Answer attributes */
export type FormAnswerCreateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['input'];
  /** Form Template Question ID */
  questionId: Scalars['ID']['input'];
  /** Response object */
  resp?: InputMaybe<Array<FormAnswerRespInputObject>>;
};

/** Response type */
export type FormAnswerResp = {
  __typename?: 'FormAnswerResp';
  /** Group */
  group: Maybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if option is selected */
  selected: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates if option is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Value */
  value: Maybe<Scalars['String']['output']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId: Maybe<Scalars['ID']['output']>;
};

/** All available form answer response groups */
export enum FormAnswerRespGroupEnum {
  EndDate = 'END_DATE',
  EndTime = 'END_TIME',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  StartDate = 'START_DATE',
  StartTime = 'START_TIME',
  Yes = 'YES'
}

/** Response object */
export type FormAnswerRespInputObject = {
  /** Group */
  group?: InputMaybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates if option is selected */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Form Category entity */
export type FormCategory = TimestampInterface & {
  __typename?: 'FormCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Templates collection */
  formTemplates: FormTemplateCollection;
  /** Number of form templates */
  formTemplatesCount: Scalars['Int']['output'];
  /** Form Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Form Category entity */
export type FormCategoryFormTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** FormCategoryCollection type */
export type FormCategoryCollection = {
  __typename?: 'FormCategoryCollection';
  /** A collection of paginated FormCategoryCollection */
  collection: Array<FormCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryCreateInput = {
  /** Create attributes */
  attributes: FormCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Category attributes */
export type FormCategoryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category filters */
export type FormCategoryFilterInputObject = {
  /** Form Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Category sorts */
export type FormCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Number of form templates in this category */
  formTemplatesCount?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryUpdateInput = {
  /** Update attributes */
  attributes: FormCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category attributes */
export type FormCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template entity */
export type FormChecklistTemplate = TimestampInterface & {
  __typename?: 'FormChecklistTemplate';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Form Checklist Template Options collection */
  options: Array<FormChecklistTemplateOption>;
  /** Number of options */
  optionsCount: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FormChecklistTemplateCollection type */
export type FormChecklistTemplateCollection = {
  __typename?: 'FormChecklistTemplateCollection';
  /** A collection of paginated FormChecklistTemplateCollection */
  collection: Array<FormChecklistTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateCreateInput = {
  /** Create attributes */
  attributes: FormChecklistTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateCreateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template filters */
export type FormChecklistTemplateFilterInputObject = {
  /** Form Checklist Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Checklist Template Option entity */
export type FormChecklistTemplateOption = TimestampInterface & {
  __typename?: 'FormChecklistTemplateOption';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Checklist Template Option ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

/** Form Checklist Template Option attributes */
export type FormChecklistTemplateOptionUpdateInputObject = {
  /** Form Checklist Template Option ID (to update existing option pass ID. To create new option do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Value */
  value: Scalars['String']['input'];
};

/** Form Checklist Template sorts */
export type FormChecklistTemplateSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of options */
  optionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormChecklistTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateUpdateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Form Template entity */
export type FormTemplate = TimestampInterface & {
  __typename?: 'FormTemplate';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Form Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<FormCategory>;
  /** Form Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Latest Form Template Version entity */
  currentVersion: Maybe<FormTemplateVersion>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of versions */
  versionsCount: Scalars['Int']['output'];
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** FormTemplateCollection type */
export type FormTemplateCollection = {
  __typename?: 'FormTemplateCollection';
  /** A collection of paginated FormTemplateCollection */
  collection: Array<FormTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateCreateInput = {
  /** Create attributes */
  attributes: FormTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template attributes */
export type FormTemplateCreateInputObject = {
  /** Form Category ID */
  categoryId: Scalars['ID']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Version */
  version: FormTemplateVersionCuInputObject;
};

/** Form Template filters */
export type FormTemplateFilterInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Form Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Question entity */
export type FormTemplateQuestion = TimestampInterface & {
  __typename?: 'FormTemplateQuestion';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Related Form Question Fields */
  fields: Array<FormTemplateQuestionField>;
  /** Form Question ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Form Question Field entity */
export type FormTemplateQuestionField = TimestampInterface & {
  __typename?: 'FormTemplateQuestionField';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Related Form Question Field Options */
  options: Array<FormTemplateQuestionFieldOption>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['output'];
  /** Field settings */
  settings: FormTemplateQuestionFieldSettings;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Validity hint config
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHintConfig: Array<FormTemplateQuestionFieldValidityHintConfig>;
};

/** Form Question Field Option entity */
export type FormTemplateQuestionFieldOption = TimestampInterface & {
  __typename?: 'FormTemplateQuestionFieldOption';
  /**
   * Condition
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  condition: Maybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Group */
  group: Maybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if option will have expected result after user input in answers
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Array of values which will be used to validate user input or to display in the form (depends on the kind of the field) */
  values: Array<Scalars['String']['output']>;
};

/** All available form template question field option conditions */
export enum FormTemplateQuestionFieldOptionConditionEnum {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  NotEqual = 'NOT_EQUAL'
}

/** All available form template question field option groups */
export enum FormTemplateQuestionFieldOptionGroupEnum {
  Columns = 'COLUMNS',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  Rows = 'ROWS',
  Yes = 'YES'
}

/** Form Question Field Option attributes */
export type FormTemplateQuestionFieldOptionUpdateInputObject = {
  /** Condition */
  condition?: InputMaybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Group */
  group?: InputMaybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if option will have expected result after user input in answers */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Values */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** All available form template question field option validity hints */
export enum FormTemplateQuestionFieldOptionsValidityHintEnum {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** Field settings */
export type FormTemplateQuestionFieldSettings = {
  __typename?: 'FormTemplateQuestionFieldSettings';
  /** Indicates if field should display last response for the same question */
  allowDisplayLastAnswer: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow: Maybe<Scalars['Boolean']['output']>;
};

/** Field settings */
export type FormTemplateQuestionFieldSettingsInputObject = {
  /** Allow display last answer */
  allowDisplayLastAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Question Field attributes */
export type FormTemplateQuestionFieldUpdateInputObject = {
  /** Form Question Field ID (to update existing field pass ID. To create new field do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Form Question Field Options attributes array */
  options?: InputMaybe<Array<FormTemplateQuestionFieldOptionUpdateInputObject>>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['input'];
  /** Field settings */
  settings?: InputMaybe<FormTemplateQuestionFieldSettingsInputObject>;
  /** Validity hint config */
  validityHintConfig?: InputMaybe<Array<FormTemplateQuestionFieldValidityHintConfigInputObject>>;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfig = {
  __typename?: 'FormTemplateQuestionFieldValidityHintConfig';
  /** Option positions */
  optionPositions: Array<Scalars['Int']['output']>;
  /** Validity hint */
  validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfigInputObject = {
  /** Option positions */
  optionPositions: Array<Scalars['Int']['input']>;
  /** Validity hint */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Available form template question field kinds */
export enum FormTemplateQuestionFieldsKindEnum {
  /** Attachment */
  Attachment = 'ATTACHMENT',
  /** Multi select */
  Checkbox = 'CHECKBOX',
  /** Checkbox grid in table */
  CheckboxButtonGrid = 'CHECKBOX_BUTTON_GRID',
  /** Checklist */
  Checklist = 'CHECKLIST',
  /** Date */
  Date = 'DATE',
  /** Date and time */
  Datetime = 'DATETIME',
  /** Date range */
  DateRange = 'DATE_RANGE',
  /** Decision box */
  DecisionBox = 'DECISION_BOX',
  /** Important notice */
  ImportantNotice = 'IMPORTANT_NOTICE',
  /** Single line text */
  Input = 'INPUT',
  /** Numeric range */
  MinMax = 'MIN_MAX',
  /** Numeric */
  NumberInput = 'NUMBER_INPUT',
  /** Single select */
  RadioButton = 'RADIO_BUTTON',
  /** Rating */
  Rating = 'RATING',
  /** Section */
  Section = 'SECTION',
  /** Dropdown */
  SingleSelect = 'SINGLE_SELECT',
  /** Multi line text */
  TextArea = 'TEXT_AREA',
  /** Time */
  Time = 'TIME',
  /** Time range */
  TimeRange = 'TIME_RANGE',
  /** Yes/no */
  YesNo = 'YES_NO'
}

/** Form Question attributes */
export type FormTemplateQuestionUpdateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Form Question Fields attributes array */
  fields: Array<FormTemplateQuestionFieldUpdateInputObject>;
  /** Form Question ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
};

/** Available form template scope names */
export enum FormTemplateScopeNameEnum {
  /** Active form templates */
  Active = 'ACTIVE',
  /** Archived form templates */
  Archived = 'ARCHIVED'
}

/** Form Template sorts */
export type FormTemplateSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of versions */
  versionsCount?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  id: Scalars['ID']['input'];
};

/** Form Template attributes */
export type FormTemplateUpdateInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template Version entity */
export type FormTemplateVersion = TimestampInterface & {
  __typename?: 'FormTemplateVersion';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Related Form Questions */
  questions: Array<FormTemplateQuestion>;
  /** Status (Virtual field) */
  status: FormTemplateVersionStatusEnum;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Version */
  version: Maybe<Scalars['String']['output']>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** FormTemplateVersionCollection type */
export type FormTemplateVersionCollection = {
  __typename?: 'FormTemplateVersionCollection';
  /** A collection of paginated FormTemplateVersionCollection */
  collection: Array<FormTemplateVersion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionCreateInput = {
  /** Create attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
};

/** Form Template Version attributes */
export type FormTemplateVersionCuInputObject = {
  /** Form Template Questions attributes array */
  questions: Array<FormTemplateQuestionUpdateInputObject>;
  /** Task IDs to link */
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version filters */
export type FormTemplateVersionFilterInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<FilterDateInputObject>;
  /** Version */
  version?: InputMaybe<FilterIntInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version sorts */
export type FormTemplateVersionSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Version */
  version?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Available form template version statuses */
export enum FormTemplateVersionStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Unused = 'UNUSED'
}

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Country */
export type GeoCountry = {
  __typename?: 'GeoCountry';
  /** Country code */
  code: Scalars['String']['output'];
  /** Country name */
  name: Scalars['String']['output'];
};

/** GeoJSON Feature entity */
export type GeojsonFeature = {
  __typename?: 'GeojsonFeature';
  /** Feature geometry */
  geometry: GeojsonGeometry;
  /** Feature properties */
  properties: Maybe<GeojsonProperties>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** GeoJSON Feature Collection entity */
export type GeojsonFeatureCollection = {
  __typename?: 'GeojsonFeatureCollection';
  /** Features collection */
  features: Array<GeojsonFeature>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** GeoJSON Feature Collection input */
export type GeojsonFeatureCollectionInputObject = {
  /** Features collection */
  features: Array<GeojsonFeatureInputObject>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** Available GeoJSON feature collection types */
export enum GeojsonFeatureCollectionTypeEnum {
  /** Feature Collection */
  FeatureCollection = 'FeatureCollection'
}

/** GeoJSON Feature input */
export type GeojsonFeatureInputObject = {
  /** Feature geometry */
  geometry: GeojsonGeometryInputObject;
  /** Feature properties */
  properties?: InputMaybe<GeojsonPropertiesInputObject>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** Available GeoJSON feature types */
export enum GeojsonFeatureTypeEnum {
  /** Feature */
  Feature = 'Feature'
}

/** GeoJSON Geometry entity */
export type GeojsonGeometry = {
  __typename?: 'GeojsonGeometry';
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['output'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** GeoJSON Geometry input */
export type GeojsonGeometryInputObject = {
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['input'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** Available GeoJSON geometry types */
export enum GeojsonGeometryTypeEnum {
  /** Point */
  Point = 'Point',
  /** Polygon */
  Polygon = 'Polygon'
}

/** GeoJSON Properties entity */
export type GeojsonProperties = {
  __typename?: 'GeojsonProperties';
  /** Address (exact address that syncs with the coordinates) */
  address: Maybe<Scalars['String']['output']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<Scalars['String']['output']>;
  /** Icon */
  icon: Maybe<Scalars['String']['output']>;
  /** ID (must be used by FE to recognize the same object on the map if it is returned multiple times during multiple requests) */
  id: Maybe<Scalars['String']['output']>;
  /** Point count (number of points in the cluster) */
  pointCount: Maybe<Scalars['Int']['output']>;
  /** Shape */
  shape: Maybe<Scalars['String']['output']>;
  /** Sourceables Collection. A set of unique object classes and identifiers associated with the cluster. This indicates that the cluster contains defined locations for each of these objects. */
  sourceables: Maybe<Array<GeojsonPropertiesPolymorphicIdentity>>;
  /** Type (cluster, polygon, point, line, etc.). Must be used by FE to identify the type of the feature and to render it correctly. */
  type: Maybe<GeojsonPropertiesTypeEnum>;
};

/** GeoJSON Properties input */
export type GeojsonPropertiesInputObject = {
  /** Address (exact address that syncs with the coordinates) */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Shape */
  shape?: InputMaybe<Scalars['String']['input']>;
};

/** Polymorphic identity entity */
export type GeojsonPropertiesPolymorphicIdentity = {
  __typename?: 'GeojsonPropertiesPolymorphicIdentity';
  /** ID */
  id: Scalars['ID']['output'];
  /** Type (Class name) */
  type: GeojsonPropertiesPolymorphicIdentityTypeEnum;
};

/** Available GeoJSON properties polymorphic identity types */
export enum GeojsonPropertiesPolymorphicIdentityTypeEnum {
  /** Sector */
  Sector = 'SECTOR',
  /** Site */
  Site = 'SITE'
}

/** Available GeoJSON properties types */
export enum GeojsonPropertiesTypeEnum {
  /** Cluster */
  Cluster = 'CLUSTER',
  /** Line */
  Line = 'LINE',
  /** Point */
  Point = 'POINT',
  /** Polygon */
  Polygon = 'POLYGON'
}

/** History entity */
export type History = {
  __typename?: 'History';
  /** Diff data */
  data: Maybe<HistoryDataUnion>;
  /** History ID */
  id: Scalars['ID']['output'];
  /** Kind of operation */
  kind: HistoryKindEnum;
  /** Metadata */
  metadata: Maybe<HistoryMetadataUnion>;
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if operation was done by the Datizy system */
  system: Maybe<Scalars['Boolean']['output']>;
  /**
   * User entity who made the operation
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** User ID who made the operation */
  userId: Maybe<Scalars['ID']['output']>;
};

/** HistoryCollection type */
export type HistoryCollection = {
  __typename?: 'HistoryCollection';
  /** A collection of paginated HistoryCollection */
  collection: Array<History>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** History data */
export type HistoryDataUnion = InterventionActionHistoryData;

/** Available intervention action history metadata reasons */
export enum HistoryInterventionActionHistoryMetadataReasonEnum {
  /** When intervention was closed */
  InterventionClosed = 'INTERVENTION_CLOSED'
}

/** Available history kinds */
export enum HistoryKindEnum {
  /** Created action */
  Created = 'CREATED',
  /** Updated action */
  Updated = 'UPDATED'
}

/** History metadata */
export type HistoryMetadataUnion = InterventionActionHistoryMetadata;

/** History sorts */
export type HistorySortInputObject = {
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt?: InputMaybe<SortDirectionEnum>;
};

/** Available source types */
export enum HistorySourceableTypeEnum {
  /** Intervention Action entity */
  InterventionAction = 'INTERVENTION_ACTION'
}

/** Home Page entity */
export type HomePage = TimestampInterface & {
  __typename?: 'HomePage';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Home Page ID */
  id: Scalars['ID']['output'];
  /** Indicates if Home Page is default */
  isDefault: Scalars['Boolean']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID */
  userId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type HomePageBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<HomePageUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** HomePageCollection type */
export type HomePageCollection = {
  __typename?: 'HomePageCollection';
  /** A collection of paginated HomePageCollection */
  collection: Array<HomePage>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Home Page attributes */
export type HomePageUpdateInputObject = {
  /** Destroy home page (if true, home page will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Industry entity */
export type Industry = TimestampInterface & {
  __typename?: 'Industry';
  /** Color */
  color: Scalars['String']['output'];
  /** Companies */
  companies: CompanyCollection;
  /** Number of companies in this industry */
  companiesCount: Scalars['Int']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Industry ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Industry entity */
export type IndustryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** IndustryCollection type */
export type IndustryCollection = {
  __typename?: 'IndustryCollection';
  /** A collection of paginated IndustryCollection */
  collection: Array<Industry>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryCreateInput = {
  /** Create attributes */
  attributes: IndustryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Industry attributes */
export type IndustryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type IndustryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry filters */
export type IndustryFilterInputObject = {
  /** Industry name */
  name?: InputMaybe<FilterInputObject>;
};

/** Industry sorts */
export type IndustrySortInputObject = {
  /** Number of companies in this industry */
  companiesCount?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryUpdateInput = {
  /** Update attributes */
  attributes: IndustryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry attributes */
export type IndustryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention entity */
export type Intervention = TimestampInterface & {
  __typename?: 'Intervention';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canClose: AuthorizationResult;
  canCreate: AuthorizationResult;
  canCreateAction: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Intervention Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<InterventionCategory>;
  /** Intervention Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention ID */
  id: Scalars['ID']['output'];
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: InterventionStatusEnum;
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the supervisorId field to reduce the load on the database.
   */
  supervisor: Maybe<User>;
  /** User ID */
  supervisorId: Maybe<Scalars['ID']['output']>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  taskGroupKey: Maybe<Scalars['ID']['output']>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Total duration time (in minutes) (intervention.duration_time + SUM(intervention_actions.duration_time)) */
  totalDurationTime: Maybe<Scalars['Int']['output']>;
  /** Total estimated time (in minutes) (intervention.estimated_time + SUM(intervention_actions.estimated_time)) */
  totalEstimatedTime: Maybe<Scalars['Int']['output']>;
  /** Total logistic time (in minutes) (intervention.logistic_time + SUM(intervention_actions.logistic_time)) */
  totalLogisticTime: Maybe<Scalars['Int']['output']>;
  /** Total duration time + Total logistic time */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Intervention Action entity */
export type InterventionAction = TimestampInterface & {
  __typename?: 'InterventionAction';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention Action ID */
  id: Scalars['ID']['output'];
  /** Intervention ID */
  interventionId: Maybe<Scalars['ID']['output']>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Test */
  text: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** InterventionActionCollection type */
export type InterventionActionCollection = {
  __typename?: 'InterventionActionCollection';
  /** A collection of paginated InterventionActionCollection */
  collection: Array<InterventionAction>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionCreateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionActionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create attributes */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionCreateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Text */
  text: Scalars['String']['input'];
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
};

/** Intervention Action filters */
export type InterventionActionFilterInputObject = {
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Mentioned users in text field */
  textMentionsUsersId?: InputMaybe<FilterIdInputObject>;
};

/** Intervention Action entity */
export type InterventionActionHistoryData = {
  __typename?: 'InterventionActionHistoryData';
  /** Duration time (in minutes) */
  durationTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Estimated date */
  estimatedDate: Maybe<Array<Maybe<Scalars['ISO8601Date']['output']>>>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Status */
  status: Maybe<Array<InterventionActionStatusEnum>>;
};

/** Intervention Action History Metadata entity */
export type InterventionActionHistoryMetadata = {
  __typename?: 'InterventionActionHistoryMetadata';
  /** Reason */
  reason: Maybe<HistoryInterventionActionHistoryMetadataReasonEnum>;
};

/** Intervention Action sorts */
export type InterventionActionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention action statuses */
export enum InterventionActionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionActionUpdateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionActionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status?: InputMaybe<InterventionActionStatusEnum>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionBulkCloseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Intervention Category entity */
export type InterventionCategory = TimestampInterface & {
  __typename?: 'InterventionCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Intervention Category ID */
  id: Scalars['ID']['output'];
  /** Intervention collection */
  interventions: InterventionCollection;
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Interventions */
  visibleInterventionsCount: Scalars['Int']['output'];
};


/** Intervention Category entity */
export type InterventionCategoryInterventionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** InterventionCategoryCollection type */
export type InterventionCategoryCollection = {
  __typename?: 'InterventionCategoryCollection';
  /** A collection of paginated InterventionCategoryCollection */
  collection: Array<InterventionCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryCreateInput = {
  /** Create attributes */
  attributes: InterventionCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention Category attributes */
export type InterventionCategoryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category filters */
export type InterventionCategoryFilterInputObject = {
  /** Intervention ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Intervention Category sorts */
export type InterventionCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Interventions in this category */
  visibleInterventionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryUpdateInput = {
  /** Update attributes */
  attributes: InterventionCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category attributes */
export type InterventionCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** InterventionCollection type */
export type InterventionCollection = {
  __typename?: 'InterventionCollection';
  /** A collection of paginated InterventionCollection */
  collection: Array<Intervention>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCreateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention attributes */
export type InterventionCreateInputObject = {
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description: Scalars['String']['input'];
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
  /** Status */
  status: InterventionStatusEnum;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Task ID */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention filters */
export type InterventionFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Code */
  code?: InputMaybe<FilterInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Status */
  status?: InputMaybe<FilterIntInputObject>;
  /** Task group key */
  taskGroupKey?: InputMaybe<FilterIdInputObject>;
};

/** Available intervention priorities */
export enum InterventionPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Available intervention scope names */
export enum InterventionScopeNameEnum {
  /** All */
  All = 'ALL',
  /** Closed interventions */
  Closed = 'CLOSED',
  /** Opened interventions */
  Opened = 'OPENED',
  /** Opened interventions where user is participant (creator, supervisor, assignee, action creator, action assignee or mentioned in comments) */
  OpenedMyParticipation = 'OPENED_MY_PARTICIPATION'
}

/** Intervention sorts */
export type InterventionSortInputObject = {
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Intervention Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Closed at */
  closedAt?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention statuses */
export enum InterventionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionUpdateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention attributes */
export type InterventionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<InterventionPriorityEnum>;
  /** Status */
  status?: InputMaybe<InterventionStatusEnum>;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Job entity */
export type Job = {
  __typename?: 'Job';
  /** Number of the object currently being processed */
  at: Maybe<Scalars['Int']['output']>;
  canCancel: AuthorizationResult;
  canCreateDeliveryRequest: AuthorizationResult;
  canRetry: AuthorizationResult;
  /** Indicates if delivery request was requested */
  deliveryRequest: Maybe<Scalars['Boolean']['output']>;
  /** Estimated time of completion (in seconds) */
  eta: Maybe<Scalars['Float']['output']>;
  /** Job ID */
  jid: Maybe<Scalars['String']['output']>;
  /** Worker kind */
  kind: Maybe<JobKindEnum>;
  /** Current progress message */
  message: Maybe<Scalars['String']['output']>;
  /** Payload */
  payload: Maybe<Scalars['JSON']['output']>;
  /** Percentage of completion */
  pctComplete: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: Maybe<JobStatusEnum>;
  /** Indicates if stop was requested */
  stop: Maybe<Scalars['Boolean']['output']>;
  /** Total number of objects to be processed */
  total: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updateTime: Maybe<Scalars['Int']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type JobCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Job ID */
  jid: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type JobCreateDeliveryRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Job ID */
  jid: Scalars['String']['input'];
};

/** Available job kinds */
export enum JobKindEnum {
  /** Data import */
  DataImport = 'DATA_IMPORT',
  /** QR code generation */
  QrCodeGeneration = 'QR_CODE_GENERATION',
  /** Timeline report generation */
  TimelineReportGeneration = 'TIMELINE_REPORT_GENERATION'
}

/** Description from base input object. Please set your description for child object. */
export type JobRetryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Job ID */
  jid: Scalars['String']['input'];
};

/** Available job statuses */
export enum JobStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Retrying again (after failure) */
  Retrying = 'RETRYING',
  /** Stopped */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Available languages */
export enum LanguageEnum {
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr',
  /** Polish */
  Pl = 'pl',
  /** Romanian */
  Ro = 'ro',
  /** Ukrainian */
  Uk = 'uk'
}

/** Linking attributes */
export type LinkingInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
  /** Unlink entity */
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Location entity */
export type Location = TimestampInterface & {
  __typename?: 'Location';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** GeoJSON */
  geojson: Maybe<GeojsonFeatureCollection>;
  /** Location ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Location attributes */
export type LocationCuInputObject = {
  /** GeoJSON */
  geojson?: InputMaybe<GeojsonFeatureCollectionInputObject>;
};

/** Location filters */
export type LocationFilterInputObject = {
  /** Location kind (site location => point; sector location => boundary) */
  kind?: InputMaybe<FilterInputObject>;
};

/** Location geographical center entity */
export type LocationGeographicalCenter = {
  __typename?: 'LocationGeographicalCenter';
  /** Latitude */
  lat: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  lon: Maybe<Scalars['Float']['output']>;
};

/** Location Map Params input (current visible area on map) */
export type LocationMapParamsInputObject = {
  /** Maximum latitude */
  maxLat: Scalars['Float']['input'];
  /** Maximum longitude */
  maxLon: Scalars['Float']['input'];
  /** Minimum latitude */
  minLat: Scalars['Float']['input'];
  /** Minimum longitude */
  minLon: Scalars['Float']['input'];
  /** Zoom level */
  zoom: Scalars['Int']['input'];
};

/** List of mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Create an ApiToken */
  apiTokenCreate: Maybe<ApiToken>;
  /** Destroy an ApiToken */
  apiTokenDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an ApiToken */
  apiTokenUpdate: Maybe<ApiToken>;
  /** Bulk destroy Assets */
  assetBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Assets in bulk */
  assetBulkQrCodeCreate: Maybe<Job>;
  /** Create an Asset Category */
  assetCategoryCreate: Maybe<AssetCategory>;
  /** Destroy an Asset Category */
  assetCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Asset Category */
  assetCategoryUpdate: Maybe<AssetCategory>;
  /** Create an Asset */
  assetCreate: Maybe<Asset>;
  /** Update an Asset */
  assetUpdate: Maybe<Asset>;
  /** Confirm email changing by token */
  authenticationConfirmationsEmailConfirmation: Whoami;
  /** Confirm registration by token */
  authenticationConfirmationsRegistrationConfirmation: Whoami;
  /** Resend email confirmation email */
  authenticationConfirmationsResendEmailConfirmation: ResponseMessage;
  /** Resend registration confirmation */
  authenticationConfirmationsResendRegistrationConfirmation: ResponseMessage;
  /** Complete password setup for newly created accounts */
  authenticationPasswordSetup: Scalars['Boolean']['output'];
  /** Send password reset instructions */
  authenticationPasswordsForgot: ResponseMessage;
  /** Reset password by token */
  authenticationPasswordsReset: Whoami;
  /** Change or set password. Requires session older than 24 hours and step-up 2FA verification (30-min window). Users with an existing password must provide password_challenge. SSO users without a password can set one without providing password_challenge. */
  authenticationPasswordsUpdate: Whoami;
  /** Resend account locked email */
  authenticationResendAccountLockedEmail: ResponseMessage;
  /** Resend account locked email to another system admin. Requires session older than 24 hours. */
  authenticationResendAccountLockedEmailForAdmin: Scalars['Boolean']['output'];
  /** Restore a locked account by token from email */
  authenticationRestoreAccount: Whoami;
  /** Create a session (aka Login) */
  authenticationSessionCreate: Whoami;
  /** End current session (aka Logout) */
  authenticationSessionEnd: Maybe<Scalars['Boolean']['output']>;
  /** End all sessions for the current user. Requires session older than 24 hours. */
  authenticationSessionEndAll: Scalars['Boolean']['output'];
  /** End a specific session by ID. Requires session older than 24 hours. */
  authenticationSessionEndSpecific: Scalars['Boolean']['output'];
  /** Report current session as suspicious and end all other sessions. Requires session older than 24 hours and step-up 2FA verification (30-min window). */
  authenticationSessionReportSuspicious: Scalars['Boolean']['output'];
  /** Report session as suspicious by token from email */
  authenticationSessionReportSuspiciousByToken: Scalars['Boolean']['output'];
  /** Disable email-based two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableEmailOtp: Scalars['Boolean']['output'];
  /** Disable TOTP (authenticator app) two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableTotp: Scalars['Boolean']['output'];
  /** Enable email-based two-factor authentication by verifying code from email. Requires session older than 24 hours. */
  authenticationTwoFactorEnableEmailOtp: TwoFactorSetupResult;
  /** Enable TOTP by verifying code from authenticator app. Requires session older than 24 hours. */
  authenticationTwoFactorEnableTotp: TwoFactorSetupResult;
  /** Generate new backup codes for two-factor authentication. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorGenerateBackupCodes: TwoFactorBackupCodes;
  /** Resend email OTP code */
  authenticationTwoFactorResendEmailOtp: Scalars['Boolean']['output'];
  /** Reset two-factor authentication for another admin. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorReset: Scalars['Boolean']['output'];
  /** Setup email OTP for two-factor authentication by sending verification code. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupEmailOtp: Scalars['Boolean']['output'];
  /** Setup TOTP (authenticator app) for two-factor authentication. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupTotp: TwoFactorTotpSetup;
  /** Verify two-factor authentication code during login */
  authenticationTwoFactorVerify: Whoami;
  /** Create a Company */
  companyCreate: Maybe<Company>;
  /** Destroy a Company. Requires session older than 24 hours and fresh 2FA verification on every call. */
  companyDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create a Company Domain */
  companyDomainCreate: Maybe<CompanyDomain>;
  /** Destroy a Company Domain */
  companyDomainDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Verify a Company Domain via DNS TXT record */
  companyDomainVerify: Maybe<CompanyDomain>;
  /** Plan change request */
  companyPlanChangeRequest: Maybe<Scalars['Boolean']['output']>;
  /** Update a Company */
  companyUpdate: Maybe<Company>;
  /** Bulk Destroy Counters */
  counterBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Counter in bulk */
  counterBulkQrCodeCreate: Maybe<Job>;
  /** Create a Counter */
  counterCreate: Maybe<Counter>;
  /** Create a Counter Measure */
  counterMeasureCreate: Maybe<CounterMeasure>;
  /** Reset to zero a Counter */
  counterResetToZero: Maybe<Counter>;
  /** Update a Counter */
  counterUpdate: Maybe<Counter>;
  /** Create a Data Import */
  dataImportCreate: Maybe<DataImport>;
  /** Destroy a Data Import */
  dataImportDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Data Import */
  dataImportUpdate: Maybe<DataImport>;
  /** Create a Documentation in bulk */
  documentationBulkCreate: Maybe<Scalars['Boolean']['output']>;
  /** Bulk Destroy Documentations */
  documentationBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Documentation */
  documentationUpdate: Maybe<Documentation>;
  /** Create a fake DNS record (non-production only) */
  fakeDnsRecordCreate: Maybe<FakeDnsRecord>;
  /** Destroy a fake DNS record (non-production only) */
  fakeDnsRecordDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a fake DNS record (non-production only) */
  fakeDnsRecordUpdate: Maybe<FakeDnsRecord>;
  /** Create a Frontend Filter Preset */
  feFilterPresetCreate: Maybe<FeFilterPreset>;
  /** Destroy a Frontend Filter Preset */
  feFilterPresetDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Frontend Filter Preset */
  feFilterPresetUpdate: Maybe<FeFilterPreset>;
  /** Create a Form Category */
  formCategoryCreate: Maybe<FormCategory>;
  /** Destroy a Form Category */
  formCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Category */
  formCategoryUpdate: Maybe<FormCategory>;
  /** Create a Form Checklist Template */
  formChecklistTemplateCreate: Maybe<FormChecklistTemplate>;
  /** Destroy a Form Checklist Template */
  formChecklistTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Checklist Template */
  formChecklistTemplateUpdate: Maybe<FormChecklistTemplate>;
  /** Bulk archive Form Templates */
  formTemplateBulkArchive: Maybe<Scalars['Boolean']['output']>;
  /** Bulk destroy Form Templates */
  formTemplateBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Bulk restore Form Templates */
  formTemplateBulkRestore: Maybe<Scalars['Boolean']['output']>;
  /** Create a Form Template */
  formTemplateCreate: Maybe<FormTemplate>;
  /** Update a Form Template */
  formTemplateUpdate: Maybe<FormTemplate>;
  /** Archive a Form Template Version */
  formTemplateVersionArchive: Maybe<FormTemplateVersion>;
  /** Create a Form Template Version */
  formTemplateVersionCreate: Maybe<FormTemplateVersion>;
  /** Destroy a Form Template Version */
  formTemplateVersionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Restore a Form Template Version */
  formTemplateVersionRestore: Maybe<FormTemplateVersion>;
  /** Update a Form Template Version */
  formTemplateVersionUpdate: Maybe<FormTemplateVersion>;
  /** Bulk update Home Pages */
  homePageBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create an Industry */
  industryCreate: Maybe<Industry>;
  /** Destroy an Industry */
  industryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Industry */
  industryUpdate: Maybe<Industry>;
  /** Create an Intervention Action */
  interventionActionCreate: Maybe<InterventionAction>;
  /** Destroy an Intervention Action */
  interventionActionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Action */
  interventionActionUpdate: Maybe<InterventionAction>;
  /** Bulk close Interventions */
  interventionBulkClose: Maybe<Scalars['Boolean']['output']>;
  /** Create an Intervention Category */
  interventionCategoryCreate: Maybe<InterventionCategory>;
  /** Destroy an Intervention Category */
  interventionCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Category */
  interventionCategoryUpdate: Maybe<InterventionCategory>;
  /** Create an Intervention */
  interventionCreate: Maybe<Intervention>;
  /** Destroy an Intervention */
  interventionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention */
  interventionUpdate: Maybe<Intervention>;
  /** Cancel a Job */
  jobCancel: Maybe<Scalars['Boolean']['output']>;
  /** Create a Delivery Request for a Job */
  jobCreateDeliveryRequest: Maybe<Scalars['Boolean']['output']>;
  /** Retry a Job */
  jobRetry: Maybe<Scalars['Boolean']['output']>;
  /** Bulk Destroy Nomenclatures */
  nomenclatureBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for component assets of Nomenclatures in bulk */
  nomenclatureBulkQrCodeCreate: Maybe<Job>;
  /** Create a Nomenclature */
  nomenclatureCreate: Maybe<Nomenclature>;
  /** Update a Nomenclature */
  nomenclatureUpdate: Maybe<Nomenclature>;
  /** Create a Sector */
  sectorCreate: Maybe<Sector>;
  /** Destroy a Sector */
  sectorDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Sector */
  sectorUpdate: Maybe<Sector>;
  /** Destroy Site Areas in bulk */
  siteAreaBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Site Areas in bulk */
  siteAreaBulkQrCodeCreate: Maybe<Job>;
  /** Update a Site Area */
  siteAreaUpdate: Maybe<SiteArea>;
  /** Create a Site */
  siteCreate: Maybe<Site>;
  /** Destroy a Site */
  siteDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Site */
  siteUpdate: Maybe<Site>;
  /** Activate an SSO integration */
  ssoIntegrationActivate: Maybe<SsoIntegration>;
  /** Create an SSO integration */
  ssoIntegrationCreate: Maybe<SsoIntegration>;
  /** Deactivate an SSO integration */
  ssoIntegrationDeactivate: Maybe<SsoIntegration>;
  /** Destroy an SSO integration */
  ssoIntegrationDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an SSO integration */
  ssoIntegrationUpdate: Maybe<SsoIntegration>;
  /** Create a System Admin */
  systemAdminCreate: Maybe<SystemAdmin>;
  /** Destroy a System Admin. Requires session older than 24 hours. */
  systemAdminDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self System Admin. When changing email, requires session older than 24 hours and step-up 2FA verification (30-min window). */
  systemAdminSelfUpdate: Maybe<SystemAdmin>;
  /** Update a System Admin by other System Admin */
  systemAdminUpdate: Maybe<SystemAdmin>;
  /** Create a User by System Admin */
  systemAdminUserCreate: Maybe<User>;
  /** Create a Tag */
  tagCreate: Maybe<Tag>;
  /** Destroy a Tag */
  tagDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create same Tasks in bulk */
  taskBulkCreateSame: Maybe<Array<Scalars['ID']['output']>>;
  /** Bulk update a Task's Deadline Missed Reason */
  taskBulkDeadlineMissedReasonUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Bulk schedule Tasks */
  taskBulkScheduling: Maybe<Scalars['Boolean']['output']>;
  /** Bulk update a Task's Template Version */
  taskBulkTemplateVersionUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Update Tasks status */
  taskBulkUpdateStatus: Maybe<Scalars['Boolean']['output']>;
  /** Create a Task Completion */
  taskCompletionCreate: Maybe<TaskCompletion>;
  /** Update a Task's Completion status */
  taskCompletionStatusUpdate: Maybe<TaskCompletion>;
  /** Destroy a Task */
  taskDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Generate a Tasks Timeline Report */
  taskTimelineReportCreate: Maybe<Job>;
  /** Update a Task */
  taskUpdate: Maybe<Task>;
  /** Team creation */
  teamCreate: Maybe<Team>;
  /** Team destroy */
  teamDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Team update */
  teamUpdate: Maybe<Team>;
  /** Create a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseCreate: Maybe<TechnicalPause>;
  /** Destroy a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseUpdate: Maybe<TechnicalPause>;
  /** Activate Users in bulk */
  userBulkActivate: Maybe<Scalars['Boolean']['output']>;
  /** Deactivate Users in bulk */
  userBulkDeactivate: Maybe<Scalars['Boolean']['output']>;
  /** Accept the Code of Conduct */
  userCodeOfConductAccept: Maybe<User>;
  /** Create a User */
  userCreate: Maybe<User>;
  /** Destroy a User */
  userDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self User */
  userSelfUpdate: Maybe<User>;
  /** Update a User by other Full Admin/Admin */
  userUpdate: Maybe<User>;
  /** Bulk update Widgets for a Home Page */
  widgetBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create a new Widget Template (only announcement and external_link kinds) */
  widgetTemplateCreate: Maybe<WidgetTemplate>;
  /** Delete a Widget Template (deletes all associated widgets for external_link kind) */
  widgetTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing Widget Template */
  widgetTemplateUpdate: Maybe<WidgetTemplate>;
};


/** List of mutations */
export type MutationApiTokenCreateArgs = {
  input: ApiTokenCreateInput;
};


/** List of mutations */
export type MutationApiTokenDestroyArgs = {
  input: ApiTokenDestroyInput;
};


/** List of mutations */
export type MutationApiTokenUpdateArgs = {
  input: ApiTokenUpdateInput;
};


/** List of mutations */
export type MutationAssetBulkDestroyArgs = {
  input: AssetBulkDestroyInput;
};


/** List of mutations */
export type MutationAssetBulkQrCodeCreateArgs = {
  input: AssetBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryCreateArgs = {
  input: AssetCategoryCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryDestroyArgs = {
  input: AssetCategoryDestroyInput;
};


/** List of mutations */
export type MutationAssetCategoryUpdateArgs = {
  input: AssetCategoryUpdateInput;
};


/** List of mutations */
export type MutationAssetCreateArgs = {
  input: AssetCreateInput;
};


/** List of mutations */
export type MutationAssetUpdateArgs = {
  input: AssetUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsEmailConfirmationArgs = {
  input: AuthenticationConfirmationsEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendEmailConfirmationArgs = {
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordSetupArgs = {
  input: AuthenticationPasswordSetupInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsForgotArgs = {
  input: AuthenticationPasswordsForgotInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsResetArgs = {
  input: AuthenticationPasswordsResetInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsUpdateArgs = {
  input: AuthenticationPasswordsUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailArgs = {
  input: AuthenticationResendAccountLockedEmailInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailForAdminArgs = {
  input: AuthenticationResendAccountLockedEmailForAdminInput;
};


/** List of mutations */
export type MutationAuthenticationRestoreAccountArgs = {
  input: AuthenticationRestoreAccountInput;
};


/** List of mutations */
export type MutationAuthenticationSessionCreateArgs = {
  input: AuthenticationSessionCreateInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndArgs = {
  input: AuthenticationSessionEndInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndAllArgs = {
  input: AuthenticationSessionEndAllInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndSpecificArgs = {
  input: AuthenticationSessionEndSpecificInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousArgs = {
  input: AuthenticationSessionReportSuspiciousInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousByTokenArgs = {
  input: AuthenticationSessionReportSuspiciousByTokenInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableEmailOtpArgs = {
  input: AuthenticationTwoFactorDisableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableTotpArgs = {
  input: AuthenticationTwoFactorDisableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableEmailOtpArgs = {
  input: AuthenticationTwoFactorEnableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableTotpArgs = {
  input: AuthenticationTwoFactorEnableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorGenerateBackupCodesArgs = {
  input: AuthenticationTwoFactorGenerateBackupCodesInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResendEmailOtpArgs = {
  input: AuthenticationTwoFactorResendEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResetArgs = {
  input: AuthenticationTwoFactorResetInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupEmailOtpArgs = {
  input: AuthenticationTwoFactorSetupEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupTotpArgs = {
  input: AuthenticationTwoFactorSetupTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorVerifyArgs = {
  input: AuthenticationTwoFactorVerifyInput;
};


/** List of mutations */
export type MutationCompanyCreateArgs = {
  input: CompanyCreateInput;
};


/** List of mutations */
export type MutationCompanyDestroyArgs = {
  input: CompanyDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainCreateArgs = {
  input: CompanyDomainCreateInput;
};


/** List of mutations */
export type MutationCompanyDomainDestroyArgs = {
  input: CompanyDomainDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainVerifyArgs = {
  input: CompanyDomainVerifyInput;
};


/** List of mutations */
export type MutationCompanyPlanChangeRequestArgs = {
  input: CompanyPlanChangeRequestInput;
};


/** List of mutations */
export type MutationCompanyUpdateArgs = {
  input: CompanyUpdateInput;
};


/** List of mutations */
export type MutationCounterBulkDestroyArgs = {
  input: CounterBulkDestroyInput;
};


/** List of mutations */
export type MutationCounterBulkQrCodeCreateArgs = {
  input: CounterBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationCounterCreateArgs = {
  input: CounterCreateInput;
};


/** List of mutations */
export type MutationCounterMeasureCreateArgs = {
  input: CounterMeasureCreateInput;
};


/** List of mutations */
export type MutationCounterResetToZeroArgs = {
  input: CounterResetToZeroInput;
};


/** List of mutations */
export type MutationCounterUpdateArgs = {
  input: CounterUpdateInput;
};


/** List of mutations */
export type MutationDataImportCreateArgs = {
  input: DataImportCreateInput;
};


/** List of mutations */
export type MutationDataImportDestroyArgs = {
  input: DataImportDestroyInput;
};


/** List of mutations */
export type MutationDataImportUpdateArgs = {
  input: DataImportUpdateInput;
};


/** List of mutations */
export type MutationDocumentationBulkCreateArgs = {
  input: DocumentationBulkCreateInput;
};


/** List of mutations */
export type MutationDocumentationBulkDestroyArgs = {
  input: DocumentationBulkDestroyInput;
};


/** List of mutations */
export type MutationDocumentationUpdateArgs = {
  input: DocumentationUpdateInput;
};


/** List of mutations */
export type MutationFakeDnsRecordCreateArgs = {
  input: FakeDnsRecordCreateInput;
};


/** List of mutations */
export type MutationFakeDnsRecordDestroyArgs = {
  input: FakeDnsRecordDestroyInput;
};


/** List of mutations */
export type MutationFakeDnsRecordUpdateArgs = {
  input: FakeDnsRecordUpdateInput;
};


/** List of mutations */
export type MutationFeFilterPresetCreateArgs = {
  input: FeFilterPresetCreateInput;
};


/** List of mutations */
export type MutationFeFilterPresetDestroyArgs = {
  input: FeFilterPresetDestroyInput;
};


/** List of mutations */
export type MutationFeFilterPresetUpdateArgs = {
  input: FeFilterPresetUpdateInput;
};


/** List of mutations */
export type MutationFormCategoryCreateArgs = {
  input: FormCategoryCreateInput;
};


/** List of mutations */
export type MutationFormCategoryDestroyArgs = {
  input: FormCategoryDestroyInput;
};


/** List of mutations */
export type MutationFormCategoryUpdateArgs = {
  input: FormCategoryUpdateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateCreateArgs = {
  input: FormChecklistTemplateCreateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateDestroyArgs = {
  input: FormChecklistTemplateDestroyInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateUpdateArgs = {
  input: FormChecklistTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateBulkArchiveArgs = {
  input: FormTemplateBulkArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateBulkDestroyArgs = {
  input: FormTemplateBulkDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateBulkRestoreArgs = {
  input: FormTemplateBulkRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateCreateArgs = {
  input: FormTemplateCreateInput;
};


/** List of mutations */
export type MutationFormTemplateUpdateArgs = {
  input: FormTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionArchiveArgs = {
  input: FormTemplateVersionArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateVersionCreateArgs = {
  input: FormTemplateVersionCreateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionDestroyArgs = {
  input: FormTemplateVersionDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateVersionRestoreArgs = {
  input: FormTemplateVersionRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateVersionUpdateArgs = {
  input: FormTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationHomePageBulkUpdateArgs = {
  input: HomePageBulkUpdateInput;
};


/** List of mutations */
export type MutationIndustryCreateArgs = {
  input: IndustryCreateInput;
};


/** List of mutations */
export type MutationIndustryDestroyArgs = {
  input: IndustryDestroyInput;
};


/** List of mutations */
export type MutationIndustryUpdateArgs = {
  input: IndustryUpdateInput;
};


/** List of mutations */
export type MutationInterventionActionCreateArgs = {
  input: InterventionActionCreateInput;
};


/** List of mutations */
export type MutationInterventionActionDestroyArgs = {
  input: InterventionActionDestroyInput;
};


/** List of mutations */
export type MutationInterventionActionUpdateArgs = {
  input: InterventionActionUpdateInput;
};


/** List of mutations */
export type MutationInterventionBulkCloseArgs = {
  input: InterventionBulkCloseInput;
};


/** List of mutations */
export type MutationInterventionCategoryCreateArgs = {
  input: InterventionCategoryCreateInput;
};


/** List of mutations */
export type MutationInterventionCategoryDestroyArgs = {
  input: InterventionCategoryDestroyInput;
};


/** List of mutations */
export type MutationInterventionCategoryUpdateArgs = {
  input: InterventionCategoryUpdateInput;
};


/** List of mutations */
export type MutationInterventionCreateArgs = {
  input: InterventionCreateInput;
};


/** List of mutations */
export type MutationInterventionDestroyArgs = {
  input: InterventionDestroyInput;
};


/** List of mutations */
export type MutationInterventionUpdateArgs = {
  input: InterventionUpdateInput;
};


/** List of mutations */
export type MutationJobCancelArgs = {
  input: JobCancelInput;
};


/** List of mutations */
export type MutationJobCreateDeliveryRequestArgs = {
  input: JobCreateDeliveryRequestInput;
};


/** List of mutations */
export type MutationJobRetryArgs = {
  input: JobRetryInput;
};


/** List of mutations */
export type MutationNomenclatureBulkDestroyArgs = {
  input: NomenclatureBulkDestroyInput;
};


/** List of mutations */
export type MutationNomenclatureBulkQrCodeCreateArgs = {
  input: NomenclatureBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationNomenclatureCreateArgs = {
  input: NomenclatureCreateInput;
};


/** List of mutations */
export type MutationNomenclatureUpdateArgs = {
  input: NomenclatureUpdateInput;
};


/** List of mutations */
export type MutationSectorCreateArgs = {
  input: SectorCreateInput;
};


/** List of mutations */
export type MutationSectorDestroyArgs = {
  input: SectorDestroyInput;
};


/** List of mutations */
export type MutationSectorUpdateArgs = {
  input: SectorUpdateInput;
};


/** List of mutations */
export type MutationSiteAreaBulkDestroyArgs = {
  input: SiteAreaBulkDestroyInput;
};


/** List of mutations */
export type MutationSiteAreaBulkQrCodeCreateArgs = {
  input: SiteAreaBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationSiteAreaUpdateArgs = {
  input: SiteAreaUpdateInput;
};


/** List of mutations */
export type MutationSiteCreateArgs = {
  input: SiteCreateInput;
};


/** List of mutations */
export type MutationSiteDestroyArgs = {
  input: SiteDestroyInput;
};


/** List of mutations */
export type MutationSiteUpdateArgs = {
  input: SiteUpdateInput;
};


/** List of mutations */
export type MutationSsoIntegrationActivateArgs = {
  input: SsoIntegrationActivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationCreateArgs = {
  input: SsoIntegrationCreateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDeactivateArgs = {
  input: SsoIntegrationDeactivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDestroyArgs = {
  input: SsoIntegrationDestroyInput;
};


/** List of mutations */
export type MutationSsoIntegrationUpdateArgs = {
  input: SsoIntegrationUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminCreateArgs = {
  input: SystemAdminCreateInput;
};


/** List of mutations */
export type MutationSystemAdminDestroyArgs = {
  input: SystemAdminDestroyInput;
};


/** List of mutations */
export type MutationSystemAdminSelfUpdateArgs = {
  input: SystemAdminSelfUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUpdateArgs = {
  input: SystemAdminUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUserCreateArgs = {
  input: SystemAdminUserCreateInput;
};


/** List of mutations */
export type MutationTagCreateArgs = {
  input: TagCreateInput;
};


/** List of mutations */
export type MutationTagDestroyArgs = {
  input: TagDestroyInput;
};


/** List of mutations */
export type MutationTaskBulkCreateSameArgs = {
  input: TaskBulkCreateSameInput;
};


/** List of mutations */
export type MutationTaskBulkDeadlineMissedReasonUpdateArgs = {
  input: TaskBulkDeadlineMissedReasonUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkSchedulingArgs = {
  input: TaskBulkSchedulingInput;
};


/** List of mutations */
export type MutationTaskBulkTemplateVersionUpdateArgs = {
  input: TaskBulkTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkUpdateStatusArgs = {
  input: TaskBulkUpdateStatusInput;
};


/** List of mutations */
export type MutationTaskCompletionCreateArgs = {
  input: TaskCompletionCreateInput;
};


/** List of mutations */
export type MutationTaskCompletionStatusUpdateArgs = {
  input: TaskCompletionStatusUpdateInput;
};


/** List of mutations */
export type MutationTaskDestroyArgs = {
  input: TaskDestroyInput;
};


/** List of mutations */
export type MutationTaskTimelineReportCreateArgs = {
  input: TasksTimelineReportCreateInput;
};


/** List of mutations */
export type MutationTaskUpdateArgs = {
  input: TaskUpdateInput;
};


/** List of mutations */
export type MutationTeamCreateArgs = {
  input: TeamCreateInput;
};


/** List of mutations */
export type MutationTeamDestroyArgs = {
  input: TeamDestroyInput;
};


/** List of mutations */
export type MutationTeamUpdateArgs = {
  input: TeamUpdateInput;
};


/** List of mutations */
export type MutationTechnicalPauseCreateArgs = {
  input: TechnicalPauseCreateInput;
};


/** List of mutations */
export type MutationTechnicalPauseDestroyArgs = {
  input: TechnicalPauseDestroyInput;
};


/** List of mutations */
export type MutationTechnicalPauseUpdateArgs = {
  input: TechnicalPauseUpdateInput;
};


/** List of mutations */
export type MutationUserBulkActivateArgs = {
  input: UserBulkActivateInput;
};


/** List of mutations */
export type MutationUserBulkDeactivateArgs = {
  input: UserBulkDeactivateInput;
};


/** List of mutations */
export type MutationUserCodeOfConductAcceptArgs = {
  input: UserCodeOfConductAcceptInput;
};


/** List of mutations */
export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


/** List of mutations */
export type MutationUserDestroyArgs = {
  input: UserDestroyInput;
};


/** List of mutations */
export type MutationUserSelfUpdateArgs = {
  input: UserSelfUpdateInput;
};


/** List of mutations */
export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


/** List of mutations */
export type MutationWidgetBulkUpdateArgs = {
  input: WidgetBulkUpdateInput;
};


/** List of mutations */
export type MutationWidgetTemplateCreateArgs = {
  input: WidgetTemplateCreateInput;
};


/** List of mutations */
export type MutationWidgetTemplateDestroyArgs = {
  input: WidgetTemplateDestroyInput;
};


/** List of mutations */
export type MutationWidgetTemplateUpdateArgs = {
  input: WidgetTemplateUpdateInput;
};

/** Nomenclature entity */
export type Nomenclature = TimestampInterface & {
  __typename?: 'Nomenclature';
  /**
   * Component Asset entity
   * NOTE: if you only need an Object ID, please use the componentAssetId field to reduce the load on the database.
   */
  componentAsset: Maybe<Asset>;
  /** Component Asset ID */
  componentAssetId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Nomenclature ID */
  id: Scalars['ID']['output'];
  /**
   * Main Asset entity
   * NOTE: if you only need an Object ID, please use the mainAssetId field to reduce the load on the database.
   */
  mainAsset: Maybe<Asset>;
  /** Main Asset ID */
  mainAssetId: Maybe<Scalars['ID']['output']>;
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** NomenclatureCollection type */
export type NomenclatureCollection = {
  __typename?: 'NomenclatureCollection';
  /** A collection of paginated NomenclatureCollection */
  collection: Array<Nomenclature>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureCreateInput = {
  /** Create attributes */
  attributes: NomenclatureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Nomenclature attributes */
export type NomenclatureCreateInputObject = {
  /** Component asset ID */
  componentAssetId: Scalars['ID']['input'];
  /** Main asset ID (Asset nomenclature for) */
  mainAssetId: Scalars['ID']['input'];
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Nomenclature filters */
export type NomenclatureFilterInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<FilterInputObject>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<FilterInputObject>;
};

/** Nomenclature sorts */
export type NomenclatureSortInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<SortDirectionEnum>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Quantity */
  quantity?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureUpdateInput = {
  /** Update attributes */
  attributes: NomenclatureUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature ID */
  id: Scalars['ID']['input'];
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Nomenclature attributes */
export type NomenclatureUpdateInputObject = {
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Available period group by options */
export enum PeriodGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** Available QR code file formats */
export enum QrCodeFileFormatEnum {
  /** EPS */
  Eps = 'EPS',
  /** PDF */
  Pdf = 'PDF',
  /** PNG */
  Png = 'PNG',
  /** SVG */
  Svg = 'SVG'
}

/** Available QR code file layouts */
export enum QrCodeFileLayoutEnum {
  /** Single file */
  SingleFile = 'SINGLE_FILE',
  /** Single page */
  SinglePage = 'SINGLE_PAGE'
}

/** Available QR code page sizes */
export enum QrCodePageSizeEnum {
  /** 29x39 mm */
  W29H39 = 'W29H39',
  /** 60x80 mm */
  W60H80 = 'W60H80',
  /** 67x76 mm */
  W67H76 = 'W67H76',
  /** A5 (148x210 mm) */
  W148H210 = 'W148H210'
}

/** QR codes attributes */
export type QrCodesCreateInputObject = {
  /** File format */
  fileFormat: QrCodeFileFormatEnum;
  /** File layout */
  fileLayout: QrCodeFileLayoutEnum;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Page size */
  pageSize: QrCodePageSizeEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** List of queries */
export type Query = {
  __typename?: 'Query';
  /** Show an ApiToken */
  apiToken: Maybe<ApiToken>;
  /** List of ApiTokens */
  apiTokens: ApiTokenCollection;
  /** Asset */
  asset: Maybe<Asset>;
  /** List of Asset Categories */
  assetCategories: AssetCategoryCollection;
  /** Show an Asset Category */
  assetCategory: Maybe<AssetCategory>;
  /** List of Assets */
  assets: AssetCollection;
  /** Check if an email domain has SSO integrations configured. Used on login page to show SSO options. */
  authenticationSsoCheck: SsoCheck;
  /** List of Companies */
  companies: CompanyCollection;
  /** Show a Company */
  company: Maybe<Company>;
  /** Show a Company Domain */
  companyDomain: Maybe<CompanyDomain>;
  /** List of Company Domains */
  companyDomains: CompanyDomainCollection;
  /** Show a Counter */
  counter: Maybe<Counter>;
  /** Show a Counter Measure */
  counterMeasure: Maybe<CounterMeasure>;
  /** List of Counter Measures */
  counterMeasures: CounterMeasureCollection;
  /** Counter Measures Graph Data */
  counterMeasuresGraphData: Array<CounterMeasureGraphData>;
  /** List of Counters */
  counters: CounterCollection;
  /** List of countries */
  countries: Array<GeoCountry>;
  /** Show a Data Import */
  dataImport: Maybe<DataImport>;
  /** Data Import Config */
  dataImportConfig: Maybe<Scalars['CamelizedJson']['output']>;
  /** List of Data Imports */
  dataImports: DataImportCollection;
  /** Show a documentation */
  documentation: Maybe<Documentation>;
  /** List of documentations */
  documentations: DocumentationCollection;
  /** Show a fake DNS record (non-production only) */
  fakeDnsRecord: Maybe<FakeDnsRecord>;
  /** List of fake DNS records (non-production only) */
  fakeDnsRecords: FakeDnsRecordCollection;
  /** Show a Frontend Filter Preset */
  feFilterPreset: Maybe<FeFilterPreset>;
  /** List of Frontend Filter Presets */
  feFilterPresets: FeFilterPresetCollection;
  /** List of Form Categories */
  formCategories: FormCategoryCollection;
  /** Show a Form Category */
  formCategory: Maybe<FormCategory>;
  /** Show a Form Checklist Template */
  formChecklistTemplate: Maybe<FormChecklistTemplate>;
  /** List of Form Checklist Templates */
  formChecklistTemplates: FormChecklistTemplateCollection;
  /** Show a Form Template */
  formTemplate: Maybe<FormTemplate>;
  /** Show a Form Template Version */
  formTemplateVersion: Maybe<FormTemplateVersion>;
  /** List of Form Template Versions */
  formTemplateVersions: FormTemplateVersionCollection;
  /** List of Form Templates */
  formTemplates: FormTemplateCollection;
  /** List of Histories */
  histories: HistoryCollection;
  /** Show a Home Page */
  homePage: Maybe<HomePage>;
  /** List of Home Pages */
  homePages: HomePageCollection;
  /** List of Industries */
  industries: IndustryCollection;
  /** Show an Industry */
  industry: Maybe<Industry>;
  /** Show an Intervention */
  intervention: Maybe<Intervention>;
  /** Show an Intervention Action */
  interventionAction: Maybe<InterventionAction>;
  /** List of Intervention Actions */
  interventionActions: InterventionActionCollection;
  /** List of Intervention Categories */
  interventionCategories: InterventionCategoryCollection;
  /** Show an Intervention Category */
  interventionCategory: Maybe<InterventionCategory>;
  /** List of Interventions */
  interventions: InterventionCollection;
  /** Show jobs information */
  jobs: Array<Job>;
  /** Show a Nomenclature */
  nomenclature: Maybe<Nomenclature>;
  /** List of Nomenclatures */
  nomenclatures: NomenclatureCollection;
  /** Show a Sector */
  sector: Maybe<Sector>;
  /** Sector Location Center */
  sectorLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Sector Locations */
  sectorLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sectors */
  sectors: SectorCollection;
  /** Sectors performance metrics by task deadlines missed */
  sectorsPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissed>>;
  /** Sectors performance metrics by task deadlines missed by date */
  sectorsPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sectors performance metrics by task results */
  sectorsPerformanceMetricsByTaskResults: Maybe<Array<SectorPerformanceMetricByTaskResults>>;
  /** Sectors performance metrics by task results by date */
  sectorsPerformanceMetricsByTaskResultsByDate: Maybe<Array<SectorPerformanceMetricByTaskResultsByDate>>;
  /** List of user sessions */
  sessions: SessionCollection;
  /** Show a Site */
  site: Maybe<Site>;
  /** Show a Site Area */
  siteArea: Maybe<SiteArea>;
  /** List of Site Areas */
  siteAreas: SiteAreaCollection;
  /** Site Location Center */
  siteLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Site Locations */
  siteLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sites */
  sites: SiteCollection;
  /** Sites performance metrics by task deadlines missed */
  sitesPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissed>>;
  /** Sites performance metrics by task deadlines missed by date */
  sitesPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sites performance metrics by task results */
  sitesPerformanceMetricsByTaskResults: Maybe<Array<SitePerformanceMetricByTaskResults>>;
  /** Sites performance metrics by task results by date */
  sitesPerformanceMetricsByTaskResultsByDate: Maybe<Array<SitePerformanceMetricByTaskResultsByDate>>;
  /** Show an SSO integration */
  ssoIntegration: Maybe<SsoIntegration>;
  /** Generate a new SSO code with SP URLs for IdP configuration */
  ssoIntegrationGenerateCode: SsoGeneratedCode;
  /** Get default attribute mapping and settings for a provider preset */
  ssoIntegrationPresetDefaults: Scalars['JSON']['output'];
  /** List of supported user fields for SSO attribute mapping */
  ssoIntegrationSupportedMappingFields: Array<SsoMappingField>;
  /** List of SSO integrations */
  ssoIntegrations: SsoIntegrationCollection;
  /** Show a System Admin */
  systemAdmin: Maybe<SystemAdmin>;
  /** List of System Admins */
  systemAdmins: SystemAdminCollection;
  /** Show a tag */
  tag: Maybe<Tag>;
  /** List of tags */
  tags: TagCollection;
  /** Task */
  task: Maybe<Task>;
  /** Get unique task kinds for given task IDs available for scheduling */
  taskAvailableForSchedulingKindsByIds: Array<TaskKindEnum>;
  /** Show a Task Completion */
  taskCompletion: Maybe<TaskCompletion>;
  /** List of Task Completions */
  taskCompletions: TaskCompletionCollection;
  /** List of Tasks */
  tasks: TaskCollection;
  /** Tasks data which can be completed from today until a provided date and assigned to the current user */
  tasksMyTodoCompletableByDateData: Array<TasksTodoCompletableByDateData>;
  /** Tasks Timeline */
  tasksTimeline: Array<TaskTimeline>;
  /** Show a Team */
  team: Maybe<Team>;
  /** List of Teams */
  teams: TeamCollection;
  /** Show a Technical Pause */
  technicalPause: Maybe<TechnicalPause>;
  /** List of Technical Pauses */
  technicalPauses: TechnicalPauseCollection;
  /** Show a User */
  user: Maybe<User>;
  /** List of Users */
  users: UserCollection;
  /** Show current user */
  whoami: Whoami;
  /** Show a Widget */
  widget: Maybe<Widget>;
  /** Show a Widget Template */
  widgetTemplate: Maybe<WidgetTemplate>;
  /** List of Widget Templates */
  widgetTemplates: WidgetTemplateCollection;
  /** List of Widgets */
  widgets: Array<Widget>;
};


/** List of queries */
export type QueryApiTokenArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryApiTokensArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryAssetArgs = {
  findBy: AssetFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QueryAssetCategoriesArgs = {
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
};


/** List of queries */
export type QueryAssetCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryAssetsArgs = {
  filters?: InputMaybe<Array<AssetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
};


/** List of queries */
export type QueryAuthenticationSsoCheckArgs = {
  email: Scalars['String']['input'];
};


/** List of queries */
export type QueryCompaniesArgs = {
  filters?: InputMaybe<Array<CompanyFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanySortInputObject>;
};


/** List of queries */
export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainsArgs = {
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
};


/** List of queries */
export type QueryCounterArgs = {
  assetFindBy: AssetFindByInputObject;
  findBy: CounterFindByInputObject;
};


/** List of queries */
export type QueryCounterMeasureArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCounterMeasuresArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterMeasureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterMeasureSortInputObject>;
};


/** List of queries */
export type QueryCounterMeasuresGraphDataArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  dateRange: DateRangeInputObject;
};


/** List of queries */
export type QueryCountersArgs = {
  assetId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterSortInputObject>;
};


/** List of queries */
export type QueryDataImportArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDataImportsArgs = {
  filters?: InputMaybe<Array<DataImportFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DataImportSortInputObject>;
};


/** List of queries */
export type QueryDocumentationArgs = {
  assetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationsArgs = {
  assetId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
};


/** List of queries */
export type QueryFakeDnsRecordArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFakeDnsRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryFeFilterPresetArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFeFilterPresetsArgs = {
  filters?: InputMaybe<Array<FeFilterPresetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FeFilterPresetSortInputObject>;
};


/** List of queries */
export type QueryFormCategoriesArgs = {
  filters?: InputMaybe<Array<FormCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
};


/** List of queries */
export type QueryFormCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplatesArgs = {
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
};


/** List of queries */
export type QueryFormTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionArgs = {
  formTemplateId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionsArgs = {
  filters?: InputMaybe<Array<FormTemplateVersionFilterInputObject>>;
  formTemplateId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormTemplateVersionSortInputObject>;
};


/** List of queries */
export type QueryFormTemplatesArgs = {
  filters?: InputMaybe<Array<FormTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
};


/** List of queries */
export type QueryHistoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<HistorySortInputObject>;
  sourceableId: Scalars['ID']['input'];
  sourceableType: HistorySourceableTypeEnum;
};


/** List of queries */
export type QueryHomePageArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryHomePagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryIndustriesArgs = {
  filters?: InputMaybe<Array<IndustryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<IndustrySortInputObject>;
};


/** List of queries */
export type QueryIndustryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionArgs = {
  id: Scalars['ID']['input'];
  interventionId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionsArgs = {
  filters?: InputMaybe<Array<InterventionActionFilterInputObject>>;
  interventionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoriesArgs = {
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionsArgs = {
  filters?: InputMaybe<Array<InterventionFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: InterventionScopeNameEnum;
  sorts?: InputMaybe<InterventionSortInputObject>;
};


/** List of queries */
export type QueryJobsArgs = {
  jids: Array<Scalars['String']['input']>;
};


/** List of queries */
export type QueryNomenclatureArgs = {
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryNomenclaturesArgs = {
  filters?: InputMaybe<Array<NomenclatureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainAssetId: Scalars['ID']['input'];
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<NomenclatureSortInputObject>;
};


/** List of queries */
export type QuerySectorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** List of queries */
export type QuerySectorLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsArgs = {
  filters?: InputMaybe<Array<SectorFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySessionsArgs = {
  currentFirst?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: SessionScopeEnum;
  sorts?: InputMaybe<SessionSortInputObject>;
};


/** List of queries */
export type QuerySiteArgs = {
  findBy: SiteFindByInputObject;
};


/** List of queries */
export type QuerySiteAreaArgs = {
  findBy: SiteAreaFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QuerySiteAreasArgs = {
  filters?: InputMaybe<Array<SiteAreaFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
};


/** List of queries */
export type QuerySiteLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySiteLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySitesArgs = {
  filters?: InputMaybe<Array<SiteFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySsoIntegrationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySsoIntegrationPresetDefaultsArgs = {
  preset: SsoIntegrationProviderPresetEnum;
};


/** List of queries */
export type QuerySsoIntegrationsArgs = {
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SsoIntegrationSortInputObject>;
};


/** List of queries */
export type QuerySystemAdminArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySystemAdminsArgs = {
  filters?: InputMaybe<Array<SystemAdminFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SystemAdminSortInputObject>;
};


/** List of queries */
export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTagsArgs = {
  filters?: InputMaybe<Array<TagFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TagSortInputObject>;
};


/** List of queries */
export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskAvailableForSchedulingKindsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTaskCompletionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskCompletionsArgs = {
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject>>;
  groupKey: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
};


/** List of queries */
export type QueryTasksArgs = {
  filters?: InputMaybe<Array<TaskFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  sorts?: InputMaybe<TaskSortInputObject>;
};


/** List of queries */
export type QueryTasksMyTodoCompletableByDateDataArgs = {
  date: Scalars['ISO8601DateTime']['input'];
};


/** List of queries */
export type QueryTasksTimelineArgs = {
  queryData: TaskTimelineQueryDataInputObject;
  taskIds: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTeamsArgs = {
  filters?: InputMaybe<Array<TeamFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
};


/** List of queries */
export type QueryTechnicalPauseArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTechnicalPausesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TechnicalPauseSortInputObject>;
};


/** List of queries */
export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<UserFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeInputObject>;
  sorts?: InputMaybe<UserSortInputObject>;
};


/** List of queries */
export type QueryWidgetArgs = {
  homePageId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplatesArgs = {
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
};


/** List of queries */
export type QueryWidgetsArgs = {
  homePageId: Scalars['ID']['input'];
};

/** Recurring rule entity */
export type RecurringRule = TimestampInterface & {
  __typename?: 'RecurringRule';
  /** Countdown type */
  countdownType: Maybe<RecurringRuleCountdownTypeEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** End time */
  endTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences: Maybe<Scalars['Int']['output']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Maybe<Array<Scalars['Int']['output']>>;
  /** Recurring rule ID */
  id: Scalars['ID']['output'];
  /** Recurring rule schema */
  schema: RecurringRuleSchema;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Available countdown types */
export enum RecurringRuleCountdownTypeEnum {
  Completion = 'COMPLETION',
  Deadline = 'DEADLINE'
}

/** Recurring rule attributes */
export type RecurringRuleInputObject = {
  /** Countdown type */
  countdownType: RecurringRuleCountdownTypeEnum;
  /** End time */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences?: InputMaybe<Scalars['Int']['input']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Array<Scalars['Int']['input']>;
  /** Schema attributes */
  schema: RecurringRuleSchemaInputObject;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['input'];
};

/** Available recurring rule types */
export enum RecurringRuleRuleTypeEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** Recurring rule schema type */
export type RecurringRuleSchema = {
  __typename?: 'RecurringRuleSchema';
  /** Recurring rule schema metadata */
  metadata: Maybe<RecurringRuleSchemaMetadata>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRule>;
};

/**
 * Recurring rule schema attributes
 * Examples:
 *
 *   - Daily:
 *     ```
 *     [
 *       {
 *         "ruleType": "DAILY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *     ```
 *     [
 *       {
 *         "ruleType": "WEEKLY",
 *         "interval": 1,
 *         "validations": {
 *           "day": [0,1,3,5]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st, 15th, and 31st days of the month:
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [1,15,31]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st Monday and on the last day of the month
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1]
 *           }
 *         }
 *       },
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [-1]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Yearly:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Every 2 years on the 1st and last days of the month in January, February, and December:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [1,-1],
 *           "monthOfYear": [1,2,12]
 *         }
 *       }
 *     ]
 *     ```
 *   - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1],
 *             "5": [-1]
 *           },
 *           "monthOfYear": [1,2]
 *         }
 *       },
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [-1],
 *           "monthOfYear": [1,2]
 *         }
 *       }
 *     ]
 *     ```
 *
 */
export type RecurringRuleSchemaInputObject = {
  /** Metadata */
  metadata?: InputMaybe<RecurringRuleSchemaMetadataInputObject>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRuleInputObject>;
};

/** Recurring rule schema metadata */
export type RecurringRuleSchemaMetadata = {
  __typename?: 'RecurringRuleSchemaMetadata';
  /** Recurring rule schema option */
  schemaOption: RecurringRuleSchemaOptionEnum;
};

/** Recurring rule schema metadata attributes */
export type RecurringRuleSchemaMetadataInputObject = {
  /** Schema option */
  schemaOption?: InputMaybe<RecurringRuleSchemaOptionEnum>;
};

/** Available recurring rule schema options */
export enum RecurringRuleSchemaOptionEnum {
  Each = 'EACH',
  OnThe = 'ON_THE'
}

/**
 * Recurring schema rule
 * Examples:
 *
 * - Daily:
 *   ```
 *   [
 *     {
 *       "ruleType": "DAILY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *   ```
 *   [
 *     {
 *       "ruleType": "WEEKLY",
 *       "interval": 1,
 *       "validations": {
 *         "day": [0,1,3,5]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st, 15th, and 31st days of the month:
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [1,15,31]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st Monday and on the last day of the month
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1]
 *         }
 *       }
 *     },
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [-1]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Yearly:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Every 2 years on the 1st and last days of the month in January, February, and December:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [1,-1],
 *         "monthOfYear": [1,2,12]
 *       }
 *     }
 *   ]
 *   ```
 * - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1],
 *           "5": [-1]
 *         },
 *         "monthOfYear": [1,2]
 *       }
 *     },
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [-1],
 *         "monthOfYear": [1,2]
 *       }
 *     }
 *   ]
 *   ```
 *
 */
export type RecurringRuleSchemaRule = {
  __typename?: 'RecurringRuleSchemaRule';
  /** Interval */
  interval: Scalars['Int']['output'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Recurring schema rule validations */
  validations: Maybe<RecurringRuleValidations>;
};

/** Recurring rule schema rule attributes */
export type RecurringRuleSchemaRuleInputObject = {
  /** Interval */
  interval: Scalars['Int']['input'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Validations attributes */
  validations?: InputMaybe<RecurringRuleValidationsInputObject>;
};

/** Recurring schema rule validations */
export type RecurringRuleValidations = {
  __typename?: 'RecurringRuleValidations';
  /** Day (1..31) */
  day: Maybe<Array<Scalars['Int']['output']>>;
  /** Days of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek: Maybe<Scalars['JSON']['output']>;
  /** Month of year (1..12) */
  monthOfYear: Maybe<Array<Scalars['Int']['output']>>;
};

/** Recurring rule validations */
export type RecurringRuleValidationsInputObject = {
  /** Day (1..31) */
  day?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Day of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek?: InputMaybe<Scalars['JSON']['input']>;
  /** Month of year (1..12) */
  monthOfYear?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Response message */
export type ResponseMessage = {
  __typename?: 'ResponseMessage';
  /** Message */
  message: Scalars['String']['output'];
};

/** Sector entity */
export type Sector = TimestampInterface & {
  __typename?: 'Sector';
  canDestroy: AuthorizationResult;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Location boundary */
  locationBoundary: Maybe<Location>;
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if sector is read only (default system sector) */
  readOnly: Scalars['Boolean']['output'];
  /** Sites collection */
  sites: SiteCollection;
  /** Sites count */
  sitesCount: Scalars['Int']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible User entity
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible User ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Users count (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};


/** Sector entity */
export type SectorSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** SectorCollection type */
export type SectorCollection = {
  __typename?: 'SectorCollection';
  /** A collection of paginated SectorCollection */
  collection: Array<Sector>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SectorCreateInput = {
  /** Create attributes */
  attributes: SectorCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Sector attributes */
export type SectorCreateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color: Scalars['String']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name: Scalars['String']['input'];
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector filters */
export type SectorFilterInputObject = {
  /** Sector code */
  code?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  name?: InputMaybe<FilterInputObject>;
  /** Sites ID */
  sitesId?: InputMaybe<FilterIdInputObject>;
};

/** Sector performance metric by task deadlines missed entity */
export type SectorPerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissed';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SectorPerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Sector performance metric by task results entity */
export type SectorPerformanceMetricByTaskResults = {
  __typename?: 'SectorPerformanceMetricByTaskResults';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task results by date entity */
export type SectorPerformanceMetricByTaskResultsByDate = {
  __typename?: 'SectorPerformanceMetricByTaskResultsByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Sector sorts */
export type SectorSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sites count */
  sitesCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Users count (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorUpdateInput = {
  /** Update attributes */
  attributes: SectorUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector attributes */
export type SectorUpdateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Session */
export type Session = {
  __typename?: 'Session';
  /** Minimum session age in hours required for sensitive operations */
  ageMinimumHours: Scalars['Int']['output'];
  /** Browser name */
  browserName: Scalars['String']['output'];
  /** Browser version */
  browserVersion: Scalars['String']['output'];
  /** City from IP geolocation */
  city: Scalars['String']['output'];
  /** Country from IP geolocation */
  country: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 country code */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Creation time */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Combined device info (e.g., "Desktop, Chrome 120.0") */
  device: Scalars['String']['output'];
  /** Device type (Desktop, Smartphone, Tablet, etc.) */
  deviceType: Scalars['String']['output'];
  /** Expiration time */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Session ID */
  id: Scalars['ID']['output'];
  /** IP address */
  ip: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Combined location info (e.g., "Kyiv, Kyiv Oblast, Ukraine") */
  location: Scalars['String']['output'];
  /** Operating system name */
  osName: Scalars['String']['output'];
  /** Region/state from IP geolocation */
  region: Scalars['String']['output'];
  /** Whether this session belongs to the current device */
  thisDevice: Scalars['Boolean']['output'];
  /** Whether session is too young for sensitive operations */
  tooYoung: Scalars['Boolean']['output'];
  /** Indicates if session is pending two-factor authentication verification */
  twoFactorPending: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication has been verified for this session */
  twoFactorVerified: Scalars['Boolean']['output'];
  /** User agent */
  userAgent: Maybe<Scalars['String']['output']>;
};

/** SessionCollection type */
export type SessionCollection = {
  __typename?: 'SessionCollection';
  /** A collection of paginated SessionCollection */
  collection: Array<Session>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Available session scopes */
export enum SessionScopeEnum {
  /** Active sessions (not expired) */
  Active = 'ACTIVE',
  /** Ended sessions (expired) */
  Ended = 'ENDED'
}

/** Session sorts */
export type SessionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Expires at */
  expiresAt?: InputMaybe<SortDirectionEnum>;
  /** Last activity at */
  lastActivityAt?: InputMaybe<SortDirectionEnum>;
};

/** Site entity */
export type Site = TimestampInterface & {
  __typename?: 'Site';
  /** Site cellphone */
  cellphone: Maybe<Scalars['String']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Site contact email */
  email: Scalars['String']['output'];
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Site location photo */
  locationPhotoAttached: Maybe<Attachment>;
  /** Location point */
  locationPoint: Maybe<Location>;
  /** Name */
  name: Scalars['String']['output'];
  /** Site contact phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /**
   * Sector
   * NOTE: if you only need an Object ID, please use the sectorId field to reduce the load on the database.
   */
  sector: Maybe<Sector>;
  /** Sector ID */
  sectorId: Maybe<Scalars['ID']['output']>;
  /** Number of Site Areas */
  siteAreasCount: Scalars['Int']['output'];
  /** Site Code of Conduct sections */
  siteConductCodeSections: Array<SiteConductCodeSection>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible user
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible user ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Number of Users (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};

/** Site Area entity */
export type SiteArea = TimestampInterface & {
  __typename?: 'SiteArea';
  /** Site Area address */
  address: Maybe<Scalars['String']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Site Area ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** SiteAreaCollection type */
export type SiteAreaCollection = {
  __typename?: 'SiteAreaCollection';
  /** A collection of paginated SiteAreaCollection */
  collection: Array<SiteArea>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site area attributes */
export type SiteAreaCreateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Site Area filters */
export type SiteAreaFilterInputObject = {
  /** Site Area code */
  code?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
};

/** Site area attributes */
export type SiteAreaFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site Area sorts */
export type SiteAreaSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaUpdateInput = {
  /** Update attributes */
  attributes: SiteAreaUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site Area ID */
  id: Scalars['ID']['input'];
};

/** Site area attributes */
export type SiteAreaUpdateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** SiteCollection type */
export type SiteCollection = {
  __typename?: 'SiteCollection';
  /** A collection of paginated SiteCollection */
  collection: Array<Site>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site Code of Conduct section entity */
export type SiteConductCodeSection = TimestampInterface & {
  __typename?: 'SiteConductCodeSection';
  /** Body text */
  body: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Site Code of Conduct section ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Site conduct code section attributes */
export type SiteConductCodeSectionCreateInputObject = {
  /** Body */
  body: Scalars['String']['input'];
  /** Position */
  position: Scalars['Int']['input'];
  /** Title */
  title: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteCreateInput = {
  /** Create attributes */
  attributes: SiteCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Site attributes */
export type SiteCreateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email: Scalars['String']['input'];
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint: LocationCuInputObject;
  /** Name */
  name: Scalars['String']['input'];
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId: Scalars['ID']['input'];
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site filters */
export type SiteFilterInputObject = {
  /** Site area code */
  areasCode?: InputMaybe<FilterInputObject>;
  /** Site area name */
  areasName?: InputMaybe<FilterInputObject>;
  /** Site code */
  code?: InputMaybe<FilterInputObject>;
  /** Site ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Responsible user full name */
  userFullName?: InputMaybe<FilterInputObject>;
};

/** Site attributes */
export type SiteFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site performance metric by task deadlines missed entity */
export type SitePerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissed';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SitePerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Site performance metric by task results entity */
export type SitePerformanceMetricByTaskResults = {
  __typename?: 'SitePerformanceMetricByTaskResults';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Site performance metric by task results by date entity */
export type SitePerformanceMetricByTaskResultsByDate = {
  __typename?: 'SitePerformanceMetricByTaskResultsByDate';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Site sorts */
export type SiteSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Number of site areas */
  siteAreasCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Number of users (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteUpdateInput = {
  /** Update attributes */
  attributes: SiteUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site attributes */
export type SiteUpdateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Sort directions */
export enum SortDirectionEnum {
  /** Ascending */
  Asc = 'asc',
  /** Descending */
  Desc = 'desc'
}

/** SSO availability check result */
export type SsoCheck = {
  __typename?: 'SsoCheck';
  /** Indicates if password login is allowed (always true) */
  passwordAllowed: Scalars['Boolean']['output'];
  /** Indicates if SSO is available for this email domain */
  ssoEnabled: Scalars['Boolean']['output'];
  /** List of available SSO integrations for this domain */
  ssoIntegrations: Array<SsoIntegrationPreview>;
};

/** Generated SSO code */
export type SsoGeneratedCode = {
  __typename?: 'SsoGeneratedCode';
  /** Assertion Consumer Service URL */
  acsUrl: Scalars['String']['output'];
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Service Provider entity ID */
  entityId: Scalars['String']['output'];
  /** Service Provider metadata URL */
  metadataUrl: Scalars['String']['output'];
};

/** SSO integration entity */
export type SsoIntegration = TimestampInterface & {
  __typename?: 'SsoIntegration';
  /** Whether IdP-initiated SSO login is allowed */
  allowIdpInitiated: Scalars['Boolean']['output'];
  /** Attribute mapping configuration */
  attributeMapping: Maybe<Scalars['JSON']['output']>;
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Associated company domains */
  companyDomains: Array<CompanyDomain>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Display status (computed based on status and domain verification) */
  displayStatus: SsoIntegrationDisplayStatusEnum;
  /** SSO integration icon */
  icon: Maybe<Attachment>;
  /** SSO integration ID */
  id: Scalars['ID']['output'];
  /** IdP metadata XML */
  idpMetadata: Maybe<Scalars['String']['output']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled: Scalars['Boolean']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if the SSO integration is pinned */
  pinned: Scalars['Boolean']['output'];
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Status (admin-controlled) */
  status: SsoIntegrationStatusEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes: Scalars['Boolean']['output'];
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Warning key for configuration issues */
  warningKey: Maybe<SsoIntegrationWarningKeyEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SsoIntegrationCollection type */
export type SsoIntegrationCollection = {
  __typename?: 'SsoIntegrationCollection';
  /** A collection of paginated SsoIntegrationCollection */
  collection: Array<SsoIntegration>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationCreateInput = {
  /** Create attributes */
  attributes: SsoIntegrationCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** SSO integration attributes */
export type SsoIntegrationCreateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping: Scalars['JSON']['input'];
  /** Unique code for the SSO integration */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds: Array<LinkingInputObject>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata: Scalars['String']['input'];
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Available SSO integration display statuses */
export enum SsoIntegrationDisplayStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Misconfigured = 'MISCONFIGURED'
}

/** SSO integration filters */
export type SsoIntegrationFilterInputObject = {
  /** Company domain ID */
  companyDomainsId?: InputMaybe<FilterIdInputObject>;
  /** SSO integration name */
  name?: InputMaybe<FilterInputObject>;
  /** Provider type */
  providerType?: InputMaybe<FilterInputObject>;
};

/** SSO integration preview for login page */
export type SsoIntegrationPreview = {
  __typename?: 'SsoIntegrationPreview';
  /** SSO integration code for constructing init URL */
  code: Scalars['String']['output'];
  /** Custom icon (for custom preset) */
  icon: Maybe<Attachment>;
  /** Display name */
  name: Scalars['String']['output'];
  /** Provider preset (for displaying provider icon) */
  providerPreset: SsoIntegrationProviderPresetEnum;
};

/** Available SSO provider presets */
export enum SsoIntegrationProviderPresetEnum {
  Auth0 = 'AUTH0',
  Custom = 'CUSTOM',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT',
  Okta = 'OKTA',
  Onelogin = 'ONELOGIN'
}

/** Available SSO provider types */
export enum SsoIntegrationProviderTypeEnum {
  Saml = 'SAML'
}

/** SSO integration sorts */
export type SsoIntegrationSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Available SSO integration statuses */
export enum SsoIntegrationStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationUpdateInput = {
  /** Update attributes */
  attributes: SsoIntegrationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SSO integration attributes */
export type SsoIntegrationUpdateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping?: InputMaybe<Scalars['JSON']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds?: InputMaybe<Array<LinkingInputObject>>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** SSO integration warning keys */
export enum SsoIntegrationWarningKeyEnum {
  NoVerifiedDomains = 'NO_VERIFIED_DOMAINS',
  SomeDomainsNotVerified = 'SOME_DOMAINS_NOT_VERIFIED'
}

/** SSO attribute mapping field */
export type SsoMappingField = {
  __typename?: 'SsoMappingField';
  /** Help text explaining the field purpose and constraints */
  description: Maybe<Scalars['String']['output']>;
  /** Field key */
  key: Scalars['String']['output'];
  /** Field label */
  label: Scalars['String']['output'];
  /** Indicates if the field is required */
  required: Scalars['Boolean']['output'];
  /** Display order index for the field */
  sortIndex: Scalars['Int']['output'];
};

/** SystemAdmin entity */
export type SystemAdmin = TimestampInterface & TwoFactorAuthenticatableInterface & UserInterface & {
  __typename?: 'SystemAdmin';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** SystemAdmin ID */
  id: Scalars['ID']['output'];
  /** Job title */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Lock time */
  lockedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Lock reason */
  lockedReason: Maybe<SystemAdminLockedReasonEnum>;
  /** Indicates if password change is required */
  passwordChangeRequired: Scalars['Boolean']['output'];
  /** Password change required reason */
  passwordChangeRequiredReason: Maybe<SystemAdminPasswordChangeRequiredReasonEnum>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Two-factor authentication reset required reason */
  twoFactorResetRequiredReason: Maybe<SystemAdminTwoFactorResetRequiredReasonEnum>;
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** SystemAdminCollection type */
export type SystemAdminCollection = {
  __typename?: 'SystemAdminCollection';
  /** A collection of paginated SystemAdminCollection */
  collection: Array<SystemAdmin>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminCreateInput = {
  /** Create attributes */
  attributes: SystemAdminCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin filters */
export type SystemAdminFilterInputObject = {
  /** Full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Job title */
  jobTitle?: InputMaybe<FilterInputObject>;
};

/** Available locked reasons */
export enum SystemAdminLockedReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Available password change required reasons */
export enum SystemAdminPasswordChangeRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminSelfUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** System Admin sorts */
export type SystemAdminSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Job title */
  jobTitle?: InputMaybe<SortDirectionEnum>;
};

/** Available two-factor reset required reasons */
export enum SystemAdminTwoFactorResetRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin attributes */
export type SystemAdminUpdateInputObject = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUserCreateInput = {
  /** Create attributes */
  attributes: SystemAdminUserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  companyId: Scalars['ID']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type SystemAdminUserCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Role */
  role: UserRoleEnum;
};

/** Tag entity */
export type Tag = TimestampInterface & {
  __typename?: 'Tag';
  canDestroy: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Tag ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TagCollection type */
export type TagCollection = {
  __typename?: 'TagCollection';
  /** A collection of paginated TagCollection */
  collection: Array<Tag>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TagCreateInput = {
  /** Create attributes */
  attributes: TagCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Tag attributes */
export type TagCreateInputObject = {
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TagDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Tag filters */
export type TagFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Tag sorts */
export type TagSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Task entity */
export type Task = TimestampInterface & {
  __typename?: 'Task';
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the approverId field to reduce the load on the database.
   */
  approver: Maybe<User>;
  /** Approver ID */
  approverId: Maybe<Scalars['ID']['output']>;
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  canArchive: AuthorizationResult;
  canCompletionCreate: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canFormTemplateVersionUpdate: AuthorizationResult;
  canInterventionCreate: AuthorizationResult;
  canQrCodeRelatedInfoUpdate: AuthorizationResult;
  canReschedule: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Completed date */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Task completion entity */
  completion: Maybe<TaskCompletion>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows the reason why the deadline was missed. */
  deadlineMissedReason: Maybe<TaskDeadlineMissedReasonEnum>;
  /** Indicates if the deadline was missed before. */
  deadlineWasMissed: Scalars['Boolean']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Early completion */
  earlyCompletion: Maybe<Scalars['Int']['output']>;
  /** Early completion unit */
  earlyCompletionUnit: Maybe<TaskEarlyCompletionUnitEnum>;
  /** Form Template entity */
  formTemplate: FormTemplate;
  /** Form Template Version entity */
  formTemplateVersion: FormTemplateVersion;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  groupKey: Scalars['ID']['output'];
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Intervention entity */
  intervention: Maybe<Intervention>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Form Answers from previous completion that allowed to be shown in the form */
  lastAllowedAnswers: Array<FormAnswer>;
  /** Last check date (Completion date for previous task completion) */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last deadline date */
  lastDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Maybe<Scalars['String']['output']>;
  /** Original creation date (for recurring tasks) */
  originalCreatedAt: Scalars['ISO8601DateTime']['output'];
  /** Priority */
  priority: TaskPriorityEnum;
  /**
   * Recurring rule entity
   * NOTE: if you only need an Object ID, please use the recurringRuleId field to reduce the load on the database.
   */
  recurringRule: Maybe<RecurringRule>;
  /** Recurring rule ID */
  recurringRuleId: Maybe<Scalars['ID']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: TaskStatusEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Task attributes */
export type TaskAssignationsInputObject = {
  /** Asset ID */
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Site Area ID */
  siteAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkCreateSameInput = {
  /** Create attributes */
  attributes: TaskBulkCreateSameInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task attributes */
export type TaskBulkCreateSameInputObject = {
  /** Approver ID */
  approverId: Scalars['ID']['input'];
  /** Assignations attributes array */
  assignations: TaskAssignationsInputObject;
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: TaskPriorityEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkDeadlineMissedReasonUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateDeadlineMissedReasonInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkSchedulingInput = {
  /** Scheduling params */
  attributes: TaskBulkSchedulingInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskBulkSchedulingInputObject = {
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateTemplateVersionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkUpdateStatusInput = {
  /** Update attributes */
  attributes: TaskUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** TaskCollection type */
export type TaskCollection = {
  __typename?: 'TaskCollection';
  /** A collection of paginated TaskCollection */
  collection: Array<Task>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Task completion entity */
export type TaskCompletion = TimestampInterface & {
  __typename?: 'TaskCompletion';
  /** Form Answers collection */
  answers: Maybe<Array<FormAnswer>>;
  canStatusUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Task Completion ID */
  id: Scalars['ID']['output'];
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /**
   * Solved date
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  solvedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Result status
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  status: Maybe<TaskCompletionStatusEnum>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if task completion is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** TaskCompletionCollection type */
export type TaskCompletionCollection = {
  __typename?: 'TaskCompletionCollection';
  /** A collection of paginated TaskCompletionCollection */
  collection: Array<TaskCompletion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionCreateInput = {
  /** Create attributes */
  attributes: TaskCompletionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task completion attributes */
export type TaskCompletionCreateInputObject = {
  /** Answers attributes array */
  answers: Array<FormAnswerCreateInputObject>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion filters */
export type TaskCompletionFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Performer ID
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  performerId?: InputMaybe<FilterIdInputObject>;
  /**
   * Validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint?: InputMaybe<FilterInputObject>;
};

/** Task completion sorts */
export type TaskCompletionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Performer full name */
  performerFullName?: InputMaybe<SortDirectionEnum>;
  /** Solved at */
  solvedAt?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available task completion statuses */
export enum TaskCompletionStatusEnum {
  InProgress = 'IN_PROGRESS',
  Solved = 'SOLVED',
  Unsolved = 'UNSOLVED'
}

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionStatusUpdateInput = {
  /** Update attributes */
  attributes: TaskCompletionUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion attributes */
export type TaskCompletionUpdateStatusInputObject = {
  /** Status */
  status: TaskCompletionStatusEnum;
};

/** Available deadline missed reasons */
export enum TaskDeadlineMissedReasonEnum {
  Inaccessible = 'INACCESSIBLE',
  Other = 'OTHER',
  SiteClosed = 'SITE_CLOSED',
  StaffProblem = 'STAFF_PROBLEM',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}

/** Description from base input object. Please set your description for child object. */
export type TaskDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Available early completion units */
export enum TaskEarlyCompletionUnitEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Task filters */
export type TaskFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Completed at */
  completedAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Completion validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  completionValidityHint?: InputMaybe<FilterInputObject>;
  /** Deadline at */
  deadlineAt?: InputMaybe<FilterDateInputObject>;
  /** Form Category ID */
  formCategoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  formCategoryName?: InputMaybe<FilterInputObject>;
  /** Task kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Task name */
  name?: InputMaybe<FilterInputObject>;
  /** Task priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Form Template ID */
  templateId?: InputMaybe<FilterIdInputObject>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<FilterIdInputObject>;
};

/** Available task kinds */
export enum TaskKindEnum {
  OnDemand = 'ON_DEMAND',
  Standard = 'STANDARD'
}

/** Available task priorities */
export enum TaskPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Tasks which are linked to form template and grouped by recurring rule */
export type TaskScopeArgsLinkedToFormTemplateGroupedInputObject = {
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Custom scope attributes */
export type TaskScopeCustomInputObject = {
  /** Tasks which are linked to form template and grouped by recurring rule */
  linkedToFormTemplateGrouped?: InputMaybe<TaskScopeArgsLinkedToFormTemplateGroupedInputObject>;
};

/** Task scope attributes */
export type TaskScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<TaskScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<TaskScopeNameEnum>;
};

/** Available task scope names */
export enum TaskScopeNameEnum {
  /** Current active tasks (not completed yet but validated) */
  Active = 'ACTIVE',
  /** Archived tasks */
  Archived = 'ARCHIVED',
  /** Archived tasks grouped by recurrence */
  ArchivedGrouped = 'ARCHIVED_GROUPED',
  /** Completed tasks */
  Completed = 'COMPLETED',
  /** Completed tasks grouped by recurrence */
  CompletedGrouped = 'COMPLETED_GROUPED',
  /** All tasks for dashboard */
  DashboardAll = 'DASHBOARD_ALL',
  /** All tasks for dashboard and grouped by recurring rule */
  DashboardAllGrouped = 'DASHBOARD_ALL_GROUPED',
  /** Tasks with missed deadline */
  DeadlineMissed = 'DEADLINE_MISSED',
  /** Tasks with missed deadline without selected deadline missed reason */
  DeadlineMissedWithoutReason = 'DEADLINE_MISSED_WITHOUT_REASON',
  /** Completed tasks with failure result */
  Failure = 'FAILURE',
  /** Solved completed tasks with failure result */
  FailureSolved = 'FAILURE_SOLVED',
  /** Unsolved completed tasks with failure result */
  FailureUnsolved = 'FAILURE_UNSOLVED',
  /** Current tasks need to be validated */
  MyApprovals = 'MY_APPROVALS',
  /** Completed tasks assigned to me */
  MyCompleted = 'MY_COMPLETED',
  /** Tasks assigned to me and available to complete */
  MyTodoAvailableToComplete = 'MY_TODO_AVAILABLE_TO_COMPLETE',
  /** Tasks assigned to me and not available to complete yet because of deadline date */
  MyTodoUpcoming = 'MY_TODO_UPCOMING',
  /** Completed tasks with non success result and without intervention */
  NonSuccessWithoutIntervention = 'NON_SUCCESS_WITHOUT_INTERVENTION',
  /** Tasks which have not processed yet and grouped by recurring rule */
  NotProcessedGrouped = 'NOT_PROCESSED_GROUPED',
  /** Current tasks that are on validation or validated */
  OnValidationOrValidated = 'ON_VALIDATION_OR_VALIDATED',
  /** Current pending tasks (not completed nor validated yet) */
  Pending = 'PENDING',
  /** Solved completed tasks (with warning or failure result) */
  Solved = 'SOLVED',
  /** Completed tasks with success result */
  Success = 'SUCCESS',
  /** Completed tasks with warning result */
  Warning = 'WARNING',
  /** Solved completed tasks with warning result */
  WarningSolved = 'WARNING_SOLVED',
  /** Unsolved completed tasks with warning result */
  WarningUnsolved = 'WARNING_UNSOLVED'
}

/** Task sorts */
export type TaskSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Completed at */
  completedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion solved at */
  completionSolvedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion status */
  completionStatus?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline missed reason */
  deadlineMissedReason?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  formCategoryName?: InputMaybe<SortDirectionEnum>;
  /** Task kind */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Last deadline date */
  lastDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
  /** Form Template name */
  templateName?: InputMaybe<SortDirectionEnum>;
  /** Form Template Version version */
  templateVersionVersion?: InputMaybe<SortDirectionEnum>;
};

/** Available task statuses */
export enum TaskStatusEnum {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  OnValidation = 'ON_VALIDATION',
  Rejected = 'REJECTED',
  Validated = 'VALIDATED'
}

/** Task timeline */
export type TaskTimeline = {
  __typename?: 'TaskTimeline';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Timeline rows */
  rows: Array<TaskTimelineRow>;
};

/** Available timeline completion group by options */
export enum TaskTimelineCompletionGroupByEnum {
  FormCategory = 'FORM_CATEGORY',
  FormTemplate = 'FORM_TEMPLATE',
  SiteArea = 'SITE_AREA'
}

/** Available timeline frames */
export enum TaskTimelineFrameEnum {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Available timeline group by options */
export enum TaskTimelineGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH'
}

/** Timeline query data attributes */
export type TaskTimelineQueryDataInputObject = {
  /** Date range */
  dateRange: DateRangeInputObject;
  /** Group by */
  groupBy: TaskTimelineGroupByEnum;
  /** Validity hints */
  validityHints?: InputMaybe<Array<FormTemplateQuestionFieldOptionsValidityHintEnum>>;
};

/** Timeline report attributes */
export type TaskTimelineReportCreateInputObject = {
  /** Completion group by */
  completionGroupBy: TaskTimelineCompletionGroupByEnum;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Query data */
  queryData: TaskTimelineQueryDataInputObject;
  /** Task IDs */
  taskIds: Array<Scalars['ID']['input']>;
  /** Time frame */
  timeFrame: TaskTimelineFrameEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Timeline row */
export type TaskTimelineRow = {
  __typename?: 'TaskTimelineRow';
  /** Date */
  date: Scalars['String']['output'];
  /** Validity hint counters */
  validityHintCounters: TaskTimelineValidityHintCounter;
};

/** Validity hint counter */
export type TaskTimelineValidityHintCounter = {
  __typename?: 'TaskTimelineValidityHintCounter';
  /** Failure */
  failure: Maybe<Scalars['Int']['output']>;
  /** Hint is absent (no answers where hint was set) */
  none: Maybe<Scalars['Int']['output']>;
  /** Success */
  success: Maybe<Scalars['Int']['output']>;
  /** Warning */
  warning: Maybe<Scalars['Int']['output']>;
};

/** Task attributes */
export type TaskUpdateDeadlineMissedReasonInputObject = {
  /** Deadline missed reason */
  deadlineMissedReason: TaskDeadlineMissedReasonEnum;
};

/** Description from base input object. Please set your description for child object. */
export type TaskUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Task attributes */
export type TaskUpdateInputObject = {
  /** Approver ID */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<TaskPriorityEnum>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskUpdateStatusInputObject = {
  /** Status */
  status: TaskStatusEnum;
};

/** Task attributes */
export type TaskUpdateTemplateVersionInputObject = {
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TasksTimelineReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: TaskTimelineReportCreateInputObject;
};

/** Task entity */
export type TasksTodoCompletableByDateData = {
  __typename?: 'TasksTodoCompletableByDateData';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Scalars['String']['output'];
};

/** Team entity */
export type Team = TimestampInterface & {
  __typename?: 'Team';
  /** Related accesses */
  accesses: Array<Access>;
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Team ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if team is read only (default system team) */
  readOnly: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount: Maybe<Scalars['Int']['output']>;
};

/** TeamCollection type */
export type TeamCollection = {
  __typename?: 'TeamCollection';
  /** A collection of paginated TeamCollection */
  collection: Array<Team>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TeamCreateInput = {
  /** Create attributes */
  attributes: TeamCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Team attributes */
export type TeamCreateInputObject = {
  /** Accesses attributes array */
  accesses: Array<AccessCuInputObject>;
  /** Color */
  color: Scalars['String']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team filters */
export type TeamFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Users full name */
  usersFullName?: InputMaybe<FilterInputObject>;
};

/** Team sorts */
export type TeamSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamUpdateInput = {
  /** Update attributes */
  attributes: TeamUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team attributes */
export type TeamUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Technical pause entity */
export type TechnicalPause = TimestampInterface & {
  __typename?: 'TechnicalPause';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Created by */
  createdBy: SystemAdmin;
  /** Early terminated at */
  earlyTerminatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** End time of the technical pause */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** Technical pause ID */
  id: Scalars['ID']['output'];
  /** Start time of the technical pause */
  startAt: Scalars['ISO8601DateTime']['output'];
  /** Status */
  status: TechnicalPauseStatusEnum;
  /** Time left to start/end of the technical pause */
  time: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TechnicalPauseCollection type */
export type TechnicalPauseCollection = {
  __typename?: 'TechnicalPauseCollection';
  /** A collection of paginated TechnicalPauseCollection */
  collection: Array<TechnicalPause>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseCreateInput = {
  /** Create attributes */
  attributes: TechnicalPauseCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Technical Pause attributes */
export type TechnicalPauseCreateInputObject = {
  /** End at */
  endAt: Scalars['ISO8601DateTime']['input'];
  /** Start at */
  startAt: Scalars['ISO8601DateTime']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause sorts */
export type TechnicalPauseSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /** End at */
  endAt?: InputMaybe<SortDirectionEnum>;
  /** Start at */
  startAt?: InputMaybe<SortDirectionEnum>;
};

/** Available statuses */
export enum TechnicalPauseStatusEnum {
  Completed = 'COMPLETED',
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED'
}

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseUpdateInput = {
  /** Update attributes */
  attributes: TechnicalPauseUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause attributes */
export type TechnicalPauseUpdateInputObject = {
  /** Early terminated */
  earlyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Shows timestamp */
export type TimestampInterface = {
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Two-factor authentication fields */
export type TwoFactorAuthenticatableInterface = {
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
};

/** Backup codes information */
export type TwoFactorBackupCodes = {
  __typename?: 'TwoFactorBackupCodes';
  /** List of backup codes */
  codes: Array<Scalars['String']['output']>;
  /** Number of backup codes */
  count: Scalars['Int']['output'];
};

/** Two-factor authentication setup result */
export type TwoFactorSetupResult = {
  __typename?: 'TwoFactorSetupResult';
  /** Generated backup codes (if requested) */
  backupCodes: Array<Scalars['String']['output']>;
  /** Number of generated backup codes */
  backupCodesCount: Scalars['Int']['output'];
};

/** TOTP setup information */
export type TwoFactorTotpSetup = {
  __typename?: 'TwoFactorTotpSetup';
  /** TOTP secret key */
  secret: Scalars['String']['output'];
  /** TOTP URI for QR code generation */
  uri: Scalars['String']['output'];
};

/** User entity */
export type User = TimestampInterface & UserInterface & {
  __typename?: 'User';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['output'];
  /**
   * Company
   * NOTE: if you only need an Object ID, please use the companyId field to reduce the load on the database.
   */
  company: Company;
  /** Company ID */
  companyId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** Final Access setup */
  finalAccesses: Maybe<Array<Access>>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** User ID */
  id: Scalars['ID']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Owned company */
  ownedCompany: Maybe<Company>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Related personal accesses */
  personalAccesses: Array<Access>;
  /** Personal ID */
  personalId: Maybe<Scalars['String']['output']>;
  /** Phone number in E.164 format */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** Role */
  role: UserRoleEnum;
  /** Sectors collection */
  sectors: SectorCollection;
  /** Sites collection */
  sites: SiteCollection;
  /**
   * Team entity
   * NOTE: if you only need an Object ID, please use the teamId field to reduce the load on the database.
   */
  team: Team;
  /** Team ID */
  teamId: Maybe<Scalars['ID']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Username */
  username: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};


/** User entity */
export type UserSectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** User entity */
export type UserSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserCodeOfConductAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['input'];
};

/** UserCollection type */
export type UserCollection = {
  __typename?: 'UserCollection';
  /** A collection of paginated UserCollection */
  collection: Array<User>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type UserCreateInput = {
  /** Create attributes */
  attributes: UserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserCreateInputObject = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role: UserRoleEnum;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** User attributes */
export type UserCreateOwnerInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type UserDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User filters */
export type UserFilterInputObject = {
  /** User email */
  email?: InputMaybe<FilterInputObject>;
  /** User full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Intervention Action assignees */
  interventionActionAssigneesActionId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Action mentioned users */
  interventionActionsTextMentionsId?: InputMaybe<FilterIdInputObject>;
  /** Intervention assignees */
  interventionAssigneesInterventionId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector ID */
  memberAssignedSectorsId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector name */
  memberAssignedSectorsName?: InputMaybe<FilterInputObject>;
  /** Assigned Site ID */
  memberAssignedSitesId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Site name */
  memberAssignedSitesName?: InputMaybe<FilterInputObject>;
  /** User personal ID */
  personalId?: InputMaybe<FilterInputObject>;
  /** User role */
  role?: InputMaybe<FilterIntInputObject>;
  /** Sector memberships ID */
  sectorMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Site memberships ID */
  siteMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Team ID */
  teamId?: InputMaybe<FilterIdInputObject>;
  /** Team name */
  teamName?: InputMaybe<FilterInputObject>;
  /** User username */
  username?: InputMaybe<FilterInputObject>;
};

/** Common user fields */
export type UserInterface = {
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** Available roles */
export enum UserRoleEnum {
  FullAdmin = 'FULL_ADMIN',
  User = 'USER'
}

/** User access */
export type UserScopeArgsAccessInputObject = {
  /** Component name */
  component: AccessComponentEnum;
  /** Min level of access (Means provided value or higher) */
  level: AccessLevelEnum;
  /** Sourceable ID */
  sourceableId?: InputMaybe<Scalars['ID']['input']>;
};

/** Users core filter */
export type UserScopeArgsByCoreInputObject = {
  /** User access */
  access?: InputMaybe<UserScopeArgsAccessInputObject>;
  /** When set to `true`, this filter ensures that only users who have access to **every site** listed in the `siteId` array are returned. If a user lacks access to any one of the specified sites, they will be excluded from the results. */
  allSitesAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only active users */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Site ID or array of site IDs */
  siteId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Custom scope attributes */
export type UserScopeCustomInputObject = {
  /** Users core filter */
  byCore?: InputMaybe<UserScopeArgsByCoreInputObject>;
};

/** User scope attributes */
export type UserScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<UserScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<UserScopeNameEnum>;
};

/** Available user scope names */
export enum UserScopeNameEnum {
  /** Active users */
  Active = 'ACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type UserSelfUpdateInput = {
  /** Update attributes */
  attributes: UserSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** User sorts */
export type UserSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** User email */
  email?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Personal ID */
  personalId?: InputMaybe<SortDirectionEnum>;
  /** Role */
  role?: InputMaybe<SortDirectionEnum>;
  /** Team name */
  teamName?: InputMaybe<SortDirectionEnum>;
  /** User username */
  username?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type UserUpdateInput = {
  /** Update attributes */
  attributes: UserUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User attributes */
export type UserUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<UserRoleEnum>;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Current resource */
export type Whoami = {
  __typename?: 'Whoami';
  /** Entrypoint entity */
  entrypoint: AuthenticationEntrypointUnion;
  /** Resource entity */
  resource: AuthenticationWhoamiUnion;
};

/** Widget entity */
export type Widget = TimestampInterface & {
  __typename?: 'Widget';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Widget fields configuration */
  fields: WidgetsField;
  /** Widget grid configuration */
  grid: Scalars['JSON']['output'];
  /** Home Page ID */
  homePageId: Scalars['ID']['output'];
  /** Widget ID */
  id: Scalars['ID']['output'];
  /** Widget kind */
  kind: WidgetsKindEnum;
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Widget Template ID */
  widgetTemplateId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<WidgetUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Home Page ID */
  homePageId: Scalars['ID']['input'];
};

/** Widget button item configuration */
export type WidgetFieldsButtonItemInputObject = {
  /** Indicates if button is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last update timestamp for the button */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Widget buttons configuration */
export type WidgetFieldsButtonsInputObject = {
  /** Asset button configuration */
  asset?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Form template button configuration */
  formTemplate?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Intervention button configuration */
  intervention?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Site button configuration */
  site?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Task button configuration */
  task?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Team member button configuration */
  teamMember?: InputMaybe<WidgetFieldsButtonItemInputObject>;
};

/** Widget fields configuration */
export type WidgetFieldsInputObject = {
  /** Background color */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Widget buttons configuration */
  buttons?: InputMaybe<WidgetFieldsButtonsInputObject>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Link */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Only my */
  onlyMy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template entity */
export type WidgetTemplate = TimestampInterface & {
  __typename?: 'WidgetTemplate';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Subtitle */
  description: Maybe<Scalars['String']['output']>;
  /** Widget Template fields configuration */
  fields: WidgetTemplatesField;
  /** Widget Template ID */
  id: Scalars['ID']['output'];
  /** Is default template */
  isDefault: Scalars['Boolean']['output'];
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID (creator) */
  userId: Maybe<Scalars['ID']['output']>;
  /** Visibility */
  visibility: WidgetTemplatesVisibilityEnum;
};

/** WidgetTemplateCollection type */
export type WidgetTemplateCollection = {
  __typename?: 'WidgetTemplateCollection';
  /** A collection of paginated WidgetTemplateCollection */
  collection: Array<WidgetTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateCreateInput = {
  /** Widget Template creation attributes */
  attributes: WidgetTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template attributes */
export type WidgetTemplateCreateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Scalars['String']['input'];
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template fields configuration */
export type WidgetTemplateFieldsInputObject = {
  /** Background color (for announcement only) */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Rich text content (for announcement only) */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Link URL (for external_link only) */
  link?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template filters */
export type WidgetTemplateFilterInputObject = {
  /** Is default filter */
  isDefault?: InputMaybe<FilterInputObject>;
  /** Kind filter */
  kind?: InputMaybe<FilterInputObject>;
  /** Title filter */
  title?: InputMaybe<FilterInputObject>;
  /** Visibility filter */
  visibility?: InputMaybe<FilterInputObject>;
};

/** Widget Template sorting */
export type WidgetTemplateSortInputObject = {
  /** Sort by title */
  title?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateUpdateInput = {
  /** Widget Template update attributes */
  attributes: WidgetTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template attributes */
export type WidgetTemplateUpdateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Widget Template fields configuration */
export type WidgetTemplatesField = {
  __typename?: 'WidgetTemplatesField';
  /** Background color */
  backgroundColor: Maybe<Scalars['String']['output']>;
  /** Rich text content */
  content: Maybe<Scalars['String']['output']>;
  /** Link URL */
  link: Maybe<Scalars['String']['output']>;
};

/** Available widget template kinds */
export enum WidgetTemplatesKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

/** Widget template visibility options (prv for private, pub for public) */
export enum WidgetTemplatesVisibilityEnum {
  Prv = 'PRV',
  Pub = 'PUB'
}

/** Widget attributes */
export type WidgetUpdateInputObject = {
  /** Destroy widget (if true, widget will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget fields configuration */
  fields?: InputMaybe<WidgetFieldsInputObject>;
  /** Widget grid configuration */
  grid?: InputMaybe<Scalars['JSON']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind?: InputMaybe<WidgetsKindEnum>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  widgetTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Widget fields configuration */
export type WidgetsField = {
  __typename?: 'WidgetsField';
  /** Background color */
  backgroundColor: Maybe<Scalars['String']['output']>;
  /** Widget fields buttons configuration */
  buttons: Maybe<WidgetsFieldsButtons>;
  /** End at */
  endAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Link */
  link: Maybe<Scalars['String']['output']>;
  /** Location */
  location: Maybe<Scalars['String']['output']>;
  /** Only my */
  onlyMy: Maybe<Scalars['Boolean']['output']>;
  /** Start at */
  startAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timezone */
  timezone: Maybe<Scalars['String']['output']>;
};

/** Widget button item configuration */
export type WidgetsFieldsButtonItem = {
  __typename?: 'WidgetsFieldsButtonItem';
  /** Indicates if button is enabled */
  enabled: Maybe<Scalars['Boolean']['output']>;
  /** Last update timestamp for the button */
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Widget fields buttons configuration */
export type WidgetsFieldsButtons = {
  __typename?: 'WidgetsFieldsButtons';
  /** Asset button configuration */
  asset: Maybe<WidgetsFieldsButtonItem>;
  /** Form template button configuration */
  formTemplate: Maybe<WidgetsFieldsButtonItem>;
  /** Intervention button configuration */
  intervention: Maybe<WidgetsFieldsButtonItem>;
  /** Site button configuration */
  site: Maybe<WidgetsFieldsButtonItem>;
  /** Task button configuration */
  task: Maybe<WidgetsFieldsButtonItem>;
  /** Team member button configuration */
  teamMember: Maybe<WidgetsFieldsButtonItem>;
};

/** Available widget kinds */
export enum WidgetsKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

export type ApiTokenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApiTokenQuery = { __typename?: 'Query', data: { __typename?: 'ApiToken', id: string, createdAt: any, updatedAt: any, label: string | null, status: ApiTokenStatusEnum | null } | null };

export type ApiTokensQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ApiTokensQuery = { __typename?: 'Query', data: { __typename?: 'ApiTokenCollection', collection: Array<{ __typename?: 'ApiToken', id: string, createdAt: any, label: string | null, status: ApiTokenStatusEnum | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type ApiTokenCreateMutationVariables = Exact<{
  attributes: ApiTokenCreateInputObject;
}>;


export type ApiTokenCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'ApiToken', id: string, label: string | null, token: string | null } | null };

export type ApiTokenUpdateMutationVariables = Exact<{
  attributes: ApiTokenUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type ApiTokenUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'ApiToken', label: string | null } | null };

export type ApiTokenDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApiTokenDestroyMutation = { __typename?: 'Mutation', apiTokenDestroy: boolean | null };

export type AssetCategoryFragmentFragment = { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null };

export type AssetFragmentFragment = { __typename?: 'Asset', id: string, qrPrefix: string | null, code: string, fullCode: string, manufacturer: string | null, model: string | null, name: string, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, category: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null };

export type AssetsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
  filters?: InputMaybe<Array<AssetFilterInputObject> | AssetFilterInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeCategoryData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetsQuery = { __typename?: 'Query', data: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, code: string, fullCode: string, manufacturer?: string | null, model?: string | null, name: string, serialNumber?: string | null, category?: { __typename?: 'AssetCategory', color: string, name: string, id: string } | null, site: { __typename?: 'Site', id: string, name: string, code: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetIdsQueryVariables = Exact<{
  sorts?: InputMaybe<AssetSortInputObject>;
  filters?: InputMaybe<Array<AssetFilterInputObject> | AssetFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  includeSiteId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetIdsQuery = { __typename?: 'Query', data: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, siteId?: string | null }> } };

export type AssetsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
  filters?: InputMaybe<Array<AssetFilterInputObject> | AssetFilterInputObject>;
}>;


export type AssetsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, fullCode: string, name: string, poorWifi: boolean, usesAsNomenclatureCount: number, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetQueryVariables = Exact<{
  findBy: AssetFindByInputObject;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetQuery = { __typename?: 'Query', data: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteId: string | null, qrPrefix: string | null, code: string, manufacturer: string | null, model: string | null, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, category: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type AssetWithCountersQueryVariables = Exact<{
  findBy: AssetFindByInputObject;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  mainAssetId: Scalars['ID']['input'];
  nomenclaturesFilters?: InputMaybe<Array<NomenclatureFilterInputObject> | NomenclatureFilterInputObject>;
  countersFilters?: InputMaybe<Array<CounterFilterInputObject> | CounterFilterInputObject>;
  documentationsFilters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  interventionsFilters?: InputMaybe<Array<InterventionFilterInputObject> | InterventionFilterInputObject>;
  interventionsScopeName: InterventionScopeNameEnum;
}>;


export type AssetWithCountersQuery = { __typename?: 'Query', data: { __typename?: 'Asset', id: string, name: string, fullCode: string, qrPrefix: string | null, code: string, manufacturer: string | null, model: string | null, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, site?: { __typename?: 'Site', id: string, name: string } | null, siteArea?: { __typename?: 'SiteArea', id: string, name: string } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, category: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, nomenclatures: { __typename?: 'NomenclatureCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, counters: { __typename?: 'CounterCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, documentations: { __typename?: 'DocumentationCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, interventions: { __typename?: 'InterventionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type AssetCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AssetCategoryQuery = { __typename?: 'Query', data: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null };

export type AssetCategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject> | AssetCategoryFilterInputObject>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
}>;


export type AssetCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'AssetCategoryCollection', collection: Array<{ __typename?: 'AssetCategory', visibleAssetsCount: number, color: string, name: string, id: string, prefix: string | null, assets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, name: string }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject> | AssetCategoryFilterInputObject>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
}>;


export type AssetCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'AssetCategoryCollection', collection: Array<{ __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetBulkDestroyMutationVariables = Exact<{
  input: AssetBulkDestroyInput;
}>;


export type AssetBulkDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type AssetCategoryCreateMutationVariables = Exact<{
  attributes: AssetCategoryCreateInputObject;
}>;


export type AssetCategoryCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null };

export type AssetCategoryUpdateMutationVariables = Exact<{
  attributes: AssetCategoryUpdateInputObject;
  id: Scalars['ID']['input'];
  refreshQrPrefixForAssets?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssetCategoryUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null };

export type AssetCategoryDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AssetCategoryDestroyMutation = { __typename?: 'Mutation', assetCategoryDestroy: boolean | null };

export type AssetCreateMutationVariables = Exact<{
  attributes: AssetCreateInputObject;
}>;


export type AssetCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Asset', id: string, qrPrefix: string | null, code: string, fullCode: string, manufacturer: string | null, model: string | null, name: string, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, category: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type AssetUpdateMutationVariables = Exact<{
  attributes: AssetUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type AssetUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Asset', id: string, qrPrefix: string | null, code: string, fullCode: string, manufacturer: string | null, model: string | null, name: string, serialNumber: string | null, serviceDate: any | null, description: string | null, poorWifi: boolean, category: { __typename?: 'AssetCategory', color: string, name: string, id: string, prefix: string | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type AssetBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
}>;


export type AssetBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Job', at: number | null, deliveryRequest: boolean | null, eta: number | null, jid: string | null, kind: JobKindEnum | null, message: string | null, payload: any | null, pctComplete: number | null, status: JobStatusEnum | null, stop: boolean | null, total: number | null, updateTime: number | null, canRetry: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateDeliveryRequest: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type AssetNomenclatureBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
}>;


export type AssetNomenclatureBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Job', at: number | null, deliveryRequest: boolean | null, eta: number | null, jid: string | null, kind: JobKindEnum | null, message: string | null, payload: any | null, pctComplete: number | null, status: JobStatusEnum | null, stop: boolean | null, total: number | null, updateTime: number | null, canRetry: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateDeliveryRequest: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type AssetCountersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterSortInputObject>;
  filters?: InputMaybe<Array<CounterFilterInputObject> | CounterFilterInputObject>;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCountersQuery = { __typename?: 'Query', data: { __typename?: 'CounterCollection', collection: Array<{ __typename?: 'Counter', code: string, fullCode: string, id: string, lastCheckAt: any | null, latestIndex: number | null, measureType: CounterMeasureTypeEnum, measureUnit: CounterMeasureUnitEnum, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetCountersIdsQueryVariables = Exact<{
  sorts?: InputMaybe<CounterSortInputObject>;
  filters?: InputMaybe<Array<CounterFilterInputObject> | CounterFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCountersIdsQuery = { __typename?: 'Query', data: { __typename?: 'CounterCollection', collection: Array<{ __typename?: 'Counter', id: string }> } };

export type AssetCounterQueryVariables = Exact<{
  findBy: CounterFindByInputObject;
  assetFindBy: AssetFindByInputObject;
}>;


export type AssetCounterQuery = { __typename?: 'Query', data: { __typename?: 'Counter', id: string, name: string, code: string, fullCode: string, measureType: CounterMeasureTypeEnum, measureUnit: CounterMeasureUnitEnum, prohibitLowerIndexThanPrevious: boolean, latestIndex: number | null, lastCheckAt: any | null } | null };

export type AssetCounterMeasureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
}>;


export type AssetCounterMeasureQuery = { __typename?: 'Query', data: { __typename?: 'CounterMeasure', id: string, index: number } | null };

export type AssetCounterMeasuresQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterMeasureSortInputObject>;
  filters?: InputMaybe<Array<CounterMeasureFilterInputObject> | CounterMeasureFilterInputObject>;
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
}>;


export type AssetCounterMeasuresQuery = { __typename?: 'Query', data: { __typename?: 'CounterMeasureCollection', collection: Array<{ __typename?: 'CounterMeasure', id: string, createdAt: any, cumulativeUsage: number, index: number, gap: number, resetToZero: boolean }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetCounterMeasuresGraphDataQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  dateRange: DateRangeInputObject;
}>;


export type AssetCounterMeasuresGraphDataQuery = { __typename?: 'Query', data: Array<{ __typename?: 'CounterMeasureGraphData', createdAt: any, cumulativeUsage: number, gap: number }> };

export type AssetCounterCreateMutationVariables = Exact<{
  attributes: CounterCreateInputObject;
}>;


export type AssetCounterCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Counter', id: string } | null };

export type AssetCounterUpdateMutationVariables = Exact<{
  attributes: CounterUpdateInputObject;
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Counter', id: string, name: string, code: string, fullCode: string, measureType: CounterMeasureTypeEnum, measureUnit: CounterMeasureUnitEnum, prohibitLowerIndexThanPrevious: boolean } | null };

export type AssetCounterDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterDestroyMutation = { __typename?: 'Mutation', counterBulkDestroy: boolean | null };

export type AssetCounterMeasureCreateMutationVariables = Exact<{
  attributes: CounterMeasureCreateInputObject;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterMeasureCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'CounterMeasure', id: string } | null };

export type AssetCounterResetToZeroMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterResetToZeroMutation = { __typename?: 'Mutation', data: { __typename?: 'Counter', id: string } | null };

export type AssetCounterBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
  assetId: Scalars['ID']['input'];
}>;


export type AssetCounterBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Job', at: number | null, deliveryRequest: boolean | null, eta: number | null, jid: string | null, kind: JobKindEnum | null, message: string | null, payload: any | null, pctComplete: number | null, status: JobStatusEnum | null, stop: boolean | null, total: number | null, updateTime: number | null, canRetry: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateDeliveryRequest: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type AssetNomenclaturesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<NomenclatureSortInputObject>;
  filters?: InputMaybe<Array<NomenclatureFilterInputObject> | NomenclatureFilterInputObject>;
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclaturesQuery = { __typename?: 'Query', data: { __typename?: 'NomenclatureCollection', collection: Array<{ __typename?: 'Nomenclature', id: string, quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string, code: string, fullCode: string, usesAsNomenclatureCount: number, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type AssetNomenclaturesIdsQueryVariables = Exact<{
  sorts?: InputMaybe<NomenclatureSortInputObject>;
  filters?: InputMaybe<Array<NomenclatureFilterInputObject> | NomenclatureFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclaturesIdsQuery = { __typename?: 'Query', data: { __typename?: 'NomenclatureCollection', collection: Array<{ __typename?: 'Nomenclature', id: string }> } };

export type AssetNomenclatureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclatureQuery = { __typename?: 'Query', data: { __typename?: 'Nomenclature', id: string, quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type AssetNomenclatureCreateMutationVariables = Exact<{
  attributes: NomenclatureCreateInputObject;
}>;


export type AssetNomenclatureCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Nomenclature', quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string } | null } | null };

export type AssetNomenclatureUpdateMutationVariables = Exact<{
  attributes: NomenclatureUpdateInputObject;
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclatureUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Nomenclature', quantity: number, componentAsset: { __typename?: 'Asset', id: string, name: string } | null } | null };

export type AssetNomenclatureDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
}>;


export type AssetNomenclatureDestroyMutation = { __typename?: 'Mutation', nomenclatureBulkDestroy: boolean | null };

export type AuthenticationConfirmationsEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsResendEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsResendEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsResendRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsForgotMutationVariables = Exact<{
  input: AuthenticationPasswordsForgotInput;
}>;


export type AuthenticationPasswordsForgotMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsUpdateMutationVariables = Exact<{
  input: AuthenticationPasswordsUpdateInput;
}>;


export type AuthenticationPasswordsUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationSessionEndMutationVariables = Exact<{
  input: AuthenticationSessionEndInput;
}>;


export type AuthenticationSessionEndMutation = { __typename?: 'Mutation', data: boolean | null };

export type WhoamiQueryVariables = Exact<{
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WhoamiQuery = { __typename?: 'Query', whoami: { __typename?: 'Whoami', resource: { __typename: 'SystemAdmin' } | { __typename: 'User', deactivatedAt?: any | null, debugModeUntil: any | null, createdAt?: any, email?: string | null, firstName?: string, id: string, lang?: LanguageEnum, lastName?: string, personalId?: string | null, passwordSetupRequired?: boolean, passwordUpdatedAt?: any | null, unconfirmedEmail?: string | null, updatedAt?: any, username?: string | null, verified?: boolean | null, phoneNumber?: string | null, role: UserRoleEnum, codeOfConductAccepted?: boolean, avatarAttached?: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, finalAccesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, company: { __typename?: 'Company', id: string, activeUsersCount: number, createdAt: any, plan: { __typename?: 'CompanyPlan', kind: CompanyPlanKindEnum, usersLimit: number | null, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, level: AccessLevelEnum | null }> } } } } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', data: Array<{ __typename?: 'GeoCountry', code: string, name: string }> };

export type DataImportFragmentFragment = { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, jid: string | null, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, job: { __typename?: 'Job', canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type DataImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataImportQuery = { __typename?: 'Query', data: { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, jid: string | null, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, job: { __typename?: 'Job', canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DataImportsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<DataImportFilterInputObject> | DataImportFilterInputObject>;
  sorts?: InputMaybe<DataImportSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DataImportsQuery = { __typename?: 'Query', data: { __typename?: 'DataImportCollection', collection: Array<{ __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, jid: string | null, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, job: { __typename?: 'Job', canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type DataImportIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<DataImportFilterInputObject> | DataImportFilterInputObject>;
  sorts?: InputMaybe<DataImportSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DataImportIdsQuery = { __typename?: 'Query', data: { __typename?: 'DataImportCollection', collection: Array<{ __typename?: 'DataImport', id: string }> } };

export type DataImportConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type DataImportConfigQuery = { __typename?: 'Query', data: any | null };

export type DataImportCreateMutationVariables = Exact<{
  attributes: DataImportCreateInputObject;
}>;


export type DataImportCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, jid: string | null, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, job: { __typename?: 'Job', canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DataImportUpdateMutationVariables = Exact<{
  attributes: DataImportUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type DataImportUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'DataImport', importedRows: number | null, failureDetails: any | null, fileException: Array<string> | null, id: string, jid: string | null, kind: DataImportKindEnum, status: DataImportStatusEnum, totalRows: number | null, createdAt: any, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, job: { __typename?: 'Job', canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DataImportDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataImportDestroyMutation = { __typename?: 'Mutation', dataImportDestroy: boolean | null };

export type DocumentationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  assetId: Scalars['ID']['input'];
}>;


export type DocumentationsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCollection', collection: Array<{ __typename?: 'Documentation', id: string, name: string, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type DocumentationsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
  filters?: InputMaybe<Array<DocumentationFilterInputObject> | DocumentationFilterInputObject>;
  assetId: Scalars['ID']['input'];
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DocumentationsIdsQuery = { __typename?: 'Query', data: { __typename?: 'DocumentationCollection', collection: Array<{ __typename?: 'Documentation', id: string }> } };

export type DocumentationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type DocumentationQuery = { __typename?: 'Query', data: { __typename?: 'Documentation', id: string, name: string, assetId: string, attachmentAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type DocumentationBulkCreateMutationVariables = Exact<{
  attributes: Array<DocumentationCreateInputObject> | DocumentationCreateInputObject;
  assetId: Scalars['ID']['input'];
}>;


export type DocumentationBulkCreateMutation = { __typename?: 'Mutation', documentationBulkCreate: boolean | null };

export type DocumentationUpdateMutationVariables = Exact<{
  attributes: DocumentationUpdateInputObject;
  id: Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type DocumentationUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Documentation', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type DocumentationBulkDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  assetId: Scalars['ID']['input'];
}>;


export type DocumentationBulkDestroyMutation = { __typename?: 'Mutation', documentationBulkDestroy: boolean | null };

export type FeFilterPresetFragment = { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } };

export type FeFilterPresetsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FeFilterPresetFilterInputObject> | FeFilterPresetFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FeFilterPresetSortInputObject>;
}>;


export type FeFilterPresetsQuery = { __typename?: 'Query', data: { __typename?: 'FeFilterPresetCollection', collection: Array<{ __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FeFilterPresetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeFilterPresetQuery = { __typename?: 'Query', data: { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } } | null };

export type FeFilterPresetCreateMutationVariables = Exact<{
  attributes: FeFilterPresetCreateInputObject;
}>;


export type FeFilterPresetCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } } | null };

export type FeFilterPresetUpdateMutationVariables = Exact<{
  attributes: FeFilterPresetUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type FeFilterPresetUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FeFilterPreset', data: any, id: string, kind: string, name: string, entities: { __typename?: 'FeFilterPresetEntities', sites: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, sectors: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formCategories: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null, formTemplates: Array<{ __typename?: 'FeFilterPresetEntity', id: string }> | null } } | null };

export type FeFilterPresetDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeFilterPresetDestroyMutation = { __typename?: 'Mutation', feFilterPresetDestroy: boolean | null };

export type FormCategoryFragmentFragment = { __typename?: 'FormCategory', color: string, name: string, id: string };

export type QuestionsFragmentFragment = { __typename?: 'FormTemplateVersion', questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> };

export type FormTemplateFragmentFragment = { __typename?: 'FormTemplate', description: string | null, id: string, name: string, createdAt: any, updatedAt: any, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null };

export type FormTemplateFullFragmentFragment = { __typename?: 'FormTemplate', visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null };

export type FormTemplateVersionFragmentFragment = { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> };

export type FullFormTemplateVersionFragmentFragment = { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> };

export type FormTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormTemplateQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplate', archivedAt: any | null, visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null } | null };

export type FormTemplateVersionsSearchListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateVersionFilterInputObject> | FormTemplateVersionFilterInputObject>;
  formTemplateId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormTemplateVersionSortInputObject>;
}>;


export type FormTemplateVersionsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateVersionCollection', collection: Array<{ __typename?: 'FormTemplateVersion', id: string, version: string | null, createdAt: any, status: FormTemplateVersionStatusEnum }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormTemplateVersionQueryVariables = Exact<{
  formTemplateId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type FormTemplateVersionQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateVersion', visibleLinkedTasksCount: number, id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormCategoryQuery = { __typename?: 'Query', data: { __typename?: 'FormCategory', id: string, name: string, color: string } | null };

export type FormCategoriesQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormCategoryFilterInputObject> | FormCategoryFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
}>;


export type FormCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'FormCategoryCollection', collection: Array<{ __typename?: 'FormCategory', formTemplatesCount: number, color: string, name: string, id: string, formTemplates: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string, name: string, currentVersion: { __typename?: 'FormTemplateVersion', id: string } | null }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormCategoriesSearchListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormCategoryFilterInputObject> | FormCategoryFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
}>;


export type FormCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormCategoryCollection', collection: Array<{ __typename?: 'FormCategory', color: string, name: string, id: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateFilterInputObject> | FormTemplateFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
}>;


export type FormTemplatesQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string, name: string, createdAt: any, archivedAt: any | null, versionsCount: number, visibleLinkedTasksCount: number, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, activeCounter: { __typename?: 'FormTemplateCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, archivedCounter: { __typename?: 'FormTemplateCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type FormTemplateIdsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateFilterInputObject> | FormTemplateFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
}>;


export type FormTemplateIdsQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string }> } };

export type FormTemplatesSearchListQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormTemplateFilterInputObject> | FormTemplateFilterInputObject>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
}>;


export type FormTemplatesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormTemplateCollection', collection: Array<{ __typename?: 'FormTemplate', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormCategoryCreateMutationVariables = Exact<{
  attributes: FormCategoryCreateInputObject;
}>;


export type FormCategoryCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormCategory', color: string, name: string, id: string } | null };

export type FormCategoryUpdateMutationVariables = Exact<{
  attributes: FormCategoryUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type FormCategoryUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormCategory', color: string, name: string, id: string } | null };

export type FormCategoryDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormCategoryDestroyMutation = { __typename?: 'Mutation', formCategoryDestroy: boolean | null };

export type FormTemplateCreateMutationVariables = Exact<{
  attributes: FormTemplateCreateInputObject;
}>;


export type FormTemplateCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplate', visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null } | null };

export type FormTemplateUpdateMutationVariables = Exact<{
  attributes: FormTemplateUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type FormTemplateUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplate', visibleLinkedTasksCount: number, description: string | null, id: string, name: string, createdAt: any, updatedAt: any, currentVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null } | null, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null } | null };

export type FormTemplateBulkDestroyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormTemplateBulkDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormTemplateBulkArchiveMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormTemplateBulkArchiveMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormTemplateBulkRestoreMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormTemplateBulkRestoreMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormTemplateVersionCreateMutationVariables = Exact<{
  attributes: FormTemplateVersionCuInputObject;
  formTemplateId: Scalars['ID']['input'];
}>;


export type FormTemplateVersionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormTemplateVersionUpdateMutationVariables = Exact<{
  attributes: FormTemplateVersionCuInputObject;
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
}>;


export type FormTemplateVersionUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', id: string } | null };

export type FormTemplateVersionArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
}>;


export type FormTemplateVersionArchiveMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormTemplateVersionRestoreMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
}>;


export type FormTemplateVersionRestoreMutation = { __typename?: 'Mutation', data: { __typename?: 'FormTemplateVersion', visibleLinkedTasksCount: number, id: string, templateId: string, version: string | null, createdAt: any, archivedAt: any | null, status: FormTemplateVersionStatusEnum, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean }, canArchive: { __typename?: 'AuthorizationResult', value: boolean }, canRestore: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> } | null };

export type FormTemplateVersionDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  formTemplateId: Scalars['ID']['input'];
}>;


export type FormTemplateVersionDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type FormChecklistTemplateFragmentFragment = { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type FormChecklistTemplateWithOptionsFragmentFragment = { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', id: string, value: string, position: number, updatedAt: any }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type FormChecklistTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormChecklistTemplateQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', id: string, value: string, position: number, updatedAt: any }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type FormChecklistTemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject> | FormChecklistTemplateFilterInputObject>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
}>;


export type FormChecklistTemplatesQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplateCollection', collection: Array<{ __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormChecklistTemplateIdsQueryVariables = Exact<{
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject> | FormChecklistTemplateFilterInputObject>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FormChecklistTemplateIdsQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplateCollection', collection: Array<{ __typename?: 'FormChecklistTemplate', id: string }> } };

export type FormChecklistTemplatesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject> | FormChecklistTemplateFilterInputObject>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
}>;


export type FormChecklistTemplatesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'FormChecklistTemplateCollection', collection: Array<{ __typename?: 'FormChecklistTemplate', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type FormChecklistTemplateCreateMutationVariables = Exact<{
  attributes: FormChecklistTemplateCreateInputObject;
}>;


export type FormChecklistTemplateCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', value: string, position: number, updatedAt: any, id: string }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type FormChecklistTemplateUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: FormChecklistTemplateUpdateInputObject;
}>;


export type FormChecklistTemplateUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'FormChecklistTemplate', id: string, name: string, description: string | null, optionsCount: number, options: Array<{ __typename?: 'FormChecklistTemplateOption', value: string, position: number, updatedAt: any, id: string }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type FormChecklistTemplateDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormChecklistTemplateDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type AttachmentFragmentFragment = { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null };

export type MetadataFragmentFragment = { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number };

export type AuthorizationResultFragmentFragment = { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null };

export type JobFragmentFragment = { __typename?: 'Job', at: number | null, deliveryRequest: boolean | null, eta: number | null, jid: string | null, kind: JobKindEnum | null, message: string | null, payload: any | null, pctComplete: number | null, status: JobStatusEnum | null, stop: boolean | null, total: number | null, updateTime: number | null, canRetry: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateDeliveryRequest: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type GeojsonFragmentFragment = { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> };

export type GeojsonFullFragmentFragment = { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null, pointCount: number | null, sourceables: Array<{ __typename?: 'GeojsonPropertiesPolymorphicIdentity', id: string, type: GeojsonPropertiesPolymorphicIdentityTypeEnum }> | null } | null }> };

export type LocationBoundaryFragmentFragment = { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null };

export type HomePageFragmentFragment = { __typename?: 'HomePage', id: string, name: string | null, position: number, isDefault: boolean, userId: string | null, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type WidgetFragmentFragment = { __typename?: 'Widget', id: string, homePageId: string, widgetTemplateId: string | null, kind: WidgetsKindEnum, title: string | null, description: string | null, position: number, grid: any, createdAt: any, updatedAt: any, fields: { __typename?: 'WidgetsField', backgroundColor: string | null, link: string | null, location: string | null, timezone: string | null, startAt: any | null, endAt: any | null, onlyMy: boolean | null, buttons: { __typename?: 'WidgetsFieldsButtons', asset: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, formTemplate: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, intervention: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, site: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, task: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, teamMember: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null } | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> };

export type WidgetTemplateFragmentFragment = { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: string | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> };

export type HomePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HomePageQuery = { __typename?: 'Query', data: { __typename?: 'HomePage', id: string, name: string | null, position: number, isDefault: boolean, userId: string | null, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type HomePagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HomePagesQuery = { __typename?: 'Query', data: { __typename?: 'HomePageCollection', collection: Array<{ __typename?: 'HomePage', id: string, name: string | null, position: number, isDefault: boolean, userId: string | null, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type WidgetQueryVariables = Exact<{
  homePageId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type WidgetQuery = { __typename?: 'Query', data: { __typename?: 'Widget', id: string, homePageId: string, widgetTemplateId: string | null, kind: WidgetsKindEnum, title: string | null, description: string | null, position: number, grid: any, createdAt: any, updatedAt: any, fields: { __typename?: 'WidgetsField', backgroundColor: string | null, link: string | null, location: string | null, timezone: string | null, startAt: any | null, endAt: any | null, onlyMy: boolean | null, buttons: { __typename?: 'WidgetsFieldsButtons', asset: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, formTemplate: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, intervention: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, site: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, task: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, teamMember: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null } | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type WidgetsQueryVariables = Exact<{
  homePageId: Scalars['ID']['input'];
}>;


export type WidgetsQuery = { __typename?: 'Query', data: Array<{ __typename?: 'Widget', id: string, homePageId: string, widgetTemplateId: string | null, kind: WidgetsKindEnum, title: string | null, description: string | null, position: number, grid: any, createdAt: any, updatedAt: any, fields: { __typename?: 'WidgetsField', backgroundColor: string | null, link: string | null, location: string | null, timezone: string | null, startAt: any | null, endAt: any | null, onlyMy: boolean | null, buttons: { __typename?: 'WidgetsFieldsButtons', asset: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, formTemplate: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, intervention: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, site: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, task: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null, teamMember: { __typename?: 'WidgetsFieldsButtonItem', enabled: boolean | null, updatedAt: any | null } | null } | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }> };

export type WidgetTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WidgetTemplateQuery = { __typename?: 'Query', data: { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: string | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type WidgetTemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WidgetTemplatesQuery = { __typename?: 'Query', data: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: string | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type WidgetTemplatesWithCountersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  allTemplatesFilters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  publicTemplatesFilters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
  privateTemplatesFilters?: InputMaybe<Array<WidgetTemplateFilterInputObject> | WidgetTemplateFilterInputObject>;
}>;


export type WidgetTemplatesWithCountersQuery = { __typename?: 'Query', data: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: string | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, allTemplates: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string }> }, publicTemplates: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string }> }, privateTemplates: { __typename?: 'WidgetTemplateCollection', collection: Array<{ __typename?: 'WidgetTemplate', id: string }> } };

export type HomePageBulkUpdateMutationVariables = Exact<{
  attributes: Array<HomePageUpdateInputObject> | HomePageUpdateInputObject;
}>;


export type HomePageBulkUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type WidgetBulkUpdateMutationVariables = Exact<{
  homePageId: Scalars['ID']['input'];
  attributes: Array<WidgetUpdateInputObject> | WidgetUpdateInputObject;
}>;


export type WidgetBulkUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type WidgetTemplateCreateMutationVariables = Exact<{
  attributes: WidgetTemplateCreateInputObject;
}>;


export type WidgetTemplateCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: string | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type WidgetTemplateDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WidgetTemplateDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type WidgetTemplateUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: WidgetTemplateUpdateInputObject;
}>;


export type WidgetTemplateUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'WidgetTemplate', id: string, title: string | null, description: string | null, kind: WidgetTemplatesKindEnum, visibility: WidgetTemplatesVisibilityEnum, isDefault: boolean, fields: { __typename?: 'WidgetTemplatesField', backgroundColor: string | null, content: string | null, link: string | null }, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> } | null };

export type InterventionCategoryFragmentFragment = { __typename?: 'InterventionCategory', id: string, name: string, color: string, description: string | null };

export type InterventionFragmentFragment = { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: string } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type InterventionActionFragmentFragment = { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type InterventionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionSortInputObject>;
  filters?: InputMaybe<Array<InterventionFilterInputObject> | InterventionFilterInputObject>;
  scopeName: InterventionScopeNameEnum;
}>;


export type InterventionsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCollection', collection: Array<{ __typename?: 'Intervention', id: string, name: string, createdAt: any, closedAt: any | null, code: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, category: { __typename?: 'InterventionCategory', id: string, name: string, color: string } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, openedCounter: { __typename?: 'InterventionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, closedCounter: { __typename?: 'InterventionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InterventionsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionSortInputObject>;
  filters?: InputMaybe<Array<InterventionFilterInputObject> | InterventionFilterInputObject>;
  scopeName: InterventionScopeNameEnum;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InterventionsIdsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCollection', collection: Array<{ __typename?: 'Intervention', id: string }> } };

export type InterventionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionQuery = { __typename?: 'Query', data: { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: string } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, actionsCounter: { __typename?: 'InterventionActionCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type InterventionSiteIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionSiteIdQuery = { __typename?: 'Query', data: { __typename?: 'Intervention', id: string, siteId: string | null, categoryId: string | null } | null };

export type InterventionCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionCategoryQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCategory', id: string, name: string, color: string, description: string | null } | null };

export type InterventionCategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject> | InterventionCategoryFilterInputObject>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
}>;


export type InterventionCategoriesQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCategoryCollection', collection: Array<{ __typename?: 'InterventionCategory', visibleInterventionsCount: number, id: string, name: string, color: string, description: string | null, interventions: { __typename?: 'InterventionCollection', collection: Array<{ __typename?: 'Intervention', id: string, name: string }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionCategoriesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject> | InterventionCategoryFilterInputObject>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
}>;


export type InterventionCategoriesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'InterventionCategoryCollection', collection: Array<{ __typename?: 'InterventionCategory', id: string, name: string, color: string, description: string | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionActionQueryVariables = Exact<{
  interventionId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type InterventionActionQuery = { __typename?: 'Query', data: { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionActionHistoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceableId: Scalars['ID']['input'];
  sourceableType: HistorySourceableTypeEnum;
  sorts?: InputMaybe<HistorySortInputObject>;
}>;


export type InterventionActionHistoriesQuery = { __typename?: 'Query', data: { __typename?: 'HistoryCollection', collection: Array<{ __typename?: 'History', id: string, kind: HistoryKindEnum, system: boolean | null, occurredAt: any, data: { __typename: 'InterventionActionHistoryData', durationTime: Array<number | null> | null, estimatedDate: Array<any | null> | null, estimatedTime: Array<number | null> | null, logisticTime: Array<number | null> | null, status: Array<InterventionActionStatusEnum> | null } | null, metadata: { __typename: 'InterventionActionHistoryMetadata', reason: HistoryInterventionActionHistoryMetadataReasonEnum | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionActionsQueryVariables = Exact<{
  interventionId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
  filters?: InputMaybe<Array<InterventionActionFilterInputObject> | InterventionActionFilterInputObject>;
}>;


export type InterventionActionsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionActionCollection', collection: Array<{ __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type InterventionActionIdsQueryVariables = Exact<{
  interventionId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
  filters?: InputMaybe<Array<InterventionActionFilterInputObject> | InterventionActionFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InterventionActionIdsQuery = { __typename?: 'Query', data: { __typename?: 'InterventionActionCollection', collection: Array<{ __typename?: 'InterventionAction', id: string }> } };

export type InterventionSitePrefillDataQueryVariables = Exact<{
  siteFindBy: SiteFindByInputObject;
}>;


export type InterventionSitePrefillDataQuery = { __typename?: 'Query', site: { __typename?: 'Site', id: string, name: string } | null };

export type InterventionSiteAreaPrefillDataQueryVariables = Exact<{
  siteFindBy: SiteFindByInputObject;
  siteAreaFindBy: SiteAreaFindByInputObject;
}>;


export type InterventionSiteAreaPrefillDataQuery = { __typename?: 'Query', siteArea: { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean } | null };

export type InterventionAssetPrefillDataQueryVariables = Exact<{
  assetFindBy: AssetFindByInputObject;
}>;


export type InterventionAssetPrefillDataQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteAreaId: string | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type InterventionTaskPrefillDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionTaskPrefillDataQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, name: string } | null };

export type InterventionCreateMutationVariables = Exact<{
  attributes: InterventionCreateInputObject;
  assigneeRedirectUrl: Scalars['String']['input'];
}>;


export type InterventionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: string } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionUpdateMutationVariables = Exact<{
  attributes: InterventionUpdateInputObject;
  id: Scalars['ID']['input'];
  assigneeRedirectUrl: Scalars['String']['input'];
}>;


export type InterventionUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Intervention', id: string, name: string, code: string | null, description: string | null, priority: InterventionPriorityEnum, status: InterventionStatusEnum, estimatedDate: any | null, totalLogisticTime: number | null, totalEstimatedTime: number | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, totalTime: number | null, createdAt: any, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, category: { __typename?: 'InterventionCategory', id: string, name: string, color: string } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, task: { __typename?: 'Task', id: string, name: string } | null, supervisor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canClose: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateAction: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionDestroyMutation = { __typename?: 'Mutation', interventionDestroy: boolean | null };

export type InterventionBulkCloseMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InterventionBulkCloseMutation = { __typename?: 'Mutation', interventionBulkClose: boolean | null };

export type InterventionCategoryCreateMutationVariables = Exact<{
  attributes: InterventionCategoryCreateInputObject;
}>;


export type InterventionCategoryCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionCategory', id: string, name: string, color: string, description: string | null } | null };

export type InterventionCategoryUpdateMutationVariables = Exact<{
  attributes: InterventionCategoryUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type InterventionCategoryUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionCategory', id: string, name: string, color: string, description: string | null } | null };

export type InterventionCategoryDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InterventionCategoryDestroyMutation = { __typename?: 'Mutation', interventionCategoryDestroy: boolean | null };

export type InterventionActionCreateMutationVariables = Exact<{
  attributes: InterventionActionCreateInputObject;
  assigneeRedirectUrl: Scalars['String']['input'];
  mentionRedirectUrl: Scalars['String']['input'];
  interventionId: Scalars['ID']['input'];
}>;


export type InterventionActionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionActionUpdateMutationVariables = Exact<{
  attributes: InterventionActionUpdateInputObject;
  id: Scalars['ID']['input'];
  assigneeRedirectUrl: Scalars['String']['input'];
  mentionRedirectUrl: Scalars['String']['input'];
  interventionId: Scalars['ID']['input'];
}>;


export type InterventionActionUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'InterventionAction', id: string, text: string | null, status: InterventionActionStatusEnum, createdAt: any, updatedAt: any, interventionId: string | null, closedAt: any | null, estimatedDate: any | null, estimatedTime: number | null, logisticTime: number | null, durationTime: number | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type InterventionActionDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  interventionId: Scalars['ID']['input'];
}>;


export type InterventionActionDestroyMutation = { __typename?: 'Mutation', interventionActionDestroy: boolean | null };

export type JobsQueryVariables = Exact<{
  jids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type JobsQuery = { __typename?: 'Query', data: Array<{ __typename?: 'Job', at: number | null, deliveryRequest: boolean | null, eta: number | null, jid: string | null, kind: JobKindEnum | null, message: string | null, payload: any | null, pctComplete: number | null, status: JobStatusEnum | null, stop: boolean | null, total: number | null, updateTime: number | null, canRetry: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateDeliveryRequest: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }> };

export type JobCancelMutationVariables = Exact<{
  input: JobCancelInput;
}>;


export type JobCancelMutation = { __typename?: 'Mutation', data: boolean | null };

export type JobRetryMutationVariables = Exact<{
  input: JobRetryInput;
}>;


export type JobRetryMutation = { __typename?: 'Mutation', data: boolean | null };

export type JobCreateDeliveryRequestMutationVariables = Exact<{
  input: JobCreateDeliveryRequestInput;
}>;


export type JobCreateDeliveryRequestMutation = { __typename?: 'Mutation', data: boolean | null };

export type SectorFragmentFragment = { __typename?: 'Sector', id: string, code: string | null, name: string | null, color: string | null, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type SectorFullFragmentFragment = { __typename?: 'Sector', id: string, code: string | null, name: string | null, color: string | null, readOnly: boolean, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type SectorsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  filters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskDeadlinesMissed?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SectorsQuery = { __typename?: 'Query', data: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, sitesCount?: number, totalAnomaliesByTaskDeadlinesMissed?: number | null, totalAnomaliesByTaskResults?: number | null, successPercentageByTaskDeadlinesMissed?: number | null, successPercentageByTaskResults?: number | null, code: string | null, color: string | null, readOnly: boolean, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SectorLocationsQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
  mapParams: LocationMapParamsInputObject;
}>;


export type SectorLocationsQuery = { __typename?: 'Query', data: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null, pointCount: number | null, sourceables: Array<{ __typename?: 'GeojsonPropertiesPolymorphicIdentity', id: string, type: GeojsonPropertiesPolymorphicIdentityTypeEnum }> | null } | null }> } | null };

export type SectorLocationCenterQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
}>;


export type SectorLocationCenterQuery = { __typename?: 'Query', data: { __typename?: 'LocationGeographicalCenter', lat: number | null, lon: number | null } | null };

export type SectorsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  filters?: InputMaybe<Array<SectorFilterInputObject> | SectorFilterInputObject>;
}>;


export type SectorsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, color: string | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SectorsPerformanceMetricsByTaskDeadlinesMissedQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissed', id: string, successPercentageByTaskDeadlinesMissed: number | null, totalAnomaliesByTaskDeadlinesMissed: number | null }> | null };

export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  periodGroupBy: PeriodGroupByEnum;
}>;


export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissedByDate', id: string, period: any, totalAnomaliesByTaskDeadlinesMissed: number }> | null };

export type SectorsPerformanceMetricsByTaskResultsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SectorsPerformanceMetricsByTaskResultsQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskResults', id: string, successPercentageByTaskResults: number | null, totalAnomaliesByTaskResults: number | null }> | null };

export type SectorsPerformanceMetricsByTaskResultsByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SectorsPerformanceMetricsByTaskResultsByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SectorPerformanceMetricByTaskResultsByDate', id: string, period: any, totalAnomaliesByTaskResults: number }> | null };

export type SectorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SectorQuery = { __typename?: 'Query', data: { __typename?: 'Sector', description: string | null, sitesCount: number, usersCount: number, id: string, code: string | null, name: string | null, color: string | null, readOnly: boolean, user: { __typename?: 'User', id: string, lastName: string, firstName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SectorCreateMutationVariables = Exact<{
  attributes: SectorCreateInputObject;
}>;


export type SectorCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Sector', description: string | null, id: string, code: string | null, name: string | null, color: string | null, readOnly: boolean, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SectorUpdateMutationVariables = Exact<{
  attributes: SectorUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type SectorUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Sector', description: string | null, id: string, code: string | null, name: string | null, color: string | null, readOnly: boolean, locationBoundary: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SectorDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SectorDestroyMutation = { __typename?: 'Mutation', sectorDestroy: boolean | null };

export type MainSiteFragmentFragment = { __typename?: 'Site', code: string, id: string, name: string, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type FullSiteFragmentFragment = { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: string | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null };

export type SiteQueryVariables = Exact<{
  findBy: SiteFindByInputObject;
}>;


export type SiteQuery = { __typename?: 'Query', site: { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: string | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type SitesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<SiteSortInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskDeadlinesMissed?: InputMaybe<Scalars['Boolean']['input']>;
  includePerformanceDataByTaskResults?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SitesQuery = { __typename?: 'Query', data: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string, code?: string, siteAreasCount?: number, usersCount?: number, totalAnomaliesByTaskDeadlinesMissed?: number | null, totalAnomaliesByTaskResults?: number | null, successPercentageByTaskDeadlinesMissed?: number | null, successPercentageByTaskResults?: number | null, locationPhotoAttached?: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sector?: { __typename?: 'Sector', id: string, name: string | null, color: string | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SiteLocationsQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  mapParams: LocationMapParamsInputObject;
}>;


export type SiteLocationsQuery = { __typename?: 'Query', data: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null, pointCount: number | null, sourceables: Array<{ __typename?: 'GeojsonPropertiesPolymorphicIdentity', id: string, type: GeojsonPropertiesPolymorphicIdentityTypeEnum }> | null } | null }> } | null };

export type SiteLocationCenterQueryVariables = Exact<{
  filters?: InputMaybe<Array<LocationFilterInputObject> | LocationFilterInputObject>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
}>;


export type SiteLocationCenterQuery = { __typename?: 'Query', data: { __typename?: 'LocationGeographicalCenter', lat: number | null, lon: number | null } | null };

export type SitesIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  sorts?: InputMaybe<SiteSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SitesIdsQuery = { __typename?: 'Query', data: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string }> } };

export type SitesSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteFilterInputObject> | SiteFilterInputObject>;
  sorts?: InputMaybe<SiteSortInputObject>;
}>;


export type SitesSearchListQuery = { __typename?: 'Query', data: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string, code: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SitesPerformanceMetricsByTaskDeadlinesMissedQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskDeadlinesMissed', id: string, successPercentageByTaskDeadlinesMissed: number | null, totalAnomaliesByTaskDeadlinesMissed: number | null }> | null };

export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  periodGroupBy: PeriodGroupByEnum;
}>;


export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskDeadlinesMissedByDate', id: string, period: any, totalAnomaliesByTaskDeadlinesMissed: number }> | null };

export type SitesPerformanceMetricsByTaskResultsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SitesPerformanceMetricsByTaskResultsQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskResults', id: string, successPercentageByTaskResults: number | null, totalAnomaliesByTaskResults: number | null }> | null };

export type SitesPerformanceMetricsByTaskResultsByDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type SitesPerformanceMetricsByTaskResultsByDateQuery = { __typename?: 'Query', data: Array<{ __typename?: 'SitePerformanceMetricByTaskResultsByDate', id: string, period: any, totalAnomaliesByTaskResults: number }> | null };

export type SiteCreateMutationVariables = Exact<{
  attributes: SiteCreateInputObject;
}>;


export type SiteCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: string | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type SiteUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: SiteUpdateInputObject;
}>;


export type SiteUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Site', updatedAt: any, phoneNumber: string | null, description: string | null, email: string, createdAt: any, usersCount: number, siteAreasCount: number, code: string, id: string, name: string, locationPoint: { __typename?: 'Location', kind: string, id: string, geojson: { __typename?: 'GeojsonFeatureCollection', type: GeojsonFeatureCollectionTypeEnum, features: Array<{ __typename?: 'GeojsonFeature', type: GeojsonFeatureTypeEnum, geometry: { __typename?: 'GeojsonGeometry', coordinates: any, type: GeojsonGeometryTypeEnum }, properties: { __typename?: 'GeojsonProperties', address: string | null, addressDetails: string | null, color: string | null, icon: string | null, shape: string | null, type: GeojsonPropertiesTypeEnum | null } | null }> } | null } | null, siteConductCodeSections: Array<{ __typename?: 'SiteConductCodeSection', body: string, createdAt: any, id: string, position: number, title: string, updatedAt: any }>, sector: { __typename?: 'Sector', id: string, name: string | null, color: string | null } | null, locationPhotoAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, phoneNumber: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type SiteDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SiteDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type SiteAreaFragmentFragment = { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean };

export type SiteAreaQueryVariables = Exact<{
  findBy: SiteAreaFindByInputObject;
  siteFindBy: SiteFindByInputObject;
}>;


export type SiteAreaQuery = { __typename?: 'Query', data: { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean } | null };

export type SiteAreasQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteAreaFilterInputObject> | SiteAreaFilterInputObject>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeSiteData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SiteAreasQuery = { __typename?: 'Query', data: { __typename?: 'SiteAreaCollection', collection: Array<{ __typename?: 'SiteArea', address?: string | null, code: string, description?: string | null, fullCode: string, id: string, name: string, poorWifi?: boolean, site?: { __typename?: 'Site', id: string, name: string, code: string, sector: { __typename?: 'Sector', id: string, name: string | null, color: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SiteAreaIdsQueryVariables = Exact<{
  filters?: InputMaybe<Array<SiteAreaFilterInputObject> | SiteAreaFilterInputObject>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  includeSiteId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SiteAreaIdsQuery = { __typename?: 'Query', data: { __typename?: 'SiteAreaCollection', collection: Array<{ __typename?: 'SiteArea', id: string, siteId?: string | null }> } };

export type SiteAreasSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SiteAreaFilterInputObject> | SiteAreaFilterInputObject>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
}>;


export type SiteAreasSearchListQuery = { __typename?: 'Query', data: { __typename?: 'SiteAreaCollection', collection: Array<{ __typename?: 'SiteArea', id: string, name: string, poorWifi: boolean }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SiteAreaUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: SiteAreaUpdateInputObject;
}>;


export type SiteAreaUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'SiteArea', address: string | null, code: string, description: string | null, fullCode: string, id: string, name: string, poorWifi: boolean } | null };

export type SiteAreaBulkDestroyMutationVariables = Exact<{
  input: SiteAreaBulkDestroyInput;
}>;


export type SiteAreaBulkDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type SiteAreaBulkQrCodeCreateMutationVariables = Exact<{
  params: QrCodesCreateInputObject;
}>;


export type SiteAreaBulkQrCodeCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Job', at: number | null, deliveryRequest: boolean | null, eta: number | null, jid: string | null, kind: JobKindEnum | null, message: string | null, payload: any | null, pctComplete: number | null, status: JobStatusEnum | null, stop: boolean | null, total: number | null, updateTime: number | null, canRetry: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateDeliveryRequest: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type SsoIntegrationFragmentFragment = { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> };

export type SsoIntegrationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SsoIntegrationSortInputObject>;
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject> | SsoIntegrationFilterInputObject>;
}>;


export type SsoIntegrationsQuery = { __typename?: 'Query', data: { __typename?: 'SsoIntegrationCollection', collection: Array<{ __typename?: 'SsoIntegration', id: string, name: string, status: SsoIntegrationStatusEnum, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SsoIntegrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationQuery = { __typename?: 'Query', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationCreateMutationVariables = Exact<{
  attributes: SsoIntegrationCreateInputObject;
}>;


export type SsoIntegrationCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: SsoIntegrationUpdateInputObject;
}>;


export type SsoIntegrationUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationPresetDefaultsQueryVariables = Exact<{
  preset: SsoIntegrationProviderPresetEnum;
}>;


export type SsoIntegrationPresetDefaultsQuery = { __typename?: 'Query', data: any };

export type SsoIntegrationGenerateCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type SsoIntegrationGenerateCodeQuery = { __typename?: 'Query', data: { __typename?: 'SsoGeneratedCode', code: string, acsUrl: string, entityId: string, metadataUrl: string } };

export type SsoIntegrationActivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationActivateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationDeactivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationDeactivateMutation = { __typename?: 'Mutation', data: { __typename?: 'SsoIntegration', id: string, name: string, code: string, providerPreset: SsoIntegrationProviderPresetEnum, providerType: SsoIntegrationProviderTypeEnum, displayStatus: SsoIntegrationDisplayStatusEnum, status: SsoIntegrationStatusEnum, warningKey: SsoIntegrationWarningKeyEnum | null, idpMetadata: string | null, attributeMapping: any | null, allowIdpInitiated: boolean, jitProvisioningEnabled: boolean, syncUserAttributes: boolean, timeToleranceSeconds: number | null, pinned: boolean, createdAt: any, updatedAt: any, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, companyDomains: Array<{ __typename?: 'CompanyDomain', id: string }> } | null };

export type SsoIntegrationDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SsoIntegrationDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type CompanyDomainFragmentFragment = { __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any };

export type CompanyDomainsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject> | CompanyDomainFilterInputObject>;
}>;


export type CompanyDomainsQuery = { __typename?: 'Query', data: { __typename?: 'CompanyDomainCollection', collection: Array<{ __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type CompanyDomainCreateMutationVariables = Exact<{
  attributes: CompanyDomainCreateInputObject;
}>;


export type CompanyDomainCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any } | null };

export type CompanyDomainVerifyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompanyDomainVerifyMutation = { __typename?: 'Mutation', data: { __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean, verifiedAt: any | null, dnsTxtRecord: string, createdAt: any, updatedAt: any } | null };

export type CompanyDomainDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompanyDomainDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type SsoIntegrationsDomainCheckQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject> | SsoIntegrationFilterInputObject>;
}>;


export type SsoIntegrationsDomainCheckQuery = { __typename?: 'Query', data: { __typename?: 'SsoIntegrationCollection', collection: Array<{ __typename?: 'SsoIntegration', id: string }> } };

export type CompanyDomainsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject> | CompanyDomainFilterInputObject>;
}>;


export type CompanyDomainsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'CompanyDomainCollection', collection: Array<{ __typename?: 'CompanyDomain', id: string, domain: string, verified: boolean }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type SsoIntegrationSupportedMappingFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type SsoIntegrationSupportedMappingFieldsQuery = { __typename?: 'Query', ssoIntegrationSupportedMappingFields: Array<{ __typename?: 'SsoMappingField', description: string | null, key: string, label: string, required: boolean, sortIndex: number }> };

export type TagsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TagSortInputObject>;
  filters?: InputMaybe<Array<TagFilterInputObject> | TagFilterInputObject>;
}>;


export type TagsQuery = { __typename?: 'Query', data: { __typename?: 'TagCollection', collection: Array<{ __typename?: 'Tag', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TagQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagQuery = { __typename?: 'Query', data: { __typename?: 'Tag', id: string, name: string } | null };

export type TagCreateMutationVariables = Exact<{
  attributes: TagCreateInputObject;
}>;


export type TagCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Tag', id: string, name: string } | null };

export type TagDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagDestroyMutation = { __typename?: 'Mutation', tagDestroy: boolean | null };

export type CanActionsTaskFragmentFragment = { __typename?: 'Task', canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type RecurringRuleFragmentFragment = { __typename?: 'RecurringRule', endsAfterOccurrences: number | null, endTime: any | null, id: string, countdownType: RecurringRuleCountdownTypeEnum | null, excludedWdays: Array<number> | null, startTime: any, schema: { __typename?: 'RecurringRuleSchema', rrules: Array<{ __typename?: 'RecurringRuleSchemaRule', interval: number, ruleType: RecurringRuleRuleTypeEnum, validations: { __typename?: 'RecurringRuleValidations', day: Array<number> | null, dayOfWeek: any | null, dayOfMonth: Array<number> | null, monthOfYear: Array<number> | null } | null }>, metadata: { __typename?: 'RecurringRuleSchemaMetadata', schemaOption: RecurringRuleSchemaOptionEnum } | null } };

export type EarlyCompletionFragmentFragment = { __typename?: 'Task', earlyCompletion: number | null, earlyCompletionUnit: TaskEarlyCompletionUnitEnum | null };

export type TaskFragmentFragment = { __typename?: 'Task', id: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplate: { __typename?: 'FormTemplate', canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } };

export type TaskFormCompletionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskFormCompletionQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, formTemplate: { __typename?: 'FormTemplate', description: string | null, id: string, name: string, createdAt: any, updatedAt: any, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null }, completion: { __typename?: 'TaskCompletion', id: string, answers: Array<{ __typename?: 'FormAnswer', id: string, kind: FormTemplateQuestionFieldsKindEnum, fieldId: string, questionId: string, field: { __typename?: 'FormTemplateQuestionField', id: string, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, fieldId: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string> }> }, resp: Array<{ __typename?: 'FormAnswerResp', group: FormAnswerRespGroupEnum | null, optionId: string | null, position: number | null, selected: boolean | null, value: string | null, valueId: string | null }>, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }> | null } | null } | null };

export type DashboardTaskCounterQueryVariables = Exact<{
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
}>;


export type DashboardTaskCounterQuery = { __typename?: 'Query', myApprovals: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type DashboardTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardTaskQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, formTemplate: { __typename?: 'FormTemplate', id: string, name: string, canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardFullTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardFullTaskQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, earlyCompletion: number | null, earlyCompletionUnit: TaskEarlyCompletionUnitEnum | null, formTemplate: { __typename?: 'FormTemplate', id: string, name: string, canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, recurringRule: { __typename?: 'RecurringRule', endsAfterOccurrences: number | null, endTime: any | null, id: string, countdownType: RecurringRuleCountdownTypeEnum | null, excludedWdays: Array<number> | null, startTime: any, schema: { __typename?: 'RecurringRuleSchema', rrules: Array<{ __typename?: 'RecurringRuleSchemaRule', interval: number, ruleType: RecurringRuleRuleTypeEnum, validations: { __typename?: 'RecurringRuleValidations', day: Array<number> | null, dayOfWeek: any | null, dayOfMonth: Array<number> | null, monthOfYear: Array<number> | null } | null }>, metadata: { __typename?: 'RecurringRuleSchemaMetadata', schemaOption: RecurringRuleSchemaOptionEnum } | null } } | null, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardTaskFormTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardTaskFormTemplateQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, formTemplate: { __typename?: 'FormTemplate', description: string | null, id: string, name: string, createdAt: any, updatedAt: any, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null, canUpdate: { __typename?: 'AuthorizationResult', value: boolean }, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, templateId: string, position: number, description: string | null, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, settings: { __typename?: 'FormTemplateQuestionFieldSettings', allowDisplayLastAnswer: boolean | null, limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null }, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, condition: FormTemplateQuestionFieldOptionConditionEnum | null }>, validityHintConfig: Array<{ __typename?: 'FormTemplateQuestionFieldValidityHintConfig', optionPositions: Array<number>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum }> }> }> }, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardTaskScheduleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardTaskScheduleQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, kind: TaskKindEnum, deadlineAt: any | null, earlyCompletion: number | null, earlyCompletionUnit: TaskEarlyCompletionUnitEnum | null, recurringRule: { __typename?: 'RecurringRule', endsAfterOccurrences: number | null, endTime: any | null, id: string, countdownType: RecurringRuleCountdownTypeEnum | null, excludedWdays: Array<number> | null, startTime: any, schema: { __typename?: 'RecurringRuleSchema', rrules: Array<{ __typename?: 'RecurringRuleSchemaRule', interval: number, ruleType: RecurringRuleRuleTypeEnum, validations: { __typename?: 'RecurringRuleValidations', day: Array<number> | null, dayOfWeek: any | null, dayOfMonth: Array<number> | null, monthOfYear: Array<number> | null } | null }>, metadata: { __typename?: 'RecurringRuleSchemaMetadata', schemaOption: RecurringRuleSchemaOptionEnum } | null } } | null } | null };

export type DashboardTaskShortQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardTaskShortQuery = { __typename?: 'Query', data: { __typename?: 'Task', id: string, name: string, assetId: string | null, siteId: string | null, siteAreaId: string | null, groupKey: string, formTemplate: { __typename?: 'FormTemplate', id: string }, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type DashboardTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
  includeArchivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeadlineAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeadlineMissedReason?: InputMaybe<Scalars['Boolean']['input']>;
  includeFormTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  includeLastCheckAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeLateFor?: InputMaybe<Scalars['Boolean']['input']>;
  includeAsset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DashboardTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, priority: TaskPriorityEnum, status: TaskStatusEnum, kind: TaskKindEnum, recurringRuleId: string | null, deadlineAt?: any | null, lastCheckAt?: any | null, archivedAt?: any | null, completedAt?: any | null, lateFor?: number | null, deadlineMissedReason?: TaskDeadlineMissedReasonEnum | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, asset?: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplate?: { __typename?: 'FormTemplate', id: string, category: { __typename?: 'FormCategory', id: string, name: string, color: string } | null }, completion?: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, active: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, archived: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, completed: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, myApprovals: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, pending: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, deadlineMissed: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type FormTemplateTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type FormTemplateTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, recurringRuleId: string | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, formTemplate: { __typename?: 'FormTemplate', id: string }, canFormTemplateVersionUpdate: { __typename?: 'AuthorizationResult', value: boolean } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type DashboardTaskIdsQueryVariables = Exact<{
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DashboardTaskIdsQuery = { __typename?: 'Query', data: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string }> } };

export type DashboardOverviewTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  activeTasksFilters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
  includeCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  includeStatus?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DashboardOverviewTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, deadlineAt: any | null, nextDeadlineAt: any | null, completedAt: any | null, assetId: string | null, priority: TaskPriorityEnum, status?: TaskStatusEnum, recurringRuleId: string | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, completion?: { __typename?: 'TaskCompletion', id: string, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null, canStatusUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null, intervention: { __typename?: 'Intervention', id: string, closedAt: any | null } | null, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCompletionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, active: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, completed: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, failure: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, solved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, success: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, warning: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, warningUnsolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, warningSolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, failureUnsolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, failureSolved: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, dashboardAll: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, deadlineMissedWithoutReason: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type DashboardTimelineTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type DashboardTimelineTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, deadlineAt: any | null, completedAt: any | null, archivedAt: any | null, priority: TaskPriorityEnum, status: TaskStatusEnum, recurringRuleId: string | null, formTemplate: { __typename?: 'FormTemplate', id: string, category: { __typename?: 'FormCategory', id: string, name: string, color: string } | null }, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } }, taskIds: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string }> }, timelineAll: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, timelineFailure: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, timelineWarning: { __typename?: 'TaskCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type TasksTimelineQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  queryData: TaskTimelineQueryDataInputObject;
}>;


export type TasksTimelineQuery = { __typename?: 'Query', tasksTimeline: Array<{ __typename?: 'TaskTimeline', id: string, rows: Array<{ __typename?: 'TaskTimelineRow', date: string, validityHintCounters: { __typename?: 'TaskTimelineValidityHintCounter', failure: number | null, none: number | null, success: number | null, warning: number | null } }> }> };

export type TasksSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type TasksSearchListQuery = { __typename?: 'Query', data: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TaskCompletionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  groupKey: Scalars['ID']['input'];
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject> | TaskCompletionFilterInputObject>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
}>;


export type TaskCompletionsQuery = { __typename?: 'Query', data: { __typename?: 'TaskCompletionCollection', collection: Array<{ __typename?: 'TaskCompletion', id: string, taskId: string | null, createdAt: any, solvedAt: any | null, status: TaskCompletionStatusEnum | null, answers: Array<{ __typename?: 'FormAnswer', id: string, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, resp: Array<{ __typename?: 'FormAnswerResp', selected: boolean | null, value: string | null, valueId: string | null }> }> | null, task: { __typename?: 'Task', assetId: string | null, siteAreaId: string | null, siteId: string | null, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null }, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, intervention: { __typename?: 'Intervention', id: string } | null } | null, performer: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TaskCompletionsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  groupKey: Scalars['ID']['input'];
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject> | TaskCompletionFilterInputObject>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
}>;


export type TaskCompletionsIdsQuery = { __typename?: 'Query', data: { __typename?: 'TaskCompletionCollection', collection: Array<{ __typename?: 'TaskCompletion', id: string }> } };

export type TaskCompletionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskCompletionQuery = { __typename?: 'Query', data: { __typename?: 'TaskCompletion', id: string, createdAt: any, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, answers: Array<{ __typename?: 'FormAnswer', id: string, kind: FormTemplateQuestionFieldsKindEnum, fieldId: string, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, questionId: string, field: { __typename?: 'FormTemplateQuestionField', id: string, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, fieldId: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string> }> }, resp: Array<{ __typename?: 'FormAnswerResp', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, group: FormAnswerRespGroupEnum | null, optionId: string | null, position: number | null, selected: boolean | null, value: string | null, valueId: string | null }>, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }> }> | null, task: { __typename?: 'Task', assetId: string | null, siteAreaId: string | null, siteId: string | null, formTemplateVersion: { __typename?: 'FormTemplateVersion', id: string, version: string | null, questions: Array<{ __typename?: 'FormTemplateQuestion', id: string, position: number, name: string | null, attachmentsAttached: Array<{ __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null }>, fields: Array<{ __typename?: 'FormTemplateQuestionField', id: string, kind: FormTemplateQuestionFieldsKindEnum, required: boolean, position: number, options: Array<{ __typename?: 'FormTemplateQuestionFieldOption', id: string, group: FormTemplateQuestionFieldOptionGroupEnum | null, position: number, values: Array<string>, validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null }>, settings: { __typename?: 'FormTemplateQuestionFieldSettings', limitToOneRespPerColumn: boolean | null, limitToOneRespPerRow: boolean | null, limitToOneResp: boolean | null } }> }> }, canInterventionCreate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, intervention: { __typename?: 'Intervention', id: string } | null } | null, performer: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null } | null };

export type TasksMyTodoCompletableByDateDataQueryVariables = Exact<{
  date: Scalars['ISO8601DateTime']['input'];
}>;


export type TasksMyTodoCompletableByDateDataQuery = { __typename?: 'Query', data: Array<{ __typename?: 'TasksTodoCompletableByDateData', id: string, offlineImportantDataDigest: string }> };

export type TasksDuplicationListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  filters?: InputMaybe<Array<TaskFilterInputObject> | TaskFilterInputObject>;
  sorts?: InputMaybe<TaskSortInputObject>;
}>;


export type TasksDuplicationListQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', id: string, name: string, status: TaskStatusEnum, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string } | null, formTemplate: { __typename?: 'FormTemplate', id: string, name: string, category: { __typename?: 'FormCategory', color: string, name: string, id: string } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TaskCompletionCreateMutationVariables = Exact<{
  input: TaskCompletionCreateInputObject;
}>;


export type TaskCompletionCreateMutation = { __typename?: 'Mutation', taskCompletionCreate: { __typename?: 'TaskCompletion', id: string } | null };

export type TaskBulkCreateSameMutationVariables = Exact<{
  attributes: TaskBulkCreateSameInputObject;
}>;


export type TaskBulkCreateSameMutation = { __typename?: 'Mutation', data: Array<string> | null };

export type TaskUpdateMutationVariables = Exact<{
  attributes: TaskUpdateInputObject;
  id: Scalars['ID']['input'];
}>;


export type TaskUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Task', id: string, kind: TaskKindEnum, name: string, description: string | null, priority: TaskPriorityEnum, status: TaskStatusEnum, completedAt: any | null, recurringRuleId: string | null, lastDeadlineAt: any | null, lateFor: number | null, createdAt: any, deadlineAt: any | null, archivedAt: any | null, lastCheckAt: any | null, originalCreatedAt: any, completion: { __typename?: 'TaskCompletion', validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum | null, status: TaskCompletionStatusEnum | null, solvedAt: any | null } | null, site: { __typename?: 'Site', id: string, name: string } | null, siteArea: { __typename?: 'SiteArea', id: string, name: string, fullCode: string } | null, approver: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, asset: { __typename?: 'Asset', id: string, name: string, fullCode: string, siteArea: { __typename?: 'SiteArea', code: string } | null, iconAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null } | null, formTemplate: { __typename?: 'FormTemplate', canUpdate: { __typename?: 'AuthorizationResult', value: boolean } }, canArchive: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canReschedule: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canQrCodeRelatedInfoUpdate: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type TaskBulkSchedulingMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: TaskBulkSchedulingInputObject;
}>;


export type TaskBulkSchedulingMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskBulkUpdateStatusMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: TaskUpdateStatusInputObject;
}>;


export type TaskBulkUpdateStatusMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskBulkDeadlineMissedReasonUpdateMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  attributes: TaskUpdateDeadlineMissedReasonInputObject;
}>;


export type TaskBulkDeadlineMissedReasonUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskCompletionStatusUpdateMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  attributes: TaskCompletionUpdateStatusInputObject;
}>;


export type TaskCompletionStatusUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'TaskCompletion', id: string } | null };

export type TaskBulkTemplateVersionUpdateMutationVariables = Exact<{
  input: TaskBulkTemplateVersionUpdateInput;
}>;


export type TaskBulkTemplateVersionUpdateMutation = { __typename?: 'Mutation', data: boolean | null };

export type TaskTimelineReportCreateMutationVariables = Exact<{
  input: TasksTimelineReportCreateInput;
}>;


export type TaskTimelineReportCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Job', at: number | null, deliveryRequest: boolean | null, eta: number | null, jid: string | null, kind: JobKindEnum | null, message: string | null, payload: any | null, pctComplete: number | null, status: JobStatusEnum | null, stop: boolean | null, total: number | null, updateTime: number | null, canRetry: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCancel: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, canCreateDeliveryRequest: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } } | null };

export type TeamFragmentFragment = { __typename?: 'Team', id: string, name: string | null, description: string | null, color: string, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> };

export type TeamsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
  filters?: InputMaybe<Array<TeamFilterInputObject> | TeamFilterInputObject>;
}>;


export type TeamsQuery = { __typename?: 'Query', data: { __typename?: 'TeamCollection', collection: Array<{ __typename?: 'Team', id: string, name: string | null, color: string, visibleUsersCount: number | null, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TeamsIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
  filters?: InputMaybe<Array<TeamFilterInputObject> | TeamFilterInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TeamsIdsQuery = { __typename?: 'Query', data: { __typename?: 'TeamCollection', collection: Array<{ __typename?: 'Team', id: string }> } };

export type TeamsSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
  filters?: InputMaybe<Array<TeamFilterInputObject> | TeamFilterInputObject>;
}>;


export type TeamsSearchListQuery = { __typename?: 'Query', data: { __typename?: 'TeamCollection', collection: Array<{ __typename?: 'Team', id: string, name: string | null, color: string }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type TeamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TeamQuery = { __typename?: 'Query', data: { __typename?: 'Team', id: string, name: string | null, description: string | null, color: string, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> } | null };

export type TeamCreateMutationVariables = Exact<{
  attributes: TeamCreateInputObject;
}>;


export type TeamCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Team', id: string, name: string | null, description: string | null, color: string, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> } | null };

export type TeamUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: TeamUpdateInputObject;
}>;


export type TeamUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Team', id: string, name: string | null, description: string | null, color: string, readOnly: boolean, canDestroy: { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null }, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null }> } | null };

export type TeamDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TeamDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type FullUserFragmentFragment = { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: string } };

export type UsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeShortData?: InputMaybe<Scalars['Boolean']['input']>;
  includeFinalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includePersonalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeamAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeamData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired?: boolean, role: UserRoleEnum, personalId?: string | null, unconfirmedEmail?: string | null, verified?: boolean | null, deactivatedAt?: any | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, sectors?: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, color: string | null }> }, team?: { __typename?: 'Team', id: string, name: string | null, color: string, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> }, finalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, personalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type UsersIdsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersIdsQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string }> } };

export type UsersCountersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  fullAdminsFilters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  usersFilters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  unassignedFilters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersCountersQuery = { __typename?: 'Query', all: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, fullAdmins: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, users: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } }, unassigned: { __typename?: 'UserCollection', metadata: { __typename?: 'CollectionMetadata', totalCount: number } } };

export type UsersSearchListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<UserSortInputObject>;
  filters?: InputMaybe<Array<UserFilterInputObject> | UserFilterInputObject>;
  scope?: InputMaybe<UserScopeInputObject>;
}>;


export type UsersSearchListQuery = { __typename?: 'Query', data: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeFullData?: InputMaybe<Scalars['Boolean']['input']>;
  includeFinalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includePersonalAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  includeTeamAccesses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserQuery = { __typename?: 'Query', data: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId?: string | null, phoneNumber?: string | null, verified?: boolean | null, username?: string | null, deactivatedAt: any | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites?: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, sectors?: { __typename?: 'SectorCollection', collection: Array<{ __typename?: 'Sector', id: string, name: string | null, color: string | null }> }, team?: { __typename?: 'Team', id: string, name: string | null, color: string, accesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> }, finalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, personalAccesses?: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> } | null };

export type UserCreateMutationVariables = Exact<{
  attributes: UserCreateInputObject;
  redirectUrl: Scalars['String']['input'];
}>;


export type UserCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: string } } | null };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: UserUpdateInputObject;
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  confirmEmailRedirectUrl: Scalars['String']['input'];
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: string } } | null };

export type UserSelfUpdateMutationVariables = Exact<{
  input: UserSelfUpdateInput;
}>;


export type UserSelfUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'User', deactivatedAt: any | null, id: string, firstName: string, lastName: string, email: string | null, passwordSetupRequired: boolean, role: UserRoleEnum, personalId: string | null, phoneNumber: string | null, lang: LanguageEnum, verified: boolean | null, unconfirmedEmail: string | null, username: string | null, finalAccesses: Array<{ __typename?: 'Access', component: AccessComponentEnum, itemIds: Array<string>, level: AccessLevelEnum | null, scopeLevel: AccessScopeLevelEnum | null, policy: AccessPolicyEnum | null }> | null, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null, metadata: { __typename?: 'AttachmentMetadata', intendedUse: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> }, company: { __typename?: 'Company', id: string, name: string }, team: { __typename?: 'Team', id: string, name: string | null, color: string } } | null };

export type UserDestroyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserDestroyMutation = { __typename?: 'Mutation', data: boolean | null };

export type AuthenticationPasswordSetupMutationVariables = Exact<{
  input: AuthenticationPasswordSetupInput;
}>;


export type AuthenticationPasswordSetupMutation = { __typename?: 'Mutation', data: boolean };

export type UserBulkActivateMutationVariables = Exact<{
  input: UserBulkActivateInput;
}>;


export type UserBulkActivateMutation = { __typename?: 'Mutation', data: boolean | null };

export type UserBulkDeactivateMutationVariables = Exact<{
  input: UserBulkDeactivateInput;
}>;


export type UserBulkDeactivateMutation = { __typename?: 'Mutation', data: boolean | null };

export const AssetCategoryFragmentFragmentDoc = gql`
    fragment assetCategoryFragment on AssetCategory {
  color
  name
  id
  prefix
}
    `;
export const AttachmentFragmentFragmentDoc = gql`
    fragment attachmentFragment on Attachment {
  id
  processed
  fileTag
  fileData
  filename
  urls {
    large
    medium
    original
    small
    imagePreview
    originalDirectDownload
  }
  metadata {
    intendedUse
  }
}
    `;
export const AssetFragmentFragmentDoc = gql`
    fragment assetFragment on Asset {
  category {
    ...assetCategoryFragment
  }
  id
  qrPrefix
  code
  fullCode
  manufacturer
  model
  name
  serialNumber
  serviceDate
  description
  poorWifi
  site {
    id
    name
  }
  siteArea {
    id
    name
  }
  iconAttached {
    ...attachmentFragment
  }
}
    ${AssetCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;
export const AuthorizationResultFragmentFragmentDoc = gql`
    fragment authorizationResultFragment on AuthorizationResult {
  value
  message
  reasons {
    details
    fullMessages
  }
}
    `;
export const DataImportFragmentFragmentDoc = gql`
    fragment dataImportFragment on DataImport {
  attachmentAttached {
    ...attachmentFragment
  }
  importedRows
  failureDetails
  fileException
  id
  jid
  kind
  status
  job {
    canCancel {
      ...authorizationResultFragment
    }
  }
  totalRows
  createdAt
  user {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
  }
  canDestroy {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;
export const FeFilterPresetFragmentDoc = gql`
    fragment feFilterPreset on FeFilterPreset {
  data
  id
  kind
  name
  entities {
    sites {
      id
    }
    sectors {
      id
    }
    formCategories {
      id
    }
    formTemplates {
      id
    }
  }
}
    `;
export const FormCategoryFragmentFragmentDoc = gql`
    fragment formCategoryFragment on FormCategory {
  color
  name
  id
}
    `;
export const FormTemplateFragmentFragmentDoc = gql`
    fragment formTemplateFragment on FormTemplate {
  category {
    ...formCategoryFragment
  }
  description
  id
  name
  createdAt
  updatedAt
}
    ${FormCategoryFragmentFragmentDoc}`;
export const FormTemplateFullFragmentFragmentDoc = gql`
    fragment formTemplateFullFragment on FormTemplate {
  ...formTemplateFragment
  visibleLinkedTasksCount
  currentVersion {
    id
    version
  }
}
    ${FormTemplateFragmentFragmentDoc}`;
export const QuestionsFragmentFragmentDoc = gql`
    fragment questionsFragment on FormTemplateVersion {
  questions {
    id
    templateId
    position
    description
    attachmentsAttached {
      ...attachmentFragment
    }
    name
    fields {
      id
      kind
      required
      settings {
        allowDisplayLastAnswer
        limitToOneRespPerColumn
        limitToOneRespPerRow
        limitToOneResp
      }
      options {
        id
        group
        position
        values
        validityHint
        condition
      }
      validityHintConfig {
        optionPositions
        validityHint
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;
export const FormTemplateVersionFragmentFragmentDoc = gql`
    fragment formTemplateVersionFragment on FormTemplateVersion {
  id
  templateId
  version
  createdAt
  archivedAt
  status
  ...questionsFragment
}
    ${QuestionsFragmentFragmentDoc}`;
export const FullFormTemplateVersionFragmentFragmentDoc = gql`
    fragment fullFormTemplateVersionFragment on FormTemplateVersion {
  ...formTemplateVersionFragment
  ...questionsFragment
  canUpdate {
    value
  }
  canDestroy {
    value
  }
  canArchive {
    value
  }
  canRestore {
    value
  }
}
    ${FormTemplateVersionFragmentFragmentDoc}
${QuestionsFragmentFragmentDoc}`;
export const FormChecklistTemplateFragmentFragmentDoc = gql`
    fragment formChecklistTemplateFragment on FormChecklistTemplate {
  id
  name
  description
  optionsCount
  canUpdate {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;
export const FormChecklistTemplateWithOptionsFragmentFragmentDoc = gql`
    fragment formChecklistTemplateWithOptionsFragment on FormChecklistTemplate {
  ...formChecklistTemplateFragment
  options {
    id
    value
    position
    updatedAt
  }
}
    ${FormChecklistTemplateFragmentFragmentDoc}`;
export const MetadataFragmentFragmentDoc = gql`
    fragment metadataFragment on CollectionMetadata {
  currentPage
  limitValue
  totalCount
  totalPages
}
    `;
export const JobFragmentFragmentDoc = gql`
    fragment jobFragment on Job {
  at
  deliveryRequest
  eta
  jid
  kind
  message
  payload
  pctComplete
  status
  stop
  total
  updateTime
  canRetry {
    ...authorizationResultFragment
  }
  canCancel {
    ...authorizationResultFragment
  }
  canCreateDeliveryRequest {
    ...authorizationResultFragment
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;
export const GeojsonFullFragmentFragmentDoc = gql`
    fragment geojsonFullFragment on GeojsonFeatureCollection {
  features {
    geometry {
      coordinates
      type
    }
    properties {
      address
      addressDetails
      color
      icon
      shape
      type
      pointCount
      sourceables {
        id
        type
      }
    }
    type
  }
  type
}
    `;
export const HomePageFragmentFragmentDoc = gql`
    fragment homePageFragment on HomePage {
  id
  name
  position
  isDefault
  userId
  createdAt
  updatedAt
  canUpdate {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;
export const WidgetFragmentFragmentDoc = gql`
    fragment widgetFragment on Widget {
  id
  homePageId
  widgetTemplateId
  kind
  title
  description
  position
  grid
  fields {
    backgroundColor
    link
    location
    timezone
    startAt
    endAt
    onlyMy
    buttons {
      asset {
        enabled
        updatedAt
      }
      formTemplate {
        enabled
        updatedAt
      }
      intervention {
        enabled
        updatedAt
      }
      site {
        enabled
        updatedAt
      }
      task {
        enabled
        updatedAt
      }
      teamMember {
        enabled
        updatedAt
      }
    }
  }
  attachmentsAttached {
    ...attachmentFragment
  }
  createdAt
  updatedAt
}
    ${AttachmentFragmentFragmentDoc}`;
export const WidgetTemplateFragmentFragmentDoc = gql`
    fragment widgetTemplateFragment on WidgetTemplate {
  id
  title
  description
  kind
  visibility
  isDefault
  fields {
    backgroundColor
    content
    link
  }
  attachmentsAttached {
    ...attachmentFragment
  }
}
    ${AttachmentFragmentFragmentDoc}`;
export const InterventionCategoryFragmentFragmentDoc = gql`
    fragment interventionCategoryFragment on InterventionCategory {
  id
  name
  color
  description
}
    `;
export const InterventionFragmentFragmentDoc = gql`
    fragment interventionFragment on Intervention {
  id
  name
  code
  description
  attachmentsAttached {
    ...attachmentFragment
  }
  category {
    id
    name
    color
  }
  priority
  status
  site {
    id
    name
  }
  siteArea {
    id
    name
  }
  asset {
    id
    name
    fullCode
    iconAttached {
      ...attachmentFragment
    }
  }
  task {
    id
    name
  }
  supervisor {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  estimatedDate
  totalLogisticTime
  totalEstimatedTime
  estimatedTime
  logisticTime
  durationTime
  totalTime
  createdAt
  createdBy {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  canDestroy {
    ...authorizationResultFragment
  }
  canClose {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
  canCreateAction {
    ...authorizationResultFragment
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;
export const InterventionActionFragmentFragmentDoc = gql`
    fragment interventionActionFragment on InterventionAction {
  id
  text
  status
  createdAt
  updatedAt
  interventionId
  closedAt
  estimatedDate
  estimatedTime
  logisticTime
  durationTime
  createdBy {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  attachmentsAttached {
    ...attachmentFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;
export const SectorFragmentFragmentDoc = gql`
    fragment sectorFragment on Sector {
  id
  code
  name
  color
  readOnly
  canDestroy {
    ...authorizationResultFragment
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;
export const GeojsonFragmentFragmentDoc = gql`
    fragment geojsonFragment on GeojsonFeatureCollection {
  features {
    geometry {
      coordinates
      type
    }
    properties {
      address
      addressDetails
      color
      icon
      shape
      type
    }
    type
  }
  type
}
    `;
export const LocationBoundaryFragmentFragmentDoc = gql`
    fragment locationBoundaryFragment on Location {
  kind
  id
  geojson {
    ...geojsonFragment
  }
}
    ${GeojsonFragmentFragmentDoc}`;
export const SectorFullFragmentFragmentDoc = gql`
    fragment sectorFullFragment on Sector {
  ...sectorFragment
  locationBoundary {
    ...locationBoundaryFragment
  }
}
    ${SectorFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}`;
export const MainSiteFragmentFragmentDoc = gql`
    fragment mainSiteFragment on Site {
  code
  id
  locationPhotoAttached {
    ...attachmentFragment
  }
  name
  user {
    id
    firstName
    lastName
    email
    avatarAttached {
      ...attachmentFragment
    }
    phoneNumber
  }
}
    ${AttachmentFragmentFragmentDoc}`;
export const FullSiteFragmentFragmentDoc = gql`
    fragment fullSiteFragment on Site {
  ...mainSiteFragment
  locationPoint {
    ...locationBoundaryFragment
  }
  siteConductCodeSections {
    body
    createdAt
    id
    position
    title
    updatedAt
  }
  updatedAt
  phoneNumber
  description
  email
  createdAt
  usersCount
  siteAreasCount
  sector {
    id
    name
    color
  }
}
    ${MainSiteFragmentFragmentDoc}
${LocationBoundaryFragmentFragmentDoc}`;
export const SiteAreaFragmentFragmentDoc = gql`
    fragment siteAreaFragment on SiteArea {
  address
  code
  description
  fullCode
  id
  name
  poorWifi
}
    `;
export const SsoIntegrationFragmentFragmentDoc = gql`
    fragment ssoIntegrationFragment on SsoIntegration {
  id
  name
  code
  providerPreset
  providerType
  displayStatus
  status
  warningKey
  idpMetadata
  attributeMapping
  allowIdpInitiated
  jitProvisioningEnabled
  syncUserAttributes
  timeToleranceSeconds
  pinned
  icon {
    ...attachmentFragment
  }
  companyDomains {
    id
  }
  createdAt
  updatedAt
}
    ${AttachmentFragmentFragmentDoc}`;
export const CompanyDomainFragmentFragmentDoc = gql`
    fragment companyDomainFragment on CompanyDomain {
  id
  domain
  verified
  verifiedAt
  dnsTxtRecord
  createdAt
  updatedAt
}
    `;
export const RecurringRuleFragmentFragmentDoc = gql`
    fragment recurringRuleFragment on RecurringRule {
  endsAfterOccurrences
  endTime
  id
  schema {
    rrules {
      interval
      ruleType
      validations {
        day
        dayOfWeek
        dayOfMonth
        monthOfYear
      }
    }
    metadata {
      schemaOption
    }
  }
  countdownType
  excludedWdays
  startTime
}
    `;
export const EarlyCompletionFragmentFragmentDoc = gql`
    fragment earlyCompletionFragment on Task {
  earlyCompletion
  earlyCompletionUnit
}
    `;
export const CanActionsTaskFragmentFragmentDoc = gql`
    fragment canActionsTaskFragment on Task {
  canArchive {
    ...authorizationResultFragment
  }
  canDestroy {
    ...authorizationResultFragment
  }
  canUpdate {
    ...authorizationResultFragment
  }
  canReschedule {
    ...authorizationResultFragment
  }
  canQrCodeRelatedInfoUpdate {
    ...authorizationResultFragment
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;
export const TaskFragmentFragmentDoc = gql`
    fragment taskFragment on Task {
  id
  kind
  name
  description
  priority
  status
  completedAt
  completion {
    validityHint
    status
    solvedAt
  }
  recurringRuleId
  lastDeadlineAt
  lateFor
  site {
    id
    name
  }
  siteArea {
    id
    name
    fullCode
  }
  approver {
    id
    firstName
    lastName
    avatarAttached {
      ...attachmentFragment
    }
  }
  asset {
    id
    name
    fullCode
    siteArea {
      code
    }
    iconAttached {
      ...attachmentFragment
    }
  }
  createdAt
  deadlineAt
  archivedAt
  lastCheckAt
  originalCreatedAt
  formTemplate {
    canUpdate {
      value
    }
  }
  ...canActionsTaskFragment
}
    ${AttachmentFragmentFragmentDoc}
${CanActionsTaskFragmentFragmentDoc}`;
export const TeamFragmentFragmentDoc = gql`
    fragment teamFragment on Team {
  id
  name
  description
  color
  readOnly
  canDestroy {
    ...authorizationResultFragment
  }
  accesses {
    component
    itemIds
    level
    scopeLevel
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;
export const FullUserFragmentFragmentDoc = gql`
    fragment fullUserFragment on User {
  deactivatedAt
  avatarAttached {
    ...attachmentFragment
  }
  id
  firstName
  lastName
  email
  passwordSetupRequired
  role
  personalId
  phoneNumber
  sites {
    collection {
      id
      name
    }
  }
  lang
  verified
  unconfirmedEmail
  company {
    id
    name
  }
  username
  team {
    id
    name
    color
  }
}
    ${AttachmentFragmentFragmentDoc}`;
export const ApiTokenDocument = gql`
    query apiToken($id: ID!) {
  data: apiToken(id: $id) {
    id
    createdAt
    updatedAt
    label
    status
  }
}
    `;

/**
 * __useApiTokenQuery__
 *
 * To run a query within a React component, call `useApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiTokenQuery(baseOptions: Apollo.QueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
      }
export function useApiTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export type ApiTokenQueryHookResult = ReturnType<typeof useApiTokenQuery>;
export type ApiTokenLazyQueryHookResult = ReturnType<typeof useApiTokenLazyQuery>;
export type ApiTokenQueryResult = Apollo.QueryResult<ApiTokenQuery, ApiTokenQueryVariables>;
export function refetchApiTokenQuery(variables: ApiTokenQueryVariables) {
      return { query: ApiTokenDocument, variables: variables }
    }
export const ApiTokensDocument = gql`
    query apiTokens($page: Int, $limit: Int) {
  data: apiTokens(page: $page, limit: $limit) {
    collection {
      id
      createdAt
      label
      status
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useApiTokensQuery__
 *
 * To run a query within a React component, call `useApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokensQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useApiTokensQuery(baseOptions?: Apollo.QueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
      }
export function useApiTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
        }
export type ApiTokensQueryHookResult = ReturnType<typeof useApiTokensQuery>;
export type ApiTokensLazyQueryHookResult = ReturnType<typeof useApiTokensLazyQuery>;
export type ApiTokensQueryResult = Apollo.QueryResult<ApiTokensQuery, ApiTokensQueryVariables>;
export function refetchApiTokensQuery(variables?: ApiTokensQueryVariables) {
      return { query: ApiTokensDocument, variables: variables }
    }
export const ApiTokenCreateDocument = gql`
    mutation apiTokenCreate($attributes: ApiTokenCreateInputObject!) {
  data: apiTokenCreate(input: {attributes: $attributes}) {
    id
    label
    token
  }
}
    `;
export type ApiTokenCreateMutationFn = Apollo.MutationFunction<ApiTokenCreateMutation, ApiTokenCreateMutationVariables>;

/**
 * __useApiTokenCreateMutation__
 *
 * To run a mutation, you first call `useApiTokenCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiTokenCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiTokenCreateMutation, { data, loading, error }] = useApiTokenCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useApiTokenCreateMutation(baseOptions?: Apollo.MutationHookOptions<ApiTokenCreateMutation, ApiTokenCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiTokenCreateMutation, ApiTokenCreateMutationVariables>(ApiTokenCreateDocument, options);
      }
export type ApiTokenCreateMutationHookResult = ReturnType<typeof useApiTokenCreateMutation>;
export type ApiTokenCreateMutationResult = Apollo.MutationResult<ApiTokenCreateMutation>;
export type ApiTokenCreateMutationOptions = Apollo.BaseMutationOptions<ApiTokenCreateMutation, ApiTokenCreateMutationVariables>;
export const ApiTokenUpdateDocument = gql`
    mutation apiTokenUpdate($attributes: ApiTokenUpdateInputObject!, $id: ID!) {
  data: apiTokenUpdate(input: {id: $id, attributes: $attributes}) {
    label
  }
}
    `;
export type ApiTokenUpdateMutationFn = Apollo.MutationFunction<ApiTokenUpdateMutation, ApiTokenUpdateMutationVariables>;

/**
 * __useApiTokenUpdateMutation__
 *
 * To run a mutation, you first call `useApiTokenUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiTokenUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiTokenUpdateMutation, { data, loading, error }] = useApiTokenUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiTokenUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ApiTokenUpdateMutation, ApiTokenUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiTokenUpdateMutation, ApiTokenUpdateMutationVariables>(ApiTokenUpdateDocument, options);
      }
export type ApiTokenUpdateMutationHookResult = ReturnType<typeof useApiTokenUpdateMutation>;
export type ApiTokenUpdateMutationResult = Apollo.MutationResult<ApiTokenUpdateMutation>;
export type ApiTokenUpdateMutationOptions = Apollo.BaseMutationOptions<ApiTokenUpdateMutation, ApiTokenUpdateMutationVariables>;
export const ApiTokenDestroyDocument = gql`
    mutation apiTokenDestroy($id: ID!) {
  apiTokenDestroy(input: {id: $id})
}
    `;
export type ApiTokenDestroyMutationFn = Apollo.MutationFunction<ApiTokenDestroyMutation, ApiTokenDestroyMutationVariables>;

/**
 * __useApiTokenDestroyMutation__
 *
 * To run a mutation, you first call `useApiTokenDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiTokenDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiTokenDestroyMutation, { data, loading, error }] = useApiTokenDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiTokenDestroyMutation(baseOptions?: Apollo.MutationHookOptions<ApiTokenDestroyMutation, ApiTokenDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiTokenDestroyMutation, ApiTokenDestroyMutationVariables>(ApiTokenDestroyDocument, options);
      }
export type ApiTokenDestroyMutationHookResult = ReturnType<typeof useApiTokenDestroyMutation>;
export type ApiTokenDestroyMutationResult = Apollo.MutationResult<ApiTokenDestroyMutation>;
export type ApiTokenDestroyMutationOptions = Apollo.BaseMutationOptions<ApiTokenDestroyMutation, ApiTokenDestroyMutationVariables>;
export const AssetsDocument = gql`
    query assets($page: Int, $limit: Int, $sorts: AssetSortInputObject, $filters: [AssetFilterInputObject!], $includeFullData: Boolean = false, $includeCategoryData: Boolean = false) {
  data: assets(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      category @include(if: $includeCategoryData) {
        color
        name
        id
      }
      id
      code
      fullCode
      manufacturer @include(if: $includeFullData)
      model @include(if: $includeFullData)
      name
      serialNumber @include(if: $includeFullData)
      site {
        id
        name
        code
      }
      siteArea {
        id
        name
        code
      }
      iconAttached {
        ...attachmentFragment
      }
      canDestroy {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetsQuery__
 *
 * To run a query within a React component, call `useAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      includeFullData: // value for 'includeFullData'
 *      includeCategoryData: // value for 'includeCategoryData'
 *   },
 * });
 */
export function useAssetsQuery(baseOptions?: Apollo.QueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
      }
export function useAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
export type AssetsQueryHookResult = ReturnType<typeof useAssetsQuery>;
export type AssetsLazyQueryHookResult = ReturnType<typeof useAssetsLazyQuery>;
export type AssetsQueryResult = Apollo.QueryResult<AssetsQuery, AssetsQueryVariables>;
export function refetchAssetsQuery(variables?: AssetsQueryVariables) {
      return { query: AssetsDocument, variables: variables }
    }
export const AssetIdsDocument = gql`
    query assetIds($sorts: AssetSortInputObject, $filters: [AssetFilterInputObject!], $onlyIds: Boolean, $includeSiteId: Boolean = false) {
  data: assets(sorts: $sorts, filters: $filters, onlyIds: $onlyIds) {
    collection {
      id
      siteId @include(if: $includeSiteId)
    }
  }
}
    `;

/**
 * __useAssetIdsQuery__
 *
 * To run a query within a React component, call `useAssetIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetIdsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      includeSiteId: // value for 'includeSiteId'
 *   },
 * });
 */
export function useAssetIdsQuery(baseOptions?: Apollo.QueryHookOptions<AssetIdsQuery, AssetIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetIdsQuery, AssetIdsQueryVariables>(AssetIdsDocument, options);
      }
export function useAssetIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetIdsQuery, AssetIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetIdsQuery, AssetIdsQueryVariables>(AssetIdsDocument, options);
        }
export type AssetIdsQueryHookResult = ReturnType<typeof useAssetIdsQuery>;
export type AssetIdsLazyQueryHookResult = ReturnType<typeof useAssetIdsLazyQuery>;
export type AssetIdsQueryResult = Apollo.QueryResult<AssetIdsQuery, AssetIdsQueryVariables>;
export function refetchAssetIdsQuery(variables?: AssetIdsQueryVariables) {
      return { query: AssetIdsDocument, variables: variables }
    }
export const AssetsSearchListDocument = gql`
    query assetsSearchList($page: Int, $limit: Int, $sorts: AssetSortInputObject, $filters: [AssetFilterInputObject!]) {
  data: assets(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      fullCode
      name
      iconAttached {
        ...attachmentFragment
      }
      poorWifi
      usesAsNomenclatureCount
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetsSearchListQuery__
 *
 * To run a query within a React component, call `useAssetsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAssetsSearchListQuery(baseOptions?: Apollo.QueryHookOptions<AssetsSearchListQuery, AssetsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetsSearchListQuery, AssetsSearchListQueryVariables>(AssetsSearchListDocument, options);
      }
export function useAssetsSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetsSearchListQuery, AssetsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetsSearchListQuery, AssetsSearchListQueryVariables>(AssetsSearchListDocument, options);
        }
export type AssetsSearchListQueryHookResult = ReturnType<typeof useAssetsSearchListQuery>;
export type AssetsSearchListLazyQueryHookResult = ReturnType<typeof useAssetsSearchListLazyQuery>;
export type AssetsSearchListQueryResult = Apollo.QueryResult<AssetsSearchListQuery, AssetsSearchListQueryVariables>;
export function refetchAssetsSearchListQuery(variables?: AssetsSearchListQueryVariables) {
      return { query: AssetsSearchListDocument, variables: variables }
    }
export const AssetDocument = gql`
    query asset($findBy: AssetFindByInputObject!, $includeFullData: Boolean = false) {
  data: asset(findBy: $findBy) {
    ...assetFragment @include(if: $includeFullData)
    id
    name
    fullCode
    siteId
    canDestroy {
      ...authorizationResultFragment
    }
  }
}
    ${AssetFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useAssetQuery__
 *
 * To run a query within a React component, call `useAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      includeFullData: // value for 'includeFullData'
 *   },
 * });
 */
export function useAssetQuery(baseOptions: Apollo.QueryHookOptions<AssetQuery, AssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
      }
export function useAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetQuery, AssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
        }
export type AssetQueryHookResult = ReturnType<typeof useAssetQuery>;
export type AssetLazyQueryHookResult = ReturnType<typeof useAssetLazyQuery>;
export type AssetQueryResult = Apollo.QueryResult<AssetQuery, AssetQueryVariables>;
export function refetchAssetQuery(variables: AssetQueryVariables) {
      return { query: AssetDocument, variables: variables }
    }
export const AssetWithCountersDocument = gql`
    query assetWithCounters($findBy: AssetFindByInputObject!, $includeFullData: Boolean = false, $mainAssetId: ID!, $nomenclaturesFilters: [NomenclatureFilterInputObject!], $countersFilters: [CounterFilterInputObject!], $documentationsFilters: [DocumentationFilterInputObject!], $interventionsFilters: [InterventionFilterInputObject!], $interventionsScopeName: InterventionScopeNameEnum!) {
  data: asset(findBy: $findBy) {
    ...assetFragment @include(if: $includeFullData)
    id
    name
    fullCode
    site @skip(if: $includeFullData) {
      id
      name
    }
    siteArea @skip(if: $includeFullData) {
      id
      name
    }
    canDestroy {
      ...authorizationResultFragment
    }
  }
  nomenclatures(filters: $nomenclaturesFilters, mainAssetId: $mainAssetId) {
    metadata {
      totalCount
    }
  }
  counters(filters: $countersFilters, assetId: $mainAssetId) {
    metadata {
      totalCount
    }
  }
  documentations(filters: $documentationsFilters, assetId: $mainAssetId) {
    metadata {
      totalCount
    }
  }
  interventions(
    filters: $interventionsFilters
    scopeName: $interventionsScopeName
  ) {
    metadata {
      totalCount
    }
  }
}
    ${AssetFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useAssetWithCountersQuery__
 *
 * To run a query within a React component, call `useAssetWithCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetWithCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetWithCountersQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      includeFullData: // value for 'includeFullData'
 *      mainAssetId: // value for 'mainAssetId'
 *      nomenclaturesFilters: // value for 'nomenclaturesFilters'
 *      countersFilters: // value for 'countersFilters'
 *      documentationsFilters: // value for 'documentationsFilters'
 *      interventionsFilters: // value for 'interventionsFilters'
 *      interventionsScopeName: // value for 'interventionsScopeName'
 *   },
 * });
 */
export function useAssetWithCountersQuery(baseOptions: Apollo.QueryHookOptions<AssetWithCountersQuery, AssetWithCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetWithCountersQuery, AssetWithCountersQueryVariables>(AssetWithCountersDocument, options);
      }
export function useAssetWithCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetWithCountersQuery, AssetWithCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetWithCountersQuery, AssetWithCountersQueryVariables>(AssetWithCountersDocument, options);
        }
export type AssetWithCountersQueryHookResult = ReturnType<typeof useAssetWithCountersQuery>;
export type AssetWithCountersLazyQueryHookResult = ReturnType<typeof useAssetWithCountersLazyQuery>;
export type AssetWithCountersQueryResult = Apollo.QueryResult<AssetWithCountersQuery, AssetWithCountersQueryVariables>;
export function refetchAssetWithCountersQuery(variables: AssetWithCountersQueryVariables) {
      return { query: AssetWithCountersDocument, variables: variables }
    }
export const AssetCategoryDocument = gql`
    query assetCategory($id: ID!) {
  data: assetCategory(id: $id) {
    ...assetCategoryFragment
  }
}
    ${AssetCategoryFragmentFragmentDoc}`;

/**
 * __useAssetCategoryQuery__
 *
 * To run a query within a React component, call `useAssetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetCategoryQuery(baseOptions: Apollo.QueryHookOptions<AssetCategoryQuery, AssetCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCategoryQuery, AssetCategoryQueryVariables>(AssetCategoryDocument, options);
      }
export function useAssetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCategoryQuery, AssetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCategoryQuery, AssetCategoryQueryVariables>(AssetCategoryDocument, options);
        }
export type AssetCategoryQueryHookResult = ReturnType<typeof useAssetCategoryQuery>;
export type AssetCategoryLazyQueryHookResult = ReturnType<typeof useAssetCategoryLazyQuery>;
export type AssetCategoryQueryResult = Apollo.QueryResult<AssetCategoryQuery, AssetCategoryQueryVariables>;
export function refetchAssetCategoryQuery(variables: AssetCategoryQueryVariables) {
      return { query: AssetCategoryDocument, variables: variables }
    }
export const AssetCategoriesDocument = gql`
    query assetCategories($page: Int, $limit: Int, $filters: [AssetCategoryFilterInputObject!], $sorts: AssetCategorySortInputObject) {
  data: assetCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...assetCategoryFragment
      assets {
        collection {
          id
          name
        }
      }
      visibleAssetsCount
      canDestroy {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AssetCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCategoriesQuery__
 *
 * To run a query within a React component, call `useAssetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAssetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AssetCategoriesQuery, AssetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCategoriesQuery, AssetCategoriesQueryVariables>(AssetCategoriesDocument, options);
      }
export function useAssetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCategoriesQuery, AssetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCategoriesQuery, AssetCategoriesQueryVariables>(AssetCategoriesDocument, options);
        }
export type AssetCategoriesQueryHookResult = ReturnType<typeof useAssetCategoriesQuery>;
export type AssetCategoriesLazyQueryHookResult = ReturnType<typeof useAssetCategoriesLazyQuery>;
export type AssetCategoriesQueryResult = Apollo.QueryResult<AssetCategoriesQuery, AssetCategoriesQueryVariables>;
export function refetchAssetCategoriesQuery(variables?: AssetCategoriesQueryVariables) {
      return { query: AssetCategoriesDocument, variables: variables }
    }
export const AssetCategoriesSearchListDocument = gql`
    query assetCategoriesSearchList($page: Int, $limit: Int, $filters: [AssetCategoryFilterInputObject!], $sorts: AssetCategorySortInputObject) {
  data: assetCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...assetCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AssetCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useAssetCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAssetCategoriesSearchListQuery(baseOptions?: Apollo.QueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
      }
export function useAssetCategoriesSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>(AssetCategoriesSearchListDocument, options);
        }
export type AssetCategoriesSearchListQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListQuery>;
export type AssetCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useAssetCategoriesSearchListLazyQuery>;
export type AssetCategoriesSearchListQueryResult = Apollo.QueryResult<AssetCategoriesSearchListQuery, AssetCategoriesSearchListQueryVariables>;
export function refetchAssetCategoriesSearchListQuery(variables?: AssetCategoriesSearchListQueryVariables) {
      return { query: AssetCategoriesSearchListDocument, variables: variables }
    }
export const AssetBulkDestroyDocument = gql`
    mutation assetBulkDestroy($input: AssetBulkDestroyInput!) {
  data: assetBulkDestroy(input: $input)
}
    `;
export type AssetBulkDestroyMutationFn = Apollo.MutationFunction<AssetBulkDestroyMutation, AssetBulkDestroyMutationVariables>;

/**
 * __useAssetBulkDestroyMutation__
 *
 * To run a mutation, you first call `useAssetBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetBulkDestroyMutation, { data, loading, error }] = useAssetBulkDestroyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssetBulkDestroyMutation(baseOptions?: Apollo.MutationHookOptions<AssetBulkDestroyMutation, AssetBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetBulkDestroyMutation, AssetBulkDestroyMutationVariables>(AssetBulkDestroyDocument, options);
      }
export type AssetBulkDestroyMutationHookResult = ReturnType<typeof useAssetBulkDestroyMutation>;
export type AssetBulkDestroyMutationResult = Apollo.MutationResult<AssetBulkDestroyMutation>;
export type AssetBulkDestroyMutationOptions = Apollo.BaseMutationOptions<AssetBulkDestroyMutation, AssetBulkDestroyMutationVariables>;
export const AssetCategoryCreateDocument = gql`
    mutation assetCategoryCreate($attributes: AssetCategoryCreateInputObject!) {
  data: assetCategoryCreate(input: {attributes: $attributes}) {
    ...assetCategoryFragment
  }
}
    ${AssetCategoryFragmentFragmentDoc}`;
export type AssetCategoryCreateMutationFn = Apollo.MutationFunction<AssetCategoryCreateMutation, AssetCategoryCreateMutationVariables>;

/**
 * __useAssetCategoryCreateMutation__
 *
 * To run a mutation, you first call `useAssetCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCategoryCreateMutation, { data, loading, error }] = useAssetCategoryCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetCategoryCreateMutation, AssetCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCategoryCreateMutation, AssetCategoryCreateMutationVariables>(AssetCategoryCreateDocument, options);
      }
export type AssetCategoryCreateMutationHookResult = ReturnType<typeof useAssetCategoryCreateMutation>;
export type AssetCategoryCreateMutationResult = Apollo.MutationResult<AssetCategoryCreateMutation>;
export type AssetCategoryCreateMutationOptions = Apollo.BaseMutationOptions<AssetCategoryCreateMutation, AssetCategoryCreateMutationVariables>;
export const AssetCategoryUpdateDocument = gql`
    mutation assetCategoryUpdate($attributes: AssetCategoryUpdateInputObject!, $id: ID!, $refreshQrPrefixForAssets: Boolean) {
  data: assetCategoryUpdate(
    input: {id: $id, attributes: $attributes, refreshQrPrefixForAssets: $refreshQrPrefixForAssets}
  ) {
    ...assetCategoryFragment
  }
}
    ${AssetCategoryFragmentFragmentDoc}`;
export type AssetCategoryUpdateMutationFn = Apollo.MutationFunction<AssetCategoryUpdateMutation, AssetCategoryUpdateMutationVariables>;

/**
 * __useAssetCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useAssetCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCategoryUpdateMutation, { data, loading, error }] = useAssetCategoryUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      refreshQrPrefixForAssets: // value for 'refreshQrPrefixForAssets'
 *   },
 * });
 */
export function useAssetCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AssetCategoryUpdateMutation, AssetCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCategoryUpdateMutation, AssetCategoryUpdateMutationVariables>(AssetCategoryUpdateDocument, options);
      }
export type AssetCategoryUpdateMutationHookResult = ReturnType<typeof useAssetCategoryUpdateMutation>;
export type AssetCategoryUpdateMutationResult = Apollo.MutationResult<AssetCategoryUpdateMutation>;
export type AssetCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<AssetCategoryUpdateMutation, AssetCategoryUpdateMutationVariables>;
export const AssetCategoryDestroyDocument = gql`
    mutation assetCategoryDestroy($id: ID!) {
  assetCategoryDestroy(input: {id: $id})
}
    `;
export type AssetCategoryDestroyMutationFn = Apollo.MutationFunction<AssetCategoryDestroyMutation, AssetCategoryDestroyMutationVariables>;

/**
 * __useAssetCategoryDestroyMutation__
 *
 * To run a mutation, you first call `useAssetCategoryDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCategoryDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCategoryDestroyMutation, { data, loading, error }] = useAssetCategoryDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetCategoryDestroyMutation(baseOptions?: Apollo.MutationHookOptions<AssetCategoryDestroyMutation, AssetCategoryDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCategoryDestroyMutation, AssetCategoryDestroyMutationVariables>(AssetCategoryDestroyDocument, options);
      }
export type AssetCategoryDestroyMutationHookResult = ReturnType<typeof useAssetCategoryDestroyMutation>;
export type AssetCategoryDestroyMutationResult = Apollo.MutationResult<AssetCategoryDestroyMutation>;
export type AssetCategoryDestroyMutationOptions = Apollo.BaseMutationOptions<AssetCategoryDestroyMutation, AssetCategoryDestroyMutationVariables>;
export const AssetCreateDocument = gql`
    mutation assetCreate($attributes: AssetCreateInputObject!) {
  data: assetCreate(input: {attributes: $attributes}) {
    ...assetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export type AssetCreateMutationFn = Apollo.MutationFunction<AssetCreateMutation, AssetCreateMutationVariables>;

/**
 * __useAssetCreateMutation__
 *
 * To run a mutation, you first call `useAssetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCreateMutation, { data, loading, error }] = useAssetCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetCreateMutation, AssetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCreateMutation, AssetCreateMutationVariables>(AssetCreateDocument, options);
      }
export type AssetCreateMutationHookResult = ReturnType<typeof useAssetCreateMutation>;
export type AssetCreateMutationResult = Apollo.MutationResult<AssetCreateMutation>;
export type AssetCreateMutationOptions = Apollo.BaseMutationOptions<AssetCreateMutation, AssetCreateMutationVariables>;
export const AssetUpdateDocument = gql`
    mutation assetUpdate($attributes: AssetUpdateInputObject!, $id: ID!) {
  data: assetUpdate(input: {attributes: $attributes, id: $id}) {
    ...assetFragment
  }
}
    ${AssetFragmentFragmentDoc}`;
export type AssetUpdateMutationFn = Apollo.MutationFunction<AssetUpdateMutation, AssetUpdateMutationVariables>;

/**
 * __useAssetUpdateMutation__
 *
 * To run a mutation, you first call `useAssetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetUpdateMutation, { data, loading, error }] = useAssetUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssetUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AssetUpdateMutation, AssetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetUpdateMutation, AssetUpdateMutationVariables>(AssetUpdateDocument, options);
      }
export type AssetUpdateMutationHookResult = ReturnType<typeof useAssetUpdateMutation>;
export type AssetUpdateMutationResult = Apollo.MutationResult<AssetUpdateMutation>;
export type AssetUpdateMutationOptions = Apollo.BaseMutationOptions<AssetUpdateMutation, AssetUpdateMutationVariables>;
export const AssetBulkQrCodeCreateDocument = gql`
    mutation assetBulkQrCodeCreate($params: QrCodesCreateInputObject!) {
  data: assetBulkQrCodeCreate(input: {params: $params}) {
    ...jobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export type AssetBulkQrCodeCreateMutationFn = Apollo.MutationFunction<AssetBulkQrCodeCreateMutation, AssetBulkQrCodeCreateMutationVariables>;

/**
 * __useAssetBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useAssetBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetBulkQrCodeCreateMutation, { data, loading, error }] = useAssetBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAssetBulkQrCodeCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetBulkQrCodeCreateMutation, AssetBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetBulkQrCodeCreateMutation, AssetBulkQrCodeCreateMutationVariables>(AssetBulkQrCodeCreateDocument, options);
      }
export type AssetBulkQrCodeCreateMutationHookResult = ReturnType<typeof useAssetBulkQrCodeCreateMutation>;
export type AssetBulkQrCodeCreateMutationResult = Apollo.MutationResult<AssetBulkQrCodeCreateMutation>;
export type AssetBulkQrCodeCreateMutationOptions = Apollo.BaseMutationOptions<AssetBulkQrCodeCreateMutation, AssetBulkQrCodeCreateMutationVariables>;
export const AssetNomenclatureBulkQrCodeCreateDocument = gql`
    mutation assetNomenclatureBulkQrCodeCreate($params: QrCodesCreateInputObject!) {
  data: nomenclatureBulkQrCodeCreate(input: {params: $params}) {
    ...jobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export type AssetNomenclatureBulkQrCodeCreateMutationFn = Apollo.MutationFunction<AssetNomenclatureBulkQrCodeCreateMutation, AssetNomenclatureBulkQrCodeCreateMutationVariables>;

/**
 * __useAssetNomenclatureBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureBulkQrCodeCreateMutation, { data, loading, error }] = useAssetNomenclatureBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAssetNomenclatureBulkQrCodeCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetNomenclatureBulkQrCodeCreateMutation, AssetNomenclatureBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetNomenclatureBulkQrCodeCreateMutation, AssetNomenclatureBulkQrCodeCreateMutationVariables>(AssetNomenclatureBulkQrCodeCreateDocument, options);
      }
export type AssetNomenclatureBulkQrCodeCreateMutationHookResult = ReturnType<typeof useAssetNomenclatureBulkQrCodeCreateMutation>;
export type AssetNomenclatureBulkQrCodeCreateMutationResult = Apollo.MutationResult<AssetNomenclatureBulkQrCodeCreateMutation>;
export type AssetNomenclatureBulkQrCodeCreateMutationOptions = Apollo.BaseMutationOptions<AssetNomenclatureBulkQrCodeCreateMutation, AssetNomenclatureBulkQrCodeCreateMutationVariables>;
export const AssetCountersDocument = gql`
    query assetCounters($page: Int, $limit: Int, $sorts: CounterSortInputObject, $filters: [CounterFilterInputObject!], $assetId: ID!) {
  data: counters(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    assetId: $assetId
  ) {
    collection {
      code
      fullCode
      id
      lastCheckAt
      latestIndex
      measureType
      measureUnit
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCountersQuery__
 *
 * To run a query within a React component, call `useAssetCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCountersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCountersQuery(baseOptions: Apollo.QueryHookOptions<AssetCountersQuery, AssetCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCountersQuery, AssetCountersQueryVariables>(AssetCountersDocument, options);
      }
export function useAssetCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCountersQuery, AssetCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCountersQuery, AssetCountersQueryVariables>(AssetCountersDocument, options);
        }
export type AssetCountersQueryHookResult = ReturnType<typeof useAssetCountersQuery>;
export type AssetCountersLazyQueryHookResult = ReturnType<typeof useAssetCountersLazyQuery>;
export type AssetCountersQueryResult = Apollo.QueryResult<AssetCountersQuery, AssetCountersQueryVariables>;
export function refetchAssetCountersQuery(variables: AssetCountersQueryVariables) {
      return { query: AssetCountersDocument, variables: variables }
    }
export const AssetCountersIdsDocument = gql`
    query assetCountersIds($sorts: CounterSortInputObject, $filters: [CounterFilterInputObject!], $onlyIds: Boolean, $assetId: ID!) {
  data: counters(
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
    assetId: $assetId
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useAssetCountersIdsQuery__
 *
 * To run a query within a React component, call `useAssetCountersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCountersIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCountersIdsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCountersIdsQuery(baseOptions: Apollo.QueryHookOptions<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>(AssetCountersIdsDocument, options);
      }
export function useAssetCountersIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>(AssetCountersIdsDocument, options);
        }
export type AssetCountersIdsQueryHookResult = ReturnType<typeof useAssetCountersIdsQuery>;
export type AssetCountersIdsLazyQueryHookResult = ReturnType<typeof useAssetCountersIdsLazyQuery>;
export type AssetCountersIdsQueryResult = Apollo.QueryResult<AssetCountersIdsQuery, AssetCountersIdsQueryVariables>;
export function refetchAssetCountersIdsQuery(variables: AssetCountersIdsQueryVariables) {
      return { query: AssetCountersIdsDocument, variables: variables }
    }
export const AssetCounterDocument = gql`
    query assetCounter($findBy: CounterFindByInputObject!, $assetFindBy: AssetFindByInputObject!) {
  data: counter(findBy: $findBy, assetFindBy: $assetFindBy) {
    id
    name
    code
    fullCode
    measureType
    measureUnit
    prohibitLowerIndexThanPrevious
    latestIndex
    lastCheckAt
  }
}
    `;

/**
 * __useAssetCounterQuery__
 *
 * To run a query within a React component, call `useAssetCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      assetFindBy: // value for 'assetFindBy'
 *   },
 * });
 */
export function useAssetCounterQuery(baseOptions: Apollo.QueryHookOptions<AssetCounterQuery, AssetCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCounterQuery, AssetCounterQueryVariables>(AssetCounterDocument, options);
      }
export function useAssetCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCounterQuery, AssetCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCounterQuery, AssetCounterQueryVariables>(AssetCounterDocument, options);
        }
export type AssetCounterQueryHookResult = ReturnType<typeof useAssetCounterQuery>;
export type AssetCounterLazyQueryHookResult = ReturnType<typeof useAssetCounterLazyQuery>;
export type AssetCounterQueryResult = Apollo.QueryResult<AssetCounterQuery, AssetCounterQueryVariables>;
export function refetchAssetCounterQuery(variables: AssetCounterQueryVariables) {
      return { query: AssetCounterDocument, variables: variables }
    }
export const AssetCounterMeasureDocument = gql`
    query assetCounterMeasure($id: ID!, $assetId: ID!, $counterId: ID!) {
  data: counterMeasure(id: $id, assetId: $assetId, counterId: $counterId) {
    id
    index
  }
}
    `;

/**
 * __useAssetCounterMeasureQuery__
 *
 * To run a query within a React component, call `useAssetCounterMeasureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterMeasureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *      counterId: // value for 'counterId'
 *   },
 * });
 */
export function useAssetCounterMeasureQuery(baseOptions: Apollo.QueryHookOptions<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>(AssetCounterMeasureDocument, options);
      }
export function useAssetCounterMeasureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>(AssetCounterMeasureDocument, options);
        }
export type AssetCounterMeasureQueryHookResult = ReturnType<typeof useAssetCounterMeasureQuery>;
export type AssetCounterMeasureLazyQueryHookResult = ReturnType<typeof useAssetCounterMeasureLazyQuery>;
export type AssetCounterMeasureQueryResult = Apollo.QueryResult<AssetCounterMeasureQuery, AssetCounterMeasureQueryVariables>;
export function refetchAssetCounterMeasureQuery(variables: AssetCounterMeasureQueryVariables) {
      return { query: AssetCounterMeasureDocument, variables: variables }
    }
export const AssetCounterMeasuresDocument = gql`
    query assetCounterMeasures($page: Int, $limit: Int, $sorts: CounterMeasureSortInputObject, $filters: [CounterMeasureFilterInputObject!], $assetId: ID!, $counterId: ID!) {
  data: counterMeasures(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    assetId: $assetId
    counterId: $counterId
  ) {
    collection {
      id
      createdAt
      cumulativeUsage
      index
      gap
      resetToZero
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetCounterMeasuresQuery__
 *
 * To run a query within a React component, call `useAssetCounterMeasuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterMeasuresQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      assetId: // value for 'assetId'
 *      counterId: // value for 'counterId'
 *   },
 * });
 */
export function useAssetCounterMeasuresQuery(baseOptions: Apollo.QueryHookOptions<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>(AssetCounterMeasuresDocument, options);
      }
export function useAssetCounterMeasuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>(AssetCounterMeasuresDocument, options);
        }
export type AssetCounterMeasuresQueryHookResult = ReturnType<typeof useAssetCounterMeasuresQuery>;
export type AssetCounterMeasuresLazyQueryHookResult = ReturnType<typeof useAssetCounterMeasuresLazyQuery>;
export type AssetCounterMeasuresQueryResult = Apollo.QueryResult<AssetCounterMeasuresQuery, AssetCounterMeasuresQueryVariables>;
export function refetchAssetCounterMeasuresQuery(variables: AssetCounterMeasuresQueryVariables) {
      return { query: AssetCounterMeasuresDocument, variables: variables }
    }
export const AssetCounterMeasuresGraphDataDocument = gql`
    query assetCounterMeasuresGraphData($assetId: ID!, $counterId: ID!, $dateRange: DateRangeInputObject!) {
  data: counterMeasuresGraphData(
    assetId: $assetId
    counterId: $counterId
    dateRange: $dateRange
  ) {
    createdAt
    cumulativeUsage
    gap
  }
}
    `;

/**
 * __useAssetCounterMeasuresGraphDataQuery__
 *
 * To run a query within a React component, call `useAssetCounterMeasuresGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasuresGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetCounterMeasuresGraphDataQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      counterId: // value for 'counterId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useAssetCounterMeasuresGraphDataQuery(baseOptions: Apollo.QueryHookOptions<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>(AssetCounterMeasuresGraphDataDocument, options);
      }
export function useAssetCounterMeasuresGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>(AssetCounterMeasuresGraphDataDocument, options);
        }
export type AssetCounterMeasuresGraphDataQueryHookResult = ReturnType<typeof useAssetCounterMeasuresGraphDataQuery>;
export type AssetCounterMeasuresGraphDataLazyQueryHookResult = ReturnType<typeof useAssetCounterMeasuresGraphDataLazyQuery>;
export type AssetCounterMeasuresGraphDataQueryResult = Apollo.QueryResult<AssetCounterMeasuresGraphDataQuery, AssetCounterMeasuresGraphDataQueryVariables>;
export function refetchAssetCounterMeasuresGraphDataQuery(variables: AssetCounterMeasuresGraphDataQueryVariables) {
      return { query: AssetCounterMeasuresGraphDataDocument, variables: variables }
    }
export const AssetCounterCreateDocument = gql`
    mutation assetCounterCreate($attributes: CounterCreateInputObject!) {
  data: counterCreate(input: {attributes: $attributes}) {
    id
  }
}
    `;
export type AssetCounterCreateMutationFn = Apollo.MutationFunction<AssetCounterCreateMutation, AssetCounterCreateMutationVariables>;

/**
 * __useAssetCounterCreateMutation__
 *
 * To run a mutation, you first call `useAssetCounterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterCreateMutation, { data, loading, error }] = useAssetCounterCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetCounterCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetCounterCreateMutation, AssetCounterCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCounterCreateMutation, AssetCounterCreateMutationVariables>(AssetCounterCreateDocument, options);
      }
export type AssetCounterCreateMutationHookResult = ReturnType<typeof useAssetCounterCreateMutation>;
export type AssetCounterCreateMutationResult = Apollo.MutationResult<AssetCounterCreateMutation>;
export type AssetCounterCreateMutationOptions = Apollo.BaseMutationOptions<AssetCounterCreateMutation, AssetCounterCreateMutationVariables>;
export const AssetCounterUpdateDocument = gql`
    mutation assetCounterUpdate($attributes: CounterUpdateInputObject!, $id: ID!, $assetId: ID!) {
  data: counterUpdate(
    input: {id: $id, assetId: $assetId, attributes: $attributes}
  ) {
    id
    name
    code
    fullCode
    measureType
    measureUnit
    prohibitLowerIndexThanPrevious
  }
}
    `;
export type AssetCounterUpdateMutationFn = Apollo.MutationFunction<AssetCounterUpdateMutation, AssetCounterUpdateMutationVariables>;

/**
 * __useAssetCounterUpdateMutation__
 *
 * To run a mutation, you first call `useAssetCounterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterUpdateMutation, { data, loading, error }] = useAssetCounterUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AssetCounterUpdateMutation, AssetCounterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCounterUpdateMutation, AssetCounterUpdateMutationVariables>(AssetCounterUpdateDocument, options);
      }
export type AssetCounterUpdateMutationHookResult = ReturnType<typeof useAssetCounterUpdateMutation>;
export type AssetCounterUpdateMutationResult = Apollo.MutationResult<AssetCounterUpdateMutation>;
export type AssetCounterUpdateMutationOptions = Apollo.BaseMutationOptions<AssetCounterUpdateMutation, AssetCounterUpdateMutationVariables>;
export const AssetCounterDestroyDocument = gql`
    mutation assetCounterDestroy($ids: [ID!]!, $assetId: ID!) {
  counterBulkDestroy(input: {ids: $ids, assetId: $assetId})
}
    `;
export type AssetCounterDestroyMutationFn = Apollo.MutationFunction<AssetCounterDestroyMutation, AssetCounterDestroyMutationVariables>;

/**
 * __useAssetCounterDestroyMutation__
 *
 * To run a mutation, you first call `useAssetCounterDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterDestroyMutation, { data, loading, error }] = useAssetCounterDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterDestroyMutation(baseOptions?: Apollo.MutationHookOptions<AssetCounterDestroyMutation, AssetCounterDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCounterDestroyMutation, AssetCounterDestroyMutationVariables>(AssetCounterDestroyDocument, options);
      }
export type AssetCounterDestroyMutationHookResult = ReturnType<typeof useAssetCounterDestroyMutation>;
export type AssetCounterDestroyMutationResult = Apollo.MutationResult<AssetCounterDestroyMutation>;
export type AssetCounterDestroyMutationOptions = Apollo.BaseMutationOptions<AssetCounterDestroyMutation, AssetCounterDestroyMutationVariables>;
export const AssetCounterMeasureCreateDocument = gql`
    mutation assetCounterMeasureCreate($attributes: CounterMeasureCreateInputObject!, $assetId: ID!) {
  data: counterMeasureCreate(input: {assetId: $assetId, attributes: $attributes}) {
    id
  }
}
    `;
export type AssetCounterMeasureCreateMutationFn = Apollo.MutationFunction<AssetCounterMeasureCreateMutation, AssetCounterMeasureCreateMutationVariables>;

/**
 * __useAssetCounterMeasureCreateMutation__
 *
 * To run a mutation, you first call `useAssetCounterMeasureCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterMeasureCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterMeasureCreateMutation, { data, loading, error }] = useAssetCounterMeasureCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterMeasureCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetCounterMeasureCreateMutation, AssetCounterMeasureCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCounterMeasureCreateMutation, AssetCounterMeasureCreateMutationVariables>(AssetCounterMeasureCreateDocument, options);
      }
export type AssetCounterMeasureCreateMutationHookResult = ReturnType<typeof useAssetCounterMeasureCreateMutation>;
export type AssetCounterMeasureCreateMutationResult = Apollo.MutationResult<AssetCounterMeasureCreateMutation>;
export type AssetCounterMeasureCreateMutationOptions = Apollo.BaseMutationOptions<AssetCounterMeasureCreateMutation, AssetCounterMeasureCreateMutationVariables>;
export const AssetCounterResetToZeroDocument = gql`
    mutation assetCounterResetToZero($id: ID!, $assetId: ID!) {
  data: counterResetToZero(input: {id: $id, assetId: $assetId}) {
    id
  }
}
    `;
export type AssetCounterResetToZeroMutationFn = Apollo.MutationFunction<AssetCounterResetToZeroMutation, AssetCounterResetToZeroMutationVariables>;

/**
 * __useAssetCounterResetToZeroMutation__
 *
 * To run a mutation, you first call `useAssetCounterResetToZeroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterResetToZeroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterResetToZeroMutation, { data, loading, error }] = useAssetCounterResetToZeroMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterResetToZeroMutation(baseOptions?: Apollo.MutationHookOptions<AssetCounterResetToZeroMutation, AssetCounterResetToZeroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCounterResetToZeroMutation, AssetCounterResetToZeroMutationVariables>(AssetCounterResetToZeroDocument, options);
      }
export type AssetCounterResetToZeroMutationHookResult = ReturnType<typeof useAssetCounterResetToZeroMutation>;
export type AssetCounterResetToZeroMutationResult = Apollo.MutationResult<AssetCounterResetToZeroMutation>;
export type AssetCounterResetToZeroMutationOptions = Apollo.BaseMutationOptions<AssetCounterResetToZeroMutation, AssetCounterResetToZeroMutationVariables>;
export const AssetCounterBulkQrCodeCreateDocument = gql`
    mutation assetCounterBulkQrCodeCreate($params: QrCodesCreateInputObject!, $assetId: ID!) {
  data: counterBulkQrCodeCreate(input: {assetId: $assetId, params: $params}) {
    ...jobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export type AssetCounterBulkQrCodeCreateMutationFn = Apollo.MutationFunction<AssetCounterBulkQrCodeCreateMutation, AssetCounterBulkQrCodeCreateMutationVariables>;

/**
 * __useAssetCounterBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useAssetCounterBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetCounterBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetCounterBulkQrCodeCreateMutation, { data, loading, error }] = useAssetCounterBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetCounterBulkQrCodeCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetCounterBulkQrCodeCreateMutation, AssetCounterBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetCounterBulkQrCodeCreateMutation, AssetCounterBulkQrCodeCreateMutationVariables>(AssetCounterBulkQrCodeCreateDocument, options);
      }
export type AssetCounterBulkQrCodeCreateMutationHookResult = ReturnType<typeof useAssetCounterBulkQrCodeCreateMutation>;
export type AssetCounterBulkQrCodeCreateMutationResult = Apollo.MutationResult<AssetCounterBulkQrCodeCreateMutation>;
export type AssetCounterBulkQrCodeCreateMutationOptions = Apollo.BaseMutationOptions<AssetCounterBulkQrCodeCreateMutation, AssetCounterBulkQrCodeCreateMutationVariables>;
export const AssetNomenclaturesDocument = gql`
    query assetNomenclatures($page: Int, $limit: Int, $sorts: NomenclatureSortInputObject, $filters: [NomenclatureFilterInputObject!], $mainAssetId: ID!) {
  data: nomenclatures(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    mainAssetId: $mainAssetId
  ) {
    collection {
      id
      quantity
      componentAsset {
        id
        name
        code
        fullCode
        usesAsNomenclatureCount
        iconAttached {
          ...attachmentFragment
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useAssetNomenclaturesQuery__
 *
 * To run a query within a React component, call `useAssetNomenclaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetNomenclaturesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclaturesQuery(baseOptions: Apollo.QueryHookOptions<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>(AssetNomenclaturesDocument, options);
      }
export function useAssetNomenclaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>(AssetNomenclaturesDocument, options);
        }
export type AssetNomenclaturesQueryHookResult = ReturnType<typeof useAssetNomenclaturesQuery>;
export type AssetNomenclaturesLazyQueryHookResult = ReturnType<typeof useAssetNomenclaturesLazyQuery>;
export type AssetNomenclaturesQueryResult = Apollo.QueryResult<AssetNomenclaturesQuery, AssetNomenclaturesQueryVariables>;
export function refetchAssetNomenclaturesQuery(variables: AssetNomenclaturesQueryVariables) {
      return { query: AssetNomenclaturesDocument, variables: variables }
    }
export const AssetNomenclaturesIdsDocument = gql`
    query assetNomenclaturesIds($sorts: NomenclatureSortInputObject, $filters: [NomenclatureFilterInputObject!], $onlyIds: Boolean, $mainAssetId: ID!) {
  data: nomenclatures(
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
    mainAssetId: $mainAssetId
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useAssetNomenclaturesIdsQuery__
 *
 * To run a query within a React component, call `useAssetNomenclaturesIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclaturesIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetNomenclaturesIdsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclaturesIdsQuery(baseOptions: Apollo.QueryHookOptions<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>(AssetNomenclaturesIdsDocument, options);
      }
export function useAssetNomenclaturesIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>(AssetNomenclaturesIdsDocument, options);
        }
export type AssetNomenclaturesIdsQueryHookResult = ReturnType<typeof useAssetNomenclaturesIdsQuery>;
export type AssetNomenclaturesIdsLazyQueryHookResult = ReturnType<typeof useAssetNomenclaturesIdsLazyQuery>;
export type AssetNomenclaturesIdsQueryResult = Apollo.QueryResult<AssetNomenclaturesIdsQuery, AssetNomenclaturesIdsQueryVariables>;
export function refetchAssetNomenclaturesIdsQuery(variables: AssetNomenclaturesIdsQueryVariables) {
      return { query: AssetNomenclaturesIdsDocument, variables: variables }
    }
export const AssetNomenclatureDocument = gql`
    query assetNomenclature($id: ID!, $mainAssetId: ID!) {
  data: nomenclature(id: $id, mainAssetId: $mainAssetId) {
    id
    quantity
    componentAsset {
      id
      name
      fullCode
      iconAttached {
        ...attachmentFragment
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useAssetNomenclatureQuery__
 *
 * To run a query within a React component, call `useAssetNomenclatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetNomenclatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclatureQuery(baseOptions: Apollo.QueryHookOptions<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>(AssetNomenclatureDocument, options);
      }
export function useAssetNomenclatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>(AssetNomenclatureDocument, options);
        }
export type AssetNomenclatureQueryHookResult = ReturnType<typeof useAssetNomenclatureQuery>;
export type AssetNomenclatureLazyQueryHookResult = ReturnType<typeof useAssetNomenclatureLazyQuery>;
export type AssetNomenclatureQueryResult = Apollo.QueryResult<AssetNomenclatureQuery, AssetNomenclatureQueryVariables>;
export function refetchAssetNomenclatureQuery(variables: AssetNomenclatureQueryVariables) {
      return { query: AssetNomenclatureDocument, variables: variables }
    }
export const AssetNomenclatureCreateDocument = gql`
    mutation assetNomenclatureCreate($attributes: NomenclatureCreateInputObject!) {
  data: nomenclatureCreate(input: {attributes: $attributes}) {
    componentAsset {
      id
      name
    }
    quantity
  }
}
    `;
export type AssetNomenclatureCreateMutationFn = Apollo.MutationFunction<AssetNomenclatureCreateMutation, AssetNomenclatureCreateMutationVariables>;

/**
 * __useAssetNomenclatureCreateMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureCreateMutation, { data, loading, error }] = useAssetNomenclatureCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAssetNomenclatureCreateMutation(baseOptions?: Apollo.MutationHookOptions<AssetNomenclatureCreateMutation, AssetNomenclatureCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetNomenclatureCreateMutation, AssetNomenclatureCreateMutationVariables>(AssetNomenclatureCreateDocument, options);
      }
export type AssetNomenclatureCreateMutationHookResult = ReturnType<typeof useAssetNomenclatureCreateMutation>;
export type AssetNomenclatureCreateMutationResult = Apollo.MutationResult<AssetNomenclatureCreateMutation>;
export type AssetNomenclatureCreateMutationOptions = Apollo.BaseMutationOptions<AssetNomenclatureCreateMutation, AssetNomenclatureCreateMutationVariables>;
export const AssetNomenclatureUpdateDocument = gql`
    mutation assetNomenclatureUpdate($attributes: NomenclatureUpdateInputObject!, $id: ID!, $mainAssetId: ID!) {
  data: nomenclatureUpdate(
    input: {id: $id, mainAssetId: $mainAssetId, attributes: $attributes}
  ) {
    componentAsset {
      id
      name
    }
    quantity
  }
}
    `;
export type AssetNomenclatureUpdateMutationFn = Apollo.MutationFunction<AssetNomenclatureUpdateMutation, AssetNomenclatureUpdateMutationVariables>;

/**
 * __useAssetNomenclatureUpdateMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureUpdateMutation, { data, loading, error }] = useAssetNomenclatureUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclatureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AssetNomenclatureUpdateMutation, AssetNomenclatureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetNomenclatureUpdateMutation, AssetNomenclatureUpdateMutationVariables>(AssetNomenclatureUpdateDocument, options);
      }
export type AssetNomenclatureUpdateMutationHookResult = ReturnType<typeof useAssetNomenclatureUpdateMutation>;
export type AssetNomenclatureUpdateMutationResult = Apollo.MutationResult<AssetNomenclatureUpdateMutation>;
export type AssetNomenclatureUpdateMutationOptions = Apollo.BaseMutationOptions<AssetNomenclatureUpdateMutation, AssetNomenclatureUpdateMutationVariables>;
export const AssetNomenclatureDestroyDocument = gql`
    mutation assetNomenclatureDestroy($ids: [ID!]!, $mainAssetId: ID!) {
  nomenclatureBulkDestroy(input: {ids: $ids, mainAssetId: $mainAssetId})
}
    `;
export type AssetNomenclatureDestroyMutationFn = Apollo.MutationFunction<AssetNomenclatureDestroyMutation, AssetNomenclatureDestroyMutationVariables>;

/**
 * __useAssetNomenclatureDestroyMutation__
 *
 * To run a mutation, you first call `useAssetNomenclatureDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssetNomenclatureDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assetNomenclatureDestroyMutation, { data, loading, error }] = useAssetNomenclatureDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      mainAssetId: // value for 'mainAssetId'
 *   },
 * });
 */
export function useAssetNomenclatureDestroyMutation(baseOptions?: Apollo.MutationHookOptions<AssetNomenclatureDestroyMutation, AssetNomenclatureDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssetNomenclatureDestroyMutation, AssetNomenclatureDestroyMutationVariables>(AssetNomenclatureDestroyDocument, options);
      }
export type AssetNomenclatureDestroyMutationHookResult = ReturnType<typeof useAssetNomenclatureDestroyMutation>;
export type AssetNomenclatureDestroyMutationResult = Apollo.MutationResult<AssetNomenclatureDestroyMutation>;
export type AssetNomenclatureDestroyMutationOptions = Apollo.BaseMutationOptions<AssetNomenclatureDestroyMutation, AssetNomenclatureDestroyMutationVariables>;
export const AuthenticationConfirmationsEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsEmailConfirmation($input: AuthenticationConfirmationsEmailConfirmationInput!) {
  data: authenticationConfirmationsEmailConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationConfirmationsEmailConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>(AuthenticationConfirmationsEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsEmailConfirmationMutation>;
export type AuthenticationConfirmationsEmailConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsEmailConfirmationMutation>;
export type AuthenticationConfirmationsEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>;
export const AuthenticationConfirmationsRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsRegistrationConfirmation($input: AuthenticationConfirmationsRegistrationConfirmationInput!) {
  data: authenticationConfirmationsRegistrationConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationConfirmationsRegistrationConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsRegistrationConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsRegistrationConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsRegistrationConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>;
export const AuthenticationConfirmationsResendEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsResendEmailConfirmation($input: AuthenticationConfirmationsResendEmailConfirmationInput!) {
  data: authenticationConfirmationsResendEmailConfirmation(input: $input) {
    message
  }
}
    `;
export type AuthenticationConfirmationsResendEmailConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsResendEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>(AuthenticationConfirmationsResendEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendEmailConfirmationMutation>;
export type AuthenticationConfirmationsResendEmailConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsResendEmailConfirmationMutation>;
export type AuthenticationConfirmationsResendEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>;
export const AuthenticationConfirmationsResendRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsResendRegistrationConfirmation($input: AuthenticationConfirmationsResendRegistrationConfirmationInput!) {
  data: authenticationConfirmationsResendRegistrationConfirmation(input: $input) {
    message
  }
}
    `;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsResendRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendRegistrationConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsResendRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>;
export const AuthenticationPasswordsForgotDocument = gql`
    mutation authenticationPasswordsForgot($input: AuthenticationPasswordsForgotInput!) {
  data: authenticationPasswordsForgot(input: $input) {
    message
  }
}
    `;
export type AuthenticationPasswordsForgotMutationFn = Apollo.MutationFunction<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>;

/**
 * __useAuthenticationPasswordsForgotMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsForgotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsForgotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsForgotMutation, { data, loading, error }] = useAuthenticationPasswordsForgotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsForgotMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>(AuthenticationPasswordsForgotDocument, options);
      }
export type AuthenticationPasswordsForgotMutationHookResult = ReturnType<typeof useAuthenticationPasswordsForgotMutation>;
export type AuthenticationPasswordsForgotMutationResult = Apollo.MutationResult<AuthenticationPasswordsForgotMutation>;
export type AuthenticationPasswordsForgotMutationOptions = Apollo.BaseMutationOptions<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>;
export const AuthenticationPasswordsUpdateDocument = gql`
    mutation authenticationPasswordsUpdate($input: AuthenticationPasswordsUpdateInput!) {
  data: authenticationPasswordsUpdate(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationPasswordsUpdateMutationFn = Apollo.MutationFunction<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>;

/**
 * __useAuthenticationPasswordsUpdateMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsUpdateMutation, { data, loading, error }] = useAuthenticationPasswordsUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>(AuthenticationPasswordsUpdateDocument, options);
      }
export type AuthenticationPasswordsUpdateMutationHookResult = ReturnType<typeof useAuthenticationPasswordsUpdateMutation>;
export type AuthenticationPasswordsUpdateMutationResult = Apollo.MutationResult<AuthenticationPasswordsUpdateMutation>;
export type AuthenticationPasswordsUpdateMutationOptions = Apollo.BaseMutationOptions<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>;
export const AuthenticationSessionEndDocument = gql`
    mutation authenticationSessionEnd($input: AuthenticationSessionEndInput!) {
  data: authenticationSessionEnd(input: $input)
}
    `;
export type AuthenticationSessionEndMutationFn = Apollo.MutationFunction<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>;

/**
 * __useAuthenticationSessionEndMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionEndMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionEndMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionEndMutation, { data, loading, error }] = useAuthenticationSessionEndMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionEndMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>(AuthenticationSessionEndDocument, options);
      }
export type AuthenticationSessionEndMutationHookResult = ReturnType<typeof useAuthenticationSessionEndMutation>;
export type AuthenticationSessionEndMutationResult = Apollo.MutationResult<AuthenticationSessionEndMutation>;
export type AuthenticationSessionEndMutationOptions = Apollo.BaseMutationOptions<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>;
export const WhoamiDocument = gql`
    query Whoami($includeFullData: Boolean = true) {
  whoami {
    resource {
      __typename
      ... on User {
        avatarAttached @include(if: $includeFullData) {
          ...attachmentFragment
        }
        deactivatedAt @include(if: $includeFullData)
        debugModeUntil
        createdAt @include(if: $includeFullData)
        email @include(if: $includeFullData)
        firstName @include(if: $includeFullData)
        id
        lang @include(if: $includeFullData)
        lastName @include(if: $includeFullData)
        personalId @include(if: $includeFullData)
        passwordSetupRequired @include(if: $includeFullData)
        passwordUpdatedAt @include(if: $includeFullData)
        unconfirmedEmail @include(if: $includeFullData)
        updatedAt @include(if: $includeFullData)
        username @include(if: $includeFullData)
        verified @include(if: $includeFullData)
        phoneNumber @include(if: $includeFullData)
        role
        sites @include(if: $includeFullData) {
          collection {
            id
            name
          }
        }
        codeOfConductAccepted @include(if: $includeFullData)
        finalAccesses {
          component
          itemIds
          level
          scopeLevel
          policy
        }
        company {
          id
          activeUsersCount
          plan {
            kind
            usersLimit
            accesses {
              component
              level
            }
          }
          createdAt
        }
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useWhoamiQuery__
 *
 * To run a query within a React component, call `useWhoamiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoamiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoamiQuery({
 *   variables: {
 *      includeFullData: // value for 'includeFullData'
 *   },
 * });
 */
export function useWhoamiQuery(baseOptions?: Apollo.QueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
      }
export function useWhoamiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
export type WhoamiQueryHookResult = ReturnType<typeof useWhoamiQuery>;
export type WhoamiLazyQueryHookResult = ReturnType<typeof useWhoamiLazyQuery>;
export type WhoamiQueryResult = Apollo.QueryResult<WhoamiQuery, WhoamiQueryVariables>;
export function refetchWhoamiQuery(variables?: WhoamiQueryVariables) {
      return { query: WhoamiDocument, variables: variables }
    }
export const CountriesDocument = gql`
    query countries {
  data: countries {
    code
    name
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export function refetchCountriesQuery(variables?: CountriesQueryVariables) {
      return { query: CountriesDocument, variables: variables }
    }
export const DataImportDocument = gql`
    query dataImport($id: ID!) {
  data: dataImport(id: $id) {
    ...dataImportFragment
  }
}
    ${DataImportFragmentFragmentDoc}`;

/**
 * __useDataImportQuery__
 *
 * To run a query within a React component, call `useDataImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataImportQuery(baseOptions: Apollo.QueryHookOptions<DataImportQuery, DataImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportQuery, DataImportQueryVariables>(DataImportDocument, options);
      }
export function useDataImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportQuery, DataImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportQuery, DataImportQueryVariables>(DataImportDocument, options);
        }
export type DataImportQueryHookResult = ReturnType<typeof useDataImportQuery>;
export type DataImportLazyQueryHookResult = ReturnType<typeof useDataImportLazyQuery>;
export type DataImportQueryResult = Apollo.QueryResult<DataImportQuery, DataImportQueryVariables>;
export function refetchDataImportQuery(variables: DataImportQueryVariables) {
      return { query: DataImportDocument, variables: variables }
    }
export const DataImportsDocument = gql`
    query dataImports($page: Int, $limit: Int, $filters: [DataImportFilterInputObject!], $sorts: DataImportSortInputObject, $onlyIds: Boolean) {
  data: dataImports(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      ...dataImportFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${DataImportFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDataImportsQuery__
 *
 * To run a query within a React component, call `useDataImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDataImportsQuery(baseOptions?: Apollo.QueryHookOptions<DataImportsQuery, DataImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportsQuery, DataImportsQueryVariables>(DataImportsDocument, options);
      }
export function useDataImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportsQuery, DataImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportsQuery, DataImportsQueryVariables>(DataImportsDocument, options);
        }
export type DataImportsQueryHookResult = ReturnType<typeof useDataImportsQuery>;
export type DataImportsLazyQueryHookResult = ReturnType<typeof useDataImportsLazyQuery>;
export type DataImportsQueryResult = Apollo.QueryResult<DataImportsQuery, DataImportsQueryVariables>;
export function refetchDataImportsQuery(variables?: DataImportsQueryVariables) {
      return { query: DataImportsDocument, variables: variables }
    }
export const DataImportIdsDocument = gql`
    query dataImportIds($page: Int, $limit: Int, $filters: [DataImportFilterInputObject!], $sorts: DataImportSortInputObject, $onlyIds: Boolean) {
  data: dataImports(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useDataImportIdsQuery__
 *
 * To run a query within a React component, call `useDataImportIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDataImportIdsQuery(baseOptions?: Apollo.QueryHookOptions<DataImportIdsQuery, DataImportIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportIdsQuery, DataImportIdsQueryVariables>(DataImportIdsDocument, options);
      }
export function useDataImportIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportIdsQuery, DataImportIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportIdsQuery, DataImportIdsQueryVariables>(DataImportIdsDocument, options);
        }
export type DataImportIdsQueryHookResult = ReturnType<typeof useDataImportIdsQuery>;
export type DataImportIdsLazyQueryHookResult = ReturnType<typeof useDataImportIdsLazyQuery>;
export type DataImportIdsQueryResult = Apollo.QueryResult<DataImportIdsQuery, DataImportIdsQueryVariables>;
export function refetchDataImportIdsQuery(variables?: DataImportIdsQueryVariables) {
      return { query: DataImportIdsDocument, variables: variables }
    }
export const DataImportConfigDocument = gql`
    query dataImportConfig {
  data: dataImportConfig
}
    `;

/**
 * __useDataImportConfigQuery__
 *
 * To run a query within a React component, call `useDataImportConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataImportConfigQuery(baseOptions?: Apollo.QueryHookOptions<DataImportConfigQuery, DataImportConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportConfigQuery, DataImportConfigQueryVariables>(DataImportConfigDocument, options);
      }
export function useDataImportConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportConfigQuery, DataImportConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportConfigQuery, DataImportConfigQueryVariables>(DataImportConfigDocument, options);
        }
export type DataImportConfigQueryHookResult = ReturnType<typeof useDataImportConfigQuery>;
export type DataImportConfigLazyQueryHookResult = ReturnType<typeof useDataImportConfigLazyQuery>;
export type DataImportConfigQueryResult = Apollo.QueryResult<DataImportConfigQuery, DataImportConfigQueryVariables>;
export function refetchDataImportConfigQuery(variables?: DataImportConfigQueryVariables) {
      return { query: DataImportConfigDocument, variables: variables }
    }
export const DataImportCreateDocument = gql`
    mutation dataImportCreate($attributes: DataImportCreateInputObject!) {
  data: dataImportCreate(input: {attributes: $attributes}) {
    ...dataImportFragment
  }
}
    ${DataImportFragmentFragmentDoc}`;
export type DataImportCreateMutationFn = Apollo.MutationFunction<DataImportCreateMutation, DataImportCreateMutationVariables>;

/**
 * __useDataImportCreateMutation__
 *
 * To run a mutation, you first call `useDataImportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportCreateMutation, { data, loading, error }] = useDataImportCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDataImportCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataImportCreateMutation, DataImportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportCreateMutation, DataImportCreateMutationVariables>(DataImportCreateDocument, options);
      }
export type DataImportCreateMutationHookResult = ReturnType<typeof useDataImportCreateMutation>;
export type DataImportCreateMutationResult = Apollo.MutationResult<DataImportCreateMutation>;
export type DataImportCreateMutationOptions = Apollo.BaseMutationOptions<DataImportCreateMutation, DataImportCreateMutationVariables>;
export const DataImportUpdateDocument = gql`
    mutation dataImportUpdate($attributes: DataImportUpdateInputObject!, $id: ID!) {
  data: dataImportUpdate(input: {id: $id, attributes: $attributes}) {
    ...dataImportFragment
  }
}
    ${DataImportFragmentFragmentDoc}`;
export type DataImportUpdateMutationFn = Apollo.MutationFunction<DataImportUpdateMutation, DataImportUpdateMutationVariables>;

/**
 * __useDataImportUpdateMutation__
 *
 * To run a mutation, you first call `useDataImportUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportUpdateMutation, { data, loading, error }] = useDataImportUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataImportUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataImportUpdateMutation, DataImportUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportUpdateMutation, DataImportUpdateMutationVariables>(DataImportUpdateDocument, options);
      }
export type DataImportUpdateMutationHookResult = ReturnType<typeof useDataImportUpdateMutation>;
export type DataImportUpdateMutationResult = Apollo.MutationResult<DataImportUpdateMutation>;
export type DataImportUpdateMutationOptions = Apollo.BaseMutationOptions<DataImportUpdateMutation, DataImportUpdateMutationVariables>;
export const DataImportDestroyDocument = gql`
    mutation dataImportDestroy($id: ID!) {
  dataImportDestroy(input: {id: $id})
}
    `;
export type DataImportDestroyMutationFn = Apollo.MutationFunction<DataImportDestroyMutation, DataImportDestroyMutationVariables>;

/**
 * __useDataImportDestroyMutation__
 *
 * To run a mutation, you first call `useDataImportDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataImportDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataImportDestroyMutation, { data, loading, error }] = useDataImportDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataImportDestroyMutation(baseOptions?: Apollo.MutationHookOptions<DataImportDestroyMutation, DataImportDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataImportDestroyMutation, DataImportDestroyMutationVariables>(DataImportDestroyDocument, options);
      }
export type DataImportDestroyMutationHookResult = ReturnType<typeof useDataImportDestroyMutation>;
export type DataImportDestroyMutationResult = Apollo.MutationResult<DataImportDestroyMutation>;
export type DataImportDestroyMutationOptions = Apollo.BaseMutationOptions<DataImportDestroyMutation, DataImportDestroyMutationVariables>;
export const DocumentationsDocument = gql`
    query documentations($page: Int, $limit: Int, $sorts: DocumentationSortInputObject, $filters: [DocumentationFilterInputObject!], $assetId: ID!) {
  data: documentations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    assetId: $assetId
  ) {
    collection {
      id
      name
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
        avatarAttached {
          ...attachmentFragment
        }
      }
      attachmentAttached {
        ...attachmentFragment
      }
      tags {
        id
        name
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDocumentationsQuery__
 *
 * To run a query within a React component, call `useDocumentationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDocumentationsQuery(baseOptions: Apollo.QueryHookOptions<DocumentationsQuery, DocumentationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentationsQuery, DocumentationsQueryVariables>(DocumentationsDocument, options);
      }
export function useDocumentationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentationsQuery, DocumentationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentationsQuery, DocumentationsQueryVariables>(DocumentationsDocument, options);
        }
export type DocumentationsQueryHookResult = ReturnType<typeof useDocumentationsQuery>;
export type DocumentationsLazyQueryHookResult = ReturnType<typeof useDocumentationsLazyQuery>;
export type DocumentationsQueryResult = Apollo.QueryResult<DocumentationsQuery, DocumentationsQueryVariables>;
export function refetchDocumentationsQuery(variables: DocumentationsQueryVariables) {
      return { query: DocumentationsDocument, variables: variables }
    }
export const DocumentationsIdsDocument = gql`
    query documentationsIds($page: Int, $limit: Int, $sorts: DocumentationSortInputObject, $filters: [DocumentationFilterInputObject!], $assetId: ID!, $onlyIds: Boolean) {
  data: documentations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    assetId: $assetId
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useDocumentationsIdsQuery__
 *
 * To run a query within a React component, call `useDocumentationsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentationsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentationsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      assetId: // value for 'assetId'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDocumentationsIdsQuery(baseOptions: Apollo.QueryHookOptions<DocumentationsIdsQuery, DocumentationsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentationsIdsQuery, DocumentationsIdsQueryVariables>(DocumentationsIdsDocument, options);
      }
export function useDocumentationsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentationsIdsQuery, DocumentationsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentationsIdsQuery, DocumentationsIdsQueryVariables>(DocumentationsIdsDocument, options);
        }
export type DocumentationsIdsQueryHookResult = ReturnType<typeof useDocumentationsIdsQuery>;
export type DocumentationsIdsLazyQueryHookResult = ReturnType<typeof useDocumentationsIdsLazyQuery>;
export type DocumentationsIdsQueryResult = Apollo.QueryResult<DocumentationsIdsQuery, DocumentationsIdsQueryVariables>;
export function refetchDocumentationsIdsQuery(variables: DocumentationsIdsQueryVariables) {
      return { query: DocumentationsIdsDocument, variables: variables }
    }
export const DocumentationDocument = gql`
    query documentation($id: ID!, $assetId: ID!) {
  data: documentation(id: $id, assetId: $assetId) {
    id
    name
    attachmentAttached {
      ...attachmentFragment
    }
    tags {
      id
      name
    }
    assetId
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useDocumentationQuery__
 *
 * To run a query within a React component, call `useDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDocumentationQuery(baseOptions: Apollo.QueryHookOptions<DocumentationQuery, DocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentationQuery, DocumentationQueryVariables>(DocumentationDocument, options);
      }
export function useDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentationQuery, DocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentationQuery, DocumentationQueryVariables>(DocumentationDocument, options);
        }
export type DocumentationQueryHookResult = ReturnType<typeof useDocumentationQuery>;
export type DocumentationLazyQueryHookResult = ReturnType<typeof useDocumentationLazyQuery>;
export type DocumentationQueryResult = Apollo.QueryResult<DocumentationQuery, DocumentationQueryVariables>;
export function refetchDocumentationQuery(variables: DocumentationQueryVariables) {
      return { query: DocumentationDocument, variables: variables }
    }
export const DocumentationBulkCreateDocument = gql`
    mutation documentationBulkCreate($attributes: [DocumentationCreateInputObject!]!, $assetId: ID!) {
  documentationBulkCreate(input: {attributes: $attributes, assetId: $assetId})
}
    `;
export type DocumentationBulkCreateMutationFn = Apollo.MutationFunction<DocumentationBulkCreateMutation, DocumentationBulkCreateMutationVariables>;

/**
 * __useDocumentationBulkCreateMutation__
 *
 * To run a mutation, you first call `useDocumentationBulkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationBulkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationBulkCreateMutation, { data, loading, error }] = useDocumentationBulkCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDocumentationBulkCreateMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationBulkCreateMutation, DocumentationBulkCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationBulkCreateMutation, DocumentationBulkCreateMutationVariables>(DocumentationBulkCreateDocument, options);
      }
export type DocumentationBulkCreateMutationHookResult = ReturnType<typeof useDocumentationBulkCreateMutation>;
export type DocumentationBulkCreateMutationResult = Apollo.MutationResult<DocumentationBulkCreateMutation>;
export type DocumentationBulkCreateMutationOptions = Apollo.BaseMutationOptions<DocumentationBulkCreateMutation, DocumentationBulkCreateMutationVariables>;
export const DocumentationUpdateDocument = gql`
    mutation documentationUpdate($attributes: DocumentationUpdateInputObject!, $id: ID!, $assetId: ID!) {
  data: documentationUpdate(
    input: {id: $id, assetId: $assetId, attributes: $attributes}
  ) {
    id
    name
    tags {
      id
      name
    }
  }
}
    `;
export type DocumentationUpdateMutationFn = Apollo.MutationFunction<DocumentationUpdateMutation, DocumentationUpdateMutationVariables>;

/**
 * __useDocumentationUpdateMutation__
 *
 * To run a mutation, you first call `useDocumentationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationUpdateMutation, { data, loading, error }] = useDocumentationUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDocumentationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationUpdateMutation, DocumentationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationUpdateMutation, DocumentationUpdateMutationVariables>(DocumentationUpdateDocument, options);
      }
export type DocumentationUpdateMutationHookResult = ReturnType<typeof useDocumentationUpdateMutation>;
export type DocumentationUpdateMutationResult = Apollo.MutationResult<DocumentationUpdateMutation>;
export type DocumentationUpdateMutationOptions = Apollo.BaseMutationOptions<DocumentationUpdateMutation, DocumentationUpdateMutationVariables>;
export const DocumentationBulkDestroyDocument = gql`
    mutation documentationBulkDestroy($ids: [ID!]!, $assetId: ID!) {
  documentationBulkDestroy(input: {ids: $ids, assetId: $assetId})
}
    `;
export type DocumentationBulkDestroyMutationFn = Apollo.MutationFunction<DocumentationBulkDestroyMutation, DocumentationBulkDestroyMutationVariables>;

/**
 * __useDocumentationBulkDestroyMutation__
 *
 * To run a mutation, you first call `useDocumentationBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentationBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentationBulkDestroyMutation, { data, loading, error }] = useDocumentationBulkDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDocumentationBulkDestroyMutation(baseOptions?: Apollo.MutationHookOptions<DocumentationBulkDestroyMutation, DocumentationBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentationBulkDestroyMutation, DocumentationBulkDestroyMutationVariables>(DocumentationBulkDestroyDocument, options);
      }
export type DocumentationBulkDestroyMutationHookResult = ReturnType<typeof useDocumentationBulkDestroyMutation>;
export type DocumentationBulkDestroyMutationResult = Apollo.MutationResult<DocumentationBulkDestroyMutation>;
export type DocumentationBulkDestroyMutationOptions = Apollo.BaseMutationOptions<DocumentationBulkDestroyMutation, DocumentationBulkDestroyMutationVariables>;
export const FeFilterPresetsDocument = gql`
    query feFilterPresets($filters: [FeFilterPresetFilterInputObject!], $limit: Int, $page: Int, $sorts: FeFilterPresetSortInputObject) {
  data: feFilterPresets(
    filters: $filters
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      ...feFilterPreset
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FeFilterPresetFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFeFilterPresetsQuery__
 *
 * To run a query within a React component, call `useFeFilterPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeFilterPresetsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFeFilterPresetsQuery(baseOptions?: Apollo.QueryHookOptions<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>(FeFilterPresetsDocument, options);
      }
export function useFeFilterPresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>(FeFilterPresetsDocument, options);
        }
export type FeFilterPresetsQueryHookResult = ReturnType<typeof useFeFilterPresetsQuery>;
export type FeFilterPresetsLazyQueryHookResult = ReturnType<typeof useFeFilterPresetsLazyQuery>;
export type FeFilterPresetsQueryResult = Apollo.QueryResult<FeFilterPresetsQuery, FeFilterPresetsQueryVariables>;
export function refetchFeFilterPresetsQuery(variables?: FeFilterPresetsQueryVariables) {
      return { query: FeFilterPresetsDocument, variables: variables }
    }
export const FeFilterPresetDocument = gql`
    query feFilterPreset($id: ID!) {
  data: feFilterPreset(id: $id) {
    ...feFilterPreset
  }
}
    ${FeFilterPresetFragmentDoc}`;

/**
 * __useFeFilterPresetQuery__
 *
 * To run a query within a React component, call `useFeFilterPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeFilterPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeFilterPresetQuery(baseOptions: Apollo.QueryHookOptions<FeFilterPresetQuery, FeFilterPresetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeFilterPresetQuery, FeFilterPresetQueryVariables>(FeFilterPresetDocument, options);
      }
export function useFeFilterPresetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeFilterPresetQuery, FeFilterPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeFilterPresetQuery, FeFilterPresetQueryVariables>(FeFilterPresetDocument, options);
        }
export type FeFilterPresetQueryHookResult = ReturnType<typeof useFeFilterPresetQuery>;
export type FeFilterPresetLazyQueryHookResult = ReturnType<typeof useFeFilterPresetLazyQuery>;
export type FeFilterPresetQueryResult = Apollo.QueryResult<FeFilterPresetQuery, FeFilterPresetQueryVariables>;
export function refetchFeFilterPresetQuery(variables: FeFilterPresetQueryVariables) {
      return { query: FeFilterPresetDocument, variables: variables }
    }
export const FeFilterPresetCreateDocument = gql`
    mutation feFilterPresetCreate($attributes: FeFilterPresetCreateInputObject!) {
  data: feFilterPresetCreate(input: {attributes: $attributes}) {
    ...feFilterPreset
  }
}
    ${FeFilterPresetFragmentDoc}`;
export type FeFilterPresetCreateMutationFn = Apollo.MutationFunction<FeFilterPresetCreateMutation, FeFilterPresetCreateMutationVariables>;

/**
 * __useFeFilterPresetCreateMutation__
 *
 * To run a mutation, you first call `useFeFilterPresetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feFilterPresetCreateMutation, { data, loading, error }] = useFeFilterPresetCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFeFilterPresetCreateMutation(baseOptions?: Apollo.MutationHookOptions<FeFilterPresetCreateMutation, FeFilterPresetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeFilterPresetCreateMutation, FeFilterPresetCreateMutationVariables>(FeFilterPresetCreateDocument, options);
      }
export type FeFilterPresetCreateMutationHookResult = ReturnType<typeof useFeFilterPresetCreateMutation>;
export type FeFilterPresetCreateMutationResult = Apollo.MutationResult<FeFilterPresetCreateMutation>;
export type FeFilterPresetCreateMutationOptions = Apollo.BaseMutationOptions<FeFilterPresetCreateMutation, FeFilterPresetCreateMutationVariables>;
export const FeFilterPresetUpdateDocument = gql`
    mutation feFilterPresetUpdate($attributes: FeFilterPresetUpdateInputObject!, $id: ID!) {
  data: feFilterPresetUpdate(input: {attributes: $attributes, id: $id}) {
    ...feFilterPreset
  }
}
    ${FeFilterPresetFragmentDoc}`;
export type FeFilterPresetUpdateMutationFn = Apollo.MutationFunction<FeFilterPresetUpdateMutation, FeFilterPresetUpdateMutationVariables>;

/**
 * __useFeFilterPresetUpdateMutation__
 *
 * To run a mutation, you first call `useFeFilterPresetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feFilterPresetUpdateMutation, { data, loading, error }] = useFeFilterPresetUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeFilterPresetUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FeFilterPresetUpdateMutation, FeFilterPresetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeFilterPresetUpdateMutation, FeFilterPresetUpdateMutationVariables>(FeFilterPresetUpdateDocument, options);
      }
export type FeFilterPresetUpdateMutationHookResult = ReturnType<typeof useFeFilterPresetUpdateMutation>;
export type FeFilterPresetUpdateMutationResult = Apollo.MutationResult<FeFilterPresetUpdateMutation>;
export type FeFilterPresetUpdateMutationOptions = Apollo.BaseMutationOptions<FeFilterPresetUpdateMutation, FeFilterPresetUpdateMutationVariables>;
export const FeFilterPresetDestroyDocument = gql`
    mutation feFilterPresetDestroy($id: ID!) {
  feFilterPresetDestroy(input: {id: $id})
}
    `;
export type FeFilterPresetDestroyMutationFn = Apollo.MutationFunction<FeFilterPresetDestroyMutation, FeFilterPresetDestroyMutationVariables>;

/**
 * __useFeFilterPresetDestroyMutation__
 *
 * To run a mutation, you first call `useFeFilterPresetDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeFilterPresetDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feFilterPresetDestroyMutation, { data, loading, error }] = useFeFilterPresetDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeFilterPresetDestroyMutation(baseOptions?: Apollo.MutationHookOptions<FeFilterPresetDestroyMutation, FeFilterPresetDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeFilterPresetDestroyMutation, FeFilterPresetDestroyMutationVariables>(FeFilterPresetDestroyDocument, options);
      }
export type FeFilterPresetDestroyMutationHookResult = ReturnType<typeof useFeFilterPresetDestroyMutation>;
export type FeFilterPresetDestroyMutationResult = Apollo.MutationResult<FeFilterPresetDestroyMutation>;
export type FeFilterPresetDestroyMutationOptions = Apollo.BaseMutationOptions<FeFilterPresetDestroyMutation, FeFilterPresetDestroyMutationVariables>;
export const FormTemplateDocument = gql`
    query formTemplate($id: ID!) {
  data: formTemplate(id: $id) {
    ...formTemplateFullFragment
    archivedAt
    canArchive {
      value
    }
    canDestroy {
      value
    }
    canUpdate {
      value
    }
  }
}
    ${FormTemplateFullFragmentFragmentDoc}`;

/**
 * __useFormTemplateQuery__
 *
 * To run a query within a React component, call `useFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormTemplateQuery(baseOptions: Apollo.QueryHookOptions<FormTemplateQuery, FormTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTemplateQuery, FormTemplateQueryVariables>(FormTemplateDocument, options);
      }
export function useFormTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTemplateQuery, FormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTemplateQuery, FormTemplateQueryVariables>(FormTemplateDocument, options);
        }
export type FormTemplateQueryHookResult = ReturnType<typeof useFormTemplateQuery>;
export type FormTemplateLazyQueryHookResult = ReturnType<typeof useFormTemplateLazyQuery>;
export type FormTemplateQueryResult = Apollo.QueryResult<FormTemplateQuery, FormTemplateQueryVariables>;
export function refetchFormTemplateQuery(variables: FormTemplateQueryVariables) {
      return { query: FormTemplateDocument, variables: variables }
    }
export const FormTemplateVersionsSearchListDocument = gql`
    query formTemplateVersionsSearchList($filters: [FormTemplateVersionFilterInputObject!], $formTemplateId: ID!, $limit: Int, $page: Int, $sorts: FormTemplateVersionSortInputObject) {
  data: formTemplateVersions(
    filters: $filters
    formTemplateId: $formTemplateId
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      id
      version
      createdAt
      status
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplateVersionsSearchListQuery__
 *
 * To run a query within a React component, call `useFormTemplateVersionsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateVersionsSearchListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      formTemplateId: // value for 'formTemplateId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplateVersionsSearchListQuery(baseOptions: Apollo.QueryHookOptions<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>(FormTemplateVersionsSearchListDocument, options);
      }
export function useFormTemplateVersionsSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>(FormTemplateVersionsSearchListDocument, options);
        }
export type FormTemplateVersionsSearchListQueryHookResult = ReturnType<typeof useFormTemplateVersionsSearchListQuery>;
export type FormTemplateVersionsSearchListLazyQueryHookResult = ReturnType<typeof useFormTemplateVersionsSearchListLazyQuery>;
export type FormTemplateVersionsSearchListQueryResult = Apollo.QueryResult<FormTemplateVersionsSearchListQuery, FormTemplateVersionsSearchListQueryVariables>;
export function refetchFormTemplateVersionsSearchListQuery(variables: FormTemplateVersionsSearchListQueryVariables) {
      return { query: FormTemplateVersionsSearchListDocument, variables: variables }
    }
export const FormTemplateVersionDocument = gql`
    query formTemplateVersion($formTemplateId: ID!, $id: ID!) {
  data: formTemplateVersion(formTemplateId: $formTemplateId, id: $id) {
    ...fullFormTemplateVersionFragment
    visibleLinkedTasksCount
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}`;

/**
 * __useFormTemplateVersionQuery__
 *
 * To run a query within a React component, call `useFormTemplateVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateVersionQuery({
 *   variables: {
 *      formTemplateId: // value for 'formTemplateId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormTemplateVersionQuery(baseOptions: Apollo.QueryHookOptions<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>(FormTemplateVersionDocument, options);
      }
export function useFormTemplateVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>(FormTemplateVersionDocument, options);
        }
export type FormTemplateVersionQueryHookResult = ReturnType<typeof useFormTemplateVersionQuery>;
export type FormTemplateVersionLazyQueryHookResult = ReturnType<typeof useFormTemplateVersionLazyQuery>;
export type FormTemplateVersionQueryResult = Apollo.QueryResult<FormTemplateVersionQuery, FormTemplateVersionQueryVariables>;
export function refetchFormTemplateVersionQuery(variables: FormTemplateVersionQueryVariables) {
      return { query: FormTemplateVersionDocument, variables: variables }
    }
export const FormCategoryDocument = gql`
    query formCategory($id: ID!) {
  data: formCategory(id: $id) {
    id
    name
    color
  }
}
    `;

/**
 * __useFormCategoryQuery__
 *
 * To run a query within a React component, call `useFormCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormCategoryQuery(baseOptions: Apollo.QueryHookOptions<FormCategoryQuery, FormCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormCategoryQuery, FormCategoryQueryVariables>(FormCategoryDocument, options);
      }
export function useFormCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormCategoryQuery, FormCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormCategoryQuery, FormCategoryQueryVariables>(FormCategoryDocument, options);
        }
export type FormCategoryQueryHookResult = ReturnType<typeof useFormCategoryQuery>;
export type FormCategoryLazyQueryHookResult = ReturnType<typeof useFormCategoryLazyQuery>;
export type FormCategoryQueryResult = Apollo.QueryResult<FormCategoryQuery, FormCategoryQueryVariables>;
export function refetchFormCategoryQuery(variables: FormCategoryQueryVariables) {
      return { query: FormCategoryDocument, variables: variables }
    }
export const FormCategoriesDocument = gql`
    query formCategories($filters: [FormCategoryFilterInputObject!], $limit: Int, $page: Int, $sorts: FormCategorySortInputObject) {
  data: formCategories(
    filters: $filters
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      ...formCategoryFragment
      formTemplatesCount
      formTemplates {
        collection {
          id
          name
          currentVersion {
            id
          }
        }
      }
      canDestroy {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormCategoriesQuery__
 *
 * To run a query within a React component, call `useFormCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCategoriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FormCategoriesQuery, FormCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormCategoriesQuery, FormCategoriesQueryVariables>(FormCategoriesDocument, options);
      }
export function useFormCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormCategoriesQuery, FormCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormCategoriesQuery, FormCategoriesQueryVariables>(FormCategoriesDocument, options);
        }
export type FormCategoriesQueryHookResult = ReturnType<typeof useFormCategoriesQuery>;
export type FormCategoriesLazyQueryHookResult = ReturnType<typeof useFormCategoriesLazyQuery>;
export type FormCategoriesQueryResult = Apollo.QueryResult<FormCategoriesQuery, FormCategoriesQueryVariables>;
export function refetchFormCategoriesQuery(variables?: FormCategoriesQueryVariables) {
      return { query: FormCategoriesDocument, variables: variables }
    }
export const FormCategoriesSearchListDocument = gql`
    query formCategoriesSearchList($filters: [FormCategoryFilterInputObject!], $limit: Int, $page: Int, $sorts: FormCategorySortInputObject) {
  data: formCategories(
    filters: $filters
    limit: $limit
    page: $page
    sorts: $sorts
  ) {
    collection {
      ...formCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useFormCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormCategoriesSearchListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormCategoriesSearchListQuery(baseOptions?: Apollo.QueryHookOptions<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>(FormCategoriesSearchListDocument, options);
      }
export function useFormCategoriesSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>(FormCategoriesSearchListDocument, options);
        }
export type FormCategoriesSearchListQueryHookResult = ReturnType<typeof useFormCategoriesSearchListQuery>;
export type FormCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useFormCategoriesSearchListLazyQuery>;
export type FormCategoriesSearchListQueryResult = Apollo.QueryResult<FormCategoriesSearchListQuery, FormCategoriesSearchListQueryVariables>;
export function refetchFormCategoriesSearchListQuery(variables?: FormCategoriesSearchListQueryVariables) {
      return { query: FormCategoriesSearchListDocument, variables: variables }
    }
export const FormTemplatesDocument = gql`
    query formTemplates($filters: [FormTemplateFilterInputObject!], $limit: Int, $page: Int, $scopeName: FormTemplateScopeNameEnum!, $sorts: FormTemplateSortInputObject) {
  data: formTemplates(
    filters: $filters
    limit: $limit
    page: $page
    scopeName: $scopeName
    sorts: $sorts
  ) {
    collection {
      id
      name
      category {
        ...formCategoryFragment
      }
      createdAt
      archivedAt
      currentVersion {
        id
        version
      }
      versionsCount
      visibleLinkedTasksCount
      canDestroy {
        value
      }
      canArchive {
        value
      }
      canUpdate {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  activeCounter: formTemplates(scopeName: ACTIVE, filters: $filters) {
    metadata {
      totalCount
    }
  }
  archivedCounter: formTemplates(scopeName: ARCHIVED, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplatesQuery__
 *
 * To run a query within a React component, call `useFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      scopeName: // value for 'scopeName'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplatesQuery(baseOptions: Apollo.QueryHookOptions<FormTemplatesQuery, FormTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTemplatesQuery, FormTemplatesQueryVariables>(FormTemplatesDocument, options);
      }
export function useFormTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTemplatesQuery, FormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTemplatesQuery, FormTemplatesQueryVariables>(FormTemplatesDocument, options);
        }
export type FormTemplatesQueryHookResult = ReturnType<typeof useFormTemplatesQuery>;
export type FormTemplatesLazyQueryHookResult = ReturnType<typeof useFormTemplatesLazyQuery>;
export type FormTemplatesQueryResult = Apollo.QueryResult<FormTemplatesQuery, FormTemplatesQueryVariables>;
export function refetchFormTemplatesQuery(variables: FormTemplatesQueryVariables) {
      return { query: FormTemplatesDocument, variables: variables }
    }
export const FormTemplateIdsDocument = gql`
    query formTemplateIds($filters: [FormTemplateFilterInputObject!], $onlyIds: Boolean, $scopeName: FormTemplateScopeNameEnum!, $sorts: FormTemplateSortInputObject) {
  data: formTemplates(
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
    scopeName: $scopeName
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useFormTemplateIdsQuery__
 *
 * To run a query within a React component, call `useFormTemplateIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *      scopeName: // value for 'scopeName'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplateIdsQuery(baseOptions: Apollo.QueryHookOptions<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>(FormTemplateIdsDocument, options);
      }
export function useFormTemplateIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>(FormTemplateIdsDocument, options);
        }
export type FormTemplateIdsQueryHookResult = ReturnType<typeof useFormTemplateIdsQuery>;
export type FormTemplateIdsLazyQueryHookResult = ReturnType<typeof useFormTemplateIdsLazyQuery>;
export type FormTemplateIdsQueryResult = Apollo.QueryResult<FormTemplateIdsQuery, FormTemplateIdsQueryVariables>;
export function refetchFormTemplateIdsQuery(variables: FormTemplateIdsQueryVariables) {
      return { query: FormTemplateIdsDocument, variables: variables }
    }
export const FormTemplatesSearchListDocument = gql`
    query formTemplatesSearchList($filters: [FormTemplateFilterInputObject!], $limit: Int, $page: Int, $scopeName: FormTemplateScopeNameEnum!, $sorts: FormTemplateSortInputObject) {
  data: formTemplates(
    filters: $filters
    limit: $limit
    page: $page
    scopeName: $scopeName
    sorts: $sorts
  ) {
    collection {
      id
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplatesSearchListQuery__
 *
 * To run a query within a React component, call `useFormTemplatesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplatesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplatesSearchListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      scopeName: // value for 'scopeName'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplatesSearchListQuery(baseOptions: Apollo.QueryHookOptions<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>(FormTemplatesSearchListDocument, options);
      }
export function useFormTemplatesSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>(FormTemplatesSearchListDocument, options);
        }
export type FormTemplatesSearchListQueryHookResult = ReturnType<typeof useFormTemplatesSearchListQuery>;
export type FormTemplatesSearchListLazyQueryHookResult = ReturnType<typeof useFormTemplatesSearchListLazyQuery>;
export type FormTemplatesSearchListQueryResult = Apollo.QueryResult<FormTemplatesSearchListQuery, FormTemplatesSearchListQueryVariables>;
export function refetchFormTemplatesSearchListQuery(variables: FormTemplatesSearchListQueryVariables) {
      return { query: FormTemplatesSearchListDocument, variables: variables }
    }
export const FormCategoryCreateDocument = gql`
    mutation formCategoryCreate($attributes: FormCategoryCreateInputObject!) {
  data: formCategoryCreate(input: {attributes: $attributes}) {
    ...formCategoryFragment
  }
}
    ${FormCategoryFragmentFragmentDoc}`;
export type FormCategoryCreateMutationFn = Apollo.MutationFunction<FormCategoryCreateMutation, FormCategoryCreateMutationVariables>;

/**
 * __useFormCategoryCreateMutation__
 *
 * To run a mutation, you first call `useFormCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCategoryCreateMutation, { data, loading, error }] = useFormCategoryCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormCategoryCreateMutation, FormCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormCategoryCreateMutation, FormCategoryCreateMutationVariables>(FormCategoryCreateDocument, options);
      }
export type FormCategoryCreateMutationHookResult = ReturnType<typeof useFormCategoryCreateMutation>;
export type FormCategoryCreateMutationResult = Apollo.MutationResult<FormCategoryCreateMutation>;
export type FormCategoryCreateMutationOptions = Apollo.BaseMutationOptions<FormCategoryCreateMutation, FormCategoryCreateMutationVariables>;
export const FormCategoryUpdateDocument = gql`
    mutation formCategoryUpdate($attributes: FormCategoryUpdateInputObject!, $id: ID!) {
  data: formCategoryUpdate(input: {id: $id, attributes: $attributes}) {
    ...formCategoryFragment
  }
}
    ${FormCategoryFragmentFragmentDoc}`;
export type FormCategoryUpdateMutationFn = Apollo.MutationFunction<FormCategoryUpdateMutation, FormCategoryUpdateMutationVariables>;

/**
 * __useFormCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useFormCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCategoryUpdateMutation, { data, loading, error }] = useFormCategoryUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormCategoryUpdateMutation, FormCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormCategoryUpdateMutation, FormCategoryUpdateMutationVariables>(FormCategoryUpdateDocument, options);
      }
export type FormCategoryUpdateMutationHookResult = ReturnType<typeof useFormCategoryUpdateMutation>;
export type FormCategoryUpdateMutationResult = Apollo.MutationResult<FormCategoryUpdateMutation>;
export type FormCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<FormCategoryUpdateMutation, FormCategoryUpdateMutationVariables>;
export const FormCategoryDestroyDocument = gql`
    mutation formCategoryDestroy($id: ID!) {
  formCategoryDestroy(input: {id: $id})
}
    `;
export type FormCategoryDestroyMutationFn = Apollo.MutationFunction<FormCategoryDestroyMutation, FormCategoryDestroyMutationVariables>;

/**
 * __useFormCategoryDestroyMutation__
 *
 * To run a mutation, you first call `useFormCategoryDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormCategoryDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formCategoryDestroyMutation, { data, loading, error }] = useFormCategoryDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormCategoryDestroyMutation(baseOptions?: Apollo.MutationHookOptions<FormCategoryDestroyMutation, FormCategoryDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormCategoryDestroyMutation, FormCategoryDestroyMutationVariables>(FormCategoryDestroyDocument, options);
      }
export type FormCategoryDestroyMutationHookResult = ReturnType<typeof useFormCategoryDestroyMutation>;
export type FormCategoryDestroyMutationResult = Apollo.MutationResult<FormCategoryDestroyMutation>;
export type FormCategoryDestroyMutationOptions = Apollo.BaseMutationOptions<FormCategoryDestroyMutation, FormCategoryDestroyMutationVariables>;
export const FormTemplateCreateDocument = gql`
    mutation formTemplateCreate($attributes: FormTemplateCreateInputObject!) {
  data: formTemplateCreate(input: {attributes: $attributes}) {
    ...formTemplateFullFragment
  }
}
    ${FormTemplateFullFragmentFragmentDoc}`;
export type FormTemplateCreateMutationFn = Apollo.MutationFunction<FormTemplateCreateMutation, FormTemplateCreateMutationVariables>;

/**
 * __useFormTemplateCreateMutation__
 *
 * To run a mutation, you first call `useFormTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateCreateMutation, { data, loading, error }] = useFormTemplateCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateCreateMutation, FormTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateCreateMutation, FormTemplateCreateMutationVariables>(FormTemplateCreateDocument, options);
      }
export type FormTemplateCreateMutationHookResult = ReturnType<typeof useFormTemplateCreateMutation>;
export type FormTemplateCreateMutationResult = Apollo.MutationResult<FormTemplateCreateMutation>;
export type FormTemplateCreateMutationOptions = Apollo.BaseMutationOptions<FormTemplateCreateMutation, FormTemplateCreateMutationVariables>;
export const FormTemplateUpdateDocument = gql`
    mutation formTemplateUpdate($attributes: FormTemplateUpdateInputObject!, $id: ID!) {
  data: formTemplateUpdate(input: {attributes: $attributes, id: $id}) {
    ...formTemplateFullFragment
  }
}
    ${FormTemplateFullFragmentFragmentDoc}`;
export type FormTemplateUpdateMutationFn = Apollo.MutationFunction<FormTemplateUpdateMutation, FormTemplateUpdateMutationVariables>;

/**
 * __useFormTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useFormTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateUpdateMutation, { data, loading, error }] = useFormTemplateUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateUpdateMutation, FormTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateUpdateMutation, FormTemplateUpdateMutationVariables>(FormTemplateUpdateDocument, options);
      }
export type FormTemplateUpdateMutationHookResult = ReturnType<typeof useFormTemplateUpdateMutation>;
export type FormTemplateUpdateMutationResult = Apollo.MutationResult<FormTemplateUpdateMutation>;
export type FormTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<FormTemplateUpdateMutation, FormTemplateUpdateMutationVariables>;
export const FormTemplateBulkDestroyDocument = gql`
    mutation formTemplateBulkDestroy($ids: [ID!]!) {
  data: formTemplateBulkDestroy(input: {ids: $ids})
}
    `;
export type FormTemplateBulkDestroyMutationFn = Apollo.MutationFunction<FormTemplateBulkDestroyMutation, FormTemplateBulkDestroyMutationVariables>;

/**
 * __useFormTemplateBulkDestroyMutation__
 *
 * To run a mutation, you first call `useFormTemplateBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateBulkDestroyMutation, { data, loading, error }] = useFormTemplateBulkDestroyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFormTemplateBulkDestroyMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateBulkDestroyMutation, FormTemplateBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateBulkDestroyMutation, FormTemplateBulkDestroyMutationVariables>(FormTemplateBulkDestroyDocument, options);
      }
export type FormTemplateBulkDestroyMutationHookResult = ReturnType<typeof useFormTemplateBulkDestroyMutation>;
export type FormTemplateBulkDestroyMutationResult = Apollo.MutationResult<FormTemplateBulkDestroyMutation>;
export type FormTemplateBulkDestroyMutationOptions = Apollo.BaseMutationOptions<FormTemplateBulkDestroyMutation, FormTemplateBulkDestroyMutationVariables>;
export const FormTemplateBulkArchiveDocument = gql`
    mutation formTemplateBulkArchive($ids: [ID!]!) {
  data: formTemplateBulkArchive(input: {ids: $ids})
}
    `;
export type FormTemplateBulkArchiveMutationFn = Apollo.MutationFunction<FormTemplateBulkArchiveMutation, FormTemplateBulkArchiveMutationVariables>;

/**
 * __useFormTemplateBulkArchiveMutation__
 *
 * To run a mutation, you first call `useFormTemplateBulkArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateBulkArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateBulkArchiveMutation, { data, loading, error }] = useFormTemplateBulkArchiveMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFormTemplateBulkArchiveMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateBulkArchiveMutation, FormTemplateBulkArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateBulkArchiveMutation, FormTemplateBulkArchiveMutationVariables>(FormTemplateBulkArchiveDocument, options);
      }
export type FormTemplateBulkArchiveMutationHookResult = ReturnType<typeof useFormTemplateBulkArchiveMutation>;
export type FormTemplateBulkArchiveMutationResult = Apollo.MutationResult<FormTemplateBulkArchiveMutation>;
export type FormTemplateBulkArchiveMutationOptions = Apollo.BaseMutationOptions<FormTemplateBulkArchiveMutation, FormTemplateBulkArchiveMutationVariables>;
export const FormTemplateBulkRestoreDocument = gql`
    mutation formTemplateBulkRestore($ids: [ID!]!) {
  data: formTemplateBulkRestore(input: {ids: $ids})
}
    `;
export type FormTemplateBulkRestoreMutationFn = Apollo.MutationFunction<FormTemplateBulkRestoreMutation, FormTemplateBulkRestoreMutationVariables>;

/**
 * __useFormTemplateBulkRestoreMutation__
 *
 * To run a mutation, you first call `useFormTemplateBulkRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateBulkRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateBulkRestoreMutation, { data, loading, error }] = useFormTemplateBulkRestoreMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFormTemplateBulkRestoreMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateBulkRestoreMutation, FormTemplateBulkRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateBulkRestoreMutation, FormTemplateBulkRestoreMutationVariables>(FormTemplateBulkRestoreDocument, options);
      }
export type FormTemplateBulkRestoreMutationHookResult = ReturnType<typeof useFormTemplateBulkRestoreMutation>;
export type FormTemplateBulkRestoreMutationResult = Apollo.MutationResult<FormTemplateBulkRestoreMutation>;
export type FormTemplateBulkRestoreMutationOptions = Apollo.BaseMutationOptions<FormTemplateBulkRestoreMutation, FormTemplateBulkRestoreMutationVariables>;
export const FormTemplateVersionCreateDocument = gql`
    mutation formTemplateVersionCreate($attributes: FormTemplateVersionCuInputObject!, $formTemplateId: ID!) {
  data: formTemplateVersionCreate(
    input: {attributes: $attributes, formTemplateId: $formTemplateId}
  ) {
    ...fullFormTemplateVersionFragment
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}`;
export type FormTemplateVersionCreateMutationFn = Apollo.MutationFunction<FormTemplateVersionCreateMutation, FormTemplateVersionCreateMutationVariables>;

/**
 * __useFormTemplateVersionCreateMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionCreateMutation, { data, loading, error }] = useFormTemplateVersionCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useFormTemplateVersionCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateVersionCreateMutation, FormTemplateVersionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateVersionCreateMutation, FormTemplateVersionCreateMutationVariables>(FormTemplateVersionCreateDocument, options);
      }
export type FormTemplateVersionCreateMutationHookResult = ReturnType<typeof useFormTemplateVersionCreateMutation>;
export type FormTemplateVersionCreateMutationResult = Apollo.MutationResult<FormTemplateVersionCreateMutation>;
export type FormTemplateVersionCreateMutationOptions = Apollo.BaseMutationOptions<FormTemplateVersionCreateMutation, FormTemplateVersionCreateMutationVariables>;
export const FormTemplateVersionUpdateDocument = gql`
    mutation formTemplateVersionUpdate($attributes: FormTemplateVersionCuInputObject!, $id: ID!, $formTemplateId: ID!) {
  data: formTemplateVersionUpdate(
    input: {attributes: $attributes, id: $id, formTemplateId: $formTemplateId}
  ) {
    id
  }
}
    `;
export type FormTemplateVersionUpdateMutationFn = Apollo.MutationFunction<FormTemplateVersionUpdateMutation, FormTemplateVersionUpdateMutationVariables>;

/**
 * __useFormTemplateVersionUpdateMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionUpdateMutation, { data, loading, error }] = useFormTemplateVersionUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useFormTemplateVersionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateVersionUpdateMutation, FormTemplateVersionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateVersionUpdateMutation, FormTemplateVersionUpdateMutationVariables>(FormTemplateVersionUpdateDocument, options);
      }
export type FormTemplateVersionUpdateMutationHookResult = ReturnType<typeof useFormTemplateVersionUpdateMutation>;
export type FormTemplateVersionUpdateMutationResult = Apollo.MutationResult<FormTemplateVersionUpdateMutation>;
export type FormTemplateVersionUpdateMutationOptions = Apollo.BaseMutationOptions<FormTemplateVersionUpdateMutation, FormTemplateVersionUpdateMutationVariables>;
export const FormTemplateVersionArchiveDocument = gql`
    mutation formTemplateVersionArchive($id: ID!, $formTemplateId: ID!) {
  data: formTemplateVersionArchive(
    input: {id: $id, formTemplateId: $formTemplateId}
  ) {
    ...fullFormTemplateVersionFragment
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}`;
export type FormTemplateVersionArchiveMutationFn = Apollo.MutationFunction<FormTemplateVersionArchiveMutation, FormTemplateVersionArchiveMutationVariables>;

/**
 * __useFormTemplateVersionArchiveMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionArchiveMutation, { data, loading, error }] = useFormTemplateVersionArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useFormTemplateVersionArchiveMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateVersionArchiveMutation, FormTemplateVersionArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateVersionArchiveMutation, FormTemplateVersionArchiveMutationVariables>(FormTemplateVersionArchiveDocument, options);
      }
export type FormTemplateVersionArchiveMutationHookResult = ReturnType<typeof useFormTemplateVersionArchiveMutation>;
export type FormTemplateVersionArchiveMutationResult = Apollo.MutationResult<FormTemplateVersionArchiveMutation>;
export type FormTemplateVersionArchiveMutationOptions = Apollo.BaseMutationOptions<FormTemplateVersionArchiveMutation, FormTemplateVersionArchiveMutationVariables>;
export const FormTemplateVersionRestoreDocument = gql`
    mutation formTemplateVersionRestore($id: ID!, $formTemplateId: ID!) {
  data: formTemplateVersionRestore(
    input: {id: $id, formTemplateId: $formTemplateId}
  ) {
    ...fullFormTemplateVersionFragment
    visibleLinkedTasksCount
  }
}
    ${FullFormTemplateVersionFragmentFragmentDoc}`;
export type FormTemplateVersionRestoreMutationFn = Apollo.MutationFunction<FormTemplateVersionRestoreMutation, FormTemplateVersionRestoreMutationVariables>;

/**
 * __useFormTemplateVersionRestoreMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionRestoreMutation, { data, loading, error }] = useFormTemplateVersionRestoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useFormTemplateVersionRestoreMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateVersionRestoreMutation, FormTemplateVersionRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateVersionRestoreMutation, FormTemplateVersionRestoreMutationVariables>(FormTemplateVersionRestoreDocument, options);
      }
export type FormTemplateVersionRestoreMutationHookResult = ReturnType<typeof useFormTemplateVersionRestoreMutation>;
export type FormTemplateVersionRestoreMutationResult = Apollo.MutationResult<FormTemplateVersionRestoreMutation>;
export type FormTemplateVersionRestoreMutationOptions = Apollo.BaseMutationOptions<FormTemplateVersionRestoreMutation, FormTemplateVersionRestoreMutationVariables>;
export const FormTemplateVersionDestroyDocument = gql`
    mutation formTemplateVersionDestroy($id: ID!, $formTemplateId: ID!) {
  data: formTemplateVersionDestroy(
    input: {id: $id, formTemplateId: $formTemplateId}
  )
}
    `;
export type FormTemplateVersionDestroyMutationFn = Apollo.MutationFunction<FormTemplateVersionDestroyMutation, FormTemplateVersionDestroyMutationVariables>;

/**
 * __useFormTemplateVersionDestroyMutation__
 *
 * To run a mutation, you first call `useFormTemplateVersionDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateVersionDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formTemplateVersionDestroyMutation, { data, loading, error }] = useFormTemplateVersionDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      formTemplateId: // value for 'formTemplateId'
 *   },
 * });
 */
export function useFormTemplateVersionDestroyMutation(baseOptions?: Apollo.MutationHookOptions<FormTemplateVersionDestroyMutation, FormTemplateVersionDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormTemplateVersionDestroyMutation, FormTemplateVersionDestroyMutationVariables>(FormTemplateVersionDestroyDocument, options);
      }
export type FormTemplateVersionDestroyMutationHookResult = ReturnType<typeof useFormTemplateVersionDestroyMutation>;
export type FormTemplateVersionDestroyMutationResult = Apollo.MutationResult<FormTemplateVersionDestroyMutation>;
export type FormTemplateVersionDestroyMutationOptions = Apollo.BaseMutationOptions<FormTemplateVersionDestroyMutation, FormTemplateVersionDestroyMutationVariables>;
export const FormChecklistTemplateDocument = gql`
    query formChecklistTemplate($id: ID!) {
  data: formChecklistTemplate(id: $id) {
    ...formChecklistTemplateWithOptionsFragment
  }
}
    ${FormChecklistTemplateWithOptionsFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplateQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormChecklistTemplateQuery(baseOptions: Apollo.QueryHookOptions<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>(FormChecklistTemplateDocument, options);
      }
export function useFormChecklistTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>(FormChecklistTemplateDocument, options);
        }
export type FormChecklistTemplateQueryHookResult = ReturnType<typeof useFormChecklistTemplateQuery>;
export type FormChecklistTemplateLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplateLazyQuery>;
export type FormChecklistTemplateQueryResult = Apollo.QueryResult<FormChecklistTemplateQuery, FormChecklistTemplateQueryVariables>;
export function refetchFormChecklistTemplateQuery(variables: FormChecklistTemplateQueryVariables) {
      return { query: FormChecklistTemplateDocument, variables: variables }
    }
export const FormChecklistTemplatesDocument = gql`
    query formChecklistTemplates($page: Int, $limit: Int, $filters: [FormChecklistTemplateFilterInputObject!], $sorts: FormChecklistTemplateSortInputObject) {
  data: formChecklistTemplates(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      ...formChecklistTemplateFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormChecklistTemplateFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplatesQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormChecklistTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>(FormChecklistTemplatesDocument, options);
      }
export function useFormChecklistTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>(FormChecklistTemplatesDocument, options);
        }
export type FormChecklistTemplatesQueryHookResult = ReturnType<typeof useFormChecklistTemplatesQuery>;
export type FormChecklistTemplatesLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplatesLazyQuery>;
export type FormChecklistTemplatesQueryResult = Apollo.QueryResult<FormChecklistTemplatesQuery, FormChecklistTemplatesQueryVariables>;
export function refetchFormChecklistTemplatesQuery(variables?: FormChecklistTemplatesQueryVariables) {
      return { query: FormChecklistTemplatesDocument, variables: variables }
    }
export const FormChecklistTemplateIdsDocument = gql`
    query formChecklistTemplateIds($filters: [FormChecklistTemplateFilterInputObject!], $sorts: FormChecklistTemplateSortInputObject, $onlyIds: Boolean) {
  data: formChecklistTemplates(
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useFormChecklistTemplateIdsQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplateIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplateIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useFormChecklistTemplateIdsQuery(baseOptions?: Apollo.QueryHookOptions<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>(FormChecklistTemplateIdsDocument, options);
      }
export function useFormChecklistTemplateIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>(FormChecklistTemplateIdsDocument, options);
        }
export type FormChecklistTemplateIdsQueryHookResult = ReturnType<typeof useFormChecklistTemplateIdsQuery>;
export type FormChecklistTemplateIdsLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplateIdsLazyQuery>;
export type FormChecklistTemplateIdsQueryResult = Apollo.QueryResult<FormChecklistTemplateIdsQuery, FormChecklistTemplateIdsQueryVariables>;
export function refetchFormChecklistTemplateIdsQuery(variables?: FormChecklistTemplateIdsQueryVariables) {
      return { query: FormChecklistTemplateIdsDocument, variables: variables }
    }
export const FormChecklistTemplatesSearchListDocument = gql`
    query formChecklistTemplatesSearchList($page: Int, $limit: Int, $filters: [FormChecklistTemplateFilterInputObject!], $sorts: FormChecklistTemplateSortInputObject) {
  data: formChecklistTemplates(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useFormChecklistTemplatesSearchListQuery__
 *
 * To run a query within a React component, call `useFormChecklistTemplatesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplatesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormChecklistTemplatesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormChecklistTemplatesSearchListQuery(baseOptions?: Apollo.QueryHookOptions<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>(FormChecklistTemplatesSearchListDocument, options);
      }
export function useFormChecklistTemplatesSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>(FormChecklistTemplatesSearchListDocument, options);
        }
export type FormChecklistTemplatesSearchListQueryHookResult = ReturnType<typeof useFormChecklistTemplatesSearchListQuery>;
export type FormChecklistTemplatesSearchListLazyQueryHookResult = ReturnType<typeof useFormChecklistTemplatesSearchListLazyQuery>;
export type FormChecklistTemplatesSearchListQueryResult = Apollo.QueryResult<FormChecklistTemplatesSearchListQuery, FormChecklistTemplatesSearchListQueryVariables>;
export function refetchFormChecklistTemplatesSearchListQuery(variables?: FormChecklistTemplatesSearchListQueryVariables) {
      return { query: FormChecklistTemplatesSearchListDocument, variables: variables }
    }
export const FormChecklistTemplateCreateDocument = gql`
    mutation formChecklistTemplateCreate($attributes: FormChecklistTemplateCreateInputObject!) {
  data: formChecklistTemplateCreate(input: {attributes: $attributes}) {
    ...formChecklistTemplateWithOptionsFragment
    options {
      value
      position
      updatedAt
    }
  }
}
    ${FormChecklistTemplateWithOptionsFragmentFragmentDoc}`;
export type FormChecklistTemplateCreateMutationFn = Apollo.MutationFunction<FormChecklistTemplateCreateMutation, FormChecklistTemplateCreateMutationVariables>;

/**
 * __useFormChecklistTemplateCreateMutation__
 *
 * To run a mutation, you first call `useFormChecklistTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formChecklistTemplateCreateMutation, { data, loading, error }] = useFormChecklistTemplateCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormChecklistTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<FormChecklistTemplateCreateMutation, FormChecklistTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormChecklistTemplateCreateMutation, FormChecklistTemplateCreateMutationVariables>(FormChecklistTemplateCreateDocument, options);
      }
export type FormChecklistTemplateCreateMutationHookResult = ReturnType<typeof useFormChecklistTemplateCreateMutation>;
export type FormChecklistTemplateCreateMutationResult = Apollo.MutationResult<FormChecklistTemplateCreateMutation>;
export type FormChecklistTemplateCreateMutationOptions = Apollo.BaseMutationOptions<FormChecklistTemplateCreateMutation, FormChecklistTemplateCreateMutationVariables>;
export const FormChecklistTemplateUpdateDocument = gql`
    mutation formChecklistTemplateUpdate($id: ID!, $attributes: FormChecklistTemplateUpdateInputObject!) {
  data: formChecklistTemplateUpdate(input: {id: $id, attributes: $attributes}) {
    ...formChecklistTemplateWithOptionsFragment
    options {
      value
      position
      updatedAt
    }
  }
}
    ${FormChecklistTemplateWithOptionsFragmentFragmentDoc}`;
export type FormChecklistTemplateUpdateMutationFn = Apollo.MutationFunction<FormChecklistTemplateUpdateMutation, FormChecklistTemplateUpdateMutationVariables>;

/**
 * __useFormChecklistTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useFormChecklistTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formChecklistTemplateUpdateMutation, { data, loading, error }] = useFormChecklistTemplateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useFormChecklistTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FormChecklistTemplateUpdateMutation, FormChecklistTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormChecklistTemplateUpdateMutation, FormChecklistTemplateUpdateMutationVariables>(FormChecklistTemplateUpdateDocument, options);
      }
export type FormChecklistTemplateUpdateMutationHookResult = ReturnType<typeof useFormChecklistTemplateUpdateMutation>;
export type FormChecklistTemplateUpdateMutationResult = Apollo.MutationResult<FormChecklistTemplateUpdateMutation>;
export type FormChecklistTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<FormChecklistTemplateUpdateMutation, FormChecklistTemplateUpdateMutationVariables>;
export const FormChecklistTemplateDestroyDocument = gql`
    mutation formChecklistTemplateDestroy($id: ID!) {
  data: formChecklistTemplateDestroy(input: {id: $id})
}
    `;
export type FormChecklistTemplateDestroyMutationFn = Apollo.MutationFunction<FormChecklistTemplateDestroyMutation, FormChecklistTemplateDestroyMutationVariables>;

/**
 * __useFormChecklistTemplateDestroyMutation__
 *
 * To run a mutation, you first call `useFormChecklistTemplateDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormChecklistTemplateDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formChecklistTemplateDestroyMutation, { data, loading, error }] = useFormChecklistTemplateDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormChecklistTemplateDestroyMutation(baseOptions?: Apollo.MutationHookOptions<FormChecklistTemplateDestroyMutation, FormChecklistTemplateDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormChecklistTemplateDestroyMutation, FormChecklistTemplateDestroyMutationVariables>(FormChecklistTemplateDestroyDocument, options);
      }
export type FormChecklistTemplateDestroyMutationHookResult = ReturnType<typeof useFormChecklistTemplateDestroyMutation>;
export type FormChecklistTemplateDestroyMutationResult = Apollo.MutationResult<FormChecklistTemplateDestroyMutation>;
export type FormChecklistTemplateDestroyMutationOptions = Apollo.BaseMutationOptions<FormChecklistTemplateDestroyMutation, FormChecklistTemplateDestroyMutationVariables>;
export const HomePageDocument = gql`
    query homePage($id: ID!) {
  data: homePage(id: $id) {
    ...homePageFragment
  }
}
    ${HomePageFragmentFragmentDoc}`;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomePageQuery(baseOptions: Apollo.QueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
      }
export function useHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
        }
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageLazyQueryHookResult = ReturnType<typeof useHomePageLazyQuery>;
export type HomePageQueryResult = Apollo.QueryResult<HomePageQuery, HomePageQueryVariables>;
export function refetchHomePageQuery(variables: HomePageQueryVariables) {
      return { query: HomePageDocument, variables: variables }
    }
export const HomePagesDocument = gql`
    query homePages($page: Int, $limit: Int) {
  data: homePages(page: $page, limit: $limit) {
    collection {
      ...homePageFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${HomePageFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useHomePagesQuery__
 *
 * To run a query within a React component, call `useHomePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useHomePagesQuery(baseOptions?: Apollo.QueryHookOptions<HomePagesQuery, HomePagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePagesQuery, HomePagesQueryVariables>(HomePagesDocument, options);
      }
export function useHomePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePagesQuery, HomePagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePagesQuery, HomePagesQueryVariables>(HomePagesDocument, options);
        }
export type HomePagesQueryHookResult = ReturnType<typeof useHomePagesQuery>;
export type HomePagesLazyQueryHookResult = ReturnType<typeof useHomePagesLazyQuery>;
export type HomePagesQueryResult = Apollo.QueryResult<HomePagesQuery, HomePagesQueryVariables>;
export function refetchHomePagesQuery(variables?: HomePagesQueryVariables) {
      return { query: HomePagesDocument, variables: variables }
    }
export const WidgetDocument = gql`
    query widget($homePageId: ID!, $id: ID!) {
  data: widget(homePageId: $homePageId, id: $id) {
    ...widgetFragment
  }
}
    ${WidgetFragmentFragmentDoc}`;

/**
 * __useWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetQuery({
 *   variables: {
 *      homePageId: // value for 'homePageId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
      }
export function useWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
        }
export type WidgetQueryHookResult = ReturnType<typeof useWidgetQuery>;
export type WidgetLazyQueryHookResult = ReturnType<typeof useWidgetLazyQuery>;
export type WidgetQueryResult = Apollo.QueryResult<WidgetQuery, WidgetQueryVariables>;
export function refetchWidgetQuery(variables: WidgetQueryVariables) {
      return { query: WidgetDocument, variables: variables }
    }
export const WidgetsDocument = gql`
    query widgets($homePageId: ID!) {
  data: widgets(homePageId: $homePageId) {
    ...widgetFragment
  }
}
    ${WidgetFragmentFragmentDoc}`;

/**
 * __useWidgetsQuery__
 *
 * To run a query within a React component, call `useWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetsQuery({
 *   variables: {
 *      homePageId: // value for 'homePageId'
 *   },
 * });
 */
export function useWidgetsQuery(baseOptions: Apollo.QueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
      }
export function useWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
        }
export type WidgetsQueryHookResult = ReturnType<typeof useWidgetsQuery>;
export type WidgetsLazyQueryHookResult = ReturnType<typeof useWidgetsLazyQuery>;
export type WidgetsQueryResult = Apollo.QueryResult<WidgetsQuery, WidgetsQueryVariables>;
export function refetchWidgetsQuery(variables: WidgetsQueryVariables) {
      return { query: WidgetsDocument, variables: variables }
    }
export const WidgetTemplateDocument = gql`
    query widgetTemplate($id: ID!) {
  data: widgetTemplate(id: $id) {
    ...widgetTemplateFragment
  }
}
    ${WidgetTemplateFragmentFragmentDoc}`;

/**
 * __useWidgetTemplateQuery__
 *
 * To run a query within a React component, call `useWidgetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetTemplateQuery(baseOptions: Apollo.QueryHookOptions<WidgetTemplateQuery, WidgetTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetTemplateQuery, WidgetTemplateQueryVariables>(WidgetTemplateDocument, options);
      }
export function useWidgetTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetTemplateQuery, WidgetTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetTemplateQuery, WidgetTemplateQueryVariables>(WidgetTemplateDocument, options);
        }
export type WidgetTemplateQueryHookResult = ReturnType<typeof useWidgetTemplateQuery>;
export type WidgetTemplateLazyQueryHookResult = ReturnType<typeof useWidgetTemplateLazyQuery>;
export type WidgetTemplateQueryResult = Apollo.QueryResult<WidgetTemplateQuery, WidgetTemplateQueryVariables>;
export function refetchWidgetTemplateQuery(variables: WidgetTemplateQueryVariables) {
      return { query: WidgetTemplateDocument, variables: variables }
    }
export const WidgetTemplatesDocument = gql`
    query widgetTemplates($page: Int, $limit: Int, $sorts: WidgetTemplateSortInputObject, $filters: [WidgetTemplateFilterInputObject!], $onlyIds: Boolean) {
  data: widgetTemplates(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
  ) {
    collection {
      ...widgetTemplateFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${WidgetTemplateFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useWidgetTemplatesQuery__
 *
 * To run a query within a React component, call `useWidgetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useWidgetTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>(WidgetTemplatesDocument, options);
      }
export function useWidgetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>(WidgetTemplatesDocument, options);
        }
export type WidgetTemplatesQueryHookResult = ReturnType<typeof useWidgetTemplatesQuery>;
export type WidgetTemplatesLazyQueryHookResult = ReturnType<typeof useWidgetTemplatesLazyQuery>;
export type WidgetTemplatesQueryResult = Apollo.QueryResult<WidgetTemplatesQuery, WidgetTemplatesQueryVariables>;
export function refetchWidgetTemplatesQuery(variables?: WidgetTemplatesQueryVariables) {
      return { query: WidgetTemplatesDocument, variables: variables }
    }
export const WidgetTemplatesWithCountersDocument = gql`
    query widgetTemplatesWithCounters($page: Int, $limit: Int, $sorts: WidgetTemplateSortInputObject, $filters: [WidgetTemplateFilterInputObject!], $allTemplatesFilters: [WidgetTemplateFilterInputObject!], $publicTemplatesFilters: [WidgetTemplateFilterInputObject!], $privateTemplatesFilters: [WidgetTemplateFilterInputObject!]) {
  data: widgetTemplates(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      title
      description
      kind
      fields {
        backgroundColor
        content
        link
      }
      attachmentsAttached {
        ...attachmentFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  allTemplates: widgetTemplates(filters: $allTemplatesFilters, onlyIds: true) {
    collection {
      id
    }
  }
  publicTemplates: widgetTemplates(
    filters: $publicTemplatesFilters
    onlyIds: true
  ) {
    collection {
      id
    }
  }
  privateTemplates: widgetTemplates(
    filters: $privateTemplatesFilters
    onlyIds: true
  ) {
    collection {
      id
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useWidgetTemplatesWithCountersQuery__
 *
 * To run a query within a React component, call `useWidgetTemplatesWithCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplatesWithCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetTemplatesWithCountersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      allTemplatesFilters: // value for 'allTemplatesFilters'
 *      publicTemplatesFilters: // value for 'publicTemplatesFilters'
 *      privateTemplatesFilters: // value for 'privateTemplatesFilters'
 *   },
 * });
 */
export function useWidgetTemplatesWithCountersQuery(baseOptions?: Apollo.QueryHookOptions<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>(WidgetTemplatesWithCountersDocument, options);
      }
export function useWidgetTemplatesWithCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>(WidgetTemplatesWithCountersDocument, options);
        }
export type WidgetTemplatesWithCountersQueryHookResult = ReturnType<typeof useWidgetTemplatesWithCountersQuery>;
export type WidgetTemplatesWithCountersLazyQueryHookResult = ReturnType<typeof useWidgetTemplatesWithCountersLazyQuery>;
export type WidgetTemplatesWithCountersQueryResult = Apollo.QueryResult<WidgetTemplatesWithCountersQuery, WidgetTemplatesWithCountersQueryVariables>;
export function refetchWidgetTemplatesWithCountersQuery(variables?: WidgetTemplatesWithCountersQueryVariables) {
      return { query: WidgetTemplatesWithCountersDocument, variables: variables }
    }
export const HomePageBulkUpdateDocument = gql`
    mutation homePageBulkUpdate($attributes: [HomePageUpdateInputObject!]!) {
  data: homePageBulkUpdate(input: {attributes: $attributes})
}
    `;
export type HomePageBulkUpdateMutationFn = Apollo.MutationFunction<HomePageBulkUpdateMutation, HomePageBulkUpdateMutationVariables>;

/**
 * __useHomePageBulkUpdateMutation__
 *
 * To run a mutation, you first call `useHomePageBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomePageBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homePageBulkUpdateMutation, { data, loading, error }] = useHomePageBulkUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useHomePageBulkUpdateMutation(baseOptions?: Apollo.MutationHookOptions<HomePageBulkUpdateMutation, HomePageBulkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HomePageBulkUpdateMutation, HomePageBulkUpdateMutationVariables>(HomePageBulkUpdateDocument, options);
      }
export type HomePageBulkUpdateMutationHookResult = ReturnType<typeof useHomePageBulkUpdateMutation>;
export type HomePageBulkUpdateMutationResult = Apollo.MutationResult<HomePageBulkUpdateMutation>;
export type HomePageBulkUpdateMutationOptions = Apollo.BaseMutationOptions<HomePageBulkUpdateMutation, HomePageBulkUpdateMutationVariables>;
export const WidgetBulkUpdateDocument = gql`
    mutation widgetBulkUpdate($homePageId: ID!, $attributes: [WidgetUpdateInputObject!]!) {
  data: widgetBulkUpdate(
    input: {homePageId: $homePageId, attributes: $attributes}
  )
}
    `;
export type WidgetBulkUpdateMutationFn = Apollo.MutationFunction<WidgetBulkUpdateMutation, WidgetBulkUpdateMutationVariables>;

/**
 * __useWidgetBulkUpdateMutation__
 *
 * To run a mutation, you first call `useWidgetBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetBulkUpdateMutation, { data, loading, error }] = useWidgetBulkUpdateMutation({
 *   variables: {
 *      homePageId: // value for 'homePageId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useWidgetBulkUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetBulkUpdateMutation, WidgetBulkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetBulkUpdateMutation, WidgetBulkUpdateMutationVariables>(WidgetBulkUpdateDocument, options);
      }
export type WidgetBulkUpdateMutationHookResult = ReturnType<typeof useWidgetBulkUpdateMutation>;
export type WidgetBulkUpdateMutationResult = Apollo.MutationResult<WidgetBulkUpdateMutation>;
export type WidgetBulkUpdateMutationOptions = Apollo.BaseMutationOptions<WidgetBulkUpdateMutation, WidgetBulkUpdateMutationVariables>;
export const WidgetTemplateCreateDocument = gql`
    mutation widgetTemplateCreate($attributes: WidgetTemplateCreateInputObject!) {
  data: widgetTemplateCreate(input: {attributes: $attributes}) {
    ...widgetTemplateFragment
  }
}
    ${WidgetTemplateFragmentFragmentDoc}`;
export type WidgetTemplateCreateMutationFn = Apollo.MutationFunction<WidgetTemplateCreateMutation, WidgetTemplateCreateMutationVariables>;

/**
 * __useWidgetTemplateCreateMutation__
 *
 * To run a mutation, you first call `useWidgetTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetTemplateCreateMutation, { data, loading, error }] = useWidgetTemplateCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useWidgetTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetTemplateCreateMutation, WidgetTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetTemplateCreateMutation, WidgetTemplateCreateMutationVariables>(WidgetTemplateCreateDocument, options);
      }
export type WidgetTemplateCreateMutationHookResult = ReturnType<typeof useWidgetTemplateCreateMutation>;
export type WidgetTemplateCreateMutationResult = Apollo.MutationResult<WidgetTemplateCreateMutation>;
export type WidgetTemplateCreateMutationOptions = Apollo.BaseMutationOptions<WidgetTemplateCreateMutation, WidgetTemplateCreateMutationVariables>;
export const WidgetTemplateDestroyDocument = gql`
    mutation widgetTemplateDestroy($id: ID!) {
  data: widgetTemplateDestroy(input: {id: $id})
}
    `;
export type WidgetTemplateDestroyMutationFn = Apollo.MutationFunction<WidgetTemplateDestroyMutation, WidgetTemplateDestroyMutationVariables>;

/**
 * __useWidgetTemplateDestroyMutation__
 *
 * To run a mutation, you first call `useWidgetTemplateDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetTemplateDestroyMutation, { data, loading, error }] = useWidgetTemplateDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetTemplateDestroyMutation(baseOptions?: Apollo.MutationHookOptions<WidgetTemplateDestroyMutation, WidgetTemplateDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetTemplateDestroyMutation, WidgetTemplateDestroyMutationVariables>(WidgetTemplateDestroyDocument, options);
      }
export type WidgetTemplateDestroyMutationHookResult = ReturnType<typeof useWidgetTemplateDestroyMutation>;
export type WidgetTemplateDestroyMutationResult = Apollo.MutationResult<WidgetTemplateDestroyMutation>;
export type WidgetTemplateDestroyMutationOptions = Apollo.BaseMutationOptions<WidgetTemplateDestroyMutation, WidgetTemplateDestroyMutationVariables>;
export const WidgetTemplateUpdateDocument = gql`
    mutation widgetTemplateUpdate($id: ID!, $attributes: WidgetTemplateUpdateInputObject!) {
  data: widgetTemplateUpdate(input: {id: $id, attributes: $attributes}) {
    ...widgetTemplateFragment
  }
}
    ${WidgetTemplateFragmentFragmentDoc}`;
export type WidgetTemplateUpdateMutationFn = Apollo.MutationFunction<WidgetTemplateUpdateMutation, WidgetTemplateUpdateMutationVariables>;

/**
 * __useWidgetTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useWidgetTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetTemplateUpdateMutation, { data, loading, error }] = useWidgetTemplateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useWidgetTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetTemplateUpdateMutation, WidgetTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetTemplateUpdateMutation, WidgetTemplateUpdateMutationVariables>(WidgetTemplateUpdateDocument, options);
      }
export type WidgetTemplateUpdateMutationHookResult = ReturnType<typeof useWidgetTemplateUpdateMutation>;
export type WidgetTemplateUpdateMutationResult = Apollo.MutationResult<WidgetTemplateUpdateMutation>;
export type WidgetTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<WidgetTemplateUpdateMutation, WidgetTemplateUpdateMutationVariables>;
export const InterventionsDocument = gql`
    query interventions($page: Int, $limit: Int, $sorts: InterventionSortInputObject, $filters: [InterventionFilterInputObject!], $scopeName: InterventionScopeNameEnum!) {
  data: interventions(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scopeName: $scopeName
  ) {
    collection {
      id
      name
      createdAt
      closedAt
      code
      category {
        id
        name
        color
      }
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      asset {
        id
        name
        fullCode
        iconAttached {
          ...attachmentFragment
        }
      }
      priority
      status
      canUpdate {
        ...authorizationResultFragment
      }
      canDestroy {
        ...authorizationResultFragment
      }
      canClose {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  openedCounter: interventions(scopeName: OPENED, filters: $filters) {
    metadata {
      totalCount
    }
  }
  closedCounter: interventions(scopeName: CLOSED, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionsQuery__
 *
 * To run a query within a React component, call `useInterventionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scopeName: // value for 'scopeName'
 *   },
 * });
 */
export function useInterventionsQuery(baseOptions: Apollo.QueryHookOptions<InterventionsQuery, InterventionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
      }
export function useInterventionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionsQuery, InterventionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
        }
export type InterventionsQueryHookResult = ReturnType<typeof useInterventionsQuery>;
export type InterventionsLazyQueryHookResult = ReturnType<typeof useInterventionsLazyQuery>;
export type InterventionsQueryResult = Apollo.QueryResult<InterventionsQuery, InterventionsQueryVariables>;
export function refetchInterventionsQuery(variables: InterventionsQueryVariables) {
      return { query: InterventionsDocument, variables: variables }
    }
export const InterventionsIdsDocument = gql`
    query interventionsIds($page: Int, $limit: Int, $sorts: InterventionSortInputObject, $filters: [InterventionFilterInputObject!], $scopeName: InterventionScopeNameEnum!, $onlyIds: Boolean) {
  data: interventions(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scopeName: $scopeName
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useInterventionsIdsQuery__
 *
 * To run a query within a React component, call `useInterventionsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scopeName: // value for 'scopeName'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useInterventionsIdsQuery(baseOptions: Apollo.QueryHookOptions<InterventionsIdsQuery, InterventionsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionsIdsQuery, InterventionsIdsQueryVariables>(InterventionsIdsDocument, options);
      }
export function useInterventionsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionsIdsQuery, InterventionsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionsIdsQuery, InterventionsIdsQueryVariables>(InterventionsIdsDocument, options);
        }
export type InterventionsIdsQueryHookResult = ReturnType<typeof useInterventionsIdsQuery>;
export type InterventionsIdsLazyQueryHookResult = ReturnType<typeof useInterventionsIdsLazyQuery>;
export type InterventionsIdsQueryResult = Apollo.QueryResult<InterventionsIdsQuery, InterventionsIdsQueryVariables>;
export function refetchInterventionsIdsQuery(variables: InterventionsIdsQueryVariables) {
      return { query: InterventionsIdsDocument, variables: variables }
    }
export const InterventionDocument = gql`
    query intervention($id: ID!) {
  data: intervention(id: $id) {
    ...interventionFragment
  }
  actionsCounter: interventionActions(interventionId: $id) {
    metadata {
      totalCount
    }
  }
}
    ${InterventionFragmentFragmentDoc}`;

/**
 * __useInterventionQuery__
 *
 * To run a query within a React component, call `useInterventionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionQuery(baseOptions: Apollo.QueryHookOptions<InterventionQuery, InterventionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionQuery, InterventionQueryVariables>(InterventionDocument, options);
      }
export function useInterventionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionQuery, InterventionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionQuery, InterventionQueryVariables>(InterventionDocument, options);
        }
export type InterventionQueryHookResult = ReturnType<typeof useInterventionQuery>;
export type InterventionLazyQueryHookResult = ReturnType<typeof useInterventionLazyQuery>;
export type InterventionQueryResult = Apollo.QueryResult<InterventionQuery, InterventionQueryVariables>;
export function refetchInterventionQuery(variables: InterventionQueryVariables) {
      return { query: InterventionDocument, variables: variables }
    }
export const InterventionSiteIdDocument = gql`
    query interventionSiteId($id: ID!) {
  data: intervention(id: $id) {
    id
    siteId
    categoryId
  }
}
    `;

/**
 * __useInterventionSiteIdQuery__
 *
 * To run a query within a React component, call `useInterventionSiteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionSiteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionSiteIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionSiteIdQuery(baseOptions: Apollo.QueryHookOptions<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>(InterventionSiteIdDocument, options);
      }
export function useInterventionSiteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>(InterventionSiteIdDocument, options);
        }
export type InterventionSiteIdQueryHookResult = ReturnType<typeof useInterventionSiteIdQuery>;
export type InterventionSiteIdLazyQueryHookResult = ReturnType<typeof useInterventionSiteIdLazyQuery>;
export type InterventionSiteIdQueryResult = Apollo.QueryResult<InterventionSiteIdQuery, InterventionSiteIdQueryVariables>;
export function refetchInterventionSiteIdQuery(variables: InterventionSiteIdQueryVariables) {
      return { query: InterventionSiteIdDocument, variables: variables }
    }
export const InterventionCategoryDocument = gql`
    query interventionCategory($id: ID!) {
  data: interventionCategory(id: $id) {
    ...interventionCategoryFragment
  }
}
    ${InterventionCategoryFragmentFragmentDoc}`;

/**
 * __useInterventionCategoryQuery__
 *
 * To run a query within a React component, call `useInterventionCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionCategoryQuery(baseOptions: Apollo.QueryHookOptions<InterventionCategoryQuery, InterventionCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionCategoryQuery, InterventionCategoryQueryVariables>(InterventionCategoryDocument, options);
      }
export function useInterventionCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionCategoryQuery, InterventionCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionCategoryQuery, InterventionCategoryQueryVariables>(InterventionCategoryDocument, options);
        }
export type InterventionCategoryQueryHookResult = ReturnType<typeof useInterventionCategoryQuery>;
export type InterventionCategoryLazyQueryHookResult = ReturnType<typeof useInterventionCategoryLazyQuery>;
export type InterventionCategoryQueryResult = Apollo.QueryResult<InterventionCategoryQuery, InterventionCategoryQueryVariables>;
export function refetchInterventionCategoryQuery(variables: InterventionCategoryQueryVariables) {
      return { query: InterventionCategoryDocument, variables: variables }
    }
export const InterventionCategoriesDocument = gql`
    query interventionCategories($page: Int, $limit: Int, $filters: [InterventionCategoryFilterInputObject!], $sorts: InterventionCategorySortInputObject) {
  data: interventionCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...interventionCategoryFragment
      visibleInterventionsCount
      interventions {
        collection {
          id
          name
        }
      }
      canDestroy {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${InterventionCategoryFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionCategoriesQuery__
 *
 * To run a query within a React component, call `useInterventionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useInterventionCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>(InterventionCategoriesDocument, options);
      }
export function useInterventionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>(InterventionCategoriesDocument, options);
        }
export type InterventionCategoriesQueryHookResult = ReturnType<typeof useInterventionCategoriesQuery>;
export type InterventionCategoriesLazyQueryHookResult = ReturnType<typeof useInterventionCategoriesLazyQuery>;
export type InterventionCategoriesQueryResult = Apollo.QueryResult<InterventionCategoriesQuery, InterventionCategoriesQueryVariables>;
export function refetchInterventionCategoriesQuery(variables?: InterventionCategoriesQueryVariables) {
      return { query: InterventionCategoriesDocument, variables: variables }
    }
export const InterventionCategoriesSearchListDocument = gql`
    query interventionCategoriesSearchList($page: Int, $limit: Int, $filters: [InterventionCategoryFilterInputObject!], $sorts: InterventionCategorySortInputObject) {
  data: interventionCategories(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...interventionCategoryFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${InterventionCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionCategoriesSearchListQuery__
 *
 * To run a query within a React component, call `useInterventionCategoriesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoriesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionCategoriesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useInterventionCategoriesSearchListQuery(baseOptions?: Apollo.QueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
      }
export function useInterventionCategoriesSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>(InterventionCategoriesSearchListDocument, options);
        }
export type InterventionCategoriesSearchListQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListQuery>;
export type InterventionCategoriesSearchListLazyQueryHookResult = ReturnType<typeof useInterventionCategoriesSearchListLazyQuery>;
export type InterventionCategoriesSearchListQueryResult = Apollo.QueryResult<InterventionCategoriesSearchListQuery, InterventionCategoriesSearchListQueryVariables>;
export function refetchInterventionCategoriesSearchListQuery(variables?: InterventionCategoriesSearchListQueryVariables) {
      return { query: InterventionCategoriesSearchListDocument, variables: variables }
    }
export const InterventionActionDocument = gql`
    query interventionAction($interventionId: ID!, $id: ID!) {
  data: interventionAction(interventionId: $interventionId, id: $id) {
    ...interventionActionFragment
  }
}
    ${InterventionActionFragmentFragmentDoc}`;

/**
 * __useInterventionActionQuery__
 *
 * To run a query within a React component, call `useInterventionActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionQuery({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionActionQuery(baseOptions: Apollo.QueryHookOptions<InterventionActionQuery, InterventionActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionActionQuery, InterventionActionQueryVariables>(InterventionActionDocument, options);
      }
export function useInterventionActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionActionQuery, InterventionActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionActionQuery, InterventionActionQueryVariables>(InterventionActionDocument, options);
        }
export type InterventionActionQueryHookResult = ReturnType<typeof useInterventionActionQuery>;
export type InterventionActionLazyQueryHookResult = ReturnType<typeof useInterventionActionLazyQuery>;
export type InterventionActionQueryResult = Apollo.QueryResult<InterventionActionQuery, InterventionActionQueryVariables>;
export function refetchInterventionActionQuery(variables: InterventionActionQueryVariables) {
      return { query: InterventionActionDocument, variables: variables }
    }
export const InterventionActionHistoriesDocument = gql`
    query interventionActionHistories($page: Int, $limit: Int, $sourceableId: ID!, $sourceableType: HistorySourceableTypeEnum!, $sorts: HistorySortInputObject) {
  data: histories(
    page: $page
    limit: $limit
    sourceableId: $sourceableId
    sourceableType: $sourceableType
    sorts: $sorts
  ) {
    collection {
      id
      kind
      system
      occurredAt
      data {
        __typename
        ... on InterventionActionHistoryData {
          durationTime
          estimatedDate
          estimatedTime
          logisticTime
          status
        }
      }
      metadata {
        __typename
        ... on InterventionActionHistoryMetadata {
          reason
        }
      }
      user {
        id
        firstName
        lastName
        email
        avatarAttached {
          ...attachmentFragment
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionActionHistoriesQuery__
 *
 * To run a query within a React component, call `useInterventionActionHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionHistoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sourceableId: // value for 'sourceableId'
 *      sourceableType: // value for 'sourceableType'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useInterventionActionHistoriesQuery(baseOptions: Apollo.QueryHookOptions<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>(InterventionActionHistoriesDocument, options);
      }
export function useInterventionActionHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>(InterventionActionHistoriesDocument, options);
        }
export type InterventionActionHistoriesQueryHookResult = ReturnType<typeof useInterventionActionHistoriesQuery>;
export type InterventionActionHistoriesLazyQueryHookResult = ReturnType<typeof useInterventionActionHistoriesLazyQuery>;
export type InterventionActionHistoriesQueryResult = Apollo.QueryResult<InterventionActionHistoriesQuery, InterventionActionHistoriesQueryVariables>;
export function refetchInterventionActionHistoriesQuery(variables: InterventionActionHistoriesQueryVariables) {
      return { query: InterventionActionHistoriesDocument, variables: variables }
    }
export const InterventionActionsDocument = gql`
    query interventionActions($interventionId: ID!, $page: Int, $limit: Int, $sorts: InterventionActionSortInputObject, $filters: [InterventionActionFilterInputObject!]) {
  data: interventionActions(
    interventionId: $interventionId
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...interventionActionFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${InterventionActionFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useInterventionActionsQuery__
 *
 * To run a query within a React component, call `useInterventionActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionsQuery({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInterventionActionsQuery(baseOptions: Apollo.QueryHookOptions<InterventionActionsQuery, InterventionActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionActionsQuery, InterventionActionsQueryVariables>(InterventionActionsDocument, options);
      }
export function useInterventionActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionActionsQuery, InterventionActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionActionsQuery, InterventionActionsQueryVariables>(InterventionActionsDocument, options);
        }
export type InterventionActionsQueryHookResult = ReturnType<typeof useInterventionActionsQuery>;
export type InterventionActionsLazyQueryHookResult = ReturnType<typeof useInterventionActionsLazyQuery>;
export type InterventionActionsQueryResult = Apollo.QueryResult<InterventionActionsQuery, InterventionActionsQueryVariables>;
export function refetchInterventionActionsQuery(variables: InterventionActionsQueryVariables) {
      return { query: InterventionActionsDocument, variables: variables }
    }
export const InterventionActionIdsDocument = gql`
    query interventionActionIds($interventionId: ID!, $page: Int, $limit: Int, $sorts: InterventionActionSortInputObject, $filters: [InterventionActionFilterInputObject!], $onlyIds: Boolean) {
  data: interventionActions(
    interventionId: $interventionId
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useInterventionActionIdsQuery__
 *
 * To run a query within a React component, call `useInterventionActionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionActionIdsQuery({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useInterventionActionIdsQuery(baseOptions: Apollo.QueryHookOptions<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>(InterventionActionIdsDocument, options);
      }
export function useInterventionActionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>(InterventionActionIdsDocument, options);
        }
export type InterventionActionIdsQueryHookResult = ReturnType<typeof useInterventionActionIdsQuery>;
export type InterventionActionIdsLazyQueryHookResult = ReturnType<typeof useInterventionActionIdsLazyQuery>;
export type InterventionActionIdsQueryResult = Apollo.QueryResult<InterventionActionIdsQuery, InterventionActionIdsQueryVariables>;
export function refetchInterventionActionIdsQuery(variables: InterventionActionIdsQueryVariables) {
      return { query: InterventionActionIdsDocument, variables: variables }
    }
export const InterventionSitePrefillDataDocument = gql`
    query interventionSitePrefillData($siteFindBy: SiteFindByInputObject!) {
  site(findBy: $siteFindBy) {
    id
    name
  }
}
    `;

/**
 * __useInterventionSitePrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionSitePrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionSitePrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionSitePrefillDataQuery({
 *   variables: {
 *      siteFindBy: // value for 'siteFindBy'
 *   },
 * });
 */
export function useInterventionSitePrefillDataQuery(baseOptions: Apollo.QueryHookOptions<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>(InterventionSitePrefillDataDocument, options);
      }
export function useInterventionSitePrefillDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>(InterventionSitePrefillDataDocument, options);
        }
export type InterventionSitePrefillDataQueryHookResult = ReturnType<typeof useInterventionSitePrefillDataQuery>;
export type InterventionSitePrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionSitePrefillDataLazyQuery>;
export type InterventionSitePrefillDataQueryResult = Apollo.QueryResult<InterventionSitePrefillDataQuery, InterventionSitePrefillDataQueryVariables>;
export function refetchInterventionSitePrefillDataQuery(variables: InterventionSitePrefillDataQueryVariables) {
      return { query: InterventionSitePrefillDataDocument, variables: variables }
    }
export const InterventionSiteAreaPrefillDataDocument = gql`
    query interventionSiteAreaPrefillData($siteFindBy: SiteFindByInputObject!, $siteAreaFindBy: SiteAreaFindByInputObject!) {
  siteArea(findBy: $siteAreaFindBy, siteFindBy: $siteFindBy) {
    ...siteAreaFragment
  }
}
    ${SiteAreaFragmentFragmentDoc}`;

/**
 * __useInterventionSiteAreaPrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionSiteAreaPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionSiteAreaPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionSiteAreaPrefillDataQuery({
 *   variables: {
 *      siteFindBy: // value for 'siteFindBy'
 *      siteAreaFindBy: // value for 'siteAreaFindBy'
 *   },
 * });
 */
export function useInterventionSiteAreaPrefillDataQuery(baseOptions: Apollo.QueryHookOptions<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>(InterventionSiteAreaPrefillDataDocument, options);
      }
export function useInterventionSiteAreaPrefillDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>(InterventionSiteAreaPrefillDataDocument, options);
        }
export type InterventionSiteAreaPrefillDataQueryHookResult = ReturnType<typeof useInterventionSiteAreaPrefillDataQuery>;
export type InterventionSiteAreaPrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionSiteAreaPrefillDataLazyQuery>;
export type InterventionSiteAreaPrefillDataQueryResult = Apollo.QueryResult<InterventionSiteAreaPrefillDataQuery, InterventionSiteAreaPrefillDataQueryVariables>;
export function refetchInterventionSiteAreaPrefillDataQuery(variables: InterventionSiteAreaPrefillDataQueryVariables) {
      return { query: InterventionSiteAreaPrefillDataDocument, variables: variables }
    }
export const InterventionAssetPrefillDataDocument = gql`
    query interventionAssetPrefillData($assetFindBy: AssetFindByInputObject!) {
  asset(findBy: $assetFindBy) {
    id
    name
    fullCode
    iconAttached {
      ...attachmentFragment
    }
    siteAreaId
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useInterventionAssetPrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionAssetPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionAssetPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionAssetPrefillDataQuery({
 *   variables: {
 *      assetFindBy: // value for 'assetFindBy'
 *   },
 * });
 */
export function useInterventionAssetPrefillDataQuery(baseOptions: Apollo.QueryHookOptions<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>(InterventionAssetPrefillDataDocument, options);
      }
export function useInterventionAssetPrefillDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>(InterventionAssetPrefillDataDocument, options);
        }
export type InterventionAssetPrefillDataQueryHookResult = ReturnType<typeof useInterventionAssetPrefillDataQuery>;
export type InterventionAssetPrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionAssetPrefillDataLazyQuery>;
export type InterventionAssetPrefillDataQueryResult = Apollo.QueryResult<InterventionAssetPrefillDataQuery, InterventionAssetPrefillDataQueryVariables>;
export function refetchInterventionAssetPrefillDataQuery(variables: InterventionAssetPrefillDataQueryVariables) {
      return { query: InterventionAssetPrefillDataDocument, variables: variables }
    }
export const InterventionTaskPrefillDataDocument = gql`
    query interventionTaskPrefillData($id: ID!) {
  task(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useInterventionTaskPrefillDataQuery__
 *
 * To run a query within a React component, call `useInterventionTaskPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionTaskPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionTaskPrefillDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionTaskPrefillDataQuery(baseOptions: Apollo.QueryHookOptions<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>(InterventionTaskPrefillDataDocument, options);
      }
export function useInterventionTaskPrefillDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>(InterventionTaskPrefillDataDocument, options);
        }
export type InterventionTaskPrefillDataQueryHookResult = ReturnType<typeof useInterventionTaskPrefillDataQuery>;
export type InterventionTaskPrefillDataLazyQueryHookResult = ReturnType<typeof useInterventionTaskPrefillDataLazyQuery>;
export type InterventionTaskPrefillDataQueryResult = Apollo.QueryResult<InterventionTaskPrefillDataQuery, InterventionTaskPrefillDataQueryVariables>;
export function refetchInterventionTaskPrefillDataQuery(variables: InterventionTaskPrefillDataQueryVariables) {
      return { query: InterventionTaskPrefillDataDocument, variables: variables }
    }
export const InterventionCreateDocument = gql`
    mutation interventionCreate($attributes: InterventionCreateInputObject!, $assigneeRedirectUrl: String!) {
  data: interventionCreate(
    input: {attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl}
  ) {
    ...interventionFragment
  }
}
    ${InterventionFragmentFragmentDoc}`;
export type InterventionCreateMutationFn = Apollo.MutationFunction<InterventionCreateMutation, InterventionCreateMutationVariables>;

/**
 * __useInterventionCreateMutation__
 *
 * To run a mutation, you first call `useInterventionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCreateMutation, { data, loading, error }] = useInterventionCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *   },
 * });
 */
export function useInterventionCreateMutation(baseOptions?: Apollo.MutationHookOptions<InterventionCreateMutation, InterventionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionCreateMutation, InterventionCreateMutationVariables>(InterventionCreateDocument, options);
      }
export type InterventionCreateMutationHookResult = ReturnType<typeof useInterventionCreateMutation>;
export type InterventionCreateMutationResult = Apollo.MutationResult<InterventionCreateMutation>;
export type InterventionCreateMutationOptions = Apollo.BaseMutationOptions<InterventionCreateMutation, InterventionCreateMutationVariables>;
export const InterventionUpdateDocument = gql`
    mutation interventionUpdate($attributes: InterventionUpdateInputObject!, $id: ID!, $assigneeRedirectUrl: String!) {
  data: interventionUpdate(
    input: {id: $id, attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl}
  ) {
    ...interventionFragment
  }
}
    ${InterventionFragmentFragmentDoc}`;
export type InterventionUpdateMutationFn = Apollo.MutationFunction<InterventionUpdateMutation, InterventionUpdateMutationVariables>;

/**
 * __useInterventionUpdateMutation__
 *
 * To run a mutation, you first call `useInterventionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionUpdateMutation, { data, loading, error }] = useInterventionUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *   },
 * });
 */
export function useInterventionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InterventionUpdateMutation, InterventionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionUpdateMutation, InterventionUpdateMutationVariables>(InterventionUpdateDocument, options);
      }
export type InterventionUpdateMutationHookResult = ReturnType<typeof useInterventionUpdateMutation>;
export type InterventionUpdateMutationResult = Apollo.MutationResult<InterventionUpdateMutation>;
export type InterventionUpdateMutationOptions = Apollo.BaseMutationOptions<InterventionUpdateMutation, InterventionUpdateMutationVariables>;
export const InterventionDestroyDocument = gql`
    mutation interventionDestroy($id: ID!) {
  interventionDestroy(input: {id: $id})
}
    `;
export type InterventionDestroyMutationFn = Apollo.MutationFunction<InterventionDestroyMutation, InterventionDestroyMutationVariables>;

/**
 * __useInterventionDestroyMutation__
 *
 * To run a mutation, you first call `useInterventionDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionDestroyMutation, { data, loading, error }] = useInterventionDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionDestroyMutation(baseOptions?: Apollo.MutationHookOptions<InterventionDestroyMutation, InterventionDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionDestroyMutation, InterventionDestroyMutationVariables>(InterventionDestroyDocument, options);
      }
export type InterventionDestroyMutationHookResult = ReturnType<typeof useInterventionDestroyMutation>;
export type InterventionDestroyMutationResult = Apollo.MutationResult<InterventionDestroyMutation>;
export type InterventionDestroyMutationOptions = Apollo.BaseMutationOptions<InterventionDestroyMutation, InterventionDestroyMutationVariables>;
export const InterventionBulkCloseDocument = gql`
    mutation interventionBulkClose($ids: [ID!]!) {
  interventionBulkClose(input: {ids: $ids})
}
    `;
export type InterventionBulkCloseMutationFn = Apollo.MutationFunction<InterventionBulkCloseMutation, InterventionBulkCloseMutationVariables>;

/**
 * __useInterventionBulkCloseMutation__
 *
 * To run a mutation, you first call `useInterventionBulkCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionBulkCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionBulkCloseMutation, { data, loading, error }] = useInterventionBulkCloseMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInterventionBulkCloseMutation(baseOptions?: Apollo.MutationHookOptions<InterventionBulkCloseMutation, InterventionBulkCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionBulkCloseMutation, InterventionBulkCloseMutationVariables>(InterventionBulkCloseDocument, options);
      }
export type InterventionBulkCloseMutationHookResult = ReturnType<typeof useInterventionBulkCloseMutation>;
export type InterventionBulkCloseMutationResult = Apollo.MutationResult<InterventionBulkCloseMutation>;
export type InterventionBulkCloseMutationOptions = Apollo.BaseMutationOptions<InterventionBulkCloseMutation, InterventionBulkCloseMutationVariables>;
export const InterventionCategoryCreateDocument = gql`
    mutation interventionCategoryCreate($attributes: InterventionCategoryCreateInputObject!) {
  data: interventionCategoryCreate(input: {attributes: $attributes}) {
    ...interventionCategoryFragment
  }
}
    ${InterventionCategoryFragmentFragmentDoc}`;
export type InterventionCategoryCreateMutationFn = Apollo.MutationFunction<InterventionCategoryCreateMutation, InterventionCategoryCreateMutationVariables>;

/**
 * __useInterventionCategoryCreateMutation__
 *
 * To run a mutation, you first call `useInterventionCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCategoryCreateMutation, { data, loading, error }] = useInterventionCategoryCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useInterventionCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<InterventionCategoryCreateMutation, InterventionCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionCategoryCreateMutation, InterventionCategoryCreateMutationVariables>(InterventionCategoryCreateDocument, options);
      }
export type InterventionCategoryCreateMutationHookResult = ReturnType<typeof useInterventionCategoryCreateMutation>;
export type InterventionCategoryCreateMutationResult = Apollo.MutationResult<InterventionCategoryCreateMutation>;
export type InterventionCategoryCreateMutationOptions = Apollo.BaseMutationOptions<InterventionCategoryCreateMutation, InterventionCategoryCreateMutationVariables>;
export const InterventionCategoryUpdateDocument = gql`
    mutation interventionCategoryUpdate($attributes: InterventionCategoryUpdateInputObject!, $id: ID!) {
  data: interventionCategoryUpdate(input: {id: $id, attributes: $attributes}) {
    ...interventionCategoryFragment
  }
}
    ${InterventionCategoryFragmentFragmentDoc}`;
export type InterventionCategoryUpdateMutationFn = Apollo.MutationFunction<InterventionCategoryUpdateMutation, InterventionCategoryUpdateMutationVariables>;

/**
 * __useInterventionCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useInterventionCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCategoryUpdateMutation, { data, loading, error }] = useInterventionCategoryUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InterventionCategoryUpdateMutation, InterventionCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionCategoryUpdateMutation, InterventionCategoryUpdateMutationVariables>(InterventionCategoryUpdateDocument, options);
      }
export type InterventionCategoryUpdateMutationHookResult = ReturnType<typeof useInterventionCategoryUpdateMutation>;
export type InterventionCategoryUpdateMutationResult = Apollo.MutationResult<InterventionCategoryUpdateMutation>;
export type InterventionCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<InterventionCategoryUpdateMutation, InterventionCategoryUpdateMutationVariables>;
export const InterventionCategoryDestroyDocument = gql`
    mutation interventionCategoryDestroy($id: ID!) {
  interventionCategoryDestroy(input: {id: $id})
}
    `;
export type InterventionCategoryDestroyMutationFn = Apollo.MutationFunction<InterventionCategoryDestroyMutation, InterventionCategoryDestroyMutationVariables>;

/**
 * __useInterventionCategoryDestroyMutation__
 *
 * To run a mutation, you first call `useInterventionCategoryDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionCategoryDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionCategoryDestroyMutation, { data, loading, error }] = useInterventionCategoryDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterventionCategoryDestroyMutation(baseOptions?: Apollo.MutationHookOptions<InterventionCategoryDestroyMutation, InterventionCategoryDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionCategoryDestroyMutation, InterventionCategoryDestroyMutationVariables>(InterventionCategoryDestroyDocument, options);
      }
export type InterventionCategoryDestroyMutationHookResult = ReturnType<typeof useInterventionCategoryDestroyMutation>;
export type InterventionCategoryDestroyMutationResult = Apollo.MutationResult<InterventionCategoryDestroyMutation>;
export type InterventionCategoryDestroyMutationOptions = Apollo.BaseMutationOptions<InterventionCategoryDestroyMutation, InterventionCategoryDestroyMutationVariables>;
export const InterventionActionCreateDocument = gql`
    mutation interventionActionCreate($attributes: InterventionActionCreateInputObject!, $assigneeRedirectUrl: String!, $mentionRedirectUrl: String!, $interventionId: ID!) {
  data: interventionActionCreate(
    input: {attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl, mentionRedirectUrl: $mentionRedirectUrl, interventionId: $interventionId}
  ) {
    ...interventionActionFragment
  }
}
    ${InterventionActionFragmentFragmentDoc}`;
export type InterventionActionCreateMutationFn = Apollo.MutationFunction<InterventionActionCreateMutation, InterventionActionCreateMutationVariables>;

/**
 * __useInterventionActionCreateMutation__
 *
 * To run a mutation, you first call `useInterventionActionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionActionCreateMutation, { data, loading, error }] = useInterventionActionCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *      mentionRedirectUrl: // value for 'mentionRedirectUrl'
 *      interventionId: // value for 'interventionId'
 *   },
 * });
 */
export function useInterventionActionCreateMutation(baseOptions?: Apollo.MutationHookOptions<InterventionActionCreateMutation, InterventionActionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionActionCreateMutation, InterventionActionCreateMutationVariables>(InterventionActionCreateDocument, options);
      }
export type InterventionActionCreateMutationHookResult = ReturnType<typeof useInterventionActionCreateMutation>;
export type InterventionActionCreateMutationResult = Apollo.MutationResult<InterventionActionCreateMutation>;
export type InterventionActionCreateMutationOptions = Apollo.BaseMutationOptions<InterventionActionCreateMutation, InterventionActionCreateMutationVariables>;
export const InterventionActionUpdateDocument = gql`
    mutation interventionActionUpdate($attributes: InterventionActionUpdateInputObject!, $id: ID!, $assigneeRedirectUrl: String!, $mentionRedirectUrl: String!, $interventionId: ID!) {
  data: interventionActionUpdate(
    input: {id: $id, attributes: $attributes, assigneeRedirectUrl: $assigneeRedirectUrl, mentionRedirectUrl: $mentionRedirectUrl, interventionId: $interventionId}
  ) {
    ...interventionActionFragment
  }
}
    ${InterventionActionFragmentFragmentDoc}`;
export type InterventionActionUpdateMutationFn = Apollo.MutationFunction<InterventionActionUpdateMutation, InterventionActionUpdateMutationVariables>;

/**
 * __useInterventionActionUpdateMutation__
 *
 * To run a mutation, you first call `useInterventionActionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionActionUpdateMutation, { data, loading, error }] = useInterventionActionUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *      assigneeRedirectUrl: // value for 'assigneeRedirectUrl'
 *      mentionRedirectUrl: // value for 'mentionRedirectUrl'
 *      interventionId: // value for 'interventionId'
 *   },
 * });
 */
export function useInterventionActionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InterventionActionUpdateMutation, InterventionActionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionActionUpdateMutation, InterventionActionUpdateMutationVariables>(InterventionActionUpdateDocument, options);
      }
export type InterventionActionUpdateMutationHookResult = ReturnType<typeof useInterventionActionUpdateMutation>;
export type InterventionActionUpdateMutationResult = Apollo.MutationResult<InterventionActionUpdateMutation>;
export type InterventionActionUpdateMutationOptions = Apollo.BaseMutationOptions<InterventionActionUpdateMutation, InterventionActionUpdateMutationVariables>;
export const InterventionActionDestroyDocument = gql`
    mutation interventionActionDestroy($id: ID!, $interventionId: ID!) {
  interventionActionDestroy(input: {id: $id, interventionId: $interventionId})
}
    `;
export type InterventionActionDestroyMutationFn = Apollo.MutationFunction<InterventionActionDestroyMutation, InterventionActionDestroyMutationVariables>;

/**
 * __useInterventionActionDestroyMutation__
 *
 * To run a mutation, you first call `useInterventionActionDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterventionActionDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interventionActionDestroyMutation, { data, loading, error }] = useInterventionActionDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      interventionId: // value for 'interventionId'
 *   },
 * });
 */
export function useInterventionActionDestroyMutation(baseOptions?: Apollo.MutationHookOptions<InterventionActionDestroyMutation, InterventionActionDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterventionActionDestroyMutation, InterventionActionDestroyMutationVariables>(InterventionActionDestroyDocument, options);
      }
export type InterventionActionDestroyMutationHookResult = ReturnType<typeof useInterventionActionDestroyMutation>;
export type InterventionActionDestroyMutationResult = Apollo.MutationResult<InterventionActionDestroyMutation>;
export type InterventionActionDestroyMutationOptions = Apollo.BaseMutationOptions<InterventionActionDestroyMutation, InterventionActionDestroyMutationVariables>;
export const JobsDocument = gql`
    query jobs($jids: [String!]!) {
  data: jobs(jids: $jids) {
    ...jobFragment
  }
}
    ${JobFragmentFragmentDoc}`;

/**
 * __useJobsQuery__
 *
 * To run a query within a React component, call `useJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsQuery({
 *   variables: {
 *      jids: // value for 'jids'
 *   },
 * });
 */
export function useJobsQuery(baseOptions: Apollo.QueryHookOptions<JobsQuery, JobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
      }
export function useJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
export type JobsQueryHookResult = ReturnType<typeof useJobsQuery>;
export type JobsLazyQueryHookResult = ReturnType<typeof useJobsLazyQuery>;
export type JobsQueryResult = Apollo.QueryResult<JobsQuery, JobsQueryVariables>;
export function refetchJobsQuery(variables: JobsQueryVariables) {
      return { query: JobsDocument, variables: variables }
    }
export const JobCancelDocument = gql`
    mutation jobCancel($input: JobCancelInput!) {
  data: jobCancel(input: $input)
}
    `;
export type JobCancelMutationFn = Apollo.MutationFunction<JobCancelMutation, JobCancelMutationVariables>;

/**
 * __useJobCancelMutation__
 *
 * To run a mutation, you first call `useJobCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobCancelMutation, { data, loading, error }] = useJobCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobCancelMutation(baseOptions?: Apollo.MutationHookOptions<JobCancelMutation, JobCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobCancelMutation, JobCancelMutationVariables>(JobCancelDocument, options);
      }
export type JobCancelMutationHookResult = ReturnType<typeof useJobCancelMutation>;
export type JobCancelMutationResult = Apollo.MutationResult<JobCancelMutation>;
export type JobCancelMutationOptions = Apollo.BaseMutationOptions<JobCancelMutation, JobCancelMutationVariables>;
export const JobRetryDocument = gql`
    mutation jobRetry($input: JobRetryInput!) {
  data: jobRetry(input: $input)
}
    `;
export type JobRetryMutationFn = Apollo.MutationFunction<JobRetryMutation, JobRetryMutationVariables>;

/**
 * __useJobRetryMutation__
 *
 * To run a mutation, you first call `useJobRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobRetryMutation, { data, loading, error }] = useJobRetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobRetryMutation(baseOptions?: Apollo.MutationHookOptions<JobRetryMutation, JobRetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobRetryMutation, JobRetryMutationVariables>(JobRetryDocument, options);
      }
export type JobRetryMutationHookResult = ReturnType<typeof useJobRetryMutation>;
export type JobRetryMutationResult = Apollo.MutationResult<JobRetryMutation>;
export type JobRetryMutationOptions = Apollo.BaseMutationOptions<JobRetryMutation, JobRetryMutationVariables>;
export const JobCreateDeliveryRequestDocument = gql`
    mutation jobCreateDeliveryRequest($input: JobCreateDeliveryRequestInput!) {
  data: jobCreateDeliveryRequest(input: $input)
}
    `;
export type JobCreateDeliveryRequestMutationFn = Apollo.MutationFunction<JobCreateDeliveryRequestMutation, JobCreateDeliveryRequestMutationVariables>;

/**
 * __useJobCreateDeliveryRequestMutation__
 *
 * To run a mutation, you first call `useJobCreateDeliveryRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobCreateDeliveryRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobCreateDeliveryRequestMutation, { data, loading, error }] = useJobCreateDeliveryRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobCreateDeliveryRequestMutation(baseOptions?: Apollo.MutationHookOptions<JobCreateDeliveryRequestMutation, JobCreateDeliveryRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobCreateDeliveryRequestMutation, JobCreateDeliveryRequestMutationVariables>(JobCreateDeliveryRequestDocument, options);
      }
export type JobCreateDeliveryRequestMutationHookResult = ReturnType<typeof useJobCreateDeliveryRequestMutation>;
export type JobCreateDeliveryRequestMutationResult = Apollo.MutationResult<JobCreateDeliveryRequestMutation>;
export type JobCreateDeliveryRequestMutationOptions = Apollo.BaseMutationOptions<JobCreateDeliveryRequestMutation, JobCreateDeliveryRequestMutationVariables>;
export const SectorsDocument = gql`
    query sectors($page: Int, $limit: Int, $sorts: SectorSortInputObject, $filters: [SectorFilterInputObject!], $taskFilters: [TaskFilterInputObject!], $includeFullData: Boolean = false, $includePerformanceDataByTaskDeadlinesMissed: Boolean = false, $includePerformanceDataByTaskResults: Boolean = false) {
  data: sectors(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    taskFilters: $taskFilters
  ) {
    collection {
      ...sectorFragment @include(if: $includeFullData)
      id
      name
      sitesCount @include(if: $includeFullData)
      sites @include(if: $includeFullData) {
        collection {
          id
          name
        }
      }
      totalAnomaliesByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      totalAnomaliesByTaskResults @include(if: $includePerformanceDataByTaskResults)
      successPercentageByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      successPercentageByTaskResults @include(if: $includePerformanceDataByTaskResults)
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${SectorFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useSectorsQuery__
 *
 * To run a query within a React component, call `useSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      taskFilters: // value for 'taskFilters'
 *      includeFullData: // value for 'includeFullData'
 *      includePerformanceDataByTaskDeadlinesMissed: // value for 'includePerformanceDataByTaskDeadlinesMissed'
 *      includePerformanceDataByTaskResults: // value for 'includePerformanceDataByTaskResults'
 *   },
 * });
 */
export function useSectorsQuery(baseOptions?: Apollo.QueryHookOptions<SectorsQuery, SectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, options);
      }
export function useSectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorsQuery, SectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorsQuery, SectorsQueryVariables>(SectorsDocument, options);
        }
export type SectorsQueryHookResult = ReturnType<typeof useSectorsQuery>;
export type SectorsLazyQueryHookResult = ReturnType<typeof useSectorsLazyQuery>;
export type SectorsQueryResult = Apollo.QueryResult<SectorsQuery, SectorsQueryVariables>;
export function refetchSectorsQuery(variables?: SectorsQueryVariables) {
      return { query: SectorsDocument, variables: variables }
    }
export const SectorLocationsDocument = gql`
    query sectorLocations($filters: [LocationFilterInputObject!], $sectorFilters: [SectorFilterInputObject!], $mapParams: LocationMapParamsInputObject!) {
  data: sectorLocations(
    filters: $filters
    sectorFilters: $sectorFilters
    mapParams: $mapParams
  ) {
    ...geojsonFullFragment
  }
}
    ${GeojsonFullFragmentFragmentDoc}`;

/**
 * __useSectorLocationsQuery__
 *
 * To run a query within a React component, call `useSectorLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sectorFilters: // value for 'sectorFilters'
 *      mapParams: // value for 'mapParams'
 *   },
 * });
 */
export function useSectorLocationsQuery(baseOptions: Apollo.QueryHookOptions<SectorLocationsQuery, SectorLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorLocationsQuery, SectorLocationsQueryVariables>(SectorLocationsDocument, options);
      }
export function useSectorLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorLocationsQuery, SectorLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorLocationsQuery, SectorLocationsQueryVariables>(SectorLocationsDocument, options);
        }
export type SectorLocationsQueryHookResult = ReturnType<typeof useSectorLocationsQuery>;
export type SectorLocationsLazyQueryHookResult = ReturnType<typeof useSectorLocationsLazyQuery>;
export type SectorLocationsQueryResult = Apollo.QueryResult<SectorLocationsQuery, SectorLocationsQueryVariables>;
export function refetchSectorLocationsQuery(variables: SectorLocationsQueryVariables) {
      return { query: SectorLocationsDocument, variables: variables }
    }
export const SectorLocationCenterDocument = gql`
    query sectorLocationCenter($filters: [LocationFilterInputObject!], $sectorFilters: [SectorFilterInputObject!]) {
  data: sectorLocationCenter(filters: $filters, sectorFilters: $sectorFilters) {
    lat
    lon
  }
}
    `;

/**
 * __useSectorLocationCenterQuery__
 *
 * To run a query within a React component, call `useSectorLocationCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorLocationCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorLocationCenterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sectorFilters: // value for 'sectorFilters'
 *   },
 * });
 */
export function useSectorLocationCenterQuery(baseOptions?: Apollo.QueryHookOptions<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>(SectorLocationCenterDocument, options);
      }
export function useSectorLocationCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>(SectorLocationCenterDocument, options);
        }
export type SectorLocationCenterQueryHookResult = ReturnType<typeof useSectorLocationCenterQuery>;
export type SectorLocationCenterLazyQueryHookResult = ReturnType<typeof useSectorLocationCenterLazyQuery>;
export type SectorLocationCenterQueryResult = Apollo.QueryResult<SectorLocationCenterQuery, SectorLocationCenterQueryVariables>;
export function refetchSectorLocationCenterQuery(variables?: SectorLocationCenterQueryVariables) {
      return { query: SectorLocationCenterDocument, variables: variables }
    }
export const SectorsSearchListDocument = gql`
    query sectorsSearchList($page: Int, $limit: Int, $sorts: SectorSortInputObject, $filters: [SectorFilterInputObject!]) {
  data: sectors(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      color
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSectorsSearchListQuery__
 *
 * To run a query within a React component, call `useSectorsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSectorsSearchListQuery(baseOptions?: Apollo.QueryHookOptions<SectorsSearchListQuery, SectorsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorsSearchListQuery, SectorsSearchListQueryVariables>(SectorsSearchListDocument, options);
      }
export function useSectorsSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorsSearchListQuery, SectorsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorsSearchListQuery, SectorsSearchListQueryVariables>(SectorsSearchListDocument, options);
        }
export type SectorsSearchListQueryHookResult = ReturnType<typeof useSectorsSearchListQuery>;
export type SectorsSearchListLazyQueryHookResult = ReturnType<typeof useSectorsSearchListLazyQuery>;
export type SectorsSearchListQueryResult = Apollo.QueryResult<SectorsSearchListQuery, SectorsSearchListQueryVariables>;
export function refetchSectorsSearchListQuery(variables?: SectorsSearchListQueryVariables) {
      return { query: SectorsSearchListDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskDeadlinesMissedDocument = gql`
    query sectorsPerformanceMetricsByTaskDeadlinesMissed($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sectorsPerformanceMetricsByTaskDeadlinesMissed(
    ids: $ids
    taskFilters: $taskFilters
  ) {
    id
    successPercentageByTaskDeadlinesMissed
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery(baseOptions: Apollo.QueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedDocument, options);
        }
export type SectorsPerformanceMetricsByTaskDeadlinesMissedQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedLazyQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedQueryResult = Apollo.QueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskDeadlinesMissedQuery(variables: SectorsPerformanceMetricsByTaskDeadlinesMissedQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskDeadlinesMissedDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument = gql`
    query sectorsPerformanceMetricsByTaskDeadlinesMissedByDate($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!], $periodGroupBy: PeriodGroupByEnum!) {
  data: sectorsPerformanceMetricsByTaskDeadlinesMissedByDate(
    ids: $ids
    taskFilters: $taskFilters
    periodGroupBy: $periodGroupBy
  ) {
    id
    period
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *      periodGroupBy: // value for 'periodGroupBy'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery(baseOptions: Apollo.QueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
        }
export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery>;
export type SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryResult = Apollo.QueryResult<SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskDeadlinesMissedByDateQuery(variables: SectorsPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskDeadlinesMissedByDateDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskResultsDocument = gql`
    query sectorsPerformanceMetricsByTaskResults($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sectorsPerformanceMetricsByTaskResults(
    ids: $ids
    taskFilters: $taskFilters
  ) {
    id
    successPercentageByTaskResults
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskResultsQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskResultsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskResultsQuery(baseOptions: Apollo.QueryHookOptions<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>(SectorsPerformanceMetricsByTaskResultsDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>(SectorsPerformanceMetricsByTaskResultsDocument, options);
        }
export type SectorsPerformanceMetricsByTaskResultsQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsQuery>;
export type SectorsPerformanceMetricsByTaskResultsLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsLazyQuery>;
export type SectorsPerformanceMetricsByTaskResultsQueryResult = Apollo.QueryResult<SectorsPerformanceMetricsByTaskResultsQuery, SectorsPerformanceMetricsByTaskResultsQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskResultsQuery(variables: SectorsPerformanceMetricsByTaskResultsQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskResultsDocument, variables: variables }
    }
export const SectorsPerformanceMetricsByTaskResultsByDateDocument = gql`
    query sectorsPerformanceMetricsByTaskResultsByDate($ids: [ID!]!, $periodGroupBy: PeriodGroupByEnum!, $taskFilters: [TaskFilterInputObject!]) {
  data: sectorsPerformanceMetricsByTaskResultsByDate(
    ids: $ids
    periodGroupBy: $periodGroupBy
    taskFilters: $taskFilters
  ) {
    id
    period
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSectorsPerformanceMetricsByTaskResultsByDateQuery__
 *
 * To run a query within a React component, call `useSectorsPerformanceMetricsByTaskResultsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsPerformanceMetricsByTaskResultsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsPerformanceMetricsByTaskResultsByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      periodGroupBy: // value for 'periodGroupBy'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSectorsPerformanceMetricsByTaskResultsByDateQuery(baseOptions: Apollo.QueryHookOptions<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>(SectorsPerformanceMetricsByTaskResultsByDateDocument, options);
      }
export function useSectorsPerformanceMetricsByTaskResultsByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>(SectorsPerformanceMetricsByTaskResultsByDateDocument, options);
        }
export type SectorsPerformanceMetricsByTaskResultsByDateQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsByDateQuery>;
export type SectorsPerformanceMetricsByTaskResultsByDateLazyQueryHookResult = ReturnType<typeof useSectorsPerformanceMetricsByTaskResultsByDateLazyQuery>;
export type SectorsPerformanceMetricsByTaskResultsByDateQueryResult = Apollo.QueryResult<SectorsPerformanceMetricsByTaskResultsByDateQuery, SectorsPerformanceMetricsByTaskResultsByDateQueryVariables>;
export function refetchSectorsPerformanceMetricsByTaskResultsByDateQuery(variables: SectorsPerformanceMetricsByTaskResultsByDateQueryVariables) {
      return { query: SectorsPerformanceMetricsByTaskResultsByDateDocument, variables: variables }
    }
export const SectorDocument = gql`
    query sector($id: ID!) {
  data: sector(id: $id) {
    ...sectorFullFragment
    description
    sitesCount
    usersCount
    user {
      id
      lastName
      firstName
      avatarAttached {
        ...attachmentFragment
      }
      email
      phoneNumber
    }
  }
}
    ${SectorFullFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useSectorQuery__
 *
 * To run a query within a React component, call `useSectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSectorQuery(baseOptions: Apollo.QueryHookOptions<SectorQuery, SectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorQuery, SectorQueryVariables>(SectorDocument, options);
      }
export function useSectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorQuery, SectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorQuery, SectorQueryVariables>(SectorDocument, options);
        }
export type SectorQueryHookResult = ReturnType<typeof useSectorQuery>;
export type SectorLazyQueryHookResult = ReturnType<typeof useSectorLazyQuery>;
export type SectorQueryResult = Apollo.QueryResult<SectorQuery, SectorQueryVariables>;
export function refetchSectorQuery(variables: SectorQueryVariables) {
      return { query: SectorDocument, variables: variables }
    }
export const SectorCreateDocument = gql`
    mutation sectorCreate($attributes: SectorCreateInputObject!) {
  data: sectorCreate(input: {attributes: $attributes}) {
    ...sectorFullFragment
    description
  }
}
    ${SectorFullFragmentFragmentDoc}`;
export type SectorCreateMutationFn = Apollo.MutationFunction<SectorCreateMutation, SectorCreateMutationVariables>;

/**
 * __useSectorCreateMutation__
 *
 * To run a mutation, you first call `useSectorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectorCreateMutation, { data, loading, error }] = useSectorCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSectorCreateMutation(baseOptions?: Apollo.MutationHookOptions<SectorCreateMutation, SectorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SectorCreateMutation, SectorCreateMutationVariables>(SectorCreateDocument, options);
      }
export type SectorCreateMutationHookResult = ReturnType<typeof useSectorCreateMutation>;
export type SectorCreateMutationResult = Apollo.MutationResult<SectorCreateMutation>;
export type SectorCreateMutationOptions = Apollo.BaseMutationOptions<SectorCreateMutation, SectorCreateMutationVariables>;
export const SectorUpdateDocument = gql`
    mutation sectorUpdate($attributes: SectorUpdateInputObject!, $id: ID!) {
  data: sectorUpdate(input: {attributes: $attributes, id: $id}) {
    ...sectorFullFragment
    description
  }
}
    ${SectorFullFragmentFragmentDoc}`;
export type SectorUpdateMutationFn = Apollo.MutationFunction<SectorUpdateMutation, SectorUpdateMutationVariables>;

/**
 * __useSectorUpdateMutation__
 *
 * To run a mutation, you first call `useSectorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectorUpdateMutation, { data, loading, error }] = useSectorUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSectorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SectorUpdateMutation, SectorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SectorUpdateMutation, SectorUpdateMutationVariables>(SectorUpdateDocument, options);
      }
export type SectorUpdateMutationHookResult = ReturnType<typeof useSectorUpdateMutation>;
export type SectorUpdateMutationResult = Apollo.MutationResult<SectorUpdateMutation>;
export type SectorUpdateMutationOptions = Apollo.BaseMutationOptions<SectorUpdateMutation, SectorUpdateMutationVariables>;
export const SectorDestroyDocument = gql`
    mutation sectorDestroy($id: ID!) {
  sectorDestroy(input: {id: $id})
}
    `;
export type SectorDestroyMutationFn = Apollo.MutationFunction<SectorDestroyMutation, SectorDestroyMutationVariables>;

/**
 * __useSectorDestroyMutation__
 *
 * To run a mutation, you first call `useSectorDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectorDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectorDestroyMutation, { data, loading, error }] = useSectorDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSectorDestroyMutation(baseOptions?: Apollo.MutationHookOptions<SectorDestroyMutation, SectorDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SectorDestroyMutation, SectorDestroyMutationVariables>(SectorDestroyDocument, options);
      }
export type SectorDestroyMutationHookResult = ReturnType<typeof useSectorDestroyMutation>;
export type SectorDestroyMutationResult = Apollo.MutationResult<SectorDestroyMutation>;
export type SectorDestroyMutationOptions = Apollo.BaseMutationOptions<SectorDestroyMutation, SectorDestroyMutationVariables>;
export const SiteDocument = gql`
    query site($findBy: SiteFindByInputObject!) {
  site(findBy: $findBy) {
    ...fullSiteFragment
  }
}
    ${FullSiteFragmentFragmentDoc}`;

/**
 * __useSiteQuery__
 *
 * To run a query within a React component, call `useSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *   },
 * });
 */
export function useSiteQuery(baseOptions: Apollo.QueryHookOptions<SiteQuery, SiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
      }
export function useSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteQuery, SiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
        }
export type SiteQueryHookResult = ReturnType<typeof useSiteQuery>;
export type SiteLazyQueryHookResult = ReturnType<typeof useSiteLazyQuery>;
export type SiteQueryResult = Apollo.QueryResult<SiteQuery, SiteQueryVariables>;
export function refetchSiteQuery(variables: SiteQueryVariables) {
      return { query: SiteDocument, variables: variables }
    }
export const SitesDocument = gql`
    query sites($page: Int, $limit: Int, $filters: [SiteFilterInputObject!], $taskFilters: [TaskFilterInputObject!], $sorts: SiteSortInputObject, $includeFullData: Boolean = false, $includePerformanceDataByTaskDeadlinesMissed: Boolean = false, $includePerformanceDataByTaskResults: Boolean = false) {
  data: sites(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    taskFilters: $taskFilters
  ) {
    collection {
      id
      name
      code @include(if: $includeFullData)
      locationPhotoAttached @include(if: $includeFullData) {
        ...attachmentFragment
      }
      siteAreasCount @include(if: $includeFullData)
      usersCount @include(if: $includeFullData)
      sector @include(if: $includeFullData) {
        id
        name
        color
      }
      totalAnomaliesByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      totalAnomaliesByTaskResults @include(if: $includePerformanceDataByTaskResults)
      successPercentageByTaskDeadlinesMissed @include(if: $includePerformanceDataByTaskDeadlinesMissed)
      successPercentageByTaskResults @include(if: $includePerformanceDataByTaskResults)
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useSitesQuery__
 *
 * To run a query within a React component, call `useSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      taskFilters: // value for 'taskFilters'
 *      sorts: // value for 'sorts'
 *      includeFullData: // value for 'includeFullData'
 *      includePerformanceDataByTaskDeadlinesMissed: // value for 'includePerformanceDataByTaskDeadlinesMissed'
 *      includePerformanceDataByTaskResults: // value for 'includePerformanceDataByTaskResults'
 *   },
 * });
 */
export function useSitesQuery(baseOptions?: Apollo.QueryHookOptions<SitesQuery, SitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
      }
export function useSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesQuery, SitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
        }
export type SitesQueryHookResult = ReturnType<typeof useSitesQuery>;
export type SitesLazyQueryHookResult = ReturnType<typeof useSitesLazyQuery>;
export type SitesQueryResult = Apollo.QueryResult<SitesQuery, SitesQueryVariables>;
export function refetchSitesQuery(variables?: SitesQueryVariables) {
      return { query: SitesDocument, variables: variables }
    }
export const SiteLocationsDocument = gql`
    query siteLocations($filters: [LocationFilterInputObject!], $siteFilters: [SiteFilterInputObject!], $mapParams: LocationMapParamsInputObject!) {
  data: siteLocations(
    filters: $filters
    siteFilters: $siteFilters
    mapParams: $mapParams
  ) {
    ...geojsonFullFragment
  }
}
    ${GeojsonFullFragmentFragmentDoc}`;

/**
 * __useSiteLocationsQuery__
 *
 * To run a query within a React component, call `useSiteLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteLocationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      siteFilters: // value for 'siteFilters'
 *      mapParams: // value for 'mapParams'
 *   },
 * });
 */
export function useSiteLocationsQuery(baseOptions: Apollo.QueryHookOptions<SiteLocationsQuery, SiteLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteLocationsQuery, SiteLocationsQueryVariables>(SiteLocationsDocument, options);
      }
export function useSiteLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteLocationsQuery, SiteLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteLocationsQuery, SiteLocationsQueryVariables>(SiteLocationsDocument, options);
        }
export type SiteLocationsQueryHookResult = ReturnType<typeof useSiteLocationsQuery>;
export type SiteLocationsLazyQueryHookResult = ReturnType<typeof useSiteLocationsLazyQuery>;
export type SiteLocationsQueryResult = Apollo.QueryResult<SiteLocationsQuery, SiteLocationsQueryVariables>;
export function refetchSiteLocationsQuery(variables: SiteLocationsQueryVariables) {
      return { query: SiteLocationsDocument, variables: variables }
    }
export const SiteLocationCenterDocument = gql`
    query siteLocationCenter($filters: [LocationFilterInputObject!], $siteFilters: [SiteFilterInputObject!]) {
  data: siteLocationCenter(filters: $filters, siteFilters: $siteFilters) {
    lat
    lon
  }
}
    `;

/**
 * __useSiteLocationCenterQuery__
 *
 * To run a query within a React component, call `useSiteLocationCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteLocationCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteLocationCenterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      siteFilters: // value for 'siteFilters'
 *   },
 * });
 */
export function useSiteLocationCenterQuery(baseOptions?: Apollo.QueryHookOptions<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>(SiteLocationCenterDocument, options);
      }
export function useSiteLocationCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>(SiteLocationCenterDocument, options);
        }
export type SiteLocationCenterQueryHookResult = ReturnType<typeof useSiteLocationCenterQuery>;
export type SiteLocationCenterLazyQueryHookResult = ReturnType<typeof useSiteLocationCenterLazyQuery>;
export type SiteLocationCenterQueryResult = Apollo.QueryResult<SiteLocationCenterQuery, SiteLocationCenterQueryVariables>;
export function refetchSiteLocationCenterQuery(variables?: SiteLocationCenterQueryVariables) {
      return { query: SiteLocationCenterDocument, variables: variables }
    }
export const SitesIdsDocument = gql`
    query sitesIds($page: Int, $limit: Int, $filters: [SiteFilterInputObject!], $sorts: SiteSortInputObject, $onlyIds: Boolean) {
  data: sites(
    page: $page
    limit: $limit
    filters: $filters
    sorts: $sorts
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useSitesIdsQuery__
 *
 * To run a query within a React component, call `useSitesIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useSitesIdsQuery(baseOptions?: Apollo.QueryHookOptions<SitesIdsQuery, SitesIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesIdsQuery, SitesIdsQueryVariables>(SitesIdsDocument, options);
      }
export function useSitesIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesIdsQuery, SitesIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesIdsQuery, SitesIdsQueryVariables>(SitesIdsDocument, options);
        }
export type SitesIdsQueryHookResult = ReturnType<typeof useSitesIdsQuery>;
export type SitesIdsLazyQueryHookResult = ReturnType<typeof useSitesIdsLazyQuery>;
export type SitesIdsQueryResult = Apollo.QueryResult<SitesIdsQuery, SitesIdsQueryVariables>;
export function refetchSitesIdsQuery(variables?: SitesIdsQueryVariables) {
      return { query: SitesIdsDocument, variables: variables }
    }
export const SitesSearchListDocument = gql`
    query sitesSearchList($page: Int, $limit: Int, $filters: [SiteFilterInputObject!], $sorts: SiteSortInputObject) {
  data: sites(page: $page, limit: $limit, filters: $filters, sorts: $sorts) {
    collection {
      id
      name
      code
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSitesSearchListQuery__
 *
 * To run a query within a React component, call `useSitesSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useSitesSearchListQuery(baseOptions?: Apollo.QueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
      }
export function useSitesSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesSearchListQuery, SitesSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesSearchListQuery, SitesSearchListQueryVariables>(SitesSearchListDocument, options);
        }
export type SitesSearchListQueryHookResult = ReturnType<typeof useSitesSearchListQuery>;
export type SitesSearchListLazyQueryHookResult = ReturnType<typeof useSitesSearchListLazyQuery>;
export type SitesSearchListQueryResult = Apollo.QueryResult<SitesSearchListQuery, SitesSearchListQueryVariables>;
export function refetchSitesSearchListQuery(variables?: SitesSearchListQueryVariables) {
      return { query: SitesSearchListDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskDeadlinesMissedDocument = gql`
    query sitesPerformanceMetricsByTaskDeadlinesMissed($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sitesPerformanceMetricsByTaskDeadlinesMissed(
    ids: $ids
    taskFilters: $taskFilters
  ) {
    id
    successPercentageByTaskDeadlinesMissed
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskDeadlinesMissedQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskDeadlinesMissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskDeadlinesMissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskDeadlinesMissedQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskDeadlinesMissedQuery(baseOptions: Apollo.QueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedDocument, options);
      }
export function useSitesPerformanceMetricsByTaskDeadlinesMissedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedDocument, options);
        }
export type SitesPerformanceMetricsByTaskDeadlinesMissedQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedLazyQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedQueryResult = Apollo.QueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedQuery, SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskDeadlinesMissedQuery(variables: SitesPerformanceMetricsByTaskDeadlinesMissedQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskDeadlinesMissedDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument = gql`
    query sitesPerformanceMetricsByTaskDeadlinesMissedByDate($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!], $periodGroupBy: PeriodGroupByEnum!) {
  data: sitesPerformanceMetricsByTaskDeadlinesMissedByDate(
    ids: $ids
    taskFilters: $taskFilters
    periodGroupBy: $periodGroupBy
  ) {
    id
    period
    totalAnomaliesByTaskDeadlinesMissed
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *      periodGroupBy: // value for 'periodGroupBy'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery(baseOptions: Apollo.QueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
      }
export function useSitesPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>(SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument, options);
        }
export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskDeadlinesMissedByDateLazyQuery>;
export type SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryResult = Apollo.QueryResult<SitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery, SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery(variables: SitesPerformanceMetricsByTaskDeadlinesMissedByDateQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskDeadlinesMissedByDateDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskResultsDocument = gql`
    query sitesPerformanceMetricsByTaskResults($ids: [ID!]!, $taskFilters: [TaskFilterInputObject!]) {
  data: sitesPerformanceMetricsByTaskResults(ids: $ids, taskFilters: $taskFilters) {
    id
    successPercentageByTaskResults
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskResultsQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskResultsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskResultsQuery(baseOptions: Apollo.QueryHookOptions<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>(SitesPerformanceMetricsByTaskResultsDocument, options);
      }
export function useSitesPerformanceMetricsByTaskResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>(SitesPerformanceMetricsByTaskResultsDocument, options);
        }
export type SitesPerformanceMetricsByTaskResultsQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsQuery>;
export type SitesPerformanceMetricsByTaskResultsLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsLazyQuery>;
export type SitesPerformanceMetricsByTaskResultsQueryResult = Apollo.QueryResult<SitesPerformanceMetricsByTaskResultsQuery, SitesPerformanceMetricsByTaskResultsQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskResultsQuery(variables: SitesPerformanceMetricsByTaskResultsQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskResultsDocument, variables: variables }
    }
export const SitesPerformanceMetricsByTaskResultsByDateDocument = gql`
    query sitesPerformanceMetricsByTaskResultsByDate($ids: [ID!]!, $periodGroupBy: PeriodGroupByEnum!, $taskFilters: [TaskFilterInputObject!]) {
  data: sitesPerformanceMetricsByTaskResultsByDate(
    ids: $ids
    periodGroupBy: $periodGroupBy
    taskFilters: $taskFilters
  ) {
    id
    period
    totalAnomaliesByTaskResults
  }
}
    `;

/**
 * __useSitesPerformanceMetricsByTaskResultsByDateQuery__
 *
 * To run a query within a React component, call `useSitesPerformanceMetricsByTaskResultsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesPerformanceMetricsByTaskResultsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesPerformanceMetricsByTaskResultsByDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      periodGroupBy: // value for 'periodGroupBy'
 *      taskFilters: // value for 'taskFilters'
 *   },
 * });
 */
export function useSitesPerformanceMetricsByTaskResultsByDateQuery(baseOptions: Apollo.QueryHookOptions<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>(SitesPerformanceMetricsByTaskResultsByDateDocument, options);
      }
export function useSitesPerformanceMetricsByTaskResultsByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>(SitesPerformanceMetricsByTaskResultsByDateDocument, options);
        }
export type SitesPerformanceMetricsByTaskResultsByDateQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsByDateQuery>;
export type SitesPerformanceMetricsByTaskResultsByDateLazyQueryHookResult = ReturnType<typeof useSitesPerformanceMetricsByTaskResultsByDateLazyQuery>;
export type SitesPerformanceMetricsByTaskResultsByDateQueryResult = Apollo.QueryResult<SitesPerformanceMetricsByTaskResultsByDateQuery, SitesPerformanceMetricsByTaskResultsByDateQueryVariables>;
export function refetchSitesPerformanceMetricsByTaskResultsByDateQuery(variables: SitesPerformanceMetricsByTaskResultsByDateQueryVariables) {
      return { query: SitesPerformanceMetricsByTaskResultsByDateDocument, variables: variables }
    }
export const SiteCreateDocument = gql`
    mutation siteCreate($attributes: SiteCreateInputObject!) {
  data: siteCreate(input: {attributes: $attributes}) {
    ...fullSiteFragment
  }
}
    ${FullSiteFragmentFragmentDoc}`;
export type SiteCreateMutationFn = Apollo.MutationFunction<SiteCreateMutation, SiteCreateMutationVariables>;

/**
 * __useSiteCreateMutation__
 *
 * To run a mutation, you first call `useSiteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteCreateMutation, { data, loading, error }] = useSiteCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSiteCreateMutation(baseOptions?: Apollo.MutationHookOptions<SiteCreateMutation, SiteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteCreateMutation, SiteCreateMutationVariables>(SiteCreateDocument, options);
      }
export type SiteCreateMutationHookResult = ReturnType<typeof useSiteCreateMutation>;
export type SiteCreateMutationResult = Apollo.MutationResult<SiteCreateMutation>;
export type SiteCreateMutationOptions = Apollo.BaseMutationOptions<SiteCreateMutation, SiteCreateMutationVariables>;
export const SiteUpdateDocument = gql`
    mutation siteUpdate($id: ID!, $attributes: SiteUpdateInputObject!) {
  data: siteUpdate(input: {id: $id, attributes: $attributes}) {
    ...fullSiteFragment
  }
}
    ${FullSiteFragmentFragmentDoc}`;
export type SiteUpdateMutationFn = Apollo.MutationFunction<SiteUpdateMutation, SiteUpdateMutationVariables>;

/**
 * __useSiteUpdateMutation__
 *
 * To run a mutation, you first call `useSiteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteUpdateMutation, { data, loading, error }] = useSiteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSiteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SiteUpdateMutation, SiteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteUpdateMutation, SiteUpdateMutationVariables>(SiteUpdateDocument, options);
      }
export type SiteUpdateMutationHookResult = ReturnType<typeof useSiteUpdateMutation>;
export type SiteUpdateMutationResult = Apollo.MutationResult<SiteUpdateMutation>;
export type SiteUpdateMutationOptions = Apollo.BaseMutationOptions<SiteUpdateMutation, SiteUpdateMutationVariables>;
export const SiteDestroyDocument = gql`
    mutation siteDestroy($id: ID!) {
  data: siteDestroy(input: {id: $id})
}
    `;
export type SiteDestroyMutationFn = Apollo.MutationFunction<SiteDestroyMutation, SiteDestroyMutationVariables>;

/**
 * __useSiteDestroyMutation__
 *
 * To run a mutation, you first call `useSiteDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteDestroyMutation, { data, loading, error }] = useSiteDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteDestroyMutation(baseOptions?: Apollo.MutationHookOptions<SiteDestroyMutation, SiteDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteDestroyMutation, SiteDestroyMutationVariables>(SiteDestroyDocument, options);
      }
export type SiteDestroyMutationHookResult = ReturnType<typeof useSiteDestroyMutation>;
export type SiteDestroyMutationResult = Apollo.MutationResult<SiteDestroyMutation>;
export type SiteDestroyMutationOptions = Apollo.BaseMutationOptions<SiteDestroyMutation, SiteDestroyMutationVariables>;
export const SiteAreaDocument = gql`
    query siteArea($findBy: SiteAreaFindByInputObject!, $siteFindBy: SiteFindByInputObject!) {
  data: siteArea(findBy: $findBy, siteFindBy: $siteFindBy) {
    ...siteAreaFragment
  }
}
    ${SiteAreaFragmentFragmentDoc}`;

/**
 * __useSiteAreaQuery__
 *
 * To run a query within a React component, call `useSiteAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreaQuery({
 *   variables: {
 *      findBy: // value for 'findBy'
 *      siteFindBy: // value for 'siteFindBy'
 *   },
 * });
 */
export function useSiteAreaQuery(baseOptions: Apollo.QueryHookOptions<SiteAreaQuery, SiteAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteAreaQuery, SiteAreaQueryVariables>(SiteAreaDocument, options);
      }
export function useSiteAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteAreaQuery, SiteAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteAreaQuery, SiteAreaQueryVariables>(SiteAreaDocument, options);
        }
export type SiteAreaQueryHookResult = ReturnType<typeof useSiteAreaQuery>;
export type SiteAreaLazyQueryHookResult = ReturnType<typeof useSiteAreaLazyQuery>;
export type SiteAreaQueryResult = Apollo.QueryResult<SiteAreaQuery, SiteAreaQueryVariables>;
export function refetchSiteAreaQuery(variables: SiteAreaQueryVariables) {
      return { query: SiteAreaDocument, variables: variables }
    }
export const SiteAreasDocument = gql`
    query siteAreas($page: Int, $limit: Int, $filters: [SiteAreaFilterInputObject!], $sorts: SiteAreaSortInputObject, $includeFullData: Boolean = false, $includeSiteData: Boolean = false) {
  data: siteAreas(page: $page, limit: $limit, filters: $filters, sorts: $sorts) {
    collection {
      address @include(if: $includeFullData)
      code
      description @include(if: $includeFullData)
      fullCode
      id
      name
      poorWifi @include(if: $includeFullData)
      site @include(if: $includeSiteData) {
        id
        name
        code
        sector {
          id
          name
          color
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSiteAreasQuery__
 *
 * To run a query within a React component, call `useSiteAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreasQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      includeFullData: // value for 'includeFullData'
 *      includeSiteData: // value for 'includeSiteData'
 *   },
 * });
 */
export function useSiteAreasQuery(baseOptions?: Apollo.QueryHookOptions<SiteAreasQuery, SiteAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteAreasQuery, SiteAreasQueryVariables>(SiteAreasDocument, options);
      }
export function useSiteAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteAreasQuery, SiteAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteAreasQuery, SiteAreasQueryVariables>(SiteAreasDocument, options);
        }
export type SiteAreasQueryHookResult = ReturnType<typeof useSiteAreasQuery>;
export type SiteAreasLazyQueryHookResult = ReturnType<typeof useSiteAreasLazyQuery>;
export type SiteAreasQueryResult = Apollo.QueryResult<SiteAreasQuery, SiteAreasQueryVariables>;
export function refetchSiteAreasQuery(variables?: SiteAreasQueryVariables) {
      return { query: SiteAreasDocument, variables: variables }
    }
export const SiteAreaIdsDocument = gql`
    query siteAreaIds($filters: [SiteAreaFilterInputObject!], $sorts: SiteAreaSortInputObject, $onlyIds: Boolean, $includeSiteId: Boolean = false) {
  data: siteAreas(filters: $filters, sorts: $sorts, onlyIds: $onlyIds) {
    collection {
      id
      siteId @include(if: $includeSiteId)
    }
  }
}
    `;

/**
 * __useSiteAreaIdsQuery__
 *
 * To run a query within a React component, call `useSiteAreaIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreaIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *      includeSiteId: // value for 'includeSiteId'
 *   },
 * });
 */
export function useSiteAreaIdsQuery(baseOptions?: Apollo.QueryHookOptions<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>(SiteAreaIdsDocument, options);
      }
export function useSiteAreaIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>(SiteAreaIdsDocument, options);
        }
export type SiteAreaIdsQueryHookResult = ReturnType<typeof useSiteAreaIdsQuery>;
export type SiteAreaIdsLazyQueryHookResult = ReturnType<typeof useSiteAreaIdsLazyQuery>;
export type SiteAreaIdsQueryResult = Apollo.QueryResult<SiteAreaIdsQuery, SiteAreaIdsQueryVariables>;
export function refetchSiteAreaIdsQuery(variables?: SiteAreaIdsQueryVariables) {
      return { query: SiteAreaIdsDocument, variables: variables }
    }
export const SiteAreasSearchListDocument = gql`
    query siteAreasSearchList($page: Int, $limit: Int, $filters: [SiteAreaFilterInputObject!], $sorts: SiteAreaSortInputObject) {
  data: siteAreas(page: $page, limit: $limit, filters: $filters, sorts: $sorts) {
    collection {
      id
      name
      poorWifi
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useSiteAreasSearchListQuery__
 *
 * To run a query within a React component, call `useSiteAreasSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAreasSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAreasSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useSiteAreasSearchListQuery(baseOptions?: Apollo.QueryHookOptions<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>(SiteAreasSearchListDocument, options);
      }
export function useSiteAreasSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>(SiteAreasSearchListDocument, options);
        }
export type SiteAreasSearchListQueryHookResult = ReturnType<typeof useSiteAreasSearchListQuery>;
export type SiteAreasSearchListLazyQueryHookResult = ReturnType<typeof useSiteAreasSearchListLazyQuery>;
export type SiteAreasSearchListQueryResult = Apollo.QueryResult<SiteAreasSearchListQuery, SiteAreasSearchListQueryVariables>;
export function refetchSiteAreasSearchListQuery(variables?: SiteAreasSearchListQueryVariables) {
      return { query: SiteAreasSearchListDocument, variables: variables }
    }
export const SiteAreaUpdateDocument = gql`
    mutation siteAreaUpdate($id: ID!, $attributes: SiteAreaUpdateInputObject!) {
  data: siteAreaUpdate(input: {id: $id, attributes: $attributes}) {
    ...siteAreaFragment
  }
}
    ${SiteAreaFragmentFragmentDoc}`;
export type SiteAreaUpdateMutationFn = Apollo.MutationFunction<SiteAreaUpdateMutation, SiteAreaUpdateMutationVariables>;

/**
 * __useSiteAreaUpdateMutation__
 *
 * To run a mutation, you first call `useSiteAreaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteAreaUpdateMutation, { data, loading, error }] = useSiteAreaUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSiteAreaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SiteAreaUpdateMutation, SiteAreaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteAreaUpdateMutation, SiteAreaUpdateMutationVariables>(SiteAreaUpdateDocument, options);
      }
export type SiteAreaUpdateMutationHookResult = ReturnType<typeof useSiteAreaUpdateMutation>;
export type SiteAreaUpdateMutationResult = Apollo.MutationResult<SiteAreaUpdateMutation>;
export type SiteAreaUpdateMutationOptions = Apollo.BaseMutationOptions<SiteAreaUpdateMutation, SiteAreaUpdateMutationVariables>;
export const SiteAreaBulkDestroyDocument = gql`
    mutation siteAreaBulkDestroy($input: SiteAreaBulkDestroyInput!) {
  data: siteAreaBulkDestroy(input: $input)
}
    `;
export type SiteAreaBulkDestroyMutationFn = Apollo.MutationFunction<SiteAreaBulkDestroyMutation, SiteAreaBulkDestroyMutationVariables>;

/**
 * __useSiteAreaBulkDestroyMutation__
 *
 * To run a mutation, you first call `useSiteAreaBulkDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaBulkDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteAreaBulkDestroyMutation, { data, loading, error }] = useSiteAreaBulkDestroyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteAreaBulkDestroyMutation(baseOptions?: Apollo.MutationHookOptions<SiteAreaBulkDestroyMutation, SiteAreaBulkDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteAreaBulkDestroyMutation, SiteAreaBulkDestroyMutationVariables>(SiteAreaBulkDestroyDocument, options);
      }
export type SiteAreaBulkDestroyMutationHookResult = ReturnType<typeof useSiteAreaBulkDestroyMutation>;
export type SiteAreaBulkDestroyMutationResult = Apollo.MutationResult<SiteAreaBulkDestroyMutation>;
export type SiteAreaBulkDestroyMutationOptions = Apollo.BaseMutationOptions<SiteAreaBulkDestroyMutation, SiteAreaBulkDestroyMutationVariables>;
export const SiteAreaBulkQrCodeCreateDocument = gql`
    mutation siteAreaBulkQrCodeCreate($params: QrCodesCreateInputObject!) {
  data: siteAreaBulkQrCodeCreate(input: {params: $params}) {
    ...jobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export type SiteAreaBulkQrCodeCreateMutationFn = Apollo.MutationFunction<SiteAreaBulkQrCodeCreateMutation, SiteAreaBulkQrCodeCreateMutationVariables>;

/**
 * __useSiteAreaBulkQrCodeCreateMutation__
 *
 * To run a mutation, you first call `useSiteAreaBulkQrCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteAreaBulkQrCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteAreaBulkQrCodeCreateMutation, { data, loading, error }] = useSiteAreaBulkQrCodeCreateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSiteAreaBulkQrCodeCreateMutation(baseOptions?: Apollo.MutationHookOptions<SiteAreaBulkQrCodeCreateMutation, SiteAreaBulkQrCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteAreaBulkQrCodeCreateMutation, SiteAreaBulkQrCodeCreateMutationVariables>(SiteAreaBulkQrCodeCreateDocument, options);
      }
export type SiteAreaBulkQrCodeCreateMutationHookResult = ReturnType<typeof useSiteAreaBulkQrCodeCreateMutation>;
export type SiteAreaBulkQrCodeCreateMutationResult = Apollo.MutationResult<SiteAreaBulkQrCodeCreateMutation>;
export type SiteAreaBulkQrCodeCreateMutationOptions = Apollo.BaseMutationOptions<SiteAreaBulkQrCodeCreateMutation, SiteAreaBulkQrCodeCreateMutationVariables>;
export const SsoIntegrationsDocument = gql`
    query ssoIntegrations($page: Int, $limit: Int, $sorts: SsoIntegrationSortInputObject, $filters: [SsoIntegrationFilterInputObject!]) {
  data: ssoIntegrations(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      name
      status
      providerPreset
      providerType
      displayStatus
      updatedAt
      icon {
        ...attachmentFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationsQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSsoIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>(SsoIntegrationsDocument, options);
      }
export function useSsoIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>(SsoIntegrationsDocument, options);
        }
export type SsoIntegrationsQueryHookResult = ReturnType<typeof useSsoIntegrationsQuery>;
export type SsoIntegrationsLazyQueryHookResult = ReturnType<typeof useSsoIntegrationsLazyQuery>;
export type SsoIntegrationsQueryResult = Apollo.QueryResult<SsoIntegrationsQuery, SsoIntegrationsQueryVariables>;
export function refetchSsoIntegrationsQuery(variables?: SsoIntegrationsQueryVariables) {
      return { query: SsoIntegrationsDocument, variables: variables }
    }
export const SsoIntegrationDocument = gql`
    query ssoIntegration($id: ID!) {
  data: ssoIntegration(id: $id) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}`;

/**
 * __useSsoIntegrationQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationQuery(baseOptions: Apollo.QueryHookOptions<SsoIntegrationQuery, SsoIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoIntegrationQuery, SsoIntegrationQueryVariables>(SsoIntegrationDocument, options);
      }
export function useSsoIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoIntegrationQuery, SsoIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoIntegrationQuery, SsoIntegrationQueryVariables>(SsoIntegrationDocument, options);
        }
export type SsoIntegrationQueryHookResult = ReturnType<typeof useSsoIntegrationQuery>;
export type SsoIntegrationLazyQueryHookResult = ReturnType<typeof useSsoIntegrationLazyQuery>;
export type SsoIntegrationQueryResult = Apollo.QueryResult<SsoIntegrationQuery, SsoIntegrationQueryVariables>;
export function refetchSsoIntegrationQuery(variables: SsoIntegrationQueryVariables) {
      return { query: SsoIntegrationDocument, variables: variables }
    }
export const SsoIntegrationCreateDocument = gql`
    mutation ssoIntegrationCreate($attributes: SsoIntegrationCreateInputObject!) {
  data: ssoIntegrationCreate(input: {attributes: $attributes}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}`;
export type SsoIntegrationCreateMutationFn = Apollo.MutationFunction<SsoIntegrationCreateMutation, SsoIntegrationCreateMutationVariables>;

/**
 * __useSsoIntegrationCreateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationCreateMutation, { data, loading, error }] = useSsoIntegrationCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSsoIntegrationCreateMutation(baseOptions?: Apollo.MutationHookOptions<SsoIntegrationCreateMutation, SsoIntegrationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SsoIntegrationCreateMutation, SsoIntegrationCreateMutationVariables>(SsoIntegrationCreateDocument, options);
      }
export type SsoIntegrationCreateMutationHookResult = ReturnType<typeof useSsoIntegrationCreateMutation>;
export type SsoIntegrationCreateMutationResult = Apollo.MutationResult<SsoIntegrationCreateMutation>;
export type SsoIntegrationCreateMutationOptions = Apollo.BaseMutationOptions<SsoIntegrationCreateMutation, SsoIntegrationCreateMutationVariables>;
export const SsoIntegrationUpdateDocument = gql`
    mutation ssoIntegrationUpdate($id: ID!, $attributes: SsoIntegrationUpdateInputObject!) {
  data: ssoIntegrationUpdate(input: {id: $id, attributes: $attributes}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}`;
export type SsoIntegrationUpdateMutationFn = Apollo.MutationFunction<SsoIntegrationUpdateMutation, SsoIntegrationUpdateMutationVariables>;

/**
 * __useSsoIntegrationUpdateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationUpdateMutation, { data, loading, error }] = useSsoIntegrationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSsoIntegrationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SsoIntegrationUpdateMutation, SsoIntegrationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SsoIntegrationUpdateMutation, SsoIntegrationUpdateMutationVariables>(SsoIntegrationUpdateDocument, options);
      }
export type SsoIntegrationUpdateMutationHookResult = ReturnType<typeof useSsoIntegrationUpdateMutation>;
export type SsoIntegrationUpdateMutationResult = Apollo.MutationResult<SsoIntegrationUpdateMutation>;
export type SsoIntegrationUpdateMutationOptions = Apollo.BaseMutationOptions<SsoIntegrationUpdateMutation, SsoIntegrationUpdateMutationVariables>;
export const SsoIntegrationPresetDefaultsDocument = gql`
    query ssoIntegrationPresetDefaults($preset: SsoIntegrationProviderPresetEnum!) {
  data: ssoIntegrationPresetDefaults(preset: $preset)
}
    `;

/**
 * __useSsoIntegrationPresetDefaultsQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationPresetDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationPresetDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationPresetDefaultsQuery({
 *   variables: {
 *      preset: // value for 'preset'
 *   },
 * });
 */
export function useSsoIntegrationPresetDefaultsQuery(baseOptions: Apollo.QueryHookOptions<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>(SsoIntegrationPresetDefaultsDocument, options);
      }
export function useSsoIntegrationPresetDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>(SsoIntegrationPresetDefaultsDocument, options);
        }
export type SsoIntegrationPresetDefaultsQueryHookResult = ReturnType<typeof useSsoIntegrationPresetDefaultsQuery>;
export type SsoIntegrationPresetDefaultsLazyQueryHookResult = ReturnType<typeof useSsoIntegrationPresetDefaultsLazyQuery>;
export type SsoIntegrationPresetDefaultsQueryResult = Apollo.QueryResult<SsoIntegrationPresetDefaultsQuery, SsoIntegrationPresetDefaultsQueryVariables>;
export function refetchSsoIntegrationPresetDefaultsQuery(variables: SsoIntegrationPresetDefaultsQueryVariables) {
      return { query: SsoIntegrationPresetDefaultsDocument, variables: variables }
    }
export const SsoIntegrationGenerateCodeDocument = gql`
    query ssoIntegrationGenerateCode {
  data: ssoIntegrationGenerateCode {
    code
    acsUrl
    entityId
    metadataUrl
  }
}
    `;

/**
 * __useSsoIntegrationGenerateCodeQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationGenerateCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationGenerateCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationGenerateCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useSsoIntegrationGenerateCodeQuery(baseOptions?: Apollo.QueryHookOptions<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>(SsoIntegrationGenerateCodeDocument, options);
      }
export function useSsoIntegrationGenerateCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>(SsoIntegrationGenerateCodeDocument, options);
        }
export type SsoIntegrationGenerateCodeQueryHookResult = ReturnType<typeof useSsoIntegrationGenerateCodeQuery>;
export type SsoIntegrationGenerateCodeLazyQueryHookResult = ReturnType<typeof useSsoIntegrationGenerateCodeLazyQuery>;
export type SsoIntegrationGenerateCodeQueryResult = Apollo.QueryResult<SsoIntegrationGenerateCodeQuery, SsoIntegrationGenerateCodeQueryVariables>;
export function refetchSsoIntegrationGenerateCodeQuery(variables?: SsoIntegrationGenerateCodeQueryVariables) {
      return { query: SsoIntegrationGenerateCodeDocument, variables: variables }
    }
export const SsoIntegrationActivateDocument = gql`
    mutation ssoIntegrationActivate($id: ID!) {
  data: ssoIntegrationActivate(input: {id: $id}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}`;
export type SsoIntegrationActivateMutationFn = Apollo.MutationFunction<SsoIntegrationActivateMutation, SsoIntegrationActivateMutationVariables>;

/**
 * __useSsoIntegrationActivateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationActivateMutation, { data, loading, error }] = useSsoIntegrationActivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationActivateMutation(baseOptions?: Apollo.MutationHookOptions<SsoIntegrationActivateMutation, SsoIntegrationActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SsoIntegrationActivateMutation, SsoIntegrationActivateMutationVariables>(SsoIntegrationActivateDocument, options);
      }
export type SsoIntegrationActivateMutationHookResult = ReturnType<typeof useSsoIntegrationActivateMutation>;
export type SsoIntegrationActivateMutationResult = Apollo.MutationResult<SsoIntegrationActivateMutation>;
export type SsoIntegrationActivateMutationOptions = Apollo.BaseMutationOptions<SsoIntegrationActivateMutation, SsoIntegrationActivateMutationVariables>;
export const SsoIntegrationDeactivateDocument = gql`
    mutation ssoIntegrationDeactivate($id: ID!) {
  data: ssoIntegrationDeactivate(input: {id: $id}) {
    ...ssoIntegrationFragment
  }
}
    ${SsoIntegrationFragmentFragmentDoc}`;
export type SsoIntegrationDeactivateMutationFn = Apollo.MutationFunction<SsoIntegrationDeactivateMutation, SsoIntegrationDeactivateMutationVariables>;

/**
 * __useSsoIntegrationDeactivateMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationDeactivateMutation, { data, loading, error }] = useSsoIntegrationDeactivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<SsoIntegrationDeactivateMutation, SsoIntegrationDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SsoIntegrationDeactivateMutation, SsoIntegrationDeactivateMutationVariables>(SsoIntegrationDeactivateDocument, options);
      }
export type SsoIntegrationDeactivateMutationHookResult = ReturnType<typeof useSsoIntegrationDeactivateMutation>;
export type SsoIntegrationDeactivateMutationResult = Apollo.MutationResult<SsoIntegrationDeactivateMutation>;
export type SsoIntegrationDeactivateMutationOptions = Apollo.BaseMutationOptions<SsoIntegrationDeactivateMutation, SsoIntegrationDeactivateMutationVariables>;
export const SsoIntegrationDestroyDocument = gql`
    mutation ssoIntegrationDestroy($id: ID!) {
  data: ssoIntegrationDestroy(input: {id: $id})
}
    `;
export type SsoIntegrationDestroyMutationFn = Apollo.MutationFunction<SsoIntegrationDestroyMutation, SsoIntegrationDestroyMutationVariables>;

/**
 * __useSsoIntegrationDestroyMutation__
 *
 * To run a mutation, you first call `useSsoIntegrationDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoIntegrationDestroyMutation, { data, loading, error }] = useSsoIntegrationDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSsoIntegrationDestroyMutation(baseOptions?: Apollo.MutationHookOptions<SsoIntegrationDestroyMutation, SsoIntegrationDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SsoIntegrationDestroyMutation, SsoIntegrationDestroyMutationVariables>(SsoIntegrationDestroyDocument, options);
      }
export type SsoIntegrationDestroyMutationHookResult = ReturnType<typeof useSsoIntegrationDestroyMutation>;
export type SsoIntegrationDestroyMutationResult = Apollo.MutationResult<SsoIntegrationDestroyMutation>;
export type SsoIntegrationDestroyMutationOptions = Apollo.BaseMutationOptions<SsoIntegrationDestroyMutation, SsoIntegrationDestroyMutationVariables>;
export const CompanyDomainsDocument = gql`
    query companyDomains($page: Int, $limit: Int, $sorts: CompanyDomainSortInputObject, $filters: [CompanyDomainFilterInputObject!]) {
  data: companyDomains(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      ...companyDomainFragment
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${CompanyDomainFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useCompanyDomainsQuery__
 *
 * To run a query within a React component, call `useCompanyDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDomainsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCompanyDomainsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyDomainsQuery, CompanyDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDomainsQuery, CompanyDomainsQueryVariables>(CompanyDomainsDocument, options);
      }
export function useCompanyDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDomainsQuery, CompanyDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDomainsQuery, CompanyDomainsQueryVariables>(CompanyDomainsDocument, options);
        }
export type CompanyDomainsQueryHookResult = ReturnType<typeof useCompanyDomainsQuery>;
export type CompanyDomainsLazyQueryHookResult = ReturnType<typeof useCompanyDomainsLazyQuery>;
export type CompanyDomainsQueryResult = Apollo.QueryResult<CompanyDomainsQuery, CompanyDomainsQueryVariables>;
export function refetchCompanyDomainsQuery(variables?: CompanyDomainsQueryVariables) {
      return { query: CompanyDomainsDocument, variables: variables }
    }
export const CompanyDomainCreateDocument = gql`
    mutation companyDomainCreate($attributes: CompanyDomainCreateInputObject!) {
  data: companyDomainCreate(input: {attributes: $attributes}) {
    ...companyDomainFragment
  }
}
    ${CompanyDomainFragmentFragmentDoc}`;
export type CompanyDomainCreateMutationFn = Apollo.MutationFunction<CompanyDomainCreateMutation, CompanyDomainCreateMutationVariables>;

/**
 * __useCompanyDomainCreateMutation__
 *
 * To run a mutation, you first call `useCompanyDomainCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDomainCreateMutation, { data, loading, error }] = useCompanyDomainCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCompanyDomainCreateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyDomainCreateMutation, CompanyDomainCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyDomainCreateMutation, CompanyDomainCreateMutationVariables>(CompanyDomainCreateDocument, options);
      }
export type CompanyDomainCreateMutationHookResult = ReturnType<typeof useCompanyDomainCreateMutation>;
export type CompanyDomainCreateMutationResult = Apollo.MutationResult<CompanyDomainCreateMutation>;
export type CompanyDomainCreateMutationOptions = Apollo.BaseMutationOptions<CompanyDomainCreateMutation, CompanyDomainCreateMutationVariables>;
export const CompanyDomainVerifyDocument = gql`
    mutation companyDomainVerify($id: ID!) {
  data: companyDomainVerify(input: {id: $id}) {
    ...companyDomainFragment
  }
}
    ${CompanyDomainFragmentFragmentDoc}`;
export type CompanyDomainVerifyMutationFn = Apollo.MutationFunction<CompanyDomainVerifyMutation, CompanyDomainVerifyMutationVariables>;

/**
 * __useCompanyDomainVerifyMutation__
 *
 * To run a mutation, you first call `useCompanyDomainVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDomainVerifyMutation, { data, loading, error }] = useCompanyDomainVerifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyDomainVerifyMutation(baseOptions?: Apollo.MutationHookOptions<CompanyDomainVerifyMutation, CompanyDomainVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyDomainVerifyMutation, CompanyDomainVerifyMutationVariables>(CompanyDomainVerifyDocument, options);
      }
export type CompanyDomainVerifyMutationHookResult = ReturnType<typeof useCompanyDomainVerifyMutation>;
export type CompanyDomainVerifyMutationResult = Apollo.MutationResult<CompanyDomainVerifyMutation>;
export type CompanyDomainVerifyMutationOptions = Apollo.BaseMutationOptions<CompanyDomainVerifyMutation, CompanyDomainVerifyMutationVariables>;
export const CompanyDomainDestroyDocument = gql`
    mutation companyDomainDestroy($id: ID!) {
  data: companyDomainDestroy(input: {id: $id})
}
    `;
export type CompanyDomainDestroyMutationFn = Apollo.MutationFunction<CompanyDomainDestroyMutation, CompanyDomainDestroyMutationVariables>;

/**
 * __useCompanyDomainDestroyMutation__
 *
 * To run a mutation, you first call `useCompanyDomainDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDomainDestroyMutation, { data, loading, error }] = useCompanyDomainDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyDomainDestroyMutation(baseOptions?: Apollo.MutationHookOptions<CompanyDomainDestroyMutation, CompanyDomainDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyDomainDestroyMutation, CompanyDomainDestroyMutationVariables>(CompanyDomainDestroyDocument, options);
      }
export type CompanyDomainDestroyMutationHookResult = ReturnType<typeof useCompanyDomainDestroyMutation>;
export type CompanyDomainDestroyMutationResult = Apollo.MutationResult<CompanyDomainDestroyMutation>;
export type CompanyDomainDestroyMutationOptions = Apollo.BaseMutationOptions<CompanyDomainDestroyMutation, CompanyDomainDestroyMutationVariables>;
export const SsoIntegrationsDomainCheckDocument = gql`
    query ssoIntegrationsDomainCheck($limit: Int, $filters: [SsoIntegrationFilterInputObject!]) {
  data: ssoIntegrations(limit: $limit, filters: $filters) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useSsoIntegrationsDomainCheckQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationsDomainCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationsDomainCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationsDomainCheckQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSsoIntegrationsDomainCheckQuery(baseOptions?: Apollo.QueryHookOptions<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>(SsoIntegrationsDomainCheckDocument, options);
      }
export function useSsoIntegrationsDomainCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>(SsoIntegrationsDomainCheckDocument, options);
        }
export type SsoIntegrationsDomainCheckQueryHookResult = ReturnType<typeof useSsoIntegrationsDomainCheckQuery>;
export type SsoIntegrationsDomainCheckLazyQueryHookResult = ReturnType<typeof useSsoIntegrationsDomainCheckLazyQuery>;
export type SsoIntegrationsDomainCheckQueryResult = Apollo.QueryResult<SsoIntegrationsDomainCheckQuery, SsoIntegrationsDomainCheckQueryVariables>;
export function refetchSsoIntegrationsDomainCheckQuery(variables?: SsoIntegrationsDomainCheckQueryVariables) {
      return { query: SsoIntegrationsDomainCheckDocument, variables: variables }
    }
export const CompanyDomainsSearchListDocument = gql`
    query companyDomainsSearchList($page: Int, $limit: Int, $sorts: CompanyDomainSortInputObject, $filters: [CompanyDomainFilterInputObject!]) {
  data: companyDomains(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
  ) {
    collection {
      id
      domain
      verified
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useCompanyDomainsSearchListQuery__
 *
 * To run a query within a React component, call `useCompanyDomainsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDomainsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDomainsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCompanyDomainsSearchListQuery(baseOptions?: Apollo.QueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
      }
export function useCompanyDomainsSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>(CompanyDomainsSearchListDocument, options);
        }
export type CompanyDomainsSearchListQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListQuery>;
export type CompanyDomainsSearchListLazyQueryHookResult = ReturnType<typeof useCompanyDomainsSearchListLazyQuery>;
export type CompanyDomainsSearchListQueryResult = Apollo.QueryResult<CompanyDomainsSearchListQuery, CompanyDomainsSearchListQueryVariables>;
export function refetchCompanyDomainsSearchListQuery(variables?: CompanyDomainsSearchListQueryVariables) {
      return { query: CompanyDomainsSearchListDocument, variables: variables }
    }
export const SsoIntegrationSupportedMappingFieldsDocument = gql`
    query SsoIntegrationSupportedMappingFields {
  ssoIntegrationSupportedMappingFields {
    description
    key
    label
    required
    sortIndex
  }
}
    `;

/**
 * __useSsoIntegrationSupportedMappingFieldsQuery__
 *
 * To run a query within a React component, call `useSsoIntegrationSupportedMappingFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoIntegrationSupportedMappingFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoIntegrationSupportedMappingFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSsoIntegrationSupportedMappingFieldsQuery(baseOptions?: Apollo.QueryHookOptions<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>(SsoIntegrationSupportedMappingFieldsDocument, options);
      }
export function useSsoIntegrationSupportedMappingFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>(SsoIntegrationSupportedMappingFieldsDocument, options);
        }
export type SsoIntegrationSupportedMappingFieldsQueryHookResult = ReturnType<typeof useSsoIntegrationSupportedMappingFieldsQuery>;
export type SsoIntegrationSupportedMappingFieldsLazyQueryHookResult = ReturnType<typeof useSsoIntegrationSupportedMappingFieldsLazyQuery>;
export type SsoIntegrationSupportedMappingFieldsQueryResult = Apollo.QueryResult<SsoIntegrationSupportedMappingFieldsQuery, SsoIntegrationSupportedMappingFieldsQueryVariables>;
export function refetchSsoIntegrationSupportedMappingFieldsQuery(variables?: SsoIntegrationSupportedMappingFieldsQueryVariables) {
      return { query: SsoIntegrationSupportedMappingFieldsDocument, variables: variables }
    }
export const TagsDocument = gql`
    query tags($page: Int, $limit: Int, $sorts: TagSortInputObject, $filters: [TagFilterInputObject!]) {
  data: tags(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export function refetchTagsQuery(variables?: TagsQueryVariables) {
      return { query: TagsDocument, variables: variables }
    }
export const TagDocument = gql`
    query tag($id: ID!) {
  data: tag(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQuery(baseOptions: Apollo.QueryHookOptions<TagQuery, TagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagQuery, TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagQueryResult = Apollo.QueryResult<TagQuery, TagQueryVariables>;
export function refetchTagQuery(variables: TagQueryVariables) {
      return { query: TagDocument, variables: variables }
    }
export const TagCreateDocument = gql`
    mutation tagCreate($attributes: TagCreateInputObject!) {
  data: tagCreate(input: {attributes: $attributes}) {
    id
    name
  }
}
    `;
export type TagCreateMutationFn = Apollo.MutationFunction<TagCreateMutation, TagCreateMutationVariables>;

/**
 * __useTagCreateMutation__
 *
 * To run a mutation, you first call `useTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagCreateMutation, { data, loading, error }] = useTagCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<TagCreateMutation, TagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagCreateMutation, TagCreateMutationVariables>(TagCreateDocument, options);
      }
export type TagCreateMutationHookResult = ReturnType<typeof useTagCreateMutation>;
export type TagCreateMutationResult = Apollo.MutationResult<TagCreateMutation>;
export type TagCreateMutationOptions = Apollo.BaseMutationOptions<TagCreateMutation, TagCreateMutationVariables>;
export const TagDestroyDocument = gql`
    mutation tagDestroy($id: ID!) {
  tagDestroy(input: {id: $id})
}
    `;
export type TagDestroyMutationFn = Apollo.MutationFunction<TagDestroyMutation, TagDestroyMutationVariables>;

/**
 * __useTagDestroyMutation__
 *
 * To run a mutation, you first call `useTagDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDestroyMutation, { data, loading, error }] = useTagDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagDestroyMutation(baseOptions?: Apollo.MutationHookOptions<TagDestroyMutation, TagDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagDestroyMutation, TagDestroyMutationVariables>(TagDestroyDocument, options);
      }
export type TagDestroyMutationHookResult = ReturnType<typeof useTagDestroyMutation>;
export type TagDestroyMutationResult = Apollo.MutationResult<TagDestroyMutation>;
export type TagDestroyMutationOptions = Apollo.BaseMutationOptions<TagDestroyMutation, TagDestroyMutationVariables>;
export const TaskFormCompletionDocument = gql`
    query taskFormCompletion($id: ID!) {
  data: task(id: $id) {
    id
    name
    status
    formTemplate {
      category {
        ...formCategoryFragment
      }
      description
      id
      name
      createdAt
      updatedAt
    }
    completion {
      id
      answers {
        id
        kind
        fieldId
        field {
          id
          options {
            id
            fieldId
            group
            position
            values
          }
        }
        questionId
        resp {
          group
          optionId
          position
          selected
          value
          valueId
        }
        attachmentsAttached {
          ...attachmentFragment
        }
      }
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}`;

/**
 * __useTaskFormCompletionQuery__
 *
 * To run a query within a React component, call `useTaskFormCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskFormCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskFormCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskFormCompletionQuery(baseOptions: Apollo.QueryHookOptions<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>(TaskFormCompletionDocument, options);
      }
export function useTaskFormCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>(TaskFormCompletionDocument, options);
        }
export type TaskFormCompletionQueryHookResult = ReturnType<typeof useTaskFormCompletionQuery>;
export type TaskFormCompletionLazyQueryHookResult = ReturnType<typeof useTaskFormCompletionLazyQuery>;
export type TaskFormCompletionQueryResult = Apollo.QueryResult<TaskFormCompletionQuery, TaskFormCompletionQueryVariables>;
export function refetchTaskFormCompletionQuery(variables: TaskFormCompletionQueryVariables) {
      return { query: TaskFormCompletionDocument, variables: variables }
    }
export const DashboardTaskCounterDocument = gql`
    query dashboardTaskCounter($filters: [TaskFilterInputObject!]) {
  myApprovals: tasks(scope: {name: MY_APPROVALS}, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useDashboardTaskCounterQuery__
 *
 * To run a query within a React component, call `useDashboardTaskCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskCounterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDashboardTaskCounterQuery(baseOptions?: Apollo.QueryHookOptions<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>(DashboardTaskCounterDocument, options);
      }
export function useDashboardTaskCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>(DashboardTaskCounterDocument, options);
        }
export type DashboardTaskCounterQueryHookResult = ReturnType<typeof useDashboardTaskCounterQuery>;
export type DashboardTaskCounterLazyQueryHookResult = ReturnType<typeof useDashboardTaskCounterLazyQuery>;
export type DashboardTaskCounterQueryResult = Apollo.QueryResult<DashboardTaskCounterQuery, DashboardTaskCounterQueryVariables>;
export function refetchDashboardTaskCounterQuery(variables?: DashboardTaskCounterQueryVariables) {
      return { query: DashboardTaskCounterDocument, variables: variables }
    }
export const DashboardTaskDocument = gql`
    query dashboardTask($id: ID!) {
  data: task(id: $id) {
    ...taskFragment
    formTemplate {
      id
      name
    }
    formTemplateVersion {
      id
      version
    }
  }
}
    ${TaskFragmentFragmentDoc}`;

/**
 * __useDashboardTaskQuery__
 *
 * To run a query within a React component, call `useDashboardTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTaskQuery(baseOptions: Apollo.QueryHookOptions<DashboardTaskQuery, DashboardTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTaskQuery, DashboardTaskQueryVariables>(DashboardTaskDocument, options);
      }
export function useDashboardTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTaskQuery, DashboardTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTaskQuery, DashboardTaskQueryVariables>(DashboardTaskDocument, options);
        }
export type DashboardTaskQueryHookResult = ReturnType<typeof useDashboardTaskQuery>;
export type DashboardTaskLazyQueryHookResult = ReturnType<typeof useDashboardTaskLazyQuery>;
export type DashboardTaskQueryResult = Apollo.QueryResult<DashboardTaskQuery, DashboardTaskQueryVariables>;
export function refetchDashboardTaskQuery(variables: DashboardTaskQueryVariables) {
      return { query: DashboardTaskDocument, variables: variables }
    }
export const DashboardFullTaskDocument = gql`
    query dashboardFullTask($id: ID!) {
  data: task(id: $id) {
    ...taskFragment
    ...earlyCompletionFragment
    formTemplate {
      id
      name
      canUpdate {
        value
      }
    }
    formTemplateVersion {
      id
      version
    }
    recurringRule {
      ...recurringRuleFragment
    }
  }
}
    ${TaskFragmentFragmentDoc}
${EarlyCompletionFragmentFragmentDoc}
${RecurringRuleFragmentFragmentDoc}`;

/**
 * __useDashboardFullTaskQuery__
 *
 * To run a query within a React component, call `useDashboardFullTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardFullTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardFullTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardFullTaskQuery(baseOptions: Apollo.QueryHookOptions<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>(DashboardFullTaskDocument, options);
      }
export function useDashboardFullTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>(DashboardFullTaskDocument, options);
        }
export type DashboardFullTaskQueryHookResult = ReturnType<typeof useDashboardFullTaskQuery>;
export type DashboardFullTaskLazyQueryHookResult = ReturnType<typeof useDashboardFullTaskLazyQuery>;
export type DashboardFullTaskQueryResult = Apollo.QueryResult<DashboardFullTaskQuery, DashboardFullTaskQueryVariables>;
export function refetchDashboardFullTaskQuery(variables: DashboardFullTaskQueryVariables) {
      return { query: DashboardFullTaskDocument, variables: variables }
    }
export const DashboardTaskFormTemplateDocument = gql`
    query dashboardTaskFormTemplate($id: ID!) {
  data: task(id: $id) {
    id
    name
    status
    formTemplate {
      ...formTemplateFragment
      canUpdate {
        value
      }
    }
    formTemplateVersion {
      id
      version
      ...questionsFragment
      canUpdate {
        value
      }
    }
    ...canActionsTaskFragment
  }
}
    ${FormTemplateFragmentFragmentDoc}
${QuestionsFragmentFragmentDoc}
${CanActionsTaskFragmentFragmentDoc}`;

/**
 * __useDashboardTaskFormTemplateQuery__
 *
 * To run a query within a React component, call `useDashboardTaskFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskFormTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTaskFormTemplateQuery(baseOptions: Apollo.QueryHookOptions<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>(DashboardTaskFormTemplateDocument, options);
      }
export function useDashboardTaskFormTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>(DashboardTaskFormTemplateDocument, options);
        }
export type DashboardTaskFormTemplateQueryHookResult = ReturnType<typeof useDashboardTaskFormTemplateQuery>;
export type DashboardTaskFormTemplateLazyQueryHookResult = ReturnType<typeof useDashboardTaskFormTemplateLazyQuery>;
export type DashboardTaskFormTemplateQueryResult = Apollo.QueryResult<DashboardTaskFormTemplateQuery, DashboardTaskFormTemplateQueryVariables>;
export function refetchDashboardTaskFormTemplateQuery(variables: DashboardTaskFormTemplateQueryVariables) {
      return { query: DashboardTaskFormTemplateDocument, variables: variables }
    }
export const DashboardTaskScheduleDocument = gql`
    query dashboardTaskSchedule($id: ID!) {
  data: task(id: $id) {
    id
    kind
    deadlineAt
    ...earlyCompletionFragment
    recurringRule {
      ...recurringRuleFragment
    }
  }
}
    ${EarlyCompletionFragmentFragmentDoc}
${RecurringRuleFragmentFragmentDoc}`;

/**
 * __useDashboardTaskScheduleQuery__
 *
 * To run a query within a React component, call `useDashboardTaskScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTaskScheduleQuery(baseOptions: Apollo.QueryHookOptions<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>(DashboardTaskScheduleDocument, options);
      }
export function useDashboardTaskScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>(DashboardTaskScheduleDocument, options);
        }
export type DashboardTaskScheduleQueryHookResult = ReturnType<typeof useDashboardTaskScheduleQuery>;
export type DashboardTaskScheduleLazyQueryHookResult = ReturnType<typeof useDashboardTaskScheduleLazyQuery>;
export type DashboardTaskScheduleQueryResult = Apollo.QueryResult<DashboardTaskScheduleQuery, DashboardTaskScheduleQueryVariables>;
export function refetchDashboardTaskScheduleQuery(variables: DashboardTaskScheduleQueryVariables) {
      return { query: DashboardTaskScheduleDocument, variables: variables }
    }
export const DashboardTaskShortDocument = gql`
    query dashboardTaskShort($id: ID!) {
  data: task(id: $id) {
    id
    name
    assetId
    siteId
    siteAreaId
    groupKey
    formTemplate {
      id
    }
    formTemplateVersion {
      id
      version
    }
    canInterventionCreate {
      ...authorizationResultFragment
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useDashboardTaskShortQuery__
 *
 * To run a query within a React component, call `useDashboardTaskShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskShortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTaskShortQuery(baseOptions: Apollo.QueryHookOptions<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>(DashboardTaskShortDocument, options);
      }
export function useDashboardTaskShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>(DashboardTaskShortDocument, options);
        }
export type DashboardTaskShortQueryHookResult = ReturnType<typeof useDashboardTaskShortQuery>;
export type DashboardTaskShortLazyQueryHookResult = ReturnType<typeof useDashboardTaskShortLazyQuery>;
export type DashboardTaskShortQueryResult = Apollo.QueryResult<DashboardTaskShortQuery, DashboardTaskShortQueryVariables>;
export function refetchDashboardTaskShortQuery(variables: DashboardTaskShortQueryVariables) {
      return { query: DashboardTaskShortDocument, variables: variables }
    }
export const DashboardTasksDocument = gql`
    query dashboardTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject, $includeArchivedAt: Boolean = false, $includeCompletedAt: Boolean = false, $includeCompletion: Boolean = false, $includeDeadlineAt: Boolean = false, $includeDeadlineMissedReason: Boolean = false, $includeFormTemplate: Boolean = false, $includeLastCheckAt: Boolean = false, $includeLateFor: Boolean = false, $includeAsset: Boolean = false) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      priority
      status
      kind
      recurringRuleId
      canArchive {
        ...authorizationResultFragment
      }
      canDestroy {
        ...authorizationResultFragment
      }
      canUpdate {
        ...authorizationResultFragment
      }
      canReschedule {
        ...authorizationResultFragment
      }
      asset @include(if: $includeAsset) {
        id
        name
        fullCode
        siteArea {
          code
        }
        iconAttached {
          ...attachmentFragment
        }
      }
      deadlineAt @include(if: $includeDeadlineAt)
      lastCheckAt @include(if: $includeLastCheckAt)
      archivedAt @include(if: $includeArchivedAt)
      completedAt @include(if: $includeCompletedAt)
      lateFor @include(if: $includeLateFor)
      deadlineMissedReason @include(if: $includeDeadlineMissedReason)
      formTemplate @include(if: $includeFormTemplate) {
        id
        category {
          id
          name
          color
        }
      }
      completion @include(if: $includeCompletion) {
        validityHint
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  active: tasks(scope: {name: ACTIVE}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  archived: tasks(scope: {name: ARCHIVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  completed: tasks(scope: {name: COMPLETED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  myApprovals: tasks(scope: {name: MY_APPROVALS}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  pending: tasks(scope: {name: PENDING}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  deadlineMissed: tasks(scope: {name: DEADLINE_MISSED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDashboardTasksQuery__
 *
 * To run a query within a React component, call `useDashboardTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      includeArchivedAt: // value for 'includeArchivedAt'
 *      includeCompletedAt: // value for 'includeCompletedAt'
 *      includeCompletion: // value for 'includeCompletion'
 *      includeDeadlineAt: // value for 'includeDeadlineAt'
 *      includeDeadlineMissedReason: // value for 'includeDeadlineMissedReason'
 *      includeFormTemplate: // value for 'includeFormTemplate'
 *      includeLastCheckAt: // value for 'includeLastCheckAt'
 *      includeLateFor: // value for 'includeLateFor'
 *      includeAsset: // value for 'includeAsset'
 *   },
 * });
 */
export function useDashboardTasksQuery(baseOptions: Apollo.QueryHookOptions<DashboardTasksQuery, DashboardTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTasksQuery, DashboardTasksQueryVariables>(DashboardTasksDocument, options);
      }
export function useDashboardTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTasksQuery, DashboardTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTasksQuery, DashboardTasksQueryVariables>(DashboardTasksDocument, options);
        }
export type DashboardTasksQueryHookResult = ReturnType<typeof useDashboardTasksQuery>;
export type DashboardTasksLazyQueryHookResult = ReturnType<typeof useDashboardTasksLazyQuery>;
export type DashboardTasksQueryResult = Apollo.QueryResult<DashboardTasksQuery, DashboardTasksQueryVariables>;
export function refetchDashboardTasksQuery(variables: DashboardTasksQueryVariables) {
      return { query: DashboardTasksDocument, variables: variables }
    }
export const FormTemplateTasksDocument = gql`
    query formTemplateTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      status
      recurringRuleId
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      asset {
        id
        name
        fullCode
        siteArea {
          code
        }
        iconAttached {
          ...attachmentFragment
        }
      }
      formTemplateVersion {
        id
        version
      }
      formTemplate {
        id
      }
      canFormTemplateVersionUpdate {
        value
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useFormTemplateTasksQuery__
 *
 * To run a query within a React component, call `useFormTemplateTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTemplateTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTemplateTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useFormTemplateTasksQuery(baseOptions: Apollo.QueryHookOptions<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>(FormTemplateTasksDocument, options);
      }
export function useFormTemplateTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>(FormTemplateTasksDocument, options);
        }
export type FormTemplateTasksQueryHookResult = ReturnType<typeof useFormTemplateTasksQuery>;
export type FormTemplateTasksLazyQueryHookResult = ReturnType<typeof useFormTemplateTasksLazyQuery>;
export type FormTemplateTasksQueryResult = Apollo.QueryResult<FormTemplateTasksQuery, FormTemplateTasksQueryVariables>;
export function refetchFormTemplateTasksQuery(variables: FormTemplateTasksQueryVariables) {
      return { query: FormTemplateTasksDocument, variables: variables }
    }
export const DashboardTaskIdsDocument = gql`
    query dashboardTaskIds($scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject, $onlyIds: Boolean) {
  data: tasks(scope: $scope, filters: $filters, sorts: $sorts, onlyIds: $onlyIds) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useDashboardTaskIdsQuery__
 *
 * To run a query within a React component, call `useDashboardTaskIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaskIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaskIdsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useDashboardTaskIdsQuery(baseOptions: Apollo.QueryHookOptions<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>(DashboardTaskIdsDocument, options);
      }
export function useDashboardTaskIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>(DashboardTaskIdsDocument, options);
        }
export type DashboardTaskIdsQueryHookResult = ReturnType<typeof useDashboardTaskIdsQuery>;
export type DashboardTaskIdsLazyQueryHookResult = ReturnType<typeof useDashboardTaskIdsLazyQuery>;
export type DashboardTaskIdsQueryResult = Apollo.QueryResult<DashboardTaskIdsQuery, DashboardTaskIdsQueryVariables>;
export function refetchDashboardTaskIdsQuery(variables: DashboardTaskIdsQueryVariables) {
      return { query: DashboardTaskIdsDocument, variables: variables }
    }
export const DashboardOverviewTasksDocument = gql`
    query dashboardOverviewTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $activeTasksFilters: [TaskFilterInputObject!], $sorts: TaskSortInputObject, $includeCompletion: Boolean = false, $includeStatus: Boolean = false) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      deadlineAt
      nextDeadlineAt
      completedAt
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      assetId
      priority
      status @include(if: $includeStatus)
      recurringRuleId
      completion @include(if: $includeCompletion) {
        id
        validityHint
        status
        solvedAt
        canStatusUpdate {
          ...authorizationResultFragment
        }
      }
      intervention {
        id
        closedAt
      }
      canInterventionCreate {
        ...authorizationResultFragment
      }
      canCompletionCreate {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
  active: tasks(scope: {name: ACTIVE}, filters: $activeTasksFilters) {
    metadata {
      totalCount
    }
  }
  completed: tasks(scope: {name: COMPLETED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  failure: tasks(scope: {name: FAILURE}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  solved: tasks(scope: {name: SOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  success: tasks(scope: {name: SUCCESS}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  warning: tasks(scope: {name: WARNING}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  warningUnsolved: tasks(scope: {name: WARNING_UNSOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  warningSolved: tasks(scope: {name: WARNING_SOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  failureUnsolved: tasks(scope: {name: FAILURE_UNSOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  failureSolved: tasks(scope: {name: FAILURE_SOLVED}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  dashboardAll: tasks(scope: {name: DASHBOARD_ALL}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  deadlineMissedWithoutReason: tasks(
    scope: {name: DEADLINE_MISSED_WITHOUT_REASON}
    filters: $activeTasksFilters
  ) {
    metadata {
      totalCount
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useDashboardOverviewTasksQuery__
 *
 * To run a query within a React component, call `useDashboardOverviewTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardOverviewTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardOverviewTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      activeTasksFilters: // value for 'activeTasksFilters'
 *      sorts: // value for 'sorts'
 *      includeCompletion: // value for 'includeCompletion'
 *      includeStatus: // value for 'includeStatus'
 *   },
 * });
 */
export function useDashboardOverviewTasksQuery(baseOptions: Apollo.QueryHookOptions<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>(DashboardOverviewTasksDocument, options);
      }
export function useDashboardOverviewTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>(DashboardOverviewTasksDocument, options);
        }
export type DashboardOverviewTasksQueryHookResult = ReturnType<typeof useDashboardOverviewTasksQuery>;
export type DashboardOverviewTasksLazyQueryHookResult = ReturnType<typeof useDashboardOverviewTasksLazyQuery>;
export type DashboardOverviewTasksQueryResult = Apollo.QueryResult<DashboardOverviewTasksQuery, DashboardOverviewTasksQueryVariables>;
export function refetchDashboardOverviewTasksQuery(variables: DashboardOverviewTasksQueryVariables) {
      return { query: DashboardOverviewTasksDocument, variables: variables }
    }
export const DashboardTimelineTasksDocument = gql`
    query dashboardTimelineTasks($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      deadlineAt
      completedAt
      archivedAt
      formTemplate {
        id
        category {
          id
          name
          color
        }
      }
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      priority
      status
      recurringRuleId
    }
    metadata {
      ...metadataFragment
    }
  }
  taskIds: tasks(scope: $scope, filters: $filters, sorts: $sorts, onlyIds: true) {
    collection {
      id
    }
  }
  timelineAll: tasks(scope: {name: DASHBOARD_ALL}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  timelineFailure: tasks(scope: {name: FAILURE}, filters: $filters) {
    metadata {
      totalCount
    }
  }
  timelineWarning: tasks(scope: {name: WARNING}, filters: $filters) {
    metadata {
      totalCount
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useDashboardTimelineTasksQuery__
 *
 * To run a query within a React component, call `useDashboardTimelineTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTimelineTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTimelineTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useDashboardTimelineTasksQuery(baseOptions: Apollo.QueryHookOptions<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>(DashboardTimelineTasksDocument, options);
      }
export function useDashboardTimelineTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>(DashboardTimelineTasksDocument, options);
        }
export type DashboardTimelineTasksQueryHookResult = ReturnType<typeof useDashboardTimelineTasksQuery>;
export type DashboardTimelineTasksLazyQueryHookResult = ReturnType<typeof useDashboardTimelineTasksLazyQuery>;
export type DashboardTimelineTasksQueryResult = Apollo.QueryResult<DashboardTimelineTasksQuery, DashboardTimelineTasksQueryVariables>;
export function refetchDashboardTimelineTasksQuery(variables: DashboardTimelineTasksQueryVariables) {
      return { query: DashboardTimelineTasksDocument, variables: variables }
    }
export const TasksTimelineDocument = gql`
    query tasksTimeline($taskIds: [ID!]!, $queryData: TaskTimelineQueryDataInputObject!) {
  tasksTimeline(taskIds: $taskIds, queryData: $queryData) {
    id
    rows {
      date
      validityHintCounters {
        failure
        none
        success
        warning
      }
    }
  }
}
    `;

/**
 * __useTasksTimelineQuery__
 *
 * To run a query within a React component, call `useTasksTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksTimelineQuery({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      queryData: // value for 'queryData'
 *   },
 * });
 */
export function useTasksTimelineQuery(baseOptions: Apollo.QueryHookOptions<TasksTimelineQuery, TasksTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksTimelineQuery, TasksTimelineQueryVariables>(TasksTimelineDocument, options);
      }
export function useTasksTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksTimelineQuery, TasksTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksTimelineQuery, TasksTimelineQueryVariables>(TasksTimelineDocument, options);
        }
export type TasksTimelineQueryHookResult = ReturnType<typeof useTasksTimelineQuery>;
export type TasksTimelineLazyQueryHookResult = ReturnType<typeof useTasksTimelineLazyQuery>;
export type TasksTimelineQueryResult = Apollo.QueryResult<TasksTimelineQuery, TasksTimelineQueryVariables>;
export function refetchTasksTimelineQuery(variables: TasksTimelineQueryVariables) {
      return { query: TasksTimelineDocument, variables: variables }
    }
export const TasksSearchListDocument = gql`
    query tasksSearchList($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  data: tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useTasksSearchListQuery__
 *
 * To run a query within a React component, call `useTasksSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTasksSearchListQuery(baseOptions: Apollo.QueryHookOptions<TasksSearchListQuery, TasksSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksSearchListQuery, TasksSearchListQueryVariables>(TasksSearchListDocument, options);
      }
export function useTasksSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksSearchListQuery, TasksSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksSearchListQuery, TasksSearchListQueryVariables>(TasksSearchListDocument, options);
        }
export type TasksSearchListQueryHookResult = ReturnType<typeof useTasksSearchListQuery>;
export type TasksSearchListLazyQueryHookResult = ReturnType<typeof useTasksSearchListLazyQuery>;
export type TasksSearchListQueryResult = Apollo.QueryResult<TasksSearchListQuery, TasksSearchListQueryVariables>;
export function refetchTasksSearchListQuery(variables: TasksSearchListQueryVariables) {
      return { query: TasksSearchListDocument, variables: variables }
    }
export const TaskCompletionsDocument = gql`
    query taskCompletions($page: Int, $limit: Int, $groupKey: ID!, $filters: [TaskCompletionFilterInputObject!], $sorts: TaskCompletionSortInputObject) {
  data: taskCompletions(
    page: $page
    limit: $limit
    groupKey: $groupKey
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      taskId
      createdAt
      solvedAt
      status
      answers {
        id
        validityHint
        resp {
          selected
          value
          valueId
        }
      }
      task {
        assetId
        siteAreaId
        siteId
        formTemplateVersion {
          id
          version
        }
        canInterventionCreate {
          ...authorizationResultFragment
        }
        intervention {
          id
        }
      }
      performer {
        id
        firstName
        lastName
        avatarAttached {
          ...attachmentFragment
        }
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useTaskCompletionsQuery__
 *
 * To run a query within a React component, call `useTaskCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCompletionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      groupKey: // value for 'groupKey'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTaskCompletionsQuery(baseOptions: Apollo.QueryHookOptions<TaskCompletionsQuery, TaskCompletionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskCompletionsQuery, TaskCompletionsQueryVariables>(TaskCompletionsDocument, options);
      }
export function useTaskCompletionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskCompletionsQuery, TaskCompletionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskCompletionsQuery, TaskCompletionsQueryVariables>(TaskCompletionsDocument, options);
        }
export type TaskCompletionsQueryHookResult = ReturnType<typeof useTaskCompletionsQuery>;
export type TaskCompletionsLazyQueryHookResult = ReturnType<typeof useTaskCompletionsLazyQuery>;
export type TaskCompletionsQueryResult = Apollo.QueryResult<TaskCompletionsQuery, TaskCompletionsQueryVariables>;
export function refetchTaskCompletionsQuery(variables: TaskCompletionsQueryVariables) {
      return { query: TaskCompletionsDocument, variables: variables }
    }
export const TaskCompletionsIdsDocument = gql`
    query taskCompletionsIds($page: Int, $limit: Int, $groupKey: ID!, $filters: [TaskCompletionFilterInputObject!], $sorts: TaskCompletionSortInputObject) {
  data: taskCompletions(
    page: $page
    limit: $limit
    groupKey: $groupKey
    filters: $filters
    sorts: $sorts
    onlyIds: true
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useTaskCompletionsIdsQuery__
 *
 * To run a query within a React component, call `useTaskCompletionsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCompletionsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      groupKey: // value for 'groupKey'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTaskCompletionsIdsQuery(baseOptions: Apollo.QueryHookOptions<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>(TaskCompletionsIdsDocument, options);
      }
export function useTaskCompletionsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>(TaskCompletionsIdsDocument, options);
        }
export type TaskCompletionsIdsQueryHookResult = ReturnType<typeof useTaskCompletionsIdsQuery>;
export type TaskCompletionsIdsLazyQueryHookResult = ReturnType<typeof useTaskCompletionsIdsLazyQuery>;
export type TaskCompletionsIdsQueryResult = Apollo.QueryResult<TaskCompletionsIdsQuery, TaskCompletionsIdsQueryVariables>;
export function refetchTaskCompletionsIdsQuery(variables: TaskCompletionsIdsQueryVariables) {
      return { query: TaskCompletionsIdsDocument, variables: variables }
    }
export const TaskCompletionDocument = gql`
    query taskCompletion($id: ID!) {
  data: taskCompletion(id: $id) {
    id
    createdAt
    validityHint
    answers {
      id
      kind
      fieldId
      validityHint
      field {
        id
        options {
          id
          fieldId
          group
          position
          values
        }
      }
      questionId
      resp {
        validityHint
        group
        optionId
        position
        selected
        value
        valueId
      }
      attachmentsAttached {
        ...attachmentFragment
      }
    }
    task {
      assetId
      siteAreaId
      siteId
      formTemplateVersion {
        id
        version
        questions {
          id
          position
          attachmentsAttached {
            ...attachmentFragment
          }
          name
          fields {
            id
            kind
            required
            position
            options {
              id
              group
              position
              values
              validityHint
            }
            settings {
              limitToOneRespPerColumn
              limitToOneRespPerRow
              limitToOneResp
            }
          }
        }
      }
      canInterventionCreate {
        ...authorizationResultFragment
      }
      intervention {
        id
      }
    }
    performer {
      id
      firstName
      lastName
      avatarAttached {
        ...attachmentFragment
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${AuthorizationResultFragmentFragmentDoc}`;

/**
 * __useTaskCompletionQuery__
 *
 * To run a query within a React component, call `useTaskCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskCompletionQuery(baseOptions: Apollo.QueryHookOptions<TaskCompletionQuery, TaskCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskCompletionQuery, TaskCompletionQueryVariables>(TaskCompletionDocument, options);
      }
export function useTaskCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskCompletionQuery, TaskCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskCompletionQuery, TaskCompletionQueryVariables>(TaskCompletionDocument, options);
        }
export type TaskCompletionQueryHookResult = ReturnType<typeof useTaskCompletionQuery>;
export type TaskCompletionLazyQueryHookResult = ReturnType<typeof useTaskCompletionLazyQuery>;
export type TaskCompletionQueryResult = Apollo.QueryResult<TaskCompletionQuery, TaskCompletionQueryVariables>;
export function refetchTaskCompletionQuery(variables: TaskCompletionQueryVariables) {
      return { query: TaskCompletionDocument, variables: variables }
    }
export const TasksMyTodoCompletableByDateDataDocument = gql`
    query tasksMyTodoCompletableByDateData($date: ISO8601DateTime!) {
  data: tasksMyTodoCompletableByDateData(date: $date) {
    id
    offlineImportantDataDigest
  }
}
    `;

/**
 * __useTasksMyTodoCompletableByDateDataQuery__
 *
 * To run a query within a React component, call `useTasksMyTodoCompletableByDateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksMyTodoCompletableByDateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksMyTodoCompletableByDateDataQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTasksMyTodoCompletableByDateDataQuery(baseOptions: Apollo.QueryHookOptions<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>(TasksMyTodoCompletableByDateDataDocument, options);
      }
export function useTasksMyTodoCompletableByDateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>(TasksMyTodoCompletableByDateDataDocument, options);
        }
export type TasksMyTodoCompletableByDateDataQueryHookResult = ReturnType<typeof useTasksMyTodoCompletableByDateDataQuery>;
export type TasksMyTodoCompletableByDateDataLazyQueryHookResult = ReturnType<typeof useTasksMyTodoCompletableByDateDataLazyQuery>;
export type TasksMyTodoCompletableByDateDataQueryResult = Apollo.QueryResult<TasksMyTodoCompletableByDateDataQuery, TasksMyTodoCompletableByDateDataQueryVariables>;
export function refetchTasksMyTodoCompletableByDateDataQuery(variables: TasksMyTodoCompletableByDateDataQueryVariables) {
      return { query: TasksMyTodoCompletableByDateDataDocument, variables: variables }
    }
export const TasksDuplicationListDocument = gql`
    query tasksDuplicationList($page: Int, $limit: Int, $scope: TaskScopeInputObject!, $filters: [TaskFilterInputObject!], $sorts: TaskSortInputObject) {
  tasks(
    page: $page
    limit: $limit
    scope: $scope
    filters: $filters
    sorts: $sorts
  ) {
    collection {
      id
      name
      status
      site {
        id
        name
      }
      siteArea {
        id
        name
      }
      formTemplate {
        category {
          ...formCategoryFragment
        }
        id
        name
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${FormCategoryFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useTasksDuplicationListQuery__
 *
 * To run a query within a React component, call `useTasksDuplicationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksDuplicationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksDuplicationListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      scope: // value for 'scope'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useTasksDuplicationListQuery(baseOptions: Apollo.QueryHookOptions<TasksDuplicationListQuery, TasksDuplicationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksDuplicationListQuery, TasksDuplicationListQueryVariables>(TasksDuplicationListDocument, options);
      }
export function useTasksDuplicationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksDuplicationListQuery, TasksDuplicationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksDuplicationListQuery, TasksDuplicationListQueryVariables>(TasksDuplicationListDocument, options);
        }
export type TasksDuplicationListQueryHookResult = ReturnType<typeof useTasksDuplicationListQuery>;
export type TasksDuplicationListLazyQueryHookResult = ReturnType<typeof useTasksDuplicationListLazyQuery>;
export type TasksDuplicationListQueryResult = Apollo.QueryResult<TasksDuplicationListQuery, TasksDuplicationListQueryVariables>;
export function refetchTasksDuplicationListQuery(variables: TasksDuplicationListQueryVariables) {
      return { query: TasksDuplicationListDocument, variables: variables }
    }
export const TaskCompletionCreateDocument = gql`
    mutation taskCompletionCreate($input: TaskCompletionCreateInputObject!) {
  taskCompletionCreate(input: {attributes: $input}) {
    id
  }
}
    `;
export type TaskCompletionCreateMutationFn = Apollo.MutationFunction<TaskCompletionCreateMutation, TaskCompletionCreateMutationVariables>;

/**
 * __useTaskCompletionCreateMutation__
 *
 * To run a mutation, you first call `useTaskCompletionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskCompletionCreateMutation, { data, loading, error }] = useTaskCompletionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskCompletionCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskCompletionCreateMutation, TaskCompletionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskCompletionCreateMutation, TaskCompletionCreateMutationVariables>(TaskCompletionCreateDocument, options);
      }
export type TaskCompletionCreateMutationHookResult = ReturnType<typeof useTaskCompletionCreateMutation>;
export type TaskCompletionCreateMutationResult = Apollo.MutationResult<TaskCompletionCreateMutation>;
export type TaskCompletionCreateMutationOptions = Apollo.BaseMutationOptions<TaskCompletionCreateMutation, TaskCompletionCreateMutationVariables>;
export const TaskBulkCreateSameDocument = gql`
    mutation taskBulkCreateSame($attributes: TaskBulkCreateSameInputObject!) {
  data: taskBulkCreateSame(input: {attributes: $attributes})
}
    `;
export type TaskBulkCreateSameMutationFn = Apollo.MutationFunction<TaskBulkCreateSameMutation, TaskBulkCreateSameMutationVariables>;

/**
 * __useTaskBulkCreateSameMutation__
 *
 * To run a mutation, you first call `useTaskBulkCreateSameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkCreateSameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkCreateSameMutation, { data, loading, error }] = useTaskBulkCreateSameMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkCreateSameMutation(baseOptions?: Apollo.MutationHookOptions<TaskBulkCreateSameMutation, TaskBulkCreateSameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBulkCreateSameMutation, TaskBulkCreateSameMutationVariables>(TaskBulkCreateSameDocument, options);
      }
export type TaskBulkCreateSameMutationHookResult = ReturnType<typeof useTaskBulkCreateSameMutation>;
export type TaskBulkCreateSameMutationResult = Apollo.MutationResult<TaskBulkCreateSameMutation>;
export type TaskBulkCreateSameMutationOptions = Apollo.BaseMutationOptions<TaskBulkCreateSameMutation, TaskBulkCreateSameMutationVariables>;
export const TaskUpdateDocument = gql`
    mutation taskUpdate($attributes: TaskUpdateInputObject!, $id: ID!) {
  data: taskUpdate(input: {attributes: $attributes, id: $id}) {
    ...taskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;
export type TaskUpdateMutationFn = Apollo.MutationFunction<TaskUpdateMutation, TaskUpdateMutationVariables>;

/**
 * __useTaskUpdateMutation__
 *
 * To run a mutation, you first call `useTaskUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskUpdateMutation, { data, loading, error }] = useTaskUpdateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskUpdateMutation, TaskUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskUpdateMutation, TaskUpdateMutationVariables>(TaskUpdateDocument, options);
      }
export type TaskUpdateMutationHookResult = ReturnType<typeof useTaskUpdateMutation>;
export type TaskUpdateMutationResult = Apollo.MutationResult<TaskUpdateMutation>;
export type TaskUpdateMutationOptions = Apollo.BaseMutationOptions<TaskUpdateMutation, TaskUpdateMutationVariables>;
export const TaskBulkSchedulingDocument = gql`
    mutation taskBulkScheduling($ids: [ID!]!, $attributes: TaskBulkSchedulingInputObject!) {
  data: taskBulkScheduling(input: {ids: $ids, attributes: $attributes})
}
    `;
export type TaskBulkSchedulingMutationFn = Apollo.MutationFunction<TaskBulkSchedulingMutation, TaskBulkSchedulingMutationVariables>;

/**
 * __useTaskBulkSchedulingMutation__
 *
 * To run a mutation, you first call `useTaskBulkSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkSchedulingMutation, { data, loading, error }] = useTaskBulkSchedulingMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<TaskBulkSchedulingMutation, TaskBulkSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBulkSchedulingMutation, TaskBulkSchedulingMutationVariables>(TaskBulkSchedulingDocument, options);
      }
export type TaskBulkSchedulingMutationHookResult = ReturnType<typeof useTaskBulkSchedulingMutation>;
export type TaskBulkSchedulingMutationResult = Apollo.MutationResult<TaskBulkSchedulingMutation>;
export type TaskBulkSchedulingMutationOptions = Apollo.BaseMutationOptions<TaskBulkSchedulingMutation, TaskBulkSchedulingMutationVariables>;
export const TaskBulkUpdateStatusDocument = gql`
    mutation taskBulkUpdateStatus($ids: [ID!]!, $attributes: TaskUpdateStatusInputObject!) {
  data: taskBulkUpdateStatus(input: {ids: $ids, attributes: $attributes})
}
    `;
export type TaskBulkUpdateStatusMutationFn = Apollo.MutationFunction<TaskBulkUpdateStatusMutation, TaskBulkUpdateStatusMutationVariables>;

/**
 * __useTaskBulkUpdateStatusMutation__
 *
 * To run a mutation, you first call `useTaskBulkUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkUpdateStatusMutation, { data, loading, error }] = useTaskBulkUpdateStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<TaskBulkUpdateStatusMutation, TaskBulkUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBulkUpdateStatusMutation, TaskBulkUpdateStatusMutationVariables>(TaskBulkUpdateStatusDocument, options);
      }
export type TaskBulkUpdateStatusMutationHookResult = ReturnType<typeof useTaskBulkUpdateStatusMutation>;
export type TaskBulkUpdateStatusMutationResult = Apollo.MutationResult<TaskBulkUpdateStatusMutation>;
export type TaskBulkUpdateStatusMutationOptions = Apollo.BaseMutationOptions<TaskBulkUpdateStatusMutation, TaskBulkUpdateStatusMutationVariables>;
export const TaskBulkDeadlineMissedReasonUpdateDocument = gql`
    mutation taskBulkDeadlineMissedReasonUpdate($ids: [ID!]!, $attributes: TaskUpdateDeadlineMissedReasonInputObject!) {
  data: taskBulkDeadlineMissedReasonUpdate(
    input: {ids: $ids, attributes: $attributes}
  )
}
    `;
export type TaskBulkDeadlineMissedReasonUpdateMutationFn = Apollo.MutationFunction<TaskBulkDeadlineMissedReasonUpdateMutation, TaskBulkDeadlineMissedReasonUpdateMutationVariables>;

/**
 * __useTaskBulkDeadlineMissedReasonUpdateMutation__
 *
 * To run a mutation, you first call `useTaskBulkDeadlineMissedReasonUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkDeadlineMissedReasonUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkDeadlineMissedReasonUpdateMutation, { data, loading, error }] = useTaskBulkDeadlineMissedReasonUpdateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskBulkDeadlineMissedReasonUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskBulkDeadlineMissedReasonUpdateMutation, TaskBulkDeadlineMissedReasonUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBulkDeadlineMissedReasonUpdateMutation, TaskBulkDeadlineMissedReasonUpdateMutationVariables>(TaskBulkDeadlineMissedReasonUpdateDocument, options);
      }
export type TaskBulkDeadlineMissedReasonUpdateMutationHookResult = ReturnType<typeof useTaskBulkDeadlineMissedReasonUpdateMutation>;
export type TaskBulkDeadlineMissedReasonUpdateMutationResult = Apollo.MutationResult<TaskBulkDeadlineMissedReasonUpdateMutation>;
export type TaskBulkDeadlineMissedReasonUpdateMutationOptions = Apollo.BaseMutationOptions<TaskBulkDeadlineMissedReasonUpdateMutation, TaskBulkDeadlineMissedReasonUpdateMutationVariables>;
export const TaskDestroyDocument = gql`
    mutation taskDestroy($id: ID!) {
  data: taskDestroy(input: {id: $id})
}
    `;
export type TaskDestroyMutationFn = Apollo.MutationFunction<TaskDestroyMutation, TaskDestroyMutationVariables>;

/**
 * __useTaskDestroyMutation__
 *
 * To run a mutation, you first call `useTaskDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskDestroyMutation, { data, loading, error }] = useTaskDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskDestroyMutation(baseOptions?: Apollo.MutationHookOptions<TaskDestroyMutation, TaskDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskDestroyMutation, TaskDestroyMutationVariables>(TaskDestroyDocument, options);
      }
export type TaskDestroyMutationHookResult = ReturnType<typeof useTaskDestroyMutation>;
export type TaskDestroyMutationResult = Apollo.MutationResult<TaskDestroyMutation>;
export type TaskDestroyMutationOptions = Apollo.BaseMutationOptions<TaskDestroyMutation, TaskDestroyMutationVariables>;
export const TaskCompletionStatusUpdateDocument = gql`
    mutation taskCompletionStatusUpdate($taskId: ID!, $attributes: TaskCompletionUpdateStatusInputObject!) {
  data: taskCompletionStatusUpdate(
    input: {taskId: $taskId, attributes: $attributes}
  ) {
    id
  }
}
    `;
export type TaskCompletionStatusUpdateMutationFn = Apollo.MutationFunction<TaskCompletionStatusUpdateMutation, TaskCompletionStatusUpdateMutationVariables>;

/**
 * __useTaskCompletionStatusUpdateMutation__
 *
 * To run a mutation, you first call `useTaskCompletionStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskCompletionStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskCompletionStatusUpdateMutation, { data, loading, error }] = useTaskCompletionStatusUpdateMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTaskCompletionStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskCompletionStatusUpdateMutation, TaskCompletionStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskCompletionStatusUpdateMutation, TaskCompletionStatusUpdateMutationVariables>(TaskCompletionStatusUpdateDocument, options);
      }
export type TaskCompletionStatusUpdateMutationHookResult = ReturnType<typeof useTaskCompletionStatusUpdateMutation>;
export type TaskCompletionStatusUpdateMutationResult = Apollo.MutationResult<TaskCompletionStatusUpdateMutation>;
export type TaskCompletionStatusUpdateMutationOptions = Apollo.BaseMutationOptions<TaskCompletionStatusUpdateMutation, TaskCompletionStatusUpdateMutationVariables>;
export const TaskBulkTemplateVersionUpdateDocument = gql`
    mutation taskBulkTemplateVersionUpdate($input: TaskBulkTemplateVersionUpdateInput!) {
  data: taskBulkTemplateVersionUpdate(input: $input)
}
    `;
export type TaskBulkTemplateVersionUpdateMutationFn = Apollo.MutationFunction<TaskBulkTemplateVersionUpdateMutation, TaskBulkTemplateVersionUpdateMutationVariables>;

/**
 * __useTaskBulkTemplateVersionUpdateMutation__
 *
 * To run a mutation, you first call `useTaskBulkTemplateVersionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBulkTemplateVersionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBulkTemplateVersionUpdateMutation, { data, loading, error }] = useTaskBulkTemplateVersionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskBulkTemplateVersionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskBulkTemplateVersionUpdateMutation, TaskBulkTemplateVersionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskBulkTemplateVersionUpdateMutation, TaskBulkTemplateVersionUpdateMutationVariables>(TaskBulkTemplateVersionUpdateDocument, options);
      }
export type TaskBulkTemplateVersionUpdateMutationHookResult = ReturnType<typeof useTaskBulkTemplateVersionUpdateMutation>;
export type TaskBulkTemplateVersionUpdateMutationResult = Apollo.MutationResult<TaskBulkTemplateVersionUpdateMutation>;
export type TaskBulkTemplateVersionUpdateMutationOptions = Apollo.BaseMutationOptions<TaskBulkTemplateVersionUpdateMutation, TaskBulkTemplateVersionUpdateMutationVariables>;
export const TaskTimelineReportCreateDocument = gql`
    mutation taskTimelineReportCreate($input: TasksTimelineReportCreateInput!) {
  data: taskTimelineReportCreate(input: $input) {
    ...jobFragment
  }
}
    ${JobFragmentFragmentDoc}`;
export type TaskTimelineReportCreateMutationFn = Apollo.MutationFunction<TaskTimelineReportCreateMutation, TaskTimelineReportCreateMutationVariables>;

/**
 * __useTaskTimelineReportCreateMutation__
 *
 * To run a mutation, you first call `useTaskTimelineReportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskTimelineReportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskTimelineReportCreateMutation, { data, loading, error }] = useTaskTimelineReportCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskTimelineReportCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskTimelineReportCreateMutation, TaskTimelineReportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskTimelineReportCreateMutation, TaskTimelineReportCreateMutationVariables>(TaskTimelineReportCreateDocument, options);
      }
export type TaskTimelineReportCreateMutationHookResult = ReturnType<typeof useTaskTimelineReportCreateMutation>;
export type TaskTimelineReportCreateMutationResult = Apollo.MutationResult<TaskTimelineReportCreateMutation>;
export type TaskTimelineReportCreateMutationOptions = Apollo.BaseMutationOptions<TaskTimelineReportCreateMutation, TaskTimelineReportCreateMutationVariables>;
export const TeamsDocument = gql`
    query teams($page: Int, $limit: Int, $sorts: TeamSortInputObject, $filters: [TeamFilterInputObject!]) {
  data: teams(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      color
      visibleUsersCount
      readOnly
      canDestroy {
        ...authorizationResultFragment
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AuthorizationResultFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export function refetchTeamsQuery(variables?: TeamsQueryVariables) {
      return { query: TeamsDocument, variables: variables }
    }
export const TeamsIdsDocument = gql`
    query teamsIds($page: Int, $limit: Int, $sorts: TeamSortInputObject, $filters: [TeamFilterInputObject!], $onlyIds: Boolean) {
  data: teams(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useTeamsIdsQuery__
 *
 * To run a query within a React component, call `useTeamsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useTeamsIdsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsIdsQuery, TeamsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsIdsQuery, TeamsIdsQueryVariables>(TeamsIdsDocument, options);
      }
export function useTeamsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsIdsQuery, TeamsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsIdsQuery, TeamsIdsQueryVariables>(TeamsIdsDocument, options);
        }
export type TeamsIdsQueryHookResult = ReturnType<typeof useTeamsIdsQuery>;
export type TeamsIdsLazyQueryHookResult = ReturnType<typeof useTeamsIdsLazyQuery>;
export type TeamsIdsQueryResult = Apollo.QueryResult<TeamsIdsQuery, TeamsIdsQueryVariables>;
export function refetchTeamsIdsQuery(variables?: TeamsIdsQueryVariables) {
      return { query: TeamsIdsDocument, variables: variables }
    }
export const TeamsSearchListDocument = gql`
    query teamsSearchList($page: Int, $limit: Int, $sorts: TeamSortInputObject, $filters: [TeamFilterInputObject!]) {
  data: teams(page: $page, limit: $limit, sorts: $sorts, filters: $filters) {
    collection {
      id
      name
      color
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${MetadataFragmentFragmentDoc}`;

/**
 * __useTeamsSearchListQuery__
 *
 * To run a query within a React component, call `useTeamsSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTeamsSearchListQuery(baseOptions?: Apollo.QueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
      }
export function useTeamsSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsSearchListQuery, TeamsSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsSearchListQuery, TeamsSearchListQueryVariables>(TeamsSearchListDocument, options);
        }
export type TeamsSearchListQueryHookResult = ReturnType<typeof useTeamsSearchListQuery>;
export type TeamsSearchListLazyQueryHookResult = ReturnType<typeof useTeamsSearchListLazyQuery>;
export type TeamsSearchListQueryResult = Apollo.QueryResult<TeamsSearchListQuery, TeamsSearchListQueryVariables>;
export function refetchTeamsSearchListQuery(variables?: TeamsSearchListQueryVariables) {
      return { query: TeamsSearchListDocument, variables: variables }
    }
export const TeamDocument = gql`
    query team($id: ID!) {
  data: team(id: $id) {
    ...teamFragment
  }
}
    ${TeamFragmentFragmentDoc}`;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export function refetchTeamQuery(variables: TeamQueryVariables) {
      return { query: TeamDocument, variables: variables }
    }
export const TeamCreateDocument = gql`
    mutation teamCreate($attributes: TeamCreateInputObject!) {
  data: teamCreate(input: {attributes: $attributes}) {
    ...teamFragment
  }
}
    ${TeamFragmentFragmentDoc}`;
export type TeamCreateMutationFn = Apollo.MutationFunction<TeamCreateMutation, TeamCreateMutationVariables>;

/**
 * __useTeamCreateMutation__
 *
 * To run a mutation, you first call `useTeamCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamCreateMutation, { data, loading, error }] = useTeamCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTeamCreateMutation(baseOptions?: Apollo.MutationHookOptions<TeamCreateMutation, TeamCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamCreateMutation, TeamCreateMutationVariables>(TeamCreateDocument, options);
      }
export type TeamCreateMutationHookResult = ReturnType<typeof useTeamCreateMutation>;
export type TeamCreateMutationResult = Apollo.MutationResult<TeamCreateMutation>;
export type TeamCreateMutationOptions = Apollo.BaseMutationOptions<TeamCreateMutation, TeamCreateMutationVariables>;
export const TeamUpdateDocument = gql`
    mutation teamUpdate($id: ID!, $attributes: TeamUpdateInputObject!) {
  data: teamUpdate(input: {id: $id, attributes: $attributes}) {
    ...teamFragment
  }
}
    ${TeamFragmentFragmentDoc}`;
export type TeamUpdateMutationFn = Apollo.MutationFunction<TeamUpdateMutation, TeamUpdateMutationVariables>;

/**
 * __useTeamUpdateMutation__
 *
 * To run a mutation, you first call `useTeamUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUpdateMutation, { data, loading, error }] = useTeamUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useTeamUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TeamUpdateMutation, TeamUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamUpdateMutation, TeamUpdateMutationVariables>(TeamUpdateDocument, options);
      }
export type TeamUpdateMutationHookResult = ReturnType<typeof useTeamUpdateMutation>;
export type TeamUpdateMutationResult = Apollo.MutationResult<TeamUpdateMutation>;
export type TeamUpdateMutationOptions = Apollo.BaseMutationOptions<TeamUpdateMutation, TeamUpdateMutationVariables>;
export const TeamDestroyDocument = gql`
    mutation teamDestroy($id: ID!) {
  data: teamDestroy(input: {id: $id})
}
    `;
export type TeamDestroyMutationFn = Apollo.MutationFunction<TeamDestroyMutation, TeamDestroyMutationVariables>;

/**
 * __useTeamDestroyMutation__
 *
 * To run a mutation, you first call `useTeamDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamDestroyMutation, { data, loading, error }] = useTeamDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamDestroyMutation(baseOptions?: Apollo.MutationHookOptions<TeamDestroyMutation, TeamDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamDestroyMutation, TeamDestroyMutationVariables>(TeamDestroyDocument, options);
      }
export type TeamDestroyMutationHookResult = ReturnType<typeof useTeamDestroyMutation>;
export type TeamDestroyMutationResult = Apollo.MutationResult<TeamDestroyMutation>;
export type TeamDestroyMutationOptions = Apollo.BaseMutationOptions<TeamDestroyMutation, TeamDestroyMutationVariables>;
export const UsersDocument = gql`
    query users($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject, $includeFullData: Boolean = false, $includeShortData: Boolean = false, $includeFinalAccesses: Boolean = false, $includePersonalAccesses: Boolean = false, $includeTeamAccesses: Boolean = false, $includeTeamData: Boolean = false) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
  ) {
    collection {
      avatarAttached {
        ...attachmentFragment
      }
      id
      firstName
      lastName
      email
      passwordSetupRequired @include(if: $includeFullData)
      passwordSetupRequired @include(if: $includeShortData)
      role
      personalId @include(if: $includeFullData)
      personalId @include(if: $includeShortData)
      sites @include(if: $includeFullData) {
        collection {
          id
          name
        }
      }
      sectors @include(if: $includeFullData) {
        collection {
          id
          name
          color
        }
      }
      unconfirmedEmail @include(if: $includeFullData)
      unconfirmedEmail @include(if: $includeShortData)
      verified @include(if: $includeFullData)
      verified @include(if: $includeShortData)
      deactivatedAt @include(if: $includeFullData)
      deactivatedAt @include(if: $includeShortData)
      team @include(if: $includeFullData) {
        id
        name
        color
      }
      team @include(if: $includeTeamData) {
        id
        name
        color
      }
      team @include(if: $includeTeamAccesses) {
        id
        name
        color
        accesses {
          component
          itemIds
          level
          scopeLevel
          policy
        }
      }
      finalAccesses @include(if: $includeFinalAccesses) {
        component
        itemIds
        level
        scopeLevel
        policy
      }
      personalAccesses @include(if: $includePersonalAccesses) {
        component
        itemIds
        level
        scopeLevel
        policy
      }
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *      includeFullData: // value for 'includeFullData'
 *      includeShortData: // value for 'includeShortData'
 *      includeFinalAccesses: // value for 'includeFinalAccesses'
 *      includePersonalAccesses: // value for 'includePersonalAccesses'
 *      includeTeamAccesses: // value for 'includeTeamAccesses'
 *      includeTeamData: // value for 'includeTeamData'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables?: UsersQueryVariables) {
      return { query: UsersDocument, variables: variables }
    }
export const UsersIdsDocument = gql`
    query usersIds($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject, $onlyIds: Boolean) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    collection {
      id
    }
  }
}
    `;

/**
 * __useUsersIdsQuery__
 *
 * To run a query within a React component, call `useUsersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersIdsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useUsersIdsQuery(baseOptions?: Apollo.QueryHookOptions<UsersIdsQuery, UsersIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersIdsQuery, UsersIdsQueryVariables>(UsersIdsDocument, options);
      }
export function useUsersIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersIdsQuery, UsersIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersIdsQuery, UsersIdsQueryVariables>(UsersIdsDocument, options);
        }
export type UsersIdsQueryHookResult = ReturnType<typeof useUsersIdsQuery>;
export type UsersIdsLazyQueryHookResult = ReturnType<typeof useUsersIdsLazyQuery>;
export type UsersIdsQueryResult = Apollo.QueryResult<UsersIdsQuery, UsersIdsQueryVariables>;
export function refetchUsersIdsQuery(variables?: UsersIdsQueryVariables) {
      return { query: UsersIdsDocument, variables: variables }
    }
export const UsersCountersDocument = gql`
    query usersCounters($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $fullAdminsFilters: [UserFilterInputObject!], $usersFilters: [UserFilterInputObject!], $unassignedFilters: [UserFilterInputObject!], $scope: UserScopeInputObject, $onlyIds: Boolean) {
  all: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
  fullAdmins: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $fullAdminsFilters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
  users: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $usersFilters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
  unassigned: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $unassignedFilters
    scope: $scope
    onlyIds: $onlyIds
  ) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useUsersCountersQuery__
 *
 * To run a query within a React component, call `useUsersCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersCountersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      fullAdminsFilters: // value for 'fullAdminsFilters'
 *      usersFilters: // value for 'usersFilters'
 *      unassignedFilters: // value for 'unassignedFilters'
 *      scope: // value for 'scope'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useUsersCountersQuery(baseOptions?: Apollo.QueryHookOptions<UsersCountersQuery, UsersCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersCountersQuery, UsersCountersQueryVariables>(UsersCountersDocument, options);
      }
export function useUsersCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersCountersQuery, UsersCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersCountersQuery, UsersCountersQueryVariables>(UsersCountersDocument, options);
        }
export type UsersCountersQueryHookResult = ReturnType<typeof useUsersCountersQuery>;
export type UsersCountersLazyQueryHookResult = ReturnType<typeof useUsersCountersLazyQuery>;
export type UsersCountersQueryResult = Apollo.QueryResult<UsersCountersQuery, UsersCountersQueryVariables>;
export function refetchUsersCountersQuery(variables?: UsersCountersQueryVariables) {
      return { query: UsersCountersDocument, variables: variables }
    }
export const UsersSearchListDocument = gql`
    query usersSearchList($page: Int, $limit: Int, $sorts: UserSortInputObject, $filters: [UserFilterInputObject!], $scope: UserScopeInputObject) {
  data: users(
    page: $page
    limit: $limit
    sorts: $sorts
    filters: $filters
    scope: $scope
  ) {
    collection {
      id
      firstName
      lastName
      avatarAttached {
        ...attachmentFragment
      }
      email
    }
    metadata {
      ...metadataFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${MetadataFragmentFragmentDoc}`;

/**
 * __useUsersSearchListQuery__
 *
 * To run a query within a React component, call `useUsersSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSearchListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *      filters: // value for 'filters'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useUsersSearchListQuery(baseOptions?: Apollo.QueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
      }
export function useUsersSearchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersSearchListQuery, UsersSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersSearchListQuery, UsersSearchListQueryVariables>(UsersSearchListDocument, options);
        }
export type UsersSearchListQueryHookResult = ReturnType<typeof useUsersSearchListQuery>;
export type UsersSearchListLazyQueryHookResult = ReturnType<typeof useUsersSearchListLazyQuery>;
export type UsersSearchListQueryResult = Apollo.QueryResult<UsersSearchListQuery, UsersSearchListQueryVariables>;
export function refetchUsersSearchListQuery(variables?: UsersSearchListQueryVariables) {
      return { query: UsersSearchListDocument, variables: variables }
    }
export const UserDocument = gql`
    query user($id: ID!, $includeFullData: Boolean = false, $includeFinalAccesses: Boolean = false, $includePersonalAccesses: Boolean = false, $includeTeamAccesses: Boolean = false) {
  data: user(id: $id) {
    avatarAttached {
      ...attachmentFragment
    }
    id
    firstName
    lastName
    email @include(if: $includeFullData)
    passwordSetupRequired
    role
    personalId @include(if: $includeFullData)
    phoneNumber @include(if: $includeFullData)
    sites @include(if: $includeFullData) {
      collection {
        id
        name
      }
    }
    sectors @include(if: $includeFullData) {
      collection {
        id
        name
        color
      }
    }
    verified @include(if: $includeFullData)
    username @include(if: $includeFullData)
    deactivatedAt
    team @include(if: $includeFullData) {
      id
      name
      color
    }
    team @include(if: $includeTeamAccesses) {
      id
      name
      color
      accesses {
        component
        itemIds
        level
        scopeLevel
        policy
      }
    }
    finalAccesses @include(if: $includeFinalAccesses) {
      component
      itemIds
      level
      scopeLevel
      policy
    }
    personalAccesses @include(if: $includePersonalAccesses) {
      component
      itemIds
      level
      scopeLevel
      policy
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeFullData: // value for 'includeFullData'
 *      includeFinalAccesses: // value for 'includeFinalAccesses'
 *      includePersonalAccesses: // value for 'includePersonalAccesses'
 *      includeTeamAccesses: // value for 'includeTeamAccesses'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables: UserQueryVariables) {
      return { query: UserDocument, variables: variables }
    }
export const UserCreateDocument = gql`
    mutation userCreate($attributes: UserCreateInputObject!, $redirectUrl: String!) {
  data: userCreate(input: {attributes: $attributes, redirectUrl: $redirectUrl}) {
    ...fullUserFragment
  }
}
    ${FullUserFragmentFragmentDoc}`;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserUpdateDocument = gql`
    mutation userUpdate($id: ID!, $attributes: UserUpdateInputObject!, $finishRegistrationRedirectUrl: String!, $confirmEmailRedirectUrl: String!) {
  data: userUpdate(
    input: {id: $id, attributes: $attributes, finishRegistrationRedirectUrl: $finishRegistrationRedirectUrl, confirmEmailRedirectUrl: $confirmEmailRedirectUrl}
  ) {
    ...fullUserFragment
  }
}
    ${FullUserFragmentFragmentDoc}`;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *      finishRegistrationRedirectUrl: // value for 'finishRegistrationRedirectUrl'
 *      confirmEmailRedirectUrl: // value for 'confirmEmailRedirectUrl'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserSelfUpdateDocument = gql`
    mutation userSelfUpdate($input: UserSelfUpdateInput!) {
  data: userSelfUpdate(input: $input) {
    ...fullUserFragment
    finalAccesses {
      component
      itemIds
      level
      scopeLevel
      policy
    }
  }
}
    ${FullUserFragmentFragmentDoc}`;
export type UserSelfUpdateMutationFn = Apollo.MutationFunction<UserSelfUpdateMutation, UserSelfUpdateMutationVariables>;

/**
 * __useUserSelfUpdateMutation__
 *
 * To run a mutation, you first call `useUserSelfUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSelfUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSelfUpdateMutation, { data, loading, error }] = useUserSelfUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSelfUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserSelfUpdateMutation, UserSelfUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSelfUpdateMutation, UserSelfUpdateMutationVariables>(UserSelfUpdateDocument, options);
      }
export type UserSelfUpdateMutationHookResult = ReturnType<typeof useUserSelfUpdateMutation>;
export type UserSelfUpdateMutationResult = Apollo.MutationResult<UserSelfUpdateMutation>;
export type UserSelfUpdateMutationOptions = Apollo.BaseMutationOptions<UserSelfUpdateMutation, UserSelfUpdateMutationVariables>;
export const UserDestroyDocument = gql`
    mutation userDestroy($id: ID!) {
  data: userDestroy(input: {id: $id})
}
    `;
export type UserDestroyMutationFn = Apollo.MutationFunction<UserDestroyMutation, UserDestroyMutationVariables>;

/**
 * __useUserDestroyMutation__
 *
 * To run a mutation, you first call `useUserDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDestroyMutation, { data, loading, error }] = useUserDestroyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDestroyMutation(baseOptions?: Apollo.MutationHookOptions<UserDestroyMutation, UserDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDestroyMutation, UserDestroyMutationVariables>(UserDestroyDocument, options);
      }
export type UserDestroyMutationHookResult = ReturnType<typeof useUserDestroyMutation>;
export type UserDestroyMutationResult = Apollo.MutationResult<UserDestroyMutation>;
export type UserDestroyMutationOptions = Apollo.BaseMutationOptions<UserDestroyMutation, UserDestroyMutationVariables>;
export const AuthenticationPasswordSetupDocument = gql`
    mutation authenticationPasswordSetup($input: AuthenticationPasswordSetupInput!) {
  data: authenticationPasswordSetup(input: $input)
}
    `;
export type AuthenticationPasswordSetupMutationFn = Apollo.MutationFunction<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>;

/**
 * __useAuthenticationPasswordSetupMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordSetupMutation, { data, loading, error }] = useAuthenticationPasswordSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordSetupMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>(AuthenticationPasswordSetupDocument, options);
      }
export type AuthenticationPasswordSetupMutationHookResult = ReturnType<typeof useAuthenticationPasswordSetupMutation>;
export type AuthenticationPasswordSetupMutationResult = Apollo.MutationResult<AuthenticationPasswordSetupMutation>;
export type AuthenticationPasswordSetupMutationOptions = Apollo.BaseMutationOptions<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>;
export const UserBulkActivateDocument = gql`
    mutation userBulkActivate($input: UserBulkActivateInput!) {
  data: userBulkActivate(input: $input)
}
    `;
export type UserBulkActivateMutationFn = Apollo.MutationFunction<UserBulkActivateMutation, UserBulkActivateMutationVariables>;

/**
 * __useUserBulkActivateMutation__
 *
 * To run a mutation, you first call `useUserBulkActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBulkActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBulkActivateMutation, { data, loading, error }] = useUserBulkActivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserBulkActivateMutation(baseOptions?: Apollo.MutationHookOptions<UserBulkActivateMutation, UserBulkActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserBulkActivateMutation, UserBulkActivateMutationVariables>(UserBulkActivateDocument, options);
      }
export type UserBulkActivateMutationHookResult = ReturnType<typeof useUserBulkActivateMutation>;
export type UserBulkActivateMutationResult = Apollo.MutationResult<UserBulkActivateMutation>;
export type UserBulkActivateMutationOptions = Apollo.BaseMutationOptions<UserBulkActivateMutation, UserBulkActivateMutationVariables>;
export const UserBulkDeactivateDocument = gql`
    mutation userBulkDeactivate($input: UserBulkDeactivateInput!) {
  data: userBulkDeactivate(input: $input)
}
    `;
export type UserBulkDeactivateMutationFn = Apollo.MutationFunction<UserBulkDeactivateMutation, UserBulkDeactivateMutationVariables>;

/**
 * __useUserBulkDeactivateMutation__
 *
 * To run a mutation, you first call `useUserBulkDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBulkDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBulkDeactivateMutation, { data, loading, error }] = useUserBulkDeactivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserBulkDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<UserBulkDeactivateMutation, UserBulkDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserBulkDeactivateMutation, UserBulkDeactivateMutationVariables>(UserBulkDeactivateDocument, options);
      }
export type UserBulkDeactivateMutationHookResult = ReturnType<typeof useUserBulkDeactivateMutation>;
export type UserBulkDeactivateMutationResult = Apollo.MutationResult<UserBulkDeactivateMutation>;
export type UserBulkDeactivateMutationOptions = Apollo.BaseMutationOptions<UserBulkDeactivateMutation, UserBulkDeactivateMutationVariables>;